import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import { gql } from 'graphql-tag';

/* tslint:disable */
/* eslint-disable */

const VariableName = ' $1fcbcbff-3e78-462f-b45c-668a3e09bfd8';

const ScalarBrandingField = ' $1fcbcbff-3e78-462f-b45c-668a3e09bfd9';

type CustomScalar<T> = { [ScalarBrandingField]: T };

/* #__PURE__ */
class Variable<T, Name extends string> {
  private [VariableName]: Name;
  // @ts-ignore
  private _type?: T;

  // @ts-ignore
  constructor(
    name: Name,
    private readonly isRequired?: boolean,
  ) {
    this[VariableName] = name;
  }
}

type ArrayInput<I> = [I] extends [$Atomic] ? never : ReadonlyArray<VariabledInput<I>>;

type AllowedInlineScalars<S> = S extends string | number ? S : never;

export type UnwrapCustomScalars<T> = T extends CustomScalar<infer S>
  ? S
  : T extends ReadonlyArray<infer I>
    ? ReadonlyArray<UnwrapCustomScalars<I>>
    : T extends Record<string, any>
      ? { [K in keyof T]: UnwrapCustomScalars<T[K]> }
      : T;

type VariableWithoutScalars<T, Str extends string> = Variable<UnwrapCustomScalars<T>, Str>;

// the array wrapper prevents distributive conditional types
// https://www.typescriptlang.org/docs/handbook/2/conditional-types.html#distributive-conditional-types
type VariabledInput<T> = [T] extends [CustomScalar<infer S> | null | undefined]
  ? // scalars only support variable input
    Variable<S | null | undefined, any> | AllowedInlineScalars<S> | null | undefined
  : [T] extends [CustomScalar<infer S>]
    ? Variable<S, any> | AllowedInlineScalars<S>
    : [T] extends [$Atomic]
      ? Variable<T, any> | T
      : T extends ReadonlyArray<infer I>
        ? VariableWithoutScalars<T, any> | T | ArrayInput<I>
        : T extends Record<string, any> | null | undefined
          ?
              | VariableWithoutScalars<T | null | undefined, any>
              | null
              | undefined
              | { [K in keyof T]: VariabledInput<T[K]> }
              | T
          : T extends Record<string, any>
            ? VariableWithoutScalars<T, any> | { [K in keyof T]: VariabledInput<T[K]> } | T
            : never;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (k: infer I) => void ? I : never;

/**
 * Creates a new query variable
 *
 * @param name The variable name
 */
export const $ = <Type, Name extends string>(name: Name): Variable<Type, Name> => {
  return new Variable(name);
};

/**
 * Creates a new query variable. A value will be required even if the input is optional
 *
 * @param name The variable name
 */
export const $$ = <Type, Name extends string>(name: Name): Variable<NonNullable<Type>, Name> => {
  return new Variable(name, true);
};

type SelectOptions = {
  argTypes?: { [key: string]: string };
  args?: { [key: string]: any };
  selection?: Selection<any>;
};

/* #__PURE__ */
class $Field<Name extends string, Type, Vars = {}> {
  public kind: 'field' = 'field';
  public type!: Type;

  public vars!: Vars;
  public alias: string | null = null;

  constructor(
    public name: Name,
    public options: SelectOptions,
  ) {}

  as<Rename extends string>(alias: Rename): $Field<Rename, Type, Vars> {
    const f = new $Field(this.name, this.options);
    f.alias = alias;
    return f as any;
  }
}

/* #__PURE__ */
class $Base<Name extends string> {
  // @ts-ignore
  constructor(private $$name: Name) {}

  protected $_select<Key extends string>(name: Key, options: SelectOptions = {}): $Field<Key, any, any> {
    return new $Field(name, options);
  }
}

// @ts-ignore
/* #__PURE__ */
class $Union<T, Name extends String> extends $Base<Name> {
  // @ts-ignore
  private $$type!: T;
  // @ts-ignore
  private $$name!: Name;

  constructor(
    private selectorClasses: { [K in keyof T]: { new (): T[K] } },
    $$name: Name,
  ) {
    super($$name);
  }

  $on<Type extends keyof T, Sel extends Selection<T[Type]>>(
    alternative: Type,
    selectorFn: (selector: T[Type]) => [...Sel],
  ): $UnionSelection<GetOutput<Sel>, GetVariables<Sel>> {
    const selection = selectorFn(new this.selectorClasses[alternative]());

    return new $UnionSelection(alternative as string, selection);
  }
}

// @ts-ignore
/* #__PURE__ */
class $Interface<T, Name extends string> extends $Base<Name> {
  // @ts-ignore
  private $$type!: T;
  // @ts-ignore
  private $$name!: Name;

  constructor(
    private selectorClasses: { [K in keyof T]: { new (): T[K] } },
    $$name: Name,
  ) {
    super($$name);
  }
  $on<Type extends keyof T, Sel extends Selection<T[Type]>>(
    alternative: Type,
    selectorFn: (selector: T[Type]) => [...Sel],
  ): $UnionSelection<GetOutput<Sel>, GetVariables<Sel>> {
    const selection = selectorFn(new this.selectorClasses[alternative]());

    return new $UnionSelection(alternative as string, selection);
  }
}

/* #__PURE__ */
class $UnionSelection<T, Vars> {
  public kind: 'union' = 'union';
  // @ts-ignore
  private vars!: Vars;
  constructor(
    public alternativeName: string,
    public alternativeSelection: Selection<T>,
  ) {}
}

type Selection<_any> = ReadonlyArray<$Field<any, any, any> | $UnionSelection<any, any>>;

type NeverNever<T> = [T] extends [never] ? {} : T;

type Simplify<T> = { [K in keyof T]: T[K] } & {};

type LeafType<T> = T extends CustomScalar<infer S> ? S : T;

export type GetOutput<X extends Selection<any>> = Simplify<
  UnionToIntersection<
    {
      [I in keyof X]: X[I] extends $Field<infer Name, infer Type, any> ? { [K in Name]: LeafType<Type> } : never;
    }[keyof X & number]
  > &
    NeverNever<
      {
        [I in keyof X]: X[I] extends $UnionSelection<infer Type, any> ? LeafType<Type> : never;
      }[keyof X & number]
    >
>;

type PossiblyOptionalVar<VName extends string, VType> = undefined extends VType
  ? { [key in VName]?: VType }
  : { [key in VName]: VType };

type ExtractInputVariables<Inputs> = Inputs extends Variable<infer VType, infer VName>
  ? PossiblyOptionalVar<VName, VType>
  : // Avoid generating an index signature for possibly undefined or null inputs.
    // The compiler incorrectly infers null or undefined, and we must force access the Inputs
    // type to convince the compiler its "never", while still retaining {} as the result
    // for null and undefined cases
    // Works around issue 79
    Inputs extends null | undefined
    ? { [K in keyof Inputs]: Inputs[K] }
    : Inputs extends $Atomic
      ? {}
      : Inputs extends any[] | readonly any[]
        ? UnionToIntersection<{ [K in keyof Inputs]: ExtractInputVariables<Inputs[K]> }[keyof Inputs & number]>
        : UnionToIntersection<{ [K in keyof Inputs]: ExtractInputVariables<Inputs[K]> }[keyof Inputs]>;

export type GetVariables<Sel extends Selection<any>, ExtraVars = {}> = UnionToIntersection<
  {
    [I in keyof Sel]: Sel[I] extends $Field<any, any, infer Vars>
      ? Vars
      : Sel[I] extends $UnionSelection<any, infer Vars>
        ? Vars
        : never;
  }[keyof Sel & number]
> &
  ExtractInputVariables<ExtraVars>;

type ArgVarType = {
  type: string;
  isRequired: boolean;
  array: {
    isRequired: boolean;
  } | null;
};

const arrRegex = /\[(.*?)\]/;

/**
 * Converts graphql string type to `ArgVarType`
 * @param input
 * @returns
 */
function getArgVarType(input: string): ArgVarType {
  const array = input.includes('[')
    ? {
        isRequired: input.endsWith('!'),
      }
    : null;

  const type = array ? arrRegex.exec(input)![1]! : input;
  const isRequired = type.endsWith('!');

  return {
    array,
    isRequired: isRequired,
    type: type.replace('!', ''),
  };
}

function fieldToQuery(prefix: string, field: $Field<any, any, any>) {
  const variables = new Map<string, { variable: Variable<any, any>; type: ArgVarType }>();

  function stringifyArgs(args: any, argTypes: { [key: string]: string }, argVarType?: ArgVarType): string {
    switch (typeof args) {
      case 'string':
        const cleanType = argVarType!.type;
        if ($Enums.has(cleanType!)) return args;
        else return JSON.stringify(args);
      case 'number':
      case 'boolean':
        return JSON.stringify(args);
      default:
        if (args == null) return 'null';
        if (VariableName in (args as any)) {
          if (!argVarType) throw new globalThis.Error('Cannot use variabe as sole unnamed field argument');
          const variable = args as Variable<any, any>;
          const argVarName = variable[VariableName];
          variables.set(argVarName, { type: argVarType, variable: variable });
          return '$' + argVarName;
        }
        if (Array.isArray(args))
          return '[' + args.map((arg) => stringifyArgs(arg, argTypes, argVarType)).join(',') + ']';
        const wrapped = (content: string) => (argVarType ? '{' + content + '}' : content);
        return wrapped(
          Array.from(Object.entries(args))
            .map(([key, val]) => {
              let argTypeForKey = argTypes[key];
              if (!argTypeForKey) {
                throw new globalThis.Error(`Argument type for ${key} not found`);
              }
              const cleanType = argTypeForKey.replace('[', '').replace(']', '').replace(/!/g, '');
              return key + ':' + stringifyArgs(val, $InputTypes[cleanType]!, getArgVarType(argTypeForKey));
            })
            .join(','),
        );
    }
  }

  function extractTextAndVars(field: $Field<any, any, any> | $UnionSelection<any, any>) {
    if (field.kind === 'field') {
      let retVal = field.name;
      if (field.alias) retVal = field.alias + ':' + retVal;
      const args = field.options.args,
        argTypes = field.options.argTypes;
      if (args && Object.keys(args).length > 0) {
        retVal += '(' + stringifyArgs(args, argTypes!) + ')';
      }
      let sel = field.options.selection;
      if (sel) {
        retVal += '{';
        for (let subField of sel) {
          retVal += extractTextAndVars(subField);
        }
        retVal += '}';
      }
      return retVal + ' ';
    } else if (field.kind === 'union') {
      let retVal = '... on ' + field.alternativeName + ' {';
      for (let subField of field.alternativeSelection) {
        retVal += extractTextAndVars(subField);
      }
      retVal += '}';

      return retVal + ' ';
    } else {
      throw new globalThis.Error('Uknown field kind');
    }
  }

  const queryRaw = extractTextAndVars(field)!;

  const queryBody = queryRaw.substring(queryRaw.indexOf('{'));

  const varList = Array.from(variables.entries());
  let ret = prefix;
  if (varList.length) {
    ret +=
      '(' +
      varList
        .map(([name, { type: kind, variable }]) => {
          let type = kind.array ? '[' : '';
          type += kind.type;
          if (kind.isRequired) type += '!';
          if (kind.array) type += kind.array.isRequired ? ']!' : ']';

          if (!type.endsWith('!') && (variable as any).isRequired === true) {
            type += '!';
          }

          return '$' + name + ':' + type;
        })
        .join(',') +
      ')';
  }
  ret += queryBody;

  return ret;
}

export type OutputTypeOf<T> = T extends $Interface<infer Subtypes, any>
  ? { [K in keyof Subtypes]: OutputTypeOf<Subtypes[K]> }[keyof Subtypes]
  : T extends $Union<infer Subtypes, any>
    ? { [K in keyof Subtypes]: OutputTypeOf<Subtypes[K]> }[keyof Subtypes]
    : T extends $Base<any>
      ? { [K in keyof T]?: OutputTypeOf<T[K]> }
      : [T] extends [$Field<any, infer FieldType, any>]
        ? FieldType
        : [T] extends [(selFn: (arg: infer Inner) => any) => any]
          ? OutputTypeOf<Inner>
          : [T] extends [(args: any, selFn: (arg: infer Inner) => any) => any]
            ? OutputTypeOf<Inner>
            : never;

export type QueryOutputType<T extends TypedDocumentNode<any>> = T extends TypedDocumentNode<infer Out> ? Out : never;

export type QueryInputType<T extends TypedDocumentNode<any>> = T extends TypedDocumentNode<any, infer In> ? In : never;

export function fragment<T, Sel extends Selection<T>>(GQLType: { new (): T }, selectFn: (selector: T) => [...Sel]) {
  return selectFn(new GQLType());
}

type LastOf<T> = UnionToIntersection<T extends any ? () => T : never> extends () => infer R ? R : never;

// TS4.0+
type Push<T extends any[], V> = [...T, V];

// TS4.1+
type TuplifyUnion<T, L = LastOf<T>, N = [T] extends [never] ? true : false> = true extends N
  ? []
  : Push<TuplifyUnion<Exclude<T, L>>, L>;

type AllFieldProperties<I> = {
  [K in keyof I]: I[K] extends $Field<infer Name, infer Type, any> ? $Field<Name, Type, any> : never;
};

type ValueOf<T> = T[keyof T];

export type AllFields<T> = TuplifyUnion<ValueOf<AllFieldProperties<T>>>;

export function all<I extends $Base<any>>(instance: I) {
  const prototype = Object.getPrototypeOf(instance);
  const allFields = Object.getOwnPropertyNames(prototype)
    .map((k) => prototype[k])
    .filter((o) => o?.kind === 'field')
    .map((o) => o?.name) as (keyof typeof instance)[];
  return allFields.map((fieldName) => instance?.[fieldName]) as any as AllFields<I>;
}

type ExactArgNames<GenericType, Constraint> = [Constraint] extends [$Atomic | CustomScalar<any>]
  ? GenericType
  : Constraint extends ReadonlyArray<infer InnerConstraint>
    ? GenericType extends ReadonlyArray<infer Inner>
      ? ReadonlyArray<ExactArgNames<Inner, InnerConstraint>>
      : GenericType
    : GenericType & {
        [Key in keyof GenericType]: Key extends keyof Constraint
          ? ExactArgNames<GenericType[Key], Constraint[Key]>
          : never;
      };

type $Atomic =
  | ArticleSortKeys
  | BlogSortKeys
  | CardBrand
  | CartCardSource
  | CartDeliveryGroupType
  | CartErrorCode
  | CartWarningCode
  | CollectionSortKeys
  | CompletionErrorCode
  | CountPrecision
  | CountryCode
  | CropRegion
  | CurrencyCode
  | CustomerErrorCode
  | DeliveryAddressValidationStrategy
  | DeliveryMethodType
  | DigitalWallet
  | DiscountApplicationAllocationMethod
  | DiscountApplicationTargetSelection
  | DiscountApplicationTargetType
  | FilterPresentation
  | FilterType
  | ImageContentType
  | LanguageCode
  | LocationSortKeys
  | MediaContentType
  | MediaHost
  | MediaPresentationFormat
  | MenuItemType
  | MetafieldDeleteErrorCode
  | MetafieldsSetUserErrorCode
  | OrderCancelReason
  | OrderFinancialStatus
  | OrderFulfillmentStatus
  | OrderSortKeys
  | PageSortKeys
  | PredictiveSearchLimitScope
  | PredictiveSearchType
  | PreferenceDeliveryMethodType
  | ProductCollectionSortKeys
  | ProductImageSortKeys
  | ProductMediaSortKeys
  | ProductRecommendationIntent
  | ProductSortKeys
  | ProductVariantSortKeys
  | SearchPrefixQueryType
  | SearchSortKeys
  | SearchType
  | SearchUnavailableProductsType
  | SearchableField
  | SellingPlanCheckoutChargeType
  | SellingPlanInterval
  | ShopPayInstallmentsFinancingPlanFrequency
  | ShopPayInstallmentsLoan
  | ShopPayPaymentRequestDeliveryMethodType
  | SitemapType
  | SubmissionErrorCode
  | UnitPriceMeasurementMeasuredType
  | UnitPriceMeasurementMeasuredUnit
  | UnitSystem
  | UserErrorsShopPayPaymentRequestSessionUserErrorsCode
  | WeightUnit
  | number
  | string
  | boolean
  | null
  | undefined;

let $Enums = new Set<string>([
  'ArticleSortKeys',
  'BlogSortKeys',
  'CardBrand',
  'CartCardSource',
  'CartDeliveryGroupType',
  'CartErrorCode',
  'CartWarningCode',
  'CollectionSortKeys',
  'CompletionErrorCode',
  'CountPrecision',
  'CountryCode',
  'CropRegion',
  'CurrencyCode',
  'CustomerErrorCode',
  'DeliveryAddressValidationStrategy',
  'DeliveryMethodType',
  'DigitalWallet',
  'DiscountApplicationAllocationMethod',
  'DiscountApplicationTargetSelection',
  'DiscountApplicationTargetType',
  'FilterPresentation',
  'FilterType',
  'ImageContentType',
  'LanguageCode',
  'LocationSortKeys',
  'MediaContentType',
  'MediaHost',
  'MediaPresentationFormat',
  'MenuItemType',
  'MetafieldDeleteErrorCode',
  'MetafieldsSetUserErrorCode',
  'OrderCancelReason',
  'OrderFinancialStatus',
  'OrderFulfillmentStatus',
  'OrderSortKeys',
  'PageSortKeys',
  'PredictiveSearchLimitScope',
  'PredictiveSearchType',
  'PreferenceDeliveryMethodType',
  'ProductCollectionSortKeys',
  'ProductImageSortKeys',
  'ProductMediaSortKeys',
  'ProductRecommendationIntent',
  'ProductSortKeys',
  'ProductVariantSortKeys',
  'SearchPrefixQueryType',
  'SearchSortKeys',
  'SearchType',
  'SearchUnavailableProductsType',
  'SearchableField',
  'SellingPlanCheckoutChargeType',
  'SellingPlanInterval',
  'ShopPayInstallmentsFinancingPlanFrequency',
  'ShopPayInstallmentsLoan',
  'ShopPayPaymentRequestDeliveryMethodType',
  'SitemapType',
  'SubmissionErrorCode',
  'UnitPriceMeasurementMeasuredType',
  'UnitPriceMeasurementMeasuredUnit',
  'UnitSystem',
  'UserErrorsShopPayPaymentRequestSessionUserErrorsCode',
  'WeightUnit',
]);

/**
 * A version of the API, as defined by [Shopify API versioning](https://shopify.dev/api/usage/versioning).
Versions are commonly referred to by their handle (for example, `2021-10`).

 */
/* #__PURE__ */
export class ApiVersion extends $Base<'ApiVersion'> {
  constructor() {
    super('ApiVersion');
  }

  /**
   * The human-readable name of the version.
   */
  get displayName(): $Field<'displayName', string> {
    return this.$_select('displayName') as any;
  }

  /**
   * The unique identifier of an ApiVersion. All supported API versions have a date-based (YYYY-MM) or `unstable` handle.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * Whether the version is actively supported by Shopify. Supported API versions are guaranteed to be stable. Unsupported API versions include unstable, release candidate, and end-of-life versions that are marked as unsupported. For more information, refer to [Versioning](https://shopify.dev/api/usage/versioning).
   */
  get supported(): $Field<'supported', boolean> {
    return this.$_select('supported') as any;
  }
}

/**
 * The input fields for submitting Apple Pay payment method information for checkout.

 */
export type ApplePayWalletContentInput = {
  billingAddress: MailingAddressInput;
  data: string;
  header: ApplePayWalletHeaderInput;
  lastDigits?: string | null | undefined;
  signature: string;
  version: string;
};

/**
 * The input fields for submitting wallet payment method information for checkout.

 */
export type ApplePayWalletHeaderInput = {
  applicationData?: string | null | undefined;
  ephemeralPublicKey: string;
  publicKeyHash: string;
  transactionId: string;
};

/**
 * Details about the gift card used on the checkout.
 */
/* #__PURE__ */
export class AppliedGiftCard extends $Base<'AppliedGiftCard'> {
  constructor() {
    super('AppliedGiftCard');
  }

  /**
   * The amount that was taken from the gift card by applying it.
   */
  amountUsed<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'amountUsed', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('amountUsed', options) as any;
  }

  /**
   * The amount that was taken from the gift card by applying it.
   */
  amountUsedV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'amountUsedV2', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('amountUsedV2', options) as any;
  }

  /**
   * The amount left on the gift card.
   */
  balance<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'balance', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('balance', options) as any;
  }

  /**
   * The amount left on the gift card.
   */
  balanceV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'balanceV2', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('balanceV2', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The last characters of the gift card.
   */
  get lastCharacters(): $Field<'lastCharacters', string> {
    return this.$_select('lastCharacters') as any;
  }

  /**
   * The amount that was applied to the checkout in its currency.
   */
  presentmentAmountUsed<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'presentmentAmountUsed', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('presentmentAmountUsed', options) as any;
  }
}

/**
 * An article in an online store blog.
 */
/* #__PURE__ */
export class Article extends $Base<'Article'> {
  constructor() {
    super('Article');
  }

  /**
   * The article's author.
   */
  author<Sel extends Selection<ArticleAuthor>>(
    selectorFn: (s: ArticleAuthor) => [...Sel],
  ): $Field<'author', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ArticleAuthor()),
    };
    return this.$_select('author', options) as any;
  }

  /**
   * The article's author.
   */
  authorV2<Sel extends Selection<ArticleAuthor>>(
    selectorFn: (s: ArticleAuthor) => [...Sel],
  ): $Field<'authorV2', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ArticleAuthor()),
    };
    return this.$_select('authorV2', options) as any;
  }

  /**
   * The blog that the article belongs to.
   */
  blog<Sel extends Selection<Blog>>(
    selectorFn: (s: Blog) => [...Sel],
  ): $Field<'blog', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Blog()),
    };
    return this.$_select('blog', options) as any;
  }

  /**
   * List of comments posted on the article.
   */
  comments<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<CommentConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: CommentConnection) => [...Sel],
  ): $Field<'comments', GetOutput<Sel>, GetVariables<Sel, Args>>;
  comments<Sel extends Selection<CommentConnection>>(
    selectorFn: (s: CommentConnection) => [...Sel],
  ): $Field<'comments', GetOutput<Sel>, GetVariables<Sel>>;
  comments(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new CommentConnection()),
    };
    return this.$_select('comments', options) as any;
  }

  /**
   * Stripped content of the article, single line with HTML tags removed.
   */
  content<
    Args extends VariabledInput<{
      truncateAt?: number | null | undefined;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        truncateAt?: number | null | undefined;
      }
    >,
  ): $Field<'content', string, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        truncateAt: 'Int',
      },
      args,
    };
    return this.$_select('content', options) as any;
  }

  /**
   * The content of the article, complete with HTML formatting.
   */
  get contentHtml(): $Field<'contentHtml', HTML> {
    return this.$_select('contentHtml') as any;
  }

  /**
   * Stripped excerpt of the article, single line with HTML tags removed.
   */
  excerpt<
    Args extends VariabledInput<{
      truncateAt?: number | null | undefined;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        truncateAt?: number | null | undefined;
      }
    >,
  ): $Field<'excerpt', string | null | undefined, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        truncateAt: 'Int',
      },
      args,
    };
    return this.$_select('excerpt', options) as any;
  }

  /**
   * The excerpt of the article, complete with HTML formatting.
   */
  get excerptHtml(): $Field<'excerptHtml', HTML | null | undefined> {
    return this.$_select('excerptHtml') as any;
  }

  /**
   * A human-friendly unique string for the Article automatically generated from its title.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The image associated with the article.
   */
  image<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('image', options) as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel.
   */
  get onlineStoreUrl(): $Field<'onlineStoreUrl', URL | null | undefined> {
    return this.$_select('onlineStoreUrl') as any;
  }

  /**
   * The date and time when the article was published.
   */
  get publishedAt(): $Field<'publishedAt', DateTime> {
    return this.$_select('publishedAt') as any;
  }

  /**
   * The article’s SEO information.
   */
  seo<Sel extends Selection<SEO>>(
    selectorFn: (s: SEO) => [...Sel],
  ): $Field<'seo', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SEO()),
    };
    return this.$_select('seo', options) as any;
  }

  /**
 * A categorization that a article can be tagged with.

 */
  get tags(): $Field<'tags', Readonly<Array<string>>> {
    return this.$_select('tags') as any;
  }

  /**
   * The article’s name.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null.
   */
  get trackingParameters(): $Field<'trackingParameters', string | null | undefined> {
    return this.$_select('trackingParameters') as any;
  }
}

/**
 * The author of an article.
 */
/* #__PURE__ */
export class ArticleAuthor extends $Base<'ArticleAuthor'> {
  constructor() {
    super('ArticleAuthor');
  }

  /**
   * The author's bio.
   */
  get bio(): $Field<'bio', string | null | undefined> {
    return this.$_select('bio') as any;
  }

  /**
   * The author’s email.
   */
  get email(): $Field<'email', string> {
    return this.$_select('email') as any;
  }

  /**
   * The author's first name.
   */
  get firstName(): $Field<'firstName', string> {
    return this.$_select('firstName') as any;
  }

  /**
   * The author's last name.
   */
  get lastName(): $Field<'lastName', string> {
    return this.$_select('lastName') as any;
  }

  /**
   * The author's full name.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Articles.

 */
/* #__PURE__ */
export class ArticleConnection extends $Base<'ArticleConnection'> {
  constructor() {
    super('ArticleConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<ArticleEdge>>(
    selectorFn: (s: ArticleEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ArticleEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in ArticleEdge.
   */
  nodes<Sel extends Selection<Article>>(
    selectorFn: (s: Article) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Article()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one Article and a cursor during pagination.

 */
/* #__PURE__ */
export class ArticleEdge extends $Base<'ArticleEdge'> {
  constructor() {
    super('ArticleEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of ArticleEdge.
   */
  node<Sel extends Selection<Article>>(
    selectorFn: (s: Article) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Article()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The set of valid sort keys for the Article query.
 */
export enum ArticleSortKeys {
  /**
   * Sort by the `title` value.
   */
  TITLE = 'TITLE',

  /**
   * Sort by the `blog_title` value.
   */
  BLOG_TITLE = 'BLOG_TITLE',

  /**
   * Sort by the `author` value.
   */
  AUTHOR = 'AUTHOR',

  /**
   * Sort by the `updated_at` value.
   */
  UPDATED_AT = 'UPDATED_AT',

  /**
   * Sort by the `published_at` value.
   */
  PUBLISHED_AT = 'PUBLISHED_AT',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * Represents a generic custom attribute, such as whether an order is a customer's first.
 */
/* #__PURE__ */
export class Attribute extends $Base<'Attribute'> {
  constructor() {
    super('Attribute');
  }

  /**
 * The key or name of the attribute. For example, `"customersFirstOrder"`.

 */
  get key(): $Field<'key', string> {
    return this.$_select('key') as any;
  }

  /**
 * The value of the attribute. For example, `"true"`.

 */
  get value(): $Field<'value', string | null | undefined> {
    return this.$_select('value') as any;
  }
}

/**
 * The input fields for an attribute.
 */
export type AttributeInput = {
  key: string;
  value: string;
};

/**
 * Automatic discount applications capture the intentions of a discount that was automatically applied.

 */
/* #__PURE__ */
export class AutomaticDiscountApplication extends $Base<'AutomaticDiscountApplication'> {
  constructor() {
    super('AutomaticDiscountApplication');
  }

  /**
   * The method by which the discount's value is allocated to its entitled items.
   */
  get allocationMethod(): $Field<'allocationMethod', DiscountApplicationAllocationMethod> {
    return this.$_select('allocationMethod') as any;
  }

  /**
   * Which lines of targetType that the discount is allocated over.
   */
  get targetSelection(): $Field<'targetSelection', DiscountApplicationTargetSelection> {
    return this.$_select('targetSelection') as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }

  /**
   * The title of the application.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * The value of the discount application.
   */
  value<Sel extends Selection<PricingValue>>(
    selectorFn: (s: PricingValue) => [...Sel],
  ): $Field<'value', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PricingValue()),
    };
    return this.$_select('value', options) as any;
  }
}

/**
 * Represents a cart line common fields.
 */
/* #__PURE__ */
export class BaseCartLine extends $Interface<
  { CartLine: CartLine; ComponentizableCartLine: ComponentizableCartLine },
  'BaseCartLine'
> {
  constructor() {
    super({ CartLine: CartLine, ComponentizableCartLine: ComponentizableCartLine }, 'BaseCartLine');
  }

  /**
   * An attribute associated with the cart line.
   */
  attribute<
    Args extends VariabledInput<{
      key: string;
    }>,
    Sel extends Selection<Attribute>,
  >(
    args: ExactArgNames<
      Args,
      {
        key: string;
      }
    >,
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'attribute', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        key: 'String!',
      },
      args,

      selection: selectorFn(new Attribute()),
    };
    return this.$_select('attribute', options) as any;
  }

  /**
   * The attributes associated with the cart line. Attributes are represented as key-value pairs.
   */
  attributes<Sel extends Selection<Attribute>>(
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'attributes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Attribute()),
    };
    return this.$_select('attributes', options) as any;
  }

  /**
   * The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout.
   */
  cost<Sel extends Selection<CartLineCost>>(
    selectorFn: (s: CartLineCost) => [...Sel],
  ): $Field<'cost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartLineCost()),
    };
    return this.$_select('cost', options) as any;
  }

  /**
   * The discounts that have been applied to the cart line.
   */
  discountAllocations<Sel extends Selection<CartDiscountAllocation>>(
    selectorFn: (s: CartDiscountAllocation) => [...Sel],
  ): $Field<'discountAllocations', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDiscountAllocation()),
    };
    return this.$_select('discountAllocations', options) as any;
  }

  /**
   * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
   */
  estimatedCost<Sel extends Selection<CartLineEstimatedCost>>(
    selectorFn: (s: CartLineEstimatedCost) => [...Sel],
  ): $Field<'estimatedCost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartLineEstimatedCost()),
    };
    return this.$_select('estimatedCost', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The merchandise that the buyer intends to purchase.
   */
  merchandise<Sel extends Selection<Merchandise>>(
    selectorFn: (s: Merchandise) => [...Sel],
  ): $Field<'merchandise', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Merchandise()),
    };
    return this.$_select('merchandise', options) as any;
  }

  /**
   * The quantity of the merchandise that the customer intends to purchase.
   */
  get quantity(): $Field<'quantity', number> {
    return this.$_select('quantity') as any;
  }

  /**
   * The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased.
   */
  sellingPlanAllocation<Sel extends Selection<SellingPlanAllocation>>(
    selectorFn: (s: SellingPlanAllocation) => [...Sel],
  ): $Field<'sellingPlanAllocation', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanAllocation()),
    };
    return this.$_select('sellingPlanAllocation', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple BaseCartLines.

 */
/* #__PURE__ */
export class BaseCartLineConnection extends $Base<'BaseCartLineConnection'> {
  constructor() {
    super('BaseCartLineConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<BaseCartLineEdge>>(
    selectorFn: (s: BaseCartLineEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new BaseCartLineEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in BaseCartLineEdge.
   */
  nodes<Sel extends Selection<BaseCartLine>>(
    selectorFn: (s: BaseCartLine) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new BaseCartLine()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one BaseCartLine and a cursor during pagination.

 */
/* #__PURE__ */
export class BaseCartLineEdge extends $Base<'BaseCartLineEdge'> {
  constructor() {
    super('BaseCartLineEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of BaseCartLineEdge.
   */
  node<Sel extends Selection<BaseCartLine>>(
    selectorFn: (s: BaseCartLine) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new BaseCartLine()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * An online store blog.
 */
/* #__PURE__ */
export class Blog extends $Base<'Blog'> {
  constructor() {
    super('Blog');
  }

  /**
   * Find an article by its handle.
   */
  articleByHandle<
    Args extends VariabledInput<{
      handle: string;
    }>,
    Sel extends Selection<Article>,
  >(
    args: ExactArgNames<
      Args,
      {
        handle: string;
      }
    >,
    selectorFn: (s: Article) => [...Sel],
  ): $Field<'articleByHandle', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        handle: 'String!',
      },
      args,

      selection: selectorFn(new Article()),
    };
    return this.$_select('articleByHandle', options) as any;
  }

  /**
   * List of the blog's articles.
   */
  articles<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: ArticleSortKeys | null | undefined;
      query?: string | null | undefined;
    }>,
    Sel extends Selection<ArticleConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: ArticleSortKeys | null | undefined;
        query?: string | null | undefined;
      }
    >,
    selectorFn: (s: ArticleConnection) => [...Sel],
  ): $Field<'articles', GetOutput<Sel>, GetVariables<Sel, Args>>;
  articles<Sel extends Selection<ArticleConnection>>(
    selectorFn: (s: ArticleConnection) => [...Sel],
  ): $Field<'articles', GetOutput<Sel>, GetVariables<Sel>>;
  articles(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'ArticleSortKeys',
        query: 'String',
      },
      args,

      selection: selectorFn(new ArticleConnection()),
    };
    return this.$_select('articles', options) as any;
  }

  /**
   * The authors who have contributed to the blog.
   */
  authors<Sel extends Selection<ArticleAuthor>>(
    selectorFn: (s: ArticleAuthor) => [...Sel],
  ): $Field<'authors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ArticleAuthor()),
    };
    return this.$_select('authors', options) as any;
  }

  /**
 * A human-friendly unique string for the Blog automatically generated from its title.

 */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel.
   */
  get onlineStoreUrl(): $Field<'onlineStoreUrl', URL | null | undefined> {
    return this.$_select('onlineStoreUrl') as any;
  }

  /**
   * The blog's SEO information.
   */
  seo<Sel extends Selection<SEO>>(
    selectorFn: (s: SEO) => [...Sel],
  ): $Field<'seo', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SEO()),
    };
    return this.$_select('seo', options) as any;
  }

  /**
   * The blogs’s title.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Blogs.

 */
/* #__PURE__ */
export class BlogConnection extends $Base<'BlogConnection'> {
  constructor() {
    super('BlogConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<BlogEdge>>(
    selectorFn: (s: BlogEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new BlogEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in BlogEdge.
   */
  nodes<Sel extends Selection<Blog>>(
    selectorFn: (s: Blog) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Blog()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one Blog and a cursor during pagination.

 */
/* #__PURE__ */
export class BlogEdge extends $Base<'BlogEdge'> {
  constructor() {
    super('BlogEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of BlogEdge.
   */
  node<Sel extends Selection<Blog>>(
    selectorFn: (s: Blog) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Blog()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The set of valid sort keys for the Blog query.
 */
export enum BlogSortKeys {
  /**
   * Sort by the `handle` value.
   */
  HANDLE = 'HANDLE',

  /**
   * Sort by the `title` value.
   */
  TITLE = 'TITLE',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * The store's [branding configuration](https://help.shopify.com/en/manual/promoting-marketing/managing-brand-assets).

 */
/* #__PURE__ */
export class Brand extends $Base<'Brand'> {
  constructor() {
    super('Brand');
  }

  /**
   * The colors of the store's brand.
   */
  colors<Sel extends Selection<BrandColors>>(
    selectorFn: (s: BrandColors) => [...Sel],
  ): $Field<'colors', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new BrandColors()),
    };
    return this.$_select('colors', options) as any;
  }

  /**
   * The store's cover image.
   */
  coverImage<Sel extends Selection<MediaImage>>(
    selectorFn: (s: MediaImage) => [...Sel],
  ): $Field<'coverImage', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaImage()),
    };
    return this.$_select('coverImage', options) as any;
  }

  /**
   * The store's default logo.
   */
  logo<Sel extends Selection<MediaImage>>(
    selectorFn: (s: MediaImage) => [...Sel],
  ): $Field<'logo', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaImage()),
    };
    return this.$_select('logo', options) as any;
  }

  /**
   * The store's short description.
   */
  get shortDescription(): $Field<'shortDescription', string | null | undefined> {
    return this.$_select('shortDescription') as any;
  }

  /**
   * The store's slogan.
   */
  get slogan(): $Field<'slogan', string | null | undefined> {
    return this.$_select('slogan') as any;
  }

  /**
   * The store's preferred logo for square UI elements.
   */
  squareLogo<Sel extends Selection<MediaImage>>(
    selectorFn: (s: MediaImage) => [...Sel],
  ): $Field<'squareLogo', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaImage()),
    };
    return this.$_select('squareLogo', options) as any;
  }
}

/**
 * A group of related colors for the shop's brand.

 */
/* #__PURE__ */
export class BrandColorGroup extends $Base<'BrandColorGroup'> {
  constructor() {
    super('BrandColorGroup');
  }

  /**
   * The background color.
   */
  get background(): $Field<'background', Color | null | undefined> {
    return this.$_select('background') as any;
  }

  /**
   * The foreground color.
   */
  get foreground(): $Field<'foreground', Color | null | undefined> {
    return this.$_select('foreground') as any;
  }
}

/**
 * The colors of the shop's brand.

 */
/* #__PURE__ */
export class BrandColors extends $Base<'BrandColors'> {
  constructor() {
    super('BrandColors');
  }

  /**
   * The shop's primary brand colors.
   */
  primary<Sel extends Selection<BrandColorGroup>>(
    selectorFn: (s: BrandColorGroup) => [...Sel],
  ): $Field<'primary', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new BrandColorGroup()),
    };
    return this.$_select('primary', options) as any;
  }

  /**
   * The shop's secondary brand colors.
   */
  secondary<Sel extends Selection<BrandColorGroup>>(
    selectorFn: (s: BrandColorGroup) => [...Sel],
  ): $Field<'secondary', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new BrandColorGroup()),
    };
    return this.$_select('secondary', options) as any;
  }
}

/**
 * The input fields for obtaining the buyer's identity.

 */
export type BuyerInput = {
  companyLocationId?: string | null | undefined;
  customerAccessToken: string;
};

/**
 * Card brand, such as Visa or Mastercard, which can be used for payments.
 */
export enum CardBrand {
  /**
   * Visa.
   */
  VISA = 'VISA',

  /**
   * Mastercard.
   */
  MASTERCARD = 'MASTERCARD',

  /**
   * Discover.
   */
  DISCOVER = 'DISCOVER',

  /**
   * American Express.
   */
  AMERICAN_EXPRESS = 'AMERICAN_EXPRESS',

  /**
   * Diners Club.
   */
  DINERS_CLUB = 'DINERS_CLUB',

  /**
   * JCB.
   */
  JCB = 'JCB',
}

/**
 * A cart represents the merchandise that a buyer intends to purchase,
and the estimated cost associated with the cart. Learn how to
[interact with a cart](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
during a customer's session.

 */
/* #__PURE__ */
export class Cart extends $Base<'Cart'> {
  constructor() {
    super('Cart');
  }

  /**
   * The gift cards that have been applied to the cart.
   */
  appliedGiftCards<Sel extends Selection<AppliedGiftCard>>(
    selectorFn: (s: AppliedGiftCard) => [...Sel],
  ): $Field<'appliedGiftCards', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new AppliedGiftCard()),
    };
    return this.$_select('appliedGiftCards', options) as any;
  }

  /**
   * An attribute associated with the cart.
   */
  attribute<
    Args extends VariabledInput<{
      key: string;
    }>,
    Sel extends Selection<Attribute>,
  >(
    args: ExactArgNames<
      Args,
      {
        key: string;
      }
    >,
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'attribute', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        key: 'String!',
      },
      args,

      selection: selectorFn(new Attribute()),
    };
    return this.$_select('attribute', options) as any;
  }

  /**
   * The attributes associated with the cart. Attributes are represented as key-value pairs.
   */
  attributes<Sel extends Selection<Attribute>>(
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'attributes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Attribute()),
    };
    return this.$_select('attributes', options) as any;
  }

  /**
   * Information about the buyer that's interacting with the cart.
   */
  buyerIdentity<Sel extends Selection<CartBuyerIdentity>>(
    selectorFn: (s: CartBuyerIdentity) => [...Sel],
  ): $Field<'buyerIdentity', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartBuyerIdentity()),
    };
    return this.$_select('buyerIdentity', options) as any;
  }

  /**
   * The URL of the checkout for the cart.
   */
  get checkoutUrl(): $Field<'checkoutUrl', URL> {
    return this.$_select('checkoutUrl') as any;
  }

  /**
   * The estimated costs that the buyer will pay at checkout. The costs are subject to change and changes will be reflected at checkout. The `cost` field uses the `buyerIdentity` field to determine [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).
   */
  cost<Sel extends Selection<CartCost>>(
    selectorFn: (s: CartCost) => [...Sel],
  ): $Field<'cost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartCost()),
    };
    return this.$_select('cost', options) as any;
  }

  /**
   * The date and time when the cart was created.
   */
  get createdAt(): $Field<'createdAt', DateTime> {
    return this.$_select('createdAt') as any;
  }

  /**
 * The delivery groups available for the cart, based on the buyer identity default
delivery address preference or the default address of the logged-in customer.

 */
  deliveryGroups<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      withCarrierRates?: boolean | null | undefined;
    }>,
    Sel extends Selection<CartDeliveryGroupConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        withCarrierRates?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: CartDeliveryGroupConnection) => [...Sel],
  ): $Field<'deliveryGroups', GetOutput<Sel>, GetVariables<Sel, Args>>;
  deliveryGroups<Sel extends Selection<CartDeliveryGroupConnection>>(
    selectorFn: (s: CartDeliveryGroupConnection) => [...Sel],
  ): $Field<'deliveryGroups', GetOutput<Sel>, GetVariables<Sel>>;
  deliveryGroups(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        withCarrierRates: 'Boolean',
      },
      args,

      selection: selectorFn(new CartDeliveryGroupConnection()),
    };
    return this.$_select('deliveryGroups', options) as any;
  }

  /**
   * The discounts that have been applied to the entire cart.
   */
  discountAllocations<Sel extends Selection<CartDiscountAllocation>>(
    selectorFn: (s: CartDiscountAllocation) => [...Sel],
  ): $Field<'discountAllocations', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDiscountAllocation()),
    };
    return this.$_select('discountAllocations', options) as any;
  }

  /**
   * The case-insensitive discount codes that the customer added at checkout.
   */
  discountCodes<Sel extends Selection<CartDiscountCode>>(
    selectorFn: (s: CartDiscountCode) => [...Sel],
  ): $Field<'discountCodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDiscountCode()),
    };
    return this.$_select('discountCodes', options) as any;
  }

  /**
   * The estimated costs that the buyer will pay at checkout. The estimated costs are subject to change and changes will be reflected at checkout. The `estimatedCost` field uses the `buyerIdentity` field to determine [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).
   */
  estimatedCost<Sel extends Selection<CartEstimatedCost>>(
    selectorFn: (s: CartEstimatedCost) => [...Sel],
  ): $Field<'estimatedCost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartEstimatedCost()),
    };
    return this.$_select('estimatedCost', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * A list of lines containing information about the items the customer intends to purchase.
   */
  lines<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<BaseCartLineConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: BaseCartLineConnection) => [...Sel],
  ): $Field<'lines', GetOutput<Sel>, GetVariables<Sel, Args>>;
  lines<Sel extends Selection<BaseCartLineConnection>>(
    selectorFn: (s: BaseCartLineConnection) => [...Sel],
  ): $Field<'lines', GetOutput<Sel>, GetVariables<Sel>>;
  lines(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new BaseCartLineConnection()),
    };
    return this.$_select('lines', options) as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * A note that's associated with the cart. For example, the note can be a personalized message to the buyer.
   */
  get note(): $Field<'note', string | null | undefined> {
    return this.$_select('note') as any;
  }

  /**
   * The total number of items in the cart.
   */
  get totalQuantity(): $Field<'totalQuantity', number> {
    return this.$_select('totalQuantity') as any;
  }

  /**
   * The date and time when the cart was updated.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * Return type for `cartAttributesUpdate` mutation.
 */
/* #__PURE__ */
export class CartAttributesUpdatePayload extends $Base<'CartAttributesUpdatePayload'> {
  constructor() {
    super('CartAttributesUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * The discounts automatically applied to the cart line based on prerequisites that have been met.
 */
/* #__PURE__ */
export class CartAutomaticDiscountAllocation extends $Base<'CartAutomaticDiscountAllocation'> {
  constructor() {
    super('CartAutomaticDiscountAllocation');
  }

  /**
   * The discounted amount that has been applied to the cart line.
   */
  discountedAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'discountedAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('discountedAmount', options) as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }

  /**
   * The title of the allocated discount.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }
}

/**
 * Return type for `cartBillingAddressUpdate` mutation.
 */
/* #__PURE__ */
export class CartBillingAddressUpdatePayload extends $Base<'CartBillingAddressUpdatePayload'> {
  constructor() {
    super('CartBillingAddressUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * Represents information about the buyer that is interacting with the cart.
 */
/* #__PURE__ */
export class CartBuyerIdentity extends $Base<'CartBuyerIdentity'> {
  constructor() {
    super('CartBuyerIdentity');
  }

  /**
   * The country where the buyer is located.
   */
  get countryCode(): $Field<'countryCode', CountryCode | null | undefined> {
    return this.$_select('countryCode') as any;
  }

  /**
   * The customer account associated with the cart.
   */
  customer<Sel extends Selection<Customer>>(
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
 * An ordered set of delivery addresses tied to the buyer that is interacting with the cart.
The rank of the preferences is determined by the order of the addresses in the array. Preferences
can be used to populate relevant fields in the checkout flow.

 */
  deliveryAddressPreferences<Sel extends Selection<DeliveryAddress>>(
    selectorFn: (s: DeliveryAddress) => [...Sel],
  ): $Field<'deliveryAddressPreferences', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new DeliveryAddress()),
    };
    return this.$_select('deliveryAddressPreferences', options) as any;
  }

  /**
   * The email address of the buyer that's interacting with the cart.
   */
  get email(): $Field<'email', string | null | undefined> {
    return this.$_select('email') as any;
  }

  /**
   * The phone number of the buyer that's interacting with the cart.
   */
  get phone(): $Field<'phone', string | null | undefined> {
    return this.$_select('phone') as any;
  }

  /**
 * A set of preferences tied to the buyer interacting with the cart. Preferences are used to prefill fields in at checkout to streamline information collection. 
Preferences are not synced back to the cart if they are overwritten.

 */
  preferences<Sel extends Selection<CartPreferences>>(
    selectorFn: (s: CartPreferences) => [...Sel],
  ): $Field<'preferences', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartPreferences()),
    };
    return this.$_select('preferences', options) as any;
  }

  /**
   * The purchasing company associated with the cart.
   */
  purchasingCompany<Sel extends Selection<PurchasingCompany>>(
    selectorFn: (s: PurchasingCompany) => [...Sel],
  ): $Field<'purchasingCompany', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PurchasingCompany()),
    };
    return this.$_select('purchasingCompany', options) as any;
  }
}

/**
 * Specifies the input fields to update the buyer information associated with a cart.
Buyer identity is used to determine
[international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
and should match the customer's shipping address.

 */
export type CartBuyerIdentityInput = {
  companyLocationId?: string | null | undefined;
  countryCode?: CountryCode | null | undefined;
  customerAccessToken?: string | null | undefined;
  deliveryAddressPreferences?: Readonly<Array<DeliveryAddressInput>> | null | undefined;
  email?: string | null | undefined;
  phone?: string | null | undefined;
  preferences?: CartPreferencesInput | null | undefined;
};

/**
 * Return type for `cartBuyerIdentityUpdate` mutation.
 */
/* #__PURE__ */
export class CartBuyerIdentityUpdatePayload extends $Base<'CartBuyerIdentityUpdatePayload'> {
  constructor() {
    super('CartBuyerIdentityUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * Represents how credit card details are provided for a direct payment.

 */
export enum CartCardSource {
  /**
 * The credit card was provided by a third party and vaulted on their system.
Using this value requires a separate permission from Shopify.

 */
  SAVED_CREDIT_CARD = 'SAVED_CREDIT_CARD',
}

/**
 * The discount that has been applied to the cart line using a discount code.
 */
/* #__PURE__ */
export class CartCodeDiscountAllocation extends $Base<'CartCodeDiscountAllocation'> {
  constructor() {
    super('CartCodeDiscountAllocation');
  }

  /**
   * The code used to apply the discount.
   */
  get code(): $Field<'code', string> {
    return this.$_select('code') as any;
  }

  /**
   * The discounted amount that has been applied to the cart line.
   */
  discountedAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'discountedAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('discountedAmount', options) as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }
}

/**
 * The completion action to checkout a cart.
 */
/* #__PURE__ */
export class CartCompletionAction extends $Union<
  { CompletePaymentChallenge: CompletePaymentChallenge },
  'CartCompletionAction'
> {
  constructor() {
    super({ CompletePaymentChallenge: CompletePaymentChallenge }, 'CartCompletionAction');
  }
}

/**
 * The required completion action to checkout a cart.
 */
/* #__PURE__ */
export class CartCompletionActionRequired extends $Base<'CartCompletionActionRequired'> {
  constructor() {
    super('CartCompletionActionRequired');
  }

  /**
   * The action required to complete the cart completion attempt.
   */
  action<Sel extends Selection<CartCompletionAction>>(
    selectorFn: (s: CartCompletionAction) => [...Sel],
  ): $Field<'action', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartCompletionAction()),
    };
    return this.$_select('action', options) as any;
  }

  /**
   * The ID of the cart completion attempt.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }
}

/**
 * The result of a cart completion attempt.
 */
/* #__PURE__ */
export class CartCompletionAttemptResult extends $Union<
  {
    CartCompletionActionRequired: CartCompletionActionRequired;
    CartCompletionFailed: CartCompletionFailed;
    CartCompletionProcessing: CartCompletionProcessing;
    CartCompletionSuccess: CartCompletionSuccess;
  },
  'CartCompletionAttemptResult'
> {
  constructor() {
    super(
      {
        CartCompletionActionRequired: CartCompletionActionRequired,
        CartCompletionFailed: CartCompletionFailed,
        CartCompletionProcessing: CartCompletionProcessing,
        CartCompletionSuccess: CartCompletionSuccess,
      },
      'CartCompletionAttemptResult',
    );
  }
}

/**
 * A failed completion to checkout a cart.
 */
/* #__PURE__ */
export class CartCompletionFailed extends $Base<'CartCompletionFailed'> {
  constructor() {
    super('CartCompletionFailed');
  }

  /**
   * The errors that caused the checkout to fail.
   */
  errors<Sel extends Selection<CompletionError>>(
    selectorFn: (s: CompletionError) => [...Sel],
  ): $Field<'errors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CompletionError()),
    };
    return this.$_select('errors', options) as any;
  }

  /**
   * The ID of the cart completion attempt.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }
}

/**
 * A cart checkout completion that's still processing.
 */
/* #__PURE__ */
export class CartCompletionProcessing extends $Base<'CartCompletionProcessing'> {
  constructor() {
    super('CartCompletionProcessing');
  }

  /**
   * The ID of the cart completion attempt.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The number of milliseconds to wait before polling again.
   */
  get pollDelay(): $Field<'pollDelay', number> {
    return this.$_select('pollDelay') as any;
  }
}

/**
 * A successful completion to checkout a cart and a created order.
 */
/* #__PURE__ */
export class CartCompletionSuccess extends $Base<'CartCompletionSuccess'> {
  constructor() {
    super('CartCompletionSuccess');
  }

  /**
   * The date and time when the job completed.
   */
  get completedAt(): $Field<'completedAt', DateTime | null | undefined> {
    return this.$_select('completedAt') as any;
  }

  /**
   * The ID of the cart completion attempt.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The ID of the order that's created in Shopify.
   */
  get orderId(): $Field<'orderId', string> {
    return this.$_select('orderId') as any;
  }

  /**
   * The URL of the order confirmation in Shopify.
   */
  get orderUrl(): $Field<'orderUrl', URL> {
    return this.$_select('orderUrl') as any;
  }
}

/**
 * The costs that the buyer will pay at checkout.
The cart cost uses [`CartBuyerIdentity`](https://shopify.dev/api/storefront/reference/cart/cartbuyeridentity) to determine
[international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).

 */
/* #__PURE__ */
export class CartCost extends $Base<'CartCost'> {
  constructor() {
    super('CartCost');
  }

  /**
   * The estimated amount, before taxes and discounts, for the customer to pay at checkout. The checkout charge amount doesn't include any deferred payments that'll be paid at a later date. If the cart has no deferred payments, then the checkout charge amount is equivalent to `subtotalAmount`.
   */
  checkoutChargeAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'checkoutChargeAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('checkoutChargeAmount', options) as any;
  }

  /**
   * The amount, before taxes and cart-level discounts, for the customer to pay.
   */
  subtotalAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'subtotalAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('subtotalAmount', options) as any;
  }

  /**
   * Whether the subtotal amount is estimated.
   */
  get subtotalAmountEstimated(): $Field<'subtotalAmountEstimated', boolean> {
    return this.$_select('subtotalAmountEstimated') as any;
  }

  /**
   * The total amount for the customer to pay.
   */
  totalAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalAmount', options) as any;
  }

  /**
   * Whether the total amount is estimated.
   */
  get totalAmountEstimated(): $Field<'totalAmountEstimated', boolean> {
    return this.$_select('totalAmountEstimated') as any;
  }

  /**
   * The duty amount for the customer to pay at checkout.
   */
  totalDutyAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalDutyAmount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalDutyAmount', options) as any;
  }

  /**
   * Whether the total duty amount is estimated.
   */
  get totalDutyAmountEstimated(): $Field<'totalDutyAmountEstimated', boolean> {
    return this.$_select('totalDutyAmountEstimated') as any;
  }

  /**
   * The tax amount for the customer to pay at checkout.
   */
  totalTaxAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalTaxAmount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalTaxAmount', options) as any;
  }

  /**
   * Whether the total tax amount is estimated.
   */
  get totalTaxAmountEstimated(): $Field<'totalTaxAmountEstimated', boolean> {
    return this.$_select('totalTaxAmountEstimated') as any;
  }
}

/**
 * Return type for `cartCreate` mutation.
 */
/* #__PURE__ */
export class CartCreatePayload extends $Base<'CartCreatePayload'> {
  constructor() {
    super('CartCreatePayload');
  }

  /**
   * The new cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * The discounts automatically applied to the cart line based on prerequisites that have been met.
 */
/* #__PURE__ */
export class CartCustomDiscountAllocation extends $Base<'CartCustomDiscountAllocation'> {
  constructor() {
    super('CartCustomDiscountAllocation');
  }

  /**
   * The discounted amount that has been applied to the cart line.
   */
  discountedAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'discountedAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('discountedAmount', options) as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }

  /**
   * The title of the allocated discount.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }
}

/**
 * Preferred location used to find the closest pick up point based on coordinates.
 */
/* #__PURE__ */
export class CartDeliveryCoordinatesPreference extends $Base<'CartDeliveryCoordinatesPreference'> {
  constructor() {
    super('CartDeliveryCoordinatesPreference');
  }

  /**
 * The two-letter code for the country of the preferred location.

For example, US.

 */
  get countryCode(): $Field<'countryCode', CountryCode> {
    return this.$_select('countryCode') as any;
  }

  /**
   * The geographic latitude for a given location. Coordinates are required in order to set pickUpHandle for pickup points.
   */
  get latitude(): $Field<'latitude', number> {
    return this.$_select('latitude') as any;
  }

  /**
   * The geographic longitude for a given location. Coordinates are required in order to set pickUpHandle for pickup points.
   */
  get longitude(): $Field<'longitude', number> {
    return this.$_select('longitude') as any;
  }
}

/**
 * Preferred location used to find the closest pick up point based on coordinates.
 */
export type CartDeliveryCoordinatesPreferenceInput = {
  countryCode: CountryCode;
  latitude: number;
  longitude: number;
};

/**
 * Information about the options available for one or more line items to be delivered to a specific address.
 */
/* #__PURE__ */
export class CartDeliveryGroup extends $Base<'CartDeliveryGroup'> {
  constructor() {
    super('CartDeliveryGroup');
  }

  /**
   * A list of cart lines for the delivery group.
   */
  cartLines<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<BaseCartLineConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: BaseCartLineConnection) => [...Sel],
  ): $Field<'cartLines', GetOutput<Sel>, GetVariables<Sel, Args>>;
  cartLines<Sel extends Selection<BaseCartLineConnection>>(
    selectorFn: (s: BaseCartLineConnection) => [...Sel],
  ): $Field<'cartLines', GetOutput<Sel>, GetVariables<Sel>>;
  cartLines(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new BaseCartLineConnection()),
    };
    return this.$_select('cartLines', options) as any;
  }

  /**
   * The destination address for the delivery group.
   */
  deliveryAddress<Sel extends Selection<MailingAddress>>(
    selectorFn: (s: MailingAddress) => [...Sel],
  ): $Field<'deliveryAddress', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddress()),
    };
    return this.$_select('deliveryAddress', options) as any;
  }

  /**
   * The delivery options available for the delivery group.
   */
  deliveryOptions<Sel extends Selection<CartDeliveryOption>>(
    selectorFn: (s: CartDeliveryOption) => [...Sel],
  ): $Field<'deliveryOptions', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDeliveryOption()),
    };
    return this.$_select('deliveryOptions', options) as any;
  }

  /**
   * The type of merchandise in the delivery group.
   */
  get groupType(): $Field<'groupType', CartDeliveryGroupType> {
    return this.$_select('groupType') as any;
  }

  /**
   * The ID for the delivery group.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The selected delivery option for the delivery group.
   */
  selectedDeliveryOption<Sel extends Selection<CartDeliveryOption>>(
    selectorFn: (s: CartDeliveryOption) => [...Sel],
  ): $Field<'selectedDeliveryOption', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDeliveryOption()),
    };
    return this.$_select('selectedDeliveryOption', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple CartDeliveryGroups.

 */
/* #__PURE__ */
export class CartDeliveryGroupConnection extends $Base<'CartDeliveryGroupConnection'> {
  constructor() {
    super('CartDeliveryGroupConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<CartDeliveryGroupEdge>>(
    selectorFn: (s: CartDeliveryGroupEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDeliveryGroupEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in CartDeliveryGroupEdge.
   */
  nodes<Sel extends Selection<CartDeliveryGroup>>(
    selectorFn: (s: CartDeliveryGroup) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDeliveryGroup()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one CartDeliveryGroup and a cursor during pagination.

 */
/* #__PURE__ */
export class CartDeliveryGroupEdge extends $Base<'CartDeliveryGroupEdge'> {
  constructor() {
    super('CartDeliveryGroupEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of CartDeliveryGroupEdge.
   */
  node<Sel extends Selection<CartDeliveryGroup>>(
    selectorFn: (s: CartDeliveryGroup) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDeliveryGroup()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Defines what type of merchandise is in the delivery group.

 */
export enum CartDeliveryGroupType {
  /**
   * The delivery group only contains subscription merchandise.
   */
  SUBSCRIPTION = 'SUBSCRIPTION',

  /**
 * The delivery group only contains merchandise that is either a one time purchase or a first delivery of
subscription merchandise.

 */
  ONE_TIME_PURCHASE = 'ONE_TIME_PURCHASE',
}

/**
 * Information about a delivery option.
 */
/* #__PURE__ */
export class CartDeliveryOption extends $Base<'CartDeliveryOption'> {
  constructor() {
    super('CartDeliveryOption');
  }

  /**
   * The code of the delivery option.
   */
  get code(): $Field<'code', string | null | undefined> {
    return this.$_select('code') as any;
  }

  /**
   * The method for the delivery option.
   */
  get deliveryMethodType(): $Field<'deliveryMethodType', DeliveryMethodType> {
    return this.$_select('deliveryMethodType') as any;
  }

  /**
   * The description of the delivery option.
   */
  get description(): $Field<'description', string | null | undefined> {
    return this.$_select('description') as any;
  }

  /**
   * The estimated cost for the delivery option.
   */
  estimatedCost<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'estimatedCost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('estimatedCost', options) as any;
  }

  /**
   * The unique identifier of the delivery option.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * The title of the delivery option.
   */
  get title(): $Field<'title', string | null | undefined> {
    return this.$_select('title') as any;
  }
}

/**
 * A set of preferences tied to the buyer interacting with the cart. Preferences are used to prefill fields in at checkout to streamline information collection. 
Preferences are not synced back to the cart if they are overwritten.

 */
/* #__PURE__ */
export class CartDeliveryPreference extends $Base<'CartDeliveryPreference'> {
  constructor() {
    super('CartDeliveryPreference');
  }

  /**
   * Preferred location used to find the closest pick up point based on coordinates.
   */
  coordinates<Sel extends Selection<CartDeliveryCoordinatesPreference>>(
    selectorFn: (s: CartDeliveryCoordinatesPreference) => [...Sel],
  ): $Field<'coordinates', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDeliveryCoordinatesPreference()),
    };
    return this.$_select('coordinates', options) as any;
  }

  /**
   * The preferred delivery methods such as shipping, local pickup or through pickup points.
   */
  get deliveryMethod(): $Field<'deliveryMethod', Readonly<Array<PreferenceDeliveryMethodType>>> {
    return this.$_select('deliveryMethod') as any;
  }

  /**
 * The pickup handle prefills checkout fields with the location for either local pickup or pickup points delivery methods.
It accepts both location ID for local pickup and external IDs for pickup points.

 */
  get pickupHandle(): $Field<'pickupHandle', Readonly<Array<string>>> {
    return this.$_select('pickupHandle') as any;
  }
}

/**
 * Delivery preferences can be used to prefill the delivery section at checkout.
 */
export type CartDeliveryPreferenceInput = {
  coordinates?: CartDeliveryCoordinatesPreferenceInput | null | undefined;
  deliveryMethod?: Readonly<Array<PreferenceDeliveryMethodType>> | null | undefined;
  pickupHandle?: Readonly<Array<string>> | null | undefined;
};

/**
 * The input fields for submitting direct payment method information for checkout.

 */
export type CartDirectPaymentMethodInput = {
  billingAddress: MailingAddressInput;
  cardSource?: CartCardSource | null | undefined;
  sessionId: string;
};

/**
 * The discounts that have been applied to the cart line.
 */
/* #__PURE__ */
export class CartDiscountAllocation extends $Interface<
  {
    CartAutomaticDiscountAllocation: CartAutomaticDiscountAllocation;
    CartCodeDiscountAllocation: CartCodeDiscountAllocation;
    CartCustomDiscountAllocation: CartCustomDiscountAllocation;
  },
  'CartDiscountAllocation'
> {
  constructor() {
    super(
      {
        CartAutomaticDiscountAllocation: CartAutomaticDiscountAllocation,
        CartCodeDiscountAllocation: CartCodeDiscountAllocation,
        CartCustomDiscountAllocation: CartCustomDiscountAllocation,
      },
      'CartDiscountAllocation',
    );
  }

  /**
   * The discounted amount that has been applied to the cart line.
   */
  discountedAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'discountedAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('discountedAmount', options) as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }
}

/**
 * The discount codes applied to the cart.
 */
/* #__PURE__ */
export class CartDiscountCode extends $Base<'CartDiscountCode'> {
  constructor() {
    super('CartDiscountCode');
  }

  /**
   * Whether the discount code is applicable to the cart's current contents.
   */
  get applicable(): $Field<'applicable', boolean> {
    return this.$_select('applicable') as any;
  }

  /**
   * The code for the discount.
   */
  get code(): $Field<'code', string> {
    return this.$_select('code') as any;
  }
}

/**
 * Return type for `cartDiscountCodesUpdate` mutation.
 */
/* #__PURE__ */
export class CartDiscountCodesUpdatePayload extends $Base<'CartDiscountCodesUpdatePayload'> {
  constructor() {
    super('CartDiscountCodesUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * Possible error codes that can be returned by `CartUserError`.
 */
export enum CartErrorCode {
  /**
   * The input value is invalid.
   */
  INVALID = 'INVALID',

  /**
   * The input value should be less than the maximum value allowed.
   */
  LESS_THAN = 'LESS_THAN',

  /**
   * Merchandise line was not found in cart.
   */
  INVALID_MERCHANDISE_LINE = 'INVALID_MERCHANDISE_LINE',

  /**
   * Missing discount code.
   */
  MISSING_DISCOUNT_CODE = 'MISSING_DISCOUNT_CODE',

  /**
   * Missing note.
   */
  MISSING_NOTE = 'MISSING_NOTE',

  /**
   * The note length must be below the specified maximum.
   */
  NOTE_TOO_LONG = 'NOTE_TOO_LONG',

  /**
   * Delivery group was not found in cart.
   */
  INVALID_DELIVERY_GROUP = 'INVALID_DELIVERY_GROUP',

  /**
   * Delivery option was not valid.
   */
  INVALID_DELIVERY_OPTION = 'INVALID_DELIVERY_OPTION',

  /**
   * The payment wasn't valid.
   */
  INVALID_PAYMENT = 'INVALID_PAYMENT',

  /**
   * The payment method is not supported.
   */
  PAYMENT_METHOD_NOT_SUPPORTED = 'PAYMENT_METHOD_NOT_SUPPORTED',

  /**
   * Cannot update payment on an empty cart
   */
  INVALID_PAYMENT_EMPTY_CART = 'INVALID_PAYMENT_EMPTY_CART',

  /**
   * Validation failed.
   */
  VALIDATION_CUSTOM = 'VALIDATION_CUSTOM',

  /**
   * The metafields were not valid.
   */
  INVALID_METAFIELDS = 'INVALID_METAFIELDS',

  /**
   * The customer access token is required when setting a company location.
   */
  MISSING_CUSTOMER_ACCESS_TOKEN = 'MISSING_CUSTOMER_ACCESS_TOKEN',

  /**
   * Company location not found or not allowed.
   */
  INVALID_COMPANY_LOCATION = 'INVALID_COMPANY_LOCATION',

  /**
   * The quantity must be a multiple of the specified increment.
   */
  INVALID_INCREMENT = 'INVALID_INCREMENT',

  /**
   * The quantity must be above the specified minimum for the item.
   */
  MINIMUM_NOT_MET = 'MINIMUM_NOT_MET',

  /**
   * The quantity must be below the specified maximum for the item.
   */
  MAXIMUM_EXCEEDED = 'MAXIMUM_EXCEEDED',

  /**
   * The specified address field is required.
   */
  ADDRESS_FIELD_IS_REQUIRED = 'ADDRESS_FIELD_IS_REQUIRED',

  /**
   * The specified address field is too long.
   */
  ADDRESS_FIELD_IS_TOO_LONG = 'ADDRESS_FIELD_IS_TOO_LONG',

  /**
   * The specified address field contains emojis.
   */
  ADDRESS_FIELD_CONTAINS_EMOJIS = 'ADDRESS_FIELD_CONTAINS_EMOJIS',

  /**
   * The specified address field contains HTML tags.
   */
  ADDRESS_FIELD_CONTAINS_HTML_TAGS = 'ADDRESS_FIELD_CONTAINS_HTML_TAGS',

  /**
   * The specified address field contains a URL.
   */
  ADDRESS_FIELD_CONTAINS_URL = 'ADDRESS_FIELD_CONTAINS_URL',

  /**
   * The specified address field does not match the expected pattern.
   */
  ADDRESS_FIELD_DOES_NOT_MATCH_EXPECTED_PATTERN = 'ADDRESS_FIELD_DOES_NOT_MATCH_EXPECTED_PATTERN',

  /**
   * The given zip code is invalid for the provided province.
   */
  INVALID_ZIP_CODE_FOR_PROVINCE = 'INVALID_ZIP_CODE_FOR_PROVINCE',

  /**
   * The given zip code is invalid for the provided country.
   */
  INVALID_ZIP_CODE_FOR_COUNTRY = 'INVALID_ZIP_CODE_FOR_COUNTRY',

  /**
   * The given zip code is unsupported.
   */
  ZIP_CODE_NOT_SUPPORTED = 'ZIP_CODE_NOT_SUPPORTED',

  /**
   * The given province cannot be found.
   */
  PROVINCE_NOT_FOUND = 'PROVINCE_NOT_FOUND',

  /**
   * A general error occurred during address validation.
   */
  UNSPECIFIED_ADDRESS_ERROR = 'UNSPECIFIED_ADDRESS_ERROR',
}

/**
 * The estimated costs that the buyer will pay at checkout. The estimated cost uses [`CartBuyerIdentity`](https://shopify.dev/api/storefront/reference/cart/cartbuyeridentity) to determine [international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing).
 */
/* #__PURE__ */
export class CartEstimatedCost extends $Base<'CartEstimatedCost'> {
  constructor() {
    super('CartEstimatedCost');
  }

  /**
   * The estimated amount, before taxes and discounts, for the customer to pay at checkout. The checkout charge amount doesn't include any deferred payments that'll be paid at a later date. If the cart has no deferred payments, then the checkout charge amount is equivalent to`subtotal_amount`.
   */
  checkoutChargeAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'checkoutChargeAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('checkoutChargeAmount', options) as any;
  }

  /**
   * The estimated amount, before taxes and discounts, for the customer to pay.
   */
  subtotalAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'subtotalAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('subtotalAmount', options) as any;
  }

  /**
   * The estimated total amount for the customer to pay.
   */
  totalAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalAmount', options) as any;
  }

  /**
   * The estimated duty amount for the customer to pay at checkout.
   */
  totalDutyAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalDutyAmount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalDutyAmount', options) as any;
  }

  /**
   * The estimated tax amount for the customer to pay at checkout.
   */
  totalTaxAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalTaxAmount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalTaxAmount', options) as any;
  }
}

/**
 * The input fields for submitting a billing address without a selected payment method.

 */
export type CartFreePaymentMethodInput = {
  billingAddress: MailingAddressInput;
};

/**
 * Return type for `cartGiftCardCodesUpdate` mutation.
 */
/* #__PURE__ */
export class CartGiftCardCodesUpdatePayload extends $Base<'CartGiftCardCodesUpdatePayload'> {
  constructor() {
    super('CartGiftCardCodesUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * The input fields to create a cart.
 */
export type CartInput = {
  attributes?: Readonly<Array<AttributeInput>> | null | undefined;
  buyerIdentity?: CartBuyerIdentityInput | null | undefined;
  discountCodes?: Readonly<Array<string>> | null | undefined;
  giftCardCodes?: Readonly<Array<string>> | null | undefined;
  lines?: Readonly<Array<CartLineInput>> | null | undefined;
  metafields?: Readonly<Array<CartInputMetafieldInput>> | null | undefined;
  note?: string | null | undefined;
};

/**
 * The input fields for a cart metafield value to set.
 */
export type CartInputMetafieldInput = {
  key: string;
  type: string;
  value: string;
};

/**
 * Represents information about the merchandise in the cart.
 */
/* #__PURE__ */
export class CartLine extends $Base<'CartLine'> {
  constructor() {
    super('CartLine');
  }

  /**
   * An attribute associated with the cart line.
   */
  attribute<
    Args extends VariabledInput<{
      key: string;
    }>,
    Sel extends Selection<Attribute>,
  >(
    args: ExactArgNames<
      Args,
      {
        key: string;
      }
    >,
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'attribute', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        key: 'String!',
      },
      args,

      selection: selectorFn(new Attribute()),
    };
    return this.$_select('attribute', options) as any;
  }

  /**
   * The attributes associated with the cart line. Attributes are represented as key-value pairs.
   */
  attributes<Sel extends Selection<Attribute>>(
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'attributes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Attribute()),
    };
    return this.$_select('attributes', options) as any;
  }

  /**
   * The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout.
   */
  cost<Sel extends Selection<CartLineCost>>(
    selectorFn: (s: CartLineCost) => [...Sel],
  ): $Field<'cost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartLineCost()),
    };
    return this.$_select('cost', options) as any;
  }

  /**
   * The discounts that have been applied to the cart line.
   */
  discountAllocations<Sel extends Selection<CartDiscountAllocation>>(
    selectorFn: (s: CartDiscountAllocation) => [...Sel],
  ): $Field<'discountAllocations', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDiscountAllocation()),
    };
    return this.$_select('discountAllocations', options) as any;
  }

  /**
   * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
   */
  estimatedCost<Sel extends Selection<CartLineEstimatedCost>>(
    selectorFn: (s: CartLineEstimatedCost) => [...Sel],
  ): $Field<'estimatedCost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartLineEstimatedCost()),
    };
    return this.$_select('estimatedCost', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The merchandise that the buyer intends to purchase.
   */
  merchandise<Sel extends Selection<Merchandise>>(
    selectorFn: (s: Merchandise) => [...Sel],
  ): $Field<'merchandise', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Merchandise()),
    };
    return this.$_select('merchandise', options) as any;
  }

  /**
   * The quantity of the merchandise that the customer intends to purchase.
   */
  get quantity(): $Field<'quantity', number> {
    return this.$_select('quantity') as any;
  }

  /**
   * The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased.
   */
  sellingPlanAllocation<Sel extends Selection<SellingPlanAllocation>>(
    selectorFn: (s: SellingPlanAllocation) => [...Sel],
  ): $Field<'sellingPlanAllocation', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanAllocation()),
    };
    return this.$_select('sellingPlanAllocation', options) as any;
  }
}

/**
 * The cost of the merchandise line that the buyer will pay at checkout.
 */
/* #__PURE__ */
export class CartLineCost extends $Base<'CartLineCost'> {
  constructor() {
    super('CartLineCost');
  }

  /**
   * The amount of the merchandise line.
   */
  amountPerQuantity<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'amountPerQuantity', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('amountPerQuantity', options) as any;
  }

  /**
   * The compare at amount of the merchandise line.
   */
  compareAtAmountPerQuantity<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'compareAtAmountPerQuantity', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('compareAtAmountPerQuantity', options) as any;
  }

  /**
   * The cost of the merchandise line before line-level discounts.
   */
  subtotalAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'subtotalAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('subtotalAmount', options) as any;
  }

  /**
   * The total cost of the merchandise line.
   */
  totalAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalAmount', options) as any;
  }
}

/**
 * The estimated cost of the merchandise line that the buyer will pay at checkout.

 */
/* #__PURE__ */
export class CartLineEstimatedCost extends $Base<'CartLineEstimatedCost'> {
  constructor() {
    super('CartLineEstimatedCost');
  }

  /**
   * The amount of the merchandise line.
   */
  amount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'amount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('amount', options) as any;
  }

  /**
   * The compare at amount of the merchandise line.
   */
  compareAtAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'compareAtAmount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('compareAtAmount', options) as any;
  }

  /**
   * The estimated cost of the merchandise line before discounts.
   */
  subtotalAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'subtotalAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('subtotalAmount', options) as any;
  }

  /**
   * The estimated total cost of the merchandise line.
   */
  totalAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalAmount', options) as any;
  }
}

/**
 * The input fields to create a merchandise line on a cart.
 */
export type CartLineInput = {
  attributes?: Readonly<Array<AttributeInput>> | null | undefined;
  merchandiseId: string;
  quantity?: number | null | undefined;
  sellingPlanId?: string | null | undefined;
};

/**
 * The input fields to update a line item on a cart.
 */
export type CartLineUpdateInput = {
  attributes?: Readonly<Array<AttributeInput>> | null | undefined;
  id: string;
  merchandiseId?: string | null | undefined;
  quantity?: number | null | undefined;
  sellingPlanId?: string | null | undefined;
};

/**
 * Return type for `cartLinesAdd` mutation.
 */
/* #__PURE__ */
export class CartLinesAddPayload extends $Base<'CartLinesAddPayload'> {
  constructor() {
    super('CartLinesAddPayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * Return type for `cartLinesRemove` mutation.
 */
/* #__PURE__ */
export class CartLinesRemovePayload extends $Base<'CartLinesRemovePayload'> {
  constructor() {
    super('CartLinesRemovePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * Return type for `cartLinesUpdate` mutation.
 */
/* #__PURE__ */
export class CartLinesUpdatePayload extends $Base<'CartLinesUpdatePayload'> {
  constructor() {
    super('CartLinesUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * The input fields to delete a cart metafield.
 */
export type CartMetafieldDeleteInput = {
  key: string;
  ownerId: string;
};

/**
 * Return type for `cartMetafieldDelete` mutation.
 */
/* #__PURE__ */
export class CartMetafieldDeletePayload extends $Base<'CartMetafieldDeletePayload'> {
  constructor() {
    super('CartMetafieldDeletePayload');
  }

  /**
   * The ID of the deleted cart metafield.
   */
  get deletedId(): $Field<'deletedId', string | null | undefined> {
    return this.$_select('deletedId') as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<MetafieldDeleteUserError>>(
    selectorFn: (s: MetafieldDeleteUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetafieldDeleteUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * The input fields for a cart metafield value to set.
 */
export type CartMetafieldsSetInput = {
  key: string;
  ownerId: string;
  type: string;
  value: string;
};

/**
 * Return type for `cartMetafieldsSet` mutation.
 */
/* #__PURE__ */
export class CartMetafieldsSetPayload extends $Base<'CartMetafieldsSetPayload'> {
  constructor() {
    super('CartMetafieldsSetPayload');
  }

  /**
   * The list of cart metafields that were set.
   */
  metafields<Sel extends Selection<Metafield>>(
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel>> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<MetafieldsSetUserError>>(
    selectorFn: (s: MetafieldsSetUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetafieldsSetUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `cartNoteUpdate` mutation.
 */
/* #__PURE__ */
export class CartNoteUpdatePayload extends $Base<'CartNoteUpdatePayload'> {
  constructor() {
    super('CartNoteUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * The input fields for updating the payment method that will be used to checkout.

 */
export type CartPaymentInput = {
  amount: MoneyInput;
  directPaymentMethod?: CartDirectPaymentMethodInput | null | undefined;
  freePaymentMethod?: CartFreePaymentMethodInput | null | undefined;
  sourceIdentifier?: string | null | undefined;
  walletPaymentMethod?: CartWalletPaymentMethodInput | null | undefined;
};

/**
 * Return type for `cartPaymentUpdate` mutation.
 */
/* #__PURE__ */
export class CartPaymentUpdatePayload extends $Base<'CartPaymentUpdatePayload'> {
  constructor() {
    super('CartPaymentUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * A set of preferences tied to the buyer interacting with the cart. Preferences are used to prefill fields in at checkout to streamline information collection. 
Preferences are not synced back to the cart if they are overwritten.

 */
/* #__PURE__ */
export class CartPreferences extends $Base<'CartPreferences'> {
  constructor() {
    super('CartPreferences');
  }

  /**
   * Delivery preferences can be used to prefill the delivery section in at checkout.
   */
  delivery<Sel extends Selection<CartDeliveryPreference>>(
    selectorFn: (s: CartDeliveryPreference) => [...Sel],
  ): $Field<'delivery', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDeliveryPreference()),
    };
    return this.$_select('delivery', options) as any;
  }

  /**
 * Wallet preferences are used to populate relevant payment fields in the checkout flow.
Accepted value: `["shop_pay"]`.

 */
  get wallet(): $Field<'wallet', Readonly<Array<string>> | null | undefined> {
    return this.$_select('wallet') as any;
  }
}

/**
 * The input fields represent preferences for the buyer that is interacting with the cart.
 */
export type CartPreferencesInput = {
  delivery?: CartDeliveryPreferenceInput | null | undefined;
  wallet?: Readonly<Array<string>> | null | undefined;
};

/**
 * The input fields for updating the selected delivery options for a delivery group.

 */
export type CartSelectedDeliveryOptionInput = {
  deliveryGroupId: string;
  deliveryOptionHandle: string;
};

/**
 * Return type for `cartSelectedDeliveryOptionsUpdate` mutation.
 */
/* #__PURE__ */
export class CartSelectedDeliveryOptionsUpdatePayload extends $Base<'CartSelectedDeliveryOptionsUpdatePayload'> {
  constructor() {
    super('CartSelectedDeliveryOptionsUpdatePayload');
  }

  /**
   * The updated cart.
   */
  cart<Sel extends Selection<Cart>>(
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }

  /**
   * A list of warnings that occurred during the mutation.
   */
  warnings<Sel extends Selection<CartWarning>>(
    selectorFn: (s: CartWarning) => [...Sel],
  ): $Field<'warnings', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartWarning()),
    };
    return this.$_select('warnings', options) as any;
  }
}

/**
 * Return type for `cartSubmitForCompletion` mutation.
 */
/* #__PURE__ */
export class CartSubmitForCompletionPayload extends $Base<'CartSubmitForCompletionPayload'> {
  constructor() {
    super('CartSubmitForCompletionPayload');
  }

  /**
   * The result of cart submission for completion.
   */
  result<Sel extends Selection<CartSubmitForCompletionResult>>(
    selectorFn: (s: CartSubmitForCompletionResult) => [...Sel],
  ): $Field<'result', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartSubmitForCompletionResult()),
    };
    return this.$_select('result', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<CartUserError>>(
    selectorFn: (s: CartUserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartUserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * The result of cart submit completion.
 */
/* #__PURE__ */
export class CartSubmitForCompletionResult extends $Union<
  {
    SubmitAlreadyAccepted: SubmitAlreadyAccepted;
    SubmitFailed: SubmitFailed;
    SubmitSuccess: SubmitSuccess;
    SubmitThrottled: SubmitThrottled;
  },
  'CartSubmitForCompletionResult'
> {
  constructor() {
    super(
      {
        SubmitAlreadyAccepted: SubmitAlreadyAccepted,
        SubmitFailed: SubmitFailed,
        SubmitSuccess: SubmitSuccess,
        SubmitThrottled: SubmitThrottled,
      },
      'CartSubmitForCompletionResult',
    );
  }
}

/**
 * Represents an error that happens during execution of a cart mutation.
 */
/* #__PURE__ */
export class CartUserError extends $Base<'CartUserError'> {
  constructor() {
    super('CartUserError');
  }

  /**
   * The error code.
   */
  get code(): $Field<'code', CartErrorCode | null | undefined> {
    return this.$_select('code') as any;
  }

  /**
   * The path to the input field that caused the error.
   */
  get field(): $Field<'field', Readonly<Array<string>> | null | undefined> {
    return this.$_select('field') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string> {
    return this.$_select('message') as any;
  }
}

/**
 * The input fields for submitting wallet payment method information for checkout.

 */
export type CartWalletPaymentMethodInput = {
  applePayWalletContent?: ApplePayWalletContentInput | null | undefined;
  shopPayWalletContent?: ShopPayWalletContentInput | null | undefined;
};

/**
 * A warning that occurred during a cart mutation.
 */
/* #__PURE__ */
export class CartWarning extends $Base<'CartWarning'> {
  constructor() {
    super('CartWarning');
  }

  /**
   * The code of the warning.
   */
  get code(): $Field<'code', CartWarningCode> {
    return this.$_select('code') as any;
  }

  /**
   * The message text of the warning.
   */
  get message(): $Field<'message', string> {
    return this.$_select('message') as any;
  }

  /**
   * The target of the warning.
   */
  get target(): $Field<'target', string> {
    return this.$_select('target') as any;
  }
}

/**
 * The code for the cart warning.
 */
export enum CartWarningCode {
  /**
   * The merchandise does not have enough stock.
   */
  MERCHANDISE_NOT_ENOUGH_STOCK = 'MERCHANDISE_NOT_ENOUGH_STOCK',

  /**
   * The merchandise is out of stock.
   */
  MERCHANDISE_OUT_OF_STOCK = 'MERCHANDISE_OUT_OF_STOCK',

  /**
   * Gift cards are not available as a payment method.
   */
  PAYMENTS_GIFT_CARDS_UNAVAILABLE = 'PAYMENTS_GIFT_CARDS_UNAVAILABLE',
}

/**
 * A collection represents a grouping of products that a shop owner can create to
organize them or make their shops easier to browse.

 */
/* #__PURE__ */
export class Collection extends $Base<'Collection'> {
  constructor() {
    super('Collection');
  }

  /**
   * Stripped description of the collection, single line with HTML tags removed.
   */
  description<
    Args extends VariabledInput<{
      truncateAt?: number | null | undefined;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        truncateAt?: number | null | undefined;
      }
    >,
  ): $Field<'description', string, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        truncateAt: 'Int',
      },
      args,
    };
    return this.$_select('description', options) as any;
  }

  /**
   * The description of the collection, complete with HTML formatting.
   */
  get descriptionHtml(): $Field<'descriptionHtml', HTML> {
    return this.$_select('descriptionHtml') as any;
  }

  /**
 * A human-friendly unique string for the collection automatically generated from its title.
Limit of 255 characters.

 */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Image associated with the collection.
   */
  image<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('image', options) as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel.
   */
  get onlineStoreUrl(): $Field<'onlineStoreUrl', URL | null | undefined> {
    return this.$_select('onlineStoreUrl') as any;
  }

  /**
   * List of products in the collection.
   */
  products<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: ProductCollectionSortKeys | null | undefined;
      filters?: Readonly<Array<ProductFilter>> | null | undefined;
    }>,
    Sel extends Selection<ProductConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: ProductCollectionSortKeys | null | undefined;
        filters?: Readonly<Array<ProductFilter>> | null | undefined;
      }
    >,
    selectorFn: (s: ProductConnection) => [...Sel],
  ): $Field<'products', GetOutput<Sel>, GetVariables<Sel, Args>>;
  products<Sel extends Selection<ProductConnection>>(
    selectorFn: (s: ProductConnection) => [...Sel],
  ): $Field<'products', GetOutput<Sel>, GetVariables<Sel>>;
  products(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'ProductCollectionSortKeys',
        filters: '[ProductFilter!]',
      },
      args,

      selection: selectorFn(new ProductConnection()),
    };
    return this.$_select('products', options) as any;
  }

  /**
   * The collection's SEO information.
   */
  seo<Sel extends Selection<SEO>>(selectorFn: (s: SEO) => [...Sel]): $Field<'seo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SEO()),
    };
    return this.$_select('seo', options) as any;
  }

  /**
   * The collection’s name. Limit of 255 characters.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null.
   */
  get trackingParameters(): $Field<'trackingParameters', string | null | undefined> {
    return this.$_select('trackingParameters') as any;
  }

  /**
   * The date and time when the collection was last modified.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Collections.

 */
/* #__PURE__ */
export class CollectionConnection extends $Base<'CollectionConnection'> {
  constructor() {
    super('CollectionConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<CollectionEdge>>(
    selectorFn: (s: CollectionEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CollectionEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in CollectionEdge.
   */
  nodes<Sel extends Selection<Collection>>(
    selectorFn: (s: Collection) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Collection()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }

  /**
   * The total count of Collections.
   */
  get totalCount(): $Field<'totalCount', UnsignedInt64> {
    return this.$_select('totalCount') as any;
  }
}

/**
 * An auto-generated type which holds one Collection and a cursor during pagination.

 */
/* #__PURE__ */
export class CollectionEdge extends $Base<'CollectionEdge'> {
  constructor() {
    super('CollectionEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of CollectionEdge.
   */
  node<Sel extends Selection<Collection>>(
    selectorFn: (s: Collection) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Collection()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The set of valid sort keys for the Collection query.
 */
export enum CollectionSortKeys {
  /**
   * Sort by the `title` value.
   */
  TITLE = 'TITLE',

  /**
   * Sort by the `updated_at` value.
   */
  UPDATED_AT = 'UPDATED_AT',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * A string containing a hexadecimal representation of a color.

For example, "#6A8D48".

 */
export type Color = string;

/**
 * A comment on an article.
 */
/* #__PURE__ */
export class Comment extends $Base<'Comment'> {
  constructor() {
    super('Comment');
  }

  /**
   * The comment’s author.
   */
  author<Sel extends Selection<CommentAuthor>>(
    selectorFn: (s: CommentAuthor) => [...Sel],
  ): $Field<'author', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CommentAuthor()),
    };
    return this.$_select('author', options) as any;
  }

  /**
   * Stripped content of the comment, single line with HTML tags removed.
   */
  content<
    Args extends VariabledInput<{
      truncateAt?: number | null | undefined;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        truncateAt?: number | null | undefined;
      }
    >,
  ): $Field<'content', string, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        truncateAt: 'Int',
      },
      args,
    };
    return this.$_select('content', options) as any;
  }

  /**
   * The content of the comment, complete with HTML formatting.
   */
  get contentHtml(): $Field<'contentHtml', HTML> {
    return this.$_select('contentHtml') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }
}

/**
 * The author of a comment.
 */
/* #__PURE__ */
export class CommentAuthor extends $Base<'CommentAuthor'> {
  constructor() {
    super('CommentAuthor');
  }

  /**
   * The author's email.
   */
  get email(): $Field<'email', string> {
    return this.$_select('email') as any;
  }

  /**
   * The author’s name.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Comments.

 */
/* #__PURE__ */
export class CommentConnection extends $Base<'CommentConnection'> {
  constructor() {
    super('CommentConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<CommentEdge>>(
    selectorFn: (s: CommentEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CommentEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in CommentEdge.
   */
  nodes<Sel extends Selection<Comment>>(
    selectorFn: (s: Comment) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Comment()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one Comment and a cursor during pagination.

 */
/* #__PURE__ */
export class CommentEdge extends $Base<'CommentEdge'> {
  constructor() {
    super('CommentEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of CommentEdge.
   */
  node<Sel extends Selection<Comment>>(
    selectorFn: (s: Comment) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Comment()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Represents information about a company which is also a customer of the shop.
 */
/* #__PURE__ */
export class Company extends $Base<'Company'> {
  constructor() {
    super('Company');
  }

  /**
   * The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company was created in Shopify.
   */
  get createdAt(): $Field<'createdAt', DateTime> {
    return this.$_select('createdAt') as any;
  }

  /**
   * A unique externally-supplied ID for the company.
   */
  get externalId(): $Field<'externalId', string | null | undefined> {
    return this.$_select('externalId') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The name of the company.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company was last modified.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * A company's main point of contact.
 */
/* #__PURE__ */
export class CompanyContact extends $Base<'CompanyContact'> {
  constructor() {
    super('CompanyContact');
  }

  /**
   * The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company contact was created in Shopify.
   */
  get createdAt(): $Field<'createdAt', DateTime> {
    return this.$_select('createdAt') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The company contact's locale (language).
   */
  get locale(): $Field<'locale', string | null | undefined> {
    return this.$_select('locale') as any;
  }

  /**
   * The company contact's job title.
   */
  get title(): $Field<'title', string | null | undefined> {
    return this.$_select('title') as any;
  }

  /**
   * The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company contact was last modified.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * A company's location.
 */
/* #__PURE__ */
export class CompanyLocation extends $Base<'CompanyLocation'> {
  constructor() {
    super('CompanyLocation');
  }

  /**
   * The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company location was created in Shopify.
   */
  get createdAt(): $Field<'createdAt', DateTime> {
    return this.$_select('createdAt') as any;
  }

  /**
   * A unique externally-supplied ID for the company.
   */
  get externalId(): $Field<'externalId', string | null | undefined> {
    return this.$_select('externalId') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The preferred locale of the company location.
   */
  get locale(): $Field<'locale', string | null | undefined> {
    return this.$_select('locale') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The name of the company location.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The date and time ([ISO 8601 format](http://en.wikipedia.org/wiki/ISO_8601)) at which the company location was last modified.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * The action for the 3DS payment redirect.
 */
/* #__PURE__ */
export class CompletePaymentChallenge extends $Base<'CompletePaymentChallenge'> {
  constructor() {
    super('CompletePaymentChallenge');
  }

  /**
   * The URL for the 3DS payment redirect.
   */
  get redirectUrl(): $Field<'redirectUrl', URL | null | undefined> {
    return this.$_select('redirectUrl') as any;
  }
}

/**
 * An error that occurred during a cart completion attempt.
 */
/* #__PURE__ */
export class CompletionError extends $Base<'CompletionError'> {
  constructor() {
    super('CompletionError');
  }

  /**
   * The error code.
   */
  get code(): $Field<'code', CompletionErrorCode> {
    return this.$_select('code') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string | null | undefined> {
    return this.$_select('message') as any;
  }
}

/**
 * The code of the error that occurred during a cart completion attempt.
 */
export enum CompletionErrorCode {
  ERROR = 'ERROR',

  INVENTORY_RESERVATION_ERROR = 'INVENTORY_RESERVATION_ERROR',

  PAYMENT_ERROR = 'PAYMENT_ERROR',

  PAYMENT_TRANSIENT_ERROR = 'PAYMENT_TRANSIENT_ERROR',

  PAYMENT_AMOUNT_TOO_SMALL = 'PAYMENT_AMOUNT_TOO_SMALL',

  PAYMENT_GATEWAY_NOT_ENABLED_ERROR = 'PAYMENT_GATEWAY_NOT_ENABLED_ERROR',

  PAYMENT_INSUFFICIENT_FUNDS = 'PAYMENT_INSUFFICIENT_FUNDS',

  PAYMENT_INVALID_PAYMENT_METHOD = 'PAYMENT_INVALID_PAYMENT_METHOD',

  PAYMENT_INVALID_CURRENCY = 'PAYMENT_INVALID_CURRENCY',

  PAYMENT_INVALID_CREDIT_CARD = 'PAYMENT_INVALID_CREDIT_CARD',

  PAYMENT_INVALID_BILLING_ADDRESS = 'PAYMENT_INVALID_BILLING_ADDRESS',

  PAYMENT_CARD_DECLINED = 'PAYMENT_CARD_DECLINED',

  PAYMENT_CALL_ISSUER = 'PAYMENT_CALL_ISSUER',
}

/**
 * Represents information about the grouped merchandise in the cart.
 */
/* #__PURE__ */
export class ComponentizableCartLine extends $Base<'ComponentizableCartLine'> {
  constructor() {
    super('ComponentizableCartLine');
  }

  /**
   * An attribute associated with the cart line.
   */
  attribute<
    Args extends VariabledInput<{
      key: string;
    }>,
    Sel extends Selection<Attribute>,
  >(
    args: ExactArgNames<
      Args,
      {
        key: string;
      }
    >,
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'attribute', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        key: 'String!',
      },
      args,

      selection: selectorFn(new Attribute()),
    };
    return this.$_select('attribute', options) as any;
  }

  /**
   * The attributes associated with the cart line. Attributes are represented as key-value pairs.
   */
  attributes<Sel extends Selection<Attribute>>(
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'attributes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Attribute()),
    };
    return this.$_select('attributes', options) as any;
  }

  /**
   * The cost of the merchandise that the buyer will pay for at checkout. The costs are subject to change and changes will be reflected at checkout.
   */
  cost<Sel extends Selection<CartLineCost>>(
    selectorFn: (s: CartLineCost) => [...Sel],
  ): $Field<'cost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartLineCost()),
    };
    return this.$_select('cost', options) as any;
  }

  /**
   * The discounts that have been applied to the cart line.
   */
  discountAllocations<Sel extends Selection<CartDiscountAllocation>>(
    selectorFn: (s: CartDiscountAllocation) => [...Sel],
  ): $Field<'discountAllocations', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartDiscountAllocation()),
    };
    return this.$_select('discountAllocations', options) as any;
  }

  /**
   * The estimated cost of the merchandise that the buyer will pay for at checkout. The estimated costs are subject to change and changes will be reflected at checkout.
   */
  estimatedCost<Sel extends Selection<CartLineEstimatedCost>>(
    selectorFn: (s: CartLineEstimatedCost) => [...Sel],
  ): $Field<'estimatedCost', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartLineEstimatedCost()),
    };
    return this.$_select('estimatedCost', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The components of the line item.
   */
  lineComponents<Sel extends Selection<CartLine>>(
    selectorFn: (s: CartLine) => [...Sel],
  ): $Field<'lineComponents', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CartLine()),
    };
    return this.$_select('lineComponents', options) as any;
  }

  /**
   * The merchandise that the buyer intends to purchase.
   */
  merchandise<Sel extends Selection<Merchandise>>(
    selectorFn: (s: Merchandise) => [...Sel],
  ): $Field<'merchandise', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Merchandise()),
    };
    return this.$_select('merchandise', options) as any;
  }

  /**
   * The quantity of the merchandise that the customer intends to purchase.
   */
  get quantity(): $Field<'quantity', number> {
    return this.$_select('quantity') as any;
  }

  /**
   * The selling plan associated with the cart line and the effect that each selling plan has on variants when they're purchased.
   */
  sellingPlanAllocation<Sel extends Selection<SellingPlanAllocation>>(
    selectorFn: (s: SellingPlanAllocation) => [...Sel],
  ): $Field<'sellingPlanAllocation', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanAllocation()),
    };
    return this.$_select('sellingPlanAllocation', options) as any;
  }
}

/**
 * Details for count of elements.
 */
/* #__PURE__ */
export class Count extends $Base<'Count'> {
  constructor() {
    super('Count');
  }

  /**
   * Count of elements.
   */
  get count(): $Field<'count', number> {
    return this.$_select('count') as any;
  }

  /**
   * Precision of count, how exact is the value.
   */
  get precision(): $Field<'precision', CountPrecision> {
    return this.$_select('precision') as any;
  }
}

/**
 * The precision of the value returned by a count field.
 */
export enum CountPrecision {
  /**
   * The count is exactly the value.
   */
  EXACT = 'EXACT',

  /**
   * The count is at least the value. A limit was reached.
   */
  AT_LEAST = 'AT_LEAST',
}

/**
 * A country.
 */
/* #__PURE__ */
export class Country extends $Base<'Country'> {
  constructor() {
    super('Country');
  }

  /**
   * The languages available for the country.
   */
  availableLanguages<Sel extends Selection<Language>>(
    selectorFn: (s: Language) => [...Sel],
  ): $Field<'availableLanguages', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Language()),
    };
    return this.$_select('availableLanguages', options) as any;
  }

  /**
   * The currency of the country.
   */
  currency<Sel extends Selection<Currency>>(
    selectorFn: (s: Currency) => [...Sel],
  ): $Field<'currency', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Currency()),
    };
    return this.$_select('currency', options) as any;
  }

  /**
   * The ISO code of the country.
   */
  get isoCode(): $Field<'isoCode', CountryCode> {
    return this.$_select('isoCode') as any;
  }

  /**
   * The market that includes this country.
   */
  market<Sel extends Selection<Market>>(
    selectorFn: (s: Market) => [...Sel],
  ): $Field<'market', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Market()),
    };
    return this.$_select('market', options) as any;
  }

  /**
   * The name of the country.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The unit system used in the country.
   */
  get unitSystem(): $Field<'unitSystem', UnitSystem> {
    return this.$_select('unitSystem') as any;
  }
}

/**
 * The code designating a country/region, which generally follows ISO 3166-1 alpha-2 guidelines.
If a territory doesn't have a country code value in the `CountryCode` enum, then it might be considered a subdivision
of another country. For example, the territories associated with Spain are represented by the country code `ES`,
and the territories associated with the United States of America are represented by the country code `US`.

 */
export enum CountryCode {
  /**
   * Afghanistan.
   */
  AF = 'AF',

  /**
   * Åland Islands.
   */
  AX = 'AX',

  /**
   * Albania.
   */
  AL = 'AL',

  /**
   * Algeria.
   */
  DZ = 'DZ',

  /**
   * Andorra.
   */
  AD = 'AD',

  /**
   * Angola.
   */
  AO = 'AO',

  /**
   * Anguilla.
   */
  AI = 'AI',

  /**
   * Antigua & Barbuda.
   */
  AG = 'AG',

  /**
   * Argentina.
   */
  AR = 'AR',

  /**
   * Armenia.
   */
  AM = 'AM',

  /**
   * Aruba.
   */
  AW = 'AW',

  /**
   * Ascension Island.
   */
  AC = 'AC',

  /**
   * Australia.
   */
  AU = 'AU',

  /**
   * Austria.
   */
  AT = 'AT',

  /**
   * Azerbaijan.
   */
  AZ = 'AZ',

  /**
   * Bahamas.
   */
  BS = 'BS',

  /**
   * Bahrain.
   */
  BH = 'BH',

  /**
   * Bangladesh.
   */
  BD = 'BD',

  /**
   * Barbados.
   */
  BB = 'BB',

  /**
   * Belarus.
   */
  BY = 'BY',

  /**
   * Belgium.
   */
  BE = 'BE',

  /**
   * Belize.
   */
  BZ = 'BZ',

  /**
   * Benin.
   */
  BJ = 'BJ',

  /**
   * Bermuda.
   */
  BM = 'BM',

  /**
   * Bhutan.
   */
  BT = 'BT',

  /**
   * Bolivia.
   */
  BO = 'BO',

  /**
   * Bosnia & Herzegovina.
   */
  BA = 'BA',

  /**
   * Botswana.
   */
  BW = 'BW',

  /**
   * Bouvet Island.
   */
  BV = 'BV',

  /**
   * Brazil.
   */
  BR = 'BR',

  /**
   * British Indian Ocean Territory.
   */
  IO = 'IO',

  /**
   * Brunei.
   */
  BN = 'BN',

  /**
   * Bulgaria.
   */
  BG = 'BG',

  /**
   * Burkina Faso.
   */
  BF = 'BF',

  /**
   * Burundi.
   */
  BI = 'BI',

  /**
   * Cambodia.
   */
  KH = 'KH',

  /**
   * Canada.
   */
  CA = 'CA',

  /**
   * Cape Verde.
   */
  CV = 'CV',

  /**
   * Caribbean Netherlands.
   */
  BQ = 'BQ',

  /**
   * Cayman Islands.
   */
  KY = 'KY',

  /**
   * Central African Republic.
   */
  CF = 'CF',

  /**
   * Chad.
   */
  TD = 'TD',

  /**
   * Chile.
   */
  CL = 'CL',

  /**
   * China.
   */
  CN = 'CN',

  /**
   * Christmas Island.
   */
  CX = 'CX',

  /**
   * Cocos (Keeling) Islands.
   */
  CC = 'CC',

  /**
   * Colombia.
   */
  CO = 'CO',

  /**
   * Comoros.
   */
  KM = 'KM',

  /**
   * Congo - Brazzaville.
   */
  CG = 'CG',

  /**
   * Congo - Kinshasa.
   */
  CD = 'CD',

  /**
   * Cook Islands.
   */
  CK = 'CK',

  /**
   * Costa Rica.
   */
  CR = 'CR',

  /**
   * Croatia.
   */
  HR = 'HR',

  /**
   * Cuba.
   */
  CU = 'CU',

  /**
   * Curaçao.
   */
  CW = 'CW',

  /**
   * Cyprus.
   */
  CY = 'CY',

  /**
   * Czechia.
   */
  CZ = 'CZ',

  /**
   * Côte d’Ivoire.
   */
  CI = 'CI',

  /**
   * Denmark.
   */
  DK = 'DK',

  /**
   * Djibouti.
   */
  DJ = 'DJ',

  /**
   * Dominica.
   */
  DM = 'DM',

  /**
   * Dominican Republic.
   */
  DO = 'DO',

  /**
   * Ecuador.
   */
  EC = 'EC',

  /**
   * Egypt.
   */
  EG = 'EG',

  /**
   * El Salvador.
   */
  SV = 'SV',

  /**
   * Equatorial Guinea.
   */
  GQ = 'GQ',

  /**
   * Eritrea.
   */
  ER = 'ER',

  /**
   * Estonia.
   */
  EE = 'EE',

  /**
   * Eswatini.
   */
  SZ = 'SZ',

  /**
   * Ethiopia.
   */
  ET = 'ET',

  /**
   * Falkland Islands.
   */
  FK = 'FK',

  /**
   * Faroe Islands.
   */
  FO = 'FO',

  /**
   * Fiji.
   */
  FJ = 'FJ',

  /**
   * Finland.
   */
  FI = 'FI',

  /**
   * France.
   */
  FR = 'FR',

  /**
   * French Guiana.
   */
  GF = 'GF',

  /**
   * French Polynesia.
   */
  PF = 'PF',

  /**
   * French Southern Territories.
   */
  TF = 'TF',

  /**
   * Gabon.
   */
  GA = 'GA',

  /**
   * Gambia.
   */
  GM = 'GM',

  /**
   * Georgia.
   */
  GE = 'GE',

  /**
   * Germany.
   */
  DE = 'DE',

  /**
   * Ghana.
   */
  GH = 'GH',

  /**
   * Gibraltar.
   */
  GI = 'GI',

  /**
   * Greece.
   */
  GR = 'GR',

  /**
   * Greenland.
   */
  GL = 'GL',

  /**
   * Grenada.
   */
  GD = 'GD',

  /**
   * Guadeloupe.
   */
  GP = 'GP',

  /**
   * Guatemala.
   */
  GT = 'GT',

  /**
   * Guernsey.
   */
  GG = 'GG',

  /**
   * Guinea.
   */
  GN = 'GN',

  /**
   * Guinea-Bissau.
   */
  GW = 'GW',

  /**
   * Guyana.
   */
  GY = 'GY',

  /**
   * Haiti.
   */
  HT = 'HT',

  /**
   * Heard & McDonald Islands.
   */
  HM = 'HM',

  /**
   * Vatican City.
   */
  VA = 'VA',

  /**
   * Honduras.
   */
  HN = 'HN',

  /**
   * Hong Kong SAR.
   */
  HK = 'HK',

  /**
   * Hungary.
   */
  HU = 'HU',

  /**
   * Iceland.
   */
  IS = 'IS',

  /**
   * India.
   */
  IN = 'IN',

  /**
   * Indonesia.
   */
  ID = 'ID',

  /**
   * Iran.
   */
  IR = 'IR',

  /**
   * Iraq.
   */
  IQ = 'IQ',

  /**
   * Ireland.
   */
  IE = 'IE',

  /**
   * Isle of Man.
   */
  IM = 'IM',

  /**
   * Israel.
   */
  IL = 'IL',

  /**
   * Italy.
   */
  IT = 'IT',

  /**
   * Jamaica.
   */
  JM = 'JM',

  /**
   * Japan.
   */
  JP = 'JP',

  /**
   * Jersey.
   */
  JE = 'JE',

  /**
   * Jordan.
   */
  JO = 'JO',

  /**
   * Kazakhstan.
   */
  KZ = 'KZ',

  /**
   * Kenya.
   */
  KE = 'KE',

  /**
   * Kiribati.
   */
  KI = 'KI',

  /**
   * North Korea.
   */
  KP = 'KP',

  /**
   * Kosovo.
   */
  XK = 'XK',

  /**
   * Kuwait.
   */
  KW = 'KW',

  /**
   * Kyrgyzstan.
   */
  KG = 'KG',

  /**
   * Laos.
   */
  LA = 'LA',

  /**
   * Latvia.
   */
  LV = 'LV',

  /**
   * Lebanon.
   */
  LB = 'LB',

  /**
   * Lesotho.
   */
  LS = 'LS',

  /**
   * Liberia.
   */
  LR = 'LR',

  /**
   * Libya.
   */
  LY = 'LY',

  /**
   * Liechtenstein.
   */
  LI = 'LI',

  /**
   * Lithuania.
   */
  LT = 'LT',

  /**
   * Luxembourg.
   */
  LU = 'LU',

  /**
   * Macao SAR.
   */
  MO = 'MO',

  /**
   * Madagascar.
   */
  MG = 'MG',

  /**
   * Malawi.
   */
  MW = 'MW',

  /**
   * Malaysia.
   */
  MY = 'MY',

  /**
   * Maldives.
   */
  MV = 'MV',

  /**
   * Mali.
   */
  ML = 'ML',

  /**
   * Malta.
   */
  MT = 'MT',

  /**
   * Martinique.
   */
  MQ = 'MQ',

  /**
   * Mauritania.
   */
  MR = 'MR',

  /**
   * Mauritius.
   */
  MU = 'MU',

  /**
   * Mayotte.
   */
  YT = 'YT',

  /**
   * Mexico.
   */
  MX = 'MX',

  /**
   * Moldova.
   */
  MD = 'MD',

  /**
   * Monaco.
   */
  MC = 'MC',

  /**
   * Mongolia.
   */
  MN = 'MN',

  /**
   * Montenegro.
   */
  ME = 'ME',

  /**
   * Montserrat.
   */
  MS = 'MS',

  /**
   * Morocco.
   */
  MA = 'MA',

  /**
   * Mozambique.
   */
  MZ = 'MZ',

  /**
   * Myanmar (Burma).
   */
  MM = 'MM',

  /**
   * Namibia.
   */
  NA = 'NA',

  /**
   * Nauru.
   */
  NR = 'NR',

  /**
   * Nepal.
   */
  NP = 'NP',

  /**
   * Netherlands.
   */
  NL = 'NL',

  /**
   * Netherlands Antilles.
   */
  AN = 'AN',

  /**
   * New Caledonia.
   */
  NC = 'NC',

  /**
   * New Zealand.
   */
  NZ = 'NZ',

  /**
   * Nicaragua.
   */
  NI = 'NI',

  /**
   * Niger.
   */
  NE = 'NE',

  /**
   * Nigeria.
   */
  NG = 'NG',

  /**
   * Niue.
   */
  NU = 'NU',

  /**
   * Norfolk Island.
   */
  NF = 'NF',

  /**
   * North Macedonia.
   */
  MK = 'MK',

  /**
   * Norway.
   */
  NO = 'NO',

  /**
   * Oman.
   */
  OM = 'OM',

  /**
   * Pakistan.
   */
  PK = 'PK',

  /**
   * Palestinian Territories.
   */
  PS = 'PS',

  /**
   * Panama.
   */
  PA = 'PA',

  /**
   * Papua New Guinea.
   */
  PG = 'PG',

  /**
   * Paraguay.
   */
  PY = 'PY',

  /**
   * Peru.
   */
  PE = 'PE',

  /**
   * Philippines.
   */
  PH = 'PH',

  /**
   * Pitcairn Islands.
   */
  PN = 'PN',

  /**
   * Poland.
   */
  PL = 'PL',

  /**
   * Portugal.
   */
  PT = 'PT',

  /**
   * Qatar.
   */
  QA = 'QA',

  /**
   * Cameroon.
   */
  CM = 'CM',

  /**
   * Réunion.
   */
  RE = 'RE',

  /**
   * Romania.
   */
  RO = 'RO',

  /**
   * Russia.
   */
  RU = 'RU',

  /**
   * Rwanda.
   */
  RW = 'RW',

  /**
   * St. Barthélemy.
   */
  BL = 'BL',

  /**
   * St. Helena.
   */
  SH = 'SH',

  /**
   * St. Kitts & Nevis.
   */
  KN = 'KN',

  /**
   * St. Lucia.
   */
  LC = 'LC',

  /**
   * St. Martin.
   */
  MF = 'MF',

  /**
   * St. Pierre & Miquelon.
   */
  PM = 'PM',

  /**
   * Samoa.
   */
  WS = 'WS',

  /**
   * San Marino.
   */
  SM = 'SM',

  /**
   * São Tomé & Príncipe.
   */
  ST = 'ST',

  /**
   * Saudi Arabia.
   */
  SA = 'SA',

  /**
   * Senegal.
   */
  SN = 'SN',

  /**
   * Serbia.
   */
  RS = 'RS',

  /**
   * Seychelles.
   */
  SC = 'SC',

  /**
   * Sierra Leone.
   */
  SL = 'SL',

  /**
   * Singapore.
   */
  SG = 'SG',

  /**
   * Sint Maarten.
   */
  SX = 'SX',

  /**
   * Slovakia.
   */
  SK = 'SK',

  /**
   * Slovenia.
   */
  SI = 'SI',

  /**
   * Solomon Islands.
   */
  SB = 'SB',

  /**
   * Somalia.
   */
  SO = 'SO',

  /**
   * South Africa.
   */
  ZA = 'ZA',

  /**
   * South Georgia & South Sandwich Islands.
   */
  GS = 'GS',

  /**
   * South Korea.
   */
  KR = 'KR',

  /**
   * South Sudan.
   */
  SS = 'SS',

  /**
   * Spain.
   */
  ES = 'ES',

  /**
   * Sri Lanka.
   */
  LK = 'LK',

  /**
   * St. Vincent & Grenadines.
   */
  VC = 'VC',

  /**
   * Sudan.
   */
  SD = 'SD',

  /**
   * Suriname.
   */
  SR = 'SR',

  /**
   * Svalbard & Jan Mayen.
   */
  SJ = 'SJ',

  /**
   * Sweden.
   */
  SE = 'SE',

  /**
   * Switzerland.
   */
  CH = 'CH',

  /**
   * Syria.
   */
  SY = 'SY',

  /**
   * Taiwan.
   */
  TW = 'TW',

  /**
   * Tajikistan.
   */
  TJ = 'TJ',

  /**
   * Tanzania.
   */
  TZ = 'TZ',

  /**
   * Thailand.
   */
  TH = 'TH',

  /**
   * Timor-Leste.
   */
  TL = 'TL',

  /**
   * Togo.
   */
  TG = 'TG',

  /**
   * Tokelau.
   */
  TK = 'TK',

  /**
   * Tonga.
   */
  TO = 'TO',

  /**
   * Trinidad & Tobago.
   */
  TT = 'TT',

  /**
   * Tristan da Cunha.
   */
  TA = 'TA',

  /**
   * Tunisia.
   */
  TN = 'TN',

  /**
   * Türkiye.
   */
  TR = 'TR',

  /**
   * Turkmenistan.
   */
  TM = 'TM',

  /**
   * Turks & Caicos Islands.
   */
  TC = 'TC',

  /**
   * Tuvalu.
   */
  TV = 'TV',

  /**
   * Uganda.
   */
  UG = 'UG',

  /**
   * Ukraine.
   */
  UA = 'UA',

  /**
   * United Arab Emirates.
   */
  AE = 'AE',

  /**
   * United Kingdom.
   */
  GB = 'GB',

  /**
   * United States.
   */
  US = 'US',

  /**
   * U.S. Outlying Islands.
   */
  UM = 'UM',

  /**
   * Uruguay.
   */
  UY = 'UY',

  /**
   * Uzbekistan.
   */
  UZ = 'UZ',

  /**
   * Vanuatu.
   */
  VU = 'VU',

  /**
   * Venezuela.
   */
  VE = 'VE',

  /**
   * Vietnam.
   */
  VN = 'VN',

  /**
   * British Virgin Islands.
   */
  VG = 'VG',

  /**
   * Wallis & Futuna.
   */
  WF = 'WF',

  /**
   * Western Sahara.
   */
  EH = 'EH',

  /**
   * Yemen.
   */
  YE = 'YE',

  /**
   * Zambia.
   */
  ZM = 'ZM',

  /**
   * Zimbabwe.
   */
  ZW = 'ZW',

  /**
   * Unknown Region.
   */
  ZZ = 'ZZ',
}

/**
 * The part of the image that should remain after cropping.
 */
export enum CropRegion {
  /**
   * Keep the center of the image.
   */
  CENTER = 'CENTER',

  /**
   * Keep the top of the image.
   */
  TOP = 'TOP',

  /**
   * Keep the bottom of the image.
   */
  BOTTOM = 'BOTTOM',

  /**
   * Keep the left of the image.
   */
  LEFT = 'LEFT',

  /**
   * Keep the right of the image.
   */
  RIGHT = 'RIGHT',
}

/**
 * A currency.
 */
/* #__PURE__ */
export class Currency extends $Base<'Currency'> {
  constructor() {
    super('Currency');
  }

  /**
   * The ISO code of the currency.
   */
  get isoCode(): $Field<'isoCode', CurrencyCode> {
    return this.$_select('isoCode') as any;
  }

  /**
   * The name of the currency.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The symbol of the currency.
   */
  get symbol(): $Field<'symbol', string> {
    return this.$_select('symbol') as any;
  }
}

/**
 * The three-letter currency codes that represent the world currencies used in
stores. These include standard ISO 4217 codes, legacy codes,
and non-standard codes.

 */
export enum CurrencyCode {
  /**
   * United States Dollars (USD).
   */
  USD = 'USD',

  /**
   * Euro (EUR).
   */
  EUR = 'EUR',

  /**
   * United Kingdom Pounds (GBP).
   */
  GBP = 'GBP',

  /**
   * Canadian Dollars (CAD).
   */
  CAD = 'CAD',

  /**
   * Afghan Afghani (AFN).
   */
  AFN = 'AFN',

  /**
   * Albanian Lek (ALL).
   */
  ALL = 'ALL',

  /**
   * Algerian Dinar (DZD).
   */
  DZD = 'DZD',

  /**
   * Angolan Kwanza (AOA).
   */
  AOA = 'AOA',

  /**
   * Argentine Pesos (ARS).
   */
  ARS = 'ARS',

  /**
   * Armenian Dram (AMD).
   */
  AMD = 'AMD',

  /**
   * Aruban Florin (AWG).
   */
  AWG = 'AWG',

  /**
   * Australian Dollars (AUD).
   */
  AUD = 'AUD',

  /**
   * Barbadian Dollar (BBD).
   */
  BBD = 'BBD',

  /**
   * Azerbaijani Manat (AZN).
   */
  AZN = 'AZN',

  /**
   * Bangladesh Taka (BDT).
   */
  BDT = 'BDT',

  /**
   * Bahamian Dollar (BSD).
   */
  BSD = 'BSD',

  /**
   * Bahraini Dinar (BHD).
   */
  BHD = 'BHD',

  /**
   * Burundian Franc (BIF).
   */
  BIF = 'BIF',

  /**
   * Belize Dollar (BZD).
   */
  BZD = 'BZD',

  /**
   * Bermudian Dollar (BMD).
   */
  BMD = 'BMD',

  /**
   * Bhutanese Ngultrum (BTN).
   */
  BTN = 'BTN',

  /**
   * Bosnia and Herzegovina Convertible Mark (BAM).
   */
  BAM = 'BAM',

  /**
   * Brazilian Real (BRL).
   */
  BRL = 'BRL',

  /**
   * Bolivian Boliviano (BOB).
   */
  BOB = 'BOB',

  /**
   * Botswana Pula (BWP).
   */
  BWP = 'BWP',

  /**
   * Brunei Dollar (BND).
   */
  BND = 'BND',

  /**
   * Bulgarian Lev (BGN).
   */
  BGN = 'BGN',

  /**
   * Burmese Kyat (MMK).
   */
  MMK = 'MMK',

  /**
   * Cambodian Riel.
   */
  KHR = 'KHR',

  /**
   * Cape Verdean escudo (CVE).
   */
  CVE = 'CVE',

  /**
   * Cayman Dollars (KYD).
   */
  KYD = 'KYD',

  /**
   * Central African CFA Franc (XAF).
   */
  XAF = 'XAF',

  /**
   * Chilean Peso (CLP).
   */
  CLP = 'CLP',

  /**
   * Chinese Yuan Renminbi (CNY).
   */
  CNY = 'CNY',

  /**
   * Colombian Peso (COP).
   */
  COP = 'COP',

  /**
   * Comorian Franc (KMF).
   */
  KMF = 'KMF',

  /**
   * Congolese franc (CDF).
   */
  CDF = 'CDF',

  /**
   * Costa Rican Colones (CRC).
   */
  CRC = 'CRC',

  /**
   * Croatian Kuna (HRK).
   */
  HRK = 'HRK',

  /**
   * Czech Koruny (CZK).
   */
  CZK = 'CZK',

  /**
   * Danish Kroner (DKK).
   */
  DKK = 'DKK',

  /**
   * Dominican Peso (DOP).
   */
  DOP = 'DOP',

  /**
   * East Caribbean Dollar (XCD).
   */
  XCD = 'XCD',

  /**
   * Egyptian Pound (EGP).
   */
  EGP = 'EGP',

  /**
   * Eritrean Nakfa (ERN).
   */
  ERN = 'ERN',

  /**
   * Ethiopian Birr (ETB).
   */
  ETB = 'ETB',

  /**
   * Falkland Islands Pounds (FKP).
   */
  FKP = 'FKP',

  /**
   * CFP Franc (XPF).
   */
  XPF = 'XPF',

  /**
   * Fijian Dollars (FJD).
   */
  FJD = 'FJD',

  /**
   * Gibraltar Pounds (GIP).
   */
  GIP = 'GIP',

  /**
   * Gambian Dalasi (GMD).
   */
  GMD = 'GMD',

  /**
   * Ghanaian Cedi (GHS).
   */
  GHS = 'GHS',

  /**
   * Guatemalan Quetzal (GTQ).
   */
  GTQ = 'GTQ',

  /**
   * Guyanese Dollar (GYD).
   */
  GYD = 'GYD',

  /**
   * Georgian Lari (GEL).
   */
  GEL = 'GEL',

  /**
   * Haitian Gourde (HTG).
   */
  HTG = 'HTG',

  /**
   * Honduran Lempira (HNL).
   */
  HNL = 'HNL',

  /**
   * Hong Kong Dollars (HKD).
   */
  HKD = 'HKD',

  /**
   * Hungarian Forint (HUF).
   */
  HUF = 'HUF',

  /**
   * Icelandic Kronur (ISK).
   */
  ISK = 'ISK',

  /**
   * Indian Rupees (INR).
   */
  INR = 'INR',

  /**
   * Indonesian Rupiah (IDR).
   */
  IDR = 'IDR',

  /**
   * Israeli New Shekel (NIS).
   */
  ILS = 'ILS',

  /**
   * Iraqi Dinar (IQD).
   */
  IQD = 'IQD',

  /**
   * Jamaican Dollars (JMD).
   */
  JMD = 'JMD',

  /**
   * Japanese Yen (JPY).
   */
  JPY = 'JPY',

  /**
   * Jersey Pound.
   */
  JEP = 'JEP',

  /**
   * Jordanian Dinar (JOD).
   */
  JOD = 'JOD',

  /**
   * Kazakhstani Tenge (KZT).
   */
  KZT = 'KZT',

  /**
   * Kenyan Shilling (KES).
   */
  KES = 'KES',

  /**
   * Kiribati Dollar (KID).
   */
  KID = 'KID',

  /**
   * Kuwaiti Dinar (KWD).
   */
  KWD = 'KWD',

  /**
   * Kyrgyzstani Som (KGS).
   */
  KGS = 'KGS',

  /**
   * Laotian Kip (LAK).
   */
  LAK = 'LAK',

  /**
   * Latvian Lati (LVL).
   */
  LVL = 'LVL',

  /**
   * Lebanese Pounds (LBP).
   */
  LBP = 'LBP',

  /**
   * Lesotho Loti (LSL).
   */
  LSL = 'LSL',

  /**
   * Liberian Dollar (LRD).
   */
  LRD = 'LRD',

  /**
   * Lithuanian Litai (LTL).
   */
  LTL = 'LTL',

  /**
   * Malagasy Ariary (MGA).
   */
  MGA = 'MGA',

  /**
   * Macedonia Denar (MKD).
   */
  MKD = 'MKD',

  /**
   * Macanese Pataca (MOP).
   */
  MOP = 'MOP',

  /**
   * Malawian Kwacha (MWK).
   */
  MWK = 'MWK',

  /**
   * Maldivian Rufiyaa (MVR).
   */
  MVR = 'MVR',

  /**
   * Mauritanian Ouguiya (MRU).
   */
  MRU = 'MRU',

  /**
   * Mexican Pesos (MXN).
   */
  MXN = 'MXN',

  /**
   * Malaysian Ringgits (MYR).
   */
  MYR = 'MYR',

  /**
   * Mauritian Rupee (MUR).
   */
  MUR = 'MUR',

  /**
   * Moldovan Leu (MDL).
   */
  MDL = 'MDL',

  /**
   * Moroccan Dirham.
   */
  MAD = 'MAD',

  /**
   * Mongolian Tugrik.
   */
  MNT = 'MNT',

  /**
   * Mozambican Metical.
   */
  MZN = 'MZN',

  /**
   * Namibian Dollar.
   */
  NAD = 'NAD',

  /**
   * Nepalese Rupee (NPR).
   */
  NPR = 'NPR',

  /**
   * Netherlands Antillean Guilder.
   */
  ANG = 'ANG',

  /**
   * New Zealand Dollars (NZD).
   */
  NZD = 'NZD',

  /**
   * Nicaraguan Córdoba (NIO).
   */
  NIO = 'NIO',

  /**
   * Nigerian Naira (NGN).
   */
  NGN = 'NGN',

  /**
   * Norwegian Kroner (NOK).
   */
  NOK = 'NOK',

  /**
   * Omani Rial (OMR).
   */
  OMR = 'OMR',

  /**
   * Panamian Balboa (PAB).
   */
  PAB = 'PAB',

  /**
   * Pakistani Rupee (PKR).
   */
  PKR = 'PKR',

  /**
   * Papua New Guinean Kina (PGK).
   */
  PGK = 'PGK',

  /**
   * Paraguayan Guarani (PYG).
   */
  PYG = 'PYG',

  /**
   * Peruvian Nuevo Sol (PEN).
   */
  PEN = 'PEN',

  /**
   * Philippine Peso (PHP).
   */
  PHP = 'PHP',

  /**
   * Polish Zlotych (PLN).
   */
  PLN = 'PLN',

  /**
   * Qatari Rial (QAR).
   */
  QAR = 'QAR',

  /**
   * Romanian Lei (RON).
   */
  RON = 'RON',

  /**
   * Russian Rubles (RUB).
   */
  RUB = 'RUB',

  /**
   * Rwandan Franc (RWF).
   */
  RWF = 'RWF',

  /**
   * Samoan Tala (WST).
   */
  WST = 'WST',

  /**
   * Saint Helena Pounds (SHP).
   */
  SHP = 'SHP',

  /**
   * Saudi Riyal (SAR).
   */
  SAR = 'SAR',

  /**
   * Serbian dinar (RSD).
   */
  RSD = 'RSD',

  /**
   * Seychellois Rupee (SCR).
   */
  SCR = 'SCR',

  /**
   * Singapore Dollars (SGD).
   */
  SGD = 'SGD',

  /**
   * Sudanese Pound (SDG).
   */
  SDG = 'SDG',

  /**
   * Somali Shilling (SOS).
   */
  SOS = 'SOS',

  /**
   * Syrian Pound (SYP).
   */
  SYP = 'SYP',

  /**
   * South African Rand (ZAR).
   */
  ZAR = 'ZAR',

  /**
   * South Korean Won (KRW).
   */
  KRW = 'KRW',

  /**
   * South Sudanese Pound (SSP).
   */
  SSP = 'SSP',

  /**
   * Solomon Islands Dollar (SBD).
   */
  SBD = 'SBD',

  /**
   * Sri Lankan Rupees (LKR).
   */
  LKR = 'LKR',

  /**
   * Surinamese Dollar (SRD).
   */
  SRD = 'SRD',

  /**
   * Swazi Lilangeni (SZL).
   */
  SZL = 'SZL',

  /**
   * Swedish Kronor (SEK).
   */
  SEK = 'SEK',

  /**
   * Swiss Francs (CHF).
   */
  CHF = 'CHF',

  /**
   * Taiwan Dollars (TWD).
   */
  TWD = 'TWD',

  /**
   * Thai baht (THB).
   */
  THB = 'THB',

  /**
   * Tanzanian Shilling (TZS).
   */
  TZS = 'TZS',

  /**
   * Trinidad and Tobago Dollars (TTD).
   */
  TTD = 'TTD',

  /**
   * Tunisian Dinar (TND).
   */
  TND = 'TND',

  /**
   * Turkish Lira (TRY).
   */
  TRY = 'TRY',

  /**
   * Turkmenistani Manat (TMT).
   */
  TMT = 'TMT',

  /**
   * Ugandan Shilling (UGX).
   */
  UGX = 'UGX',

  /**
   * Ukrainian Hryvnia (UAH).
   */
  UAH = 'UAH',

  /**
   * United Arab Emirates Dirham (AED).
   */
  AED = 'AED',

  /**
   * Uruguayan Pesos (UYU).
   */
  UYU = 'UYU',

  /**
   * Uzbekistan som (UZS).
   */
  UZS = 'UZS',

  /**
   * Vanuatu Vatu (VUV).
   */
  VUV = 'VUV',

  /**
   * Venezuelan Bolivares Soberanos (VES).
   */
  VES = 'VES',

  /**
   * Vietnamese đồng (VND).
   */
  VND = 'VND',

  /**
   * West African CFA franc (XOF).
   */
  XOF = 'XOF',

  /**
   * Yemeni Rial (YER).
   */
  YER = 'YER',

  /**
   * Zambian Kwacha (ZMW).
   */
  ZMW = 'ZMW',

  /**
   * Belarusian Ruble (BYN).
   */
  BYN = 'BYN',

  /**
   * Belarusian Ruble (BYR).
   */
  BYR = 'BYR',

  /**
   * Djiboutian Franc (DJF).
   */
  DJF = 'DJF',

  /**
   * Guinean Franc (GNF).
   */
  GNF = 'GNF',

  /**
   * Iranian Rial (IRR).
   */
  IRR = 'IRR',

  /**
   * Libyan Dinar (LYD).
   */
  LYD = 'LYD',

  /**
   * Sierra Leonean Leone (SLL).
   */
  SLL = 'SLL',

  /**
   * Sao Tome And Principe Dobra (STD).
   */
  STD = 'STD',

  /**
   * Sao Tome And Principe Dobra (STN).
   */
  STN = 'STN',

  /**
   * Tajikistani Somoni (TJS).
   */
  TJS = 'TJS',

  /**
   * Tongan Pa'anga (TOP).
   */
  TOP = 'TOP',

  /**
   * Venezuelan Bolivares (VED).
   */
  VED = 'VED',

  /**
   * Venezuelan Bolivares (VEF).
   */
  VEF = 'VEF',

  /**
   * Unrecognized currency.
   */
  XXX = 'XXX',
}

/**
 * A customer represents a customer account with the shop. Customer accounts store contact information for the customer, saving logged-in customers the trouble of having to provide it at every checkout.
 */
/* #__PURE__ */
export class Customer extends $Base<'Customer'> {
  constructor() {
    super('Customer');
  }

  /**
   * Indicates whether the customer has consented to be sent marketing material via email.
   */
  get acceptsMarketing(): $Field<'acceptsMarketing', boolean> {
    return this.$_select('acceptsMarketing') as any;
  }

  /**
   * A list of addresses for the customer.
   */
  addresses<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<MailingAddressConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: MailingAddressConnection) => [...Sel],
  ): $Field<'addresses', GetOutput<Sel>, GetVariables<Sel, Args>>;
  addresses<Sel extends Selection<MailingAddressConnection>>(
    selectorFn: (s: MailingAddressConnection) => [...Sel],
  ): $Field<'addresses', GetOutput<Sel>, GetVariables<Sel>>;
  addresses(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new MailingAddressConnection()),
    };
    return this.$_select('addresses', options) as any;
  }

  /**
   * The date and time when the customer was created.
   */
  get createdAt(): $Field<'createdAt', DateTime> {
    return this.$_select('createdAt') as any;
  }

  /**
   * The customer’s default address.
   */
  defaultAddress<Sel extends Selection<MailingAddress>>(
    selectorFn: (s: MailingAddress) => [...Sel],
  ): $Field<'defaultAddress', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddress()),
    };
    return this.$_select('defaultAddress', options) as any;
  }

  /**
   * The customer’s name, email or phone number.
   */
  get displayName(): $Field<'displayName', string> {
    return this.$_select('displayName') as any;
  }

  /**
   * The customer’s email address.
   */
  get email(): $Field<'email', string | null | undefined> {
    return this.$_select('email') as any;
  }

  /**
   * The customer’s first name.
   */
  get firstName(): $Field<'firstName', string | null | undefined> {
    return this.$_select('firstName') as any;
  }

  /**
   * A unique ID for the customer.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The customer’s last name.
   */
  get lastName(): $Field<'lastName', string | null | undefined> {
    return this.$_select('lastName') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The number of orders that the customer has made at the store in their lifetime.
   */
  get numberOfOrders(): $Field<'numberOfOrders', UnsignedInt64> {
    return this.$_select('numberOfOrders') as any;
  }

  /**
   * The orders associated with the customer.
   */
  orders<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: OrderSortKeys | null | undefined;
      query?: string | null | undefined;
    }>,
    Sel extends Selection<OrderConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: OrderSortKeys | null | undefined;
        query?: string | null | undefined;
      }
    >,
    selectorFn: (s: OrderConnection) => [...Sel],
  ): $Field<'orders', GetOutput<Sel>, GetVariables<Sel, Args>>;
  orders<Sel extends Selection<OrderConnection>>(
    selectorFn: (s: OrderConnection) => [...Sel],
  ): $Field<'orders', GetOutput<Sel>, GetVariables<Sel>>;
  orders(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'OrderSortKeys',
        query: 'String',
      },
      args,

      selection: selectorFn(new OrderConnection()),
    };
    return this.$_select('orders', options) as any;
  }

  /**
   * The customer’s phone number.
   */
  get phone(): $Field<'phone', string | null | undefined> {
    return this.$_select('phone') as any;
  }

  /**
 * A comma separated list of tags that have been added to the customer.
Additional access scope required: unauthenticated_read_customer_tags.

 */
  get tags(): $Field<'tags', Readonly<Array<string>>> {
    return this.$_select('tags') as any;
  }

  /**
   * The date and time when the customer information was updated.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * A CustomerAccessToken represents the unique token required to make modifications to the customer object.
 */
/* #__PURE__ */
export class CustomerAccessToken extends $Base<'CustomerAccessToken'> {
  constructor() {
    super('CustomerAccessToken');
  }

  /**
   * The customer’s access token.
   */
  get accessToken(): $Field<'accessToken', string> {
    return this.$_select('accessToken') as any;
  }

  /**
   * The date and time when the customer access token expires.
   */
  get expiresAt(): $Field<'expiresAt', DateTime> {
    return this.$_select('expiresAt') as any;
  }
}

/**
 * The input fields required to create a customer access token.
 */
export type CustomerAccessTokenCreateInput = {
  email: string;
  password: string;
};

/**
 * Return type for `customerAccessTokenCreate` mutation.
 */
/* #__PURE__ */
export class CustomerAccessTokenCreatePayload extends $Base<'CustomerAccessTokenCreatePayload'> {
  constructor() {
    super('CustomerAccessTokenCreatePayload');
  }

  /**
   * The newly created customer access token object.
   */
  customerAccessToken<Sel extends Selection<CustomerAccessToken>>(
    selectorFn: (s: CustomerAccessToken) => [...Sel],
  ): $Field<'customerAccessToken', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerAccessToken()),
    };
    return this.$_select('customerAccessToken', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `customerAccessTokenCreateWithMultipass` mutation.
 */
/* #__PURE__ */
export class CustomerAccessTokenCreateWithMultipassPayload extends $Base<'CustomerAccessTokenCreateWithMultipassPayload'> {
  constructor() {
    super('CustomerAccessTokenCreateWithMultipassPayload');
  }

  /**
   * An access token object associated with the customer.
   */
  customerAccessToken<Sel extends Selection<CustomerAccessToken>>(
    selectorFn: (s: CustomerAccessToken) => [...Sel],
  ): $Field<'customerAccessToken', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerAccessToken()),
    };
    return this.$_select('customerAccessToken', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }
}

/**
 * Return type for `customerAccessTokenDelete` mutation.
 */
/* #__PURE__ */
export class CustomerAccessTokenDeletePayload extends $Base<'CustomerAccessTokenDeletePayload'> {
  constructor() {
    super('CustomerAccessTokenDeletePayload');
  }

  /**
   * The destroyed access token.
   */
  get deletedAccessToken(): $Field<'deletedAccessToken', string | null | undefined> {
    return this.$_select('deletedAccessToken') as any;
  }

  /**
   * ID of the destroyed customer access token.
   */
  get deletedCustomerAccessTokenId(): $Field<'deletedCustomerAccessTokenId', string | null | undefined> {
    return this.$_select('deletedCustomerAccessTokenId') as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `customerAccessTokenRenew` mutation.
 */
/* #__PURE__ */
export class CustomerAccessTokenRenewPayload extends $Base<'CustomerAccessTokenRenewPayload'> {
  constructor() {
    super('CustomerAccessTokenRenewPayload');
  }

  /**
   * The renewed customer access token object.
   */
  customerAccessToken<Sel extends Selection<CustomerAccessToken>>(
    selectorFn: (s: CustomerAccessToken) => [...Sel],
  ): $Field<'customerAccessToken', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerAccessToken()),
    };
    return this.$_select('customerAccessToken', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `customerActivateByUrl` mutation.
 */
/* #__PURE__ */
export class CustomerActivateByUrlPayload extends $Base<'CustomerActivateByUrlPayload'> {
  constructor() {
    super('CustomerActivateByUrlPayload');
  }

  /**
   * The customer that was activated.
   */
  customer<Sel extends Selection<Customer>>(
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
   * A new customer access token for the customer.
   */
  customerAccessToken<Sel extends Selection<CustomerAccessToken>>(
    selectorFn: (s: CustomerAccessToken) => [...Sel],
  ): $Field<'customerAccessToken', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerAccessToken()),
    };
    return this.$_select('customerAccessToken', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }
}

/**
 * The input fields to activate a customer.
 */
export type CustomerActivateInput = {
  activationToken: string;
  password: string;
};

/**
 * Return type for `customerActivate` mutation.
 */
/* #__PURE__ */
export class CustomerActivatePayload extends $Base<'CustomerActivatePayload'> {
  constructor() {
    super('CustomerActivatePayload');
  }

  /**
   * The customer object.
   */
  customer<Sel extends Selection<Customer>>(
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
   * A newly created customer access token object for the customer.
   */
  customerAccessToken<Sel extends Selection<CustomerAccessToken>>(
    selectorFn: (s: CustomerAccessToken) => [...Sel],
  ): $Field<'customerAccessToken', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerAccessToken()),
    };
    return this.$_select('customerAccessToken', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `customerAddressCreate` mutation.
 */
/* #__PURE__ */
export class CustomerAddressCreatePayload extends $Base<'CustomerAddressCreatePayload'> {
  constructor() {
    super('CustomerAddressCreatePayload');
  }

  /**
   * The new customer address object.
   */
  customerAddress<Sel extends Selection<MailingAddress>>(
    selectorFn: (s: MailingAddress) => [...Sel],
  ): $Field<'customerAddress', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddress()),
    };
    return this.$_select('customerAddress', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `customerAddressDelete` mutation.
 */
/* #__PURE__ */
export class CustomerAddressDeletePayload extends $Base<'CustomerAddressDeletePayload'> {
  constructor() {
    super('CustomerAddressDeletePayload');
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * ID of the deleted customer address.
   */
  get deletedCustomerAddressId(): $Field<'deletedCustomerAddressId', string | null | undefined> {
    return this.$_select('deletedCustomerAddressId') as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `customerAddressUpdate` mutation.
 */
/* #__PURE__ */
export class CustomerAddressUpdatePayload extends $Base<'CustomerAddressUpdatePayload'> {
  constructor() {
    super('CustomerAddressUpdatePayload');
  }

  /**
   * The customer’s updated mailing address.
   */
  customerAddress<Sel extends Selection<MailingAddress>>(
    selectorFn: (s: MailingAddress) => [...Sel],
  ): $Field<'customerAddress', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddress()),
    };
    return this.$_select('customerAddress', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * The input fields to create a new customer.
 */
export type CustomerCreateInput = {
  acceptsMarketing?: boolean | null | undefined;
  email: string;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  password: string;
  phone?: string | null | undefined;
};

/**
 * Return type for `customerCreate` mutation.
 */
/* #__PURE__ */
export class CustomerCreatePayload extends $Base<'CustomerCreatePayload'> {
  constructor() {
    super('CustomerCreatePayload');
  }

  /**
   * The created customer object.
   */
  customer<Sel extends Selection<Customer>>(
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `customerDefaultAddressUpdate` mutation.
 */
/* #__PURE__ */
export class CustomerDefaultAddressUpdatePayload extends $Base<'CustomerDefaultAddressUpdatePayload'> {
  constructor() {
    super('CustomerDefaultAddressUpdatePayload');
  }

  /**
   * The updated customer object.
   */
  customer<Sel extends Selection<Customer>>(
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Possible error codes that can be returned by `CustomerUserError`.
 */
export enum CustomerErrorCode {
  /**
   * The input value is blank.
   */
  BLANK = 'BLANK',

  /**
   * The input value is invalid.
   */
  INVALID = 'INVALID',

  /**
   * The input value is already taken.
   */
  TAKEN = 'TAKEN',

  /**
   * The input value is too long.
   */
  TOO_LONG = 'TOO_LONG',

  /**
   * The input value is too short.
   */
  TOO_SHORT = 'TOO_SHORT',

  /**
   * Unidentified customer.
   */
  UNIDENTIFIED_CUSTOMER = 'UNIDENTIFIED_CUSTOMER',

  /**
   * Customer is disabled.
   */
  CUSTOMER_DISABLED = 'CUSTOMER_DISABLED',

  /**
   * Input password starts or ends with whitespace.
   */
  PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE = 'PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE',

  /**
   * Input contains HTML tags.
   */
  CONTAINS_HTML_TAGS = 'CONTAINS_HTML_TAGS',

  /**
   * Input contains URL.
   */
  CONTAINS_URL = 'CONTAINS_URL',

  /**
   * Invalid activation token.
   */
  TOKEN_INVALID = 'TOKEN_INVALID',

  /**
   * Customer already enabled.
   */
  ALREADY_ENABLED = 'ALREADY_ENABLED',

  /**
   * Address does not exist.
   */
  NOT_FOUND = 'NOT_FOUND',

  /**
   * Input email contains an invalid domain name.
   */
  BAD_DOMAIN = 'BAD_DOMAIN',

  /**
   * Multipass token is not valid.
   */
  INVALID_MULTIPASS_REQUEST = 'INVALID_MULTIPASS_REQUEST',
}

/**
 * Return type for `customerRecover` mutation.
 */
/* #__PURE__ */
export class CustomerRecoverPayload extends $Base<'CustomerRecoverPayload'> {
  constructor() {
    super('CustomerRecoverPayload');
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `customerResetByUrl` mutation.
 */
/* #__PURE__ */
export class CustomerResetByUrlPayload extends $Base<'CustomerResetByUrlPayload'> {
  constructor() {
    super('CustomerResetByUrlPayload');
  }

  /**
   * The customer object which was reset.
   */
  customer<Sel extends Selection<Customer>>(
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
   * A newly created customer access token object for the customer.
   */
  customerAccessToken<Sel extends Selection<CustomerAccessToken>>(
    selectorFn: (s: CustomerAccessToken) => [...Sel],
  ): $Field<'customerAccessToken', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerAccessToken()),
    };
    return this.$_select('customerAccessToken', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * The input fields to reset a customer's password.
 */
export type CustomerResetInput = {
  password: string;
  resetToken: string;
};

/**
 * Return type for `customerReset` mutation.
 */
/* #__PURE__ */
export class CustomerResetPayload extends $Base<'CustomerResetPayload'> {
  constructor() {
    super('CustomerResetPayload');
  }

  /**
   * The customer object which was reset.
   */
  customer<Sel extends Selection<Customer>>(
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
   * A newly created customer access token object for the customer.
   */
  customerAccessToken<Sel extends Selection<CustomerAccessToken>>(
    selectorFn: (s: CustomerAccessToken) => [...Sel],
  ): $Field<'customerAccessToken', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerAccessToken()),
    };
    return this.$_select('customerAccessToken', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * The input fields to update the Customer information.
 */
export type CustomerUpdateInput = {
  acceptsMarketing?: boolean | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  password?: string | null | undefined;
  phone?: string | null | undefined;
};

/**
 * Return type for `customerUpdate` mutation.
 */
/* #__PURE__ */
export class CustomerUpdatePayload extends $Base<'CustomerUpdatePayload'> {
  constructor() {
    super('CustomerUpdatePayload');
  }

  /**
   * The updated customer object.
   */
  customer<Sel extends Selection<Customer>>(
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
 * The newly created customer access token. If the customer's password is updated, all previous access tokens
(including the one used to perform this mutation) become invalid, and a new token is generated.

 */
  customerAccessToken<Sel extends Selection<CustomerAccessToken>>(
    selectorFn: (s: CustomerAccessToken) => [...Sel],
  ): $Field<'customerAccessToken', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerAccessToken()),
    };
    return this.$_select('customerAccessToken', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  customerUserErrors<Sel extends Selection<CustomerUserError>>(
    selectorFn: (s: CustomerUserError) => [...Sel],
  ): $Field<'customerUserErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CustomerUserError()),
    };
    return this.$_select('customerUserErrors', options) as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  userErrors<Sel extends Selection<UserError>>(
    selectorFn: (s: UserError) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserError()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Represents an error that happens during execution of a customer mutation.
 */
/* #__PURE__ */
export class CustomerUserError extends $Base<'CustomerUserError'> {
  constructor() {
    super('CustomerUserError');
  }

  /**
   * The error code.
   */
  get code(): $Field<'code', CustomerErrorCode | null | undefined> {
    return this.$_select('code') as any;
  }

  /**
   * The path to the input field that caused the error.
   */
  get field(): $Field<'field', Readonly<Array<string>> | null | undefined> {
    return this.$_select('field') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string> {
    return this.$_select('message') as any;
  }
}

/**
 * Represents an [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601)-encoded date and time string.
For example, 3:50 pm on September 7, 2019 in the time zone of UTC (Coordinated Universal Time) is
represented as `"2019-09-07T15:50:00Z`".

 */
export type DateTime = string;

/**
 * A signed decimal number, which supports arbitrary precision and is serialized as a string.

Example values: `"29.99"`, `"29.999"`.

 */
export type Decimal = string;

/**
 * A delivery address of the buyer that is interacting with the cart.
 */
/* #__PURE__ */
export class DeliveryAddress extends $Union<{ MailingAddress: MailingAddress; Node: Node }, 'DeliveryAddress'> {
  constructor() {
    super({ MailingAddress: MailingAddress, Node: Node }, 'DeliveryAddress');
  }
}

/**
 * The input fields for delivery address preferences.

 */
export type DeliveryAddressInput = {
  customerAddressId?: string | null | undefined;
  deliveryAddress?: MailingAddressInput | null | undefined;
  deliveryAddressValidationStrategy?: DeliveryAddressValidationStrategy | null | undefined;
  oneTimeUse?: boolean | null | undefined;
};

/**
 * Defines the types of available validation strategies for delivery addresses.

 */
export enum DeliveryAddressValidationStrategy {
  /**
   * Only the country code is validated.
   */
  COUNTRY_CODE_ONLY = 'COUNTRY_CODE_ONLY',

  /**
 * Strict validation is performed, i.e. all fields in the address are validated
according to Shopify's checkout rules. If the address fails validation, the cart will not be updated.

 */
  STRICT = 'STRICT',
}

/**
 * List of different delivery method types.
 */
export enum DeliveryMethodType {
  /**
   * Shipping.
   */
  SHIPPING = 'SHIPPING',

  /**
   * Local Pickup.
   */
  PICK_UP = 'PICK_UP',

  /**
   * Retail.
   */
  RETAIL = 'RETAIL',

  /**
   * Local Delivery.
   */
  LOCAL = 'LOCAL',

  /**
   * Shipping to a Pickup Point.
   */
  PICKUP_POINT = 'PICKUP_POINT',

  /**
   * None.
   */
  NONE = 'NONE',
}

/**
 * Digital wallet, such as Apple Pay, which can be used for accelerated checkouts.
 */
export enum DigitalWallet {
  /**
   * Apple Pay.
   */
  APPLE_PAY = 'APPLE_PAY',

  /**
   * Android Pay.
   */
  ANDROID_PAY = 'ANDROID_PAY',

  /**
   * Google Pay.
   */
  GOOGLE_PAY = 'GOOGLE_PAY',

  /**
   * Shopify Pay.
   */
  SHOPIFY_PAY = 'SHOPIFY_PAY',
}

/**
 * An amount discounting the line that has been allocated by a discount.

 */
/* #__PURE__ */
export class DiscountAllocation extends $Base<'DiscountAllocation'> {
  constructor() {
    super('DiscountAllocation');
  }

  /**
   * Amount of discount allocated.
   */
  allocatedAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'allocatedAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('allocatedAmount', options) as any;
  }

  /**
   * The discount this allocated amount originated from.
   */
  discountApplication<Sel extends Selection<DiscountApplication>>(
    selectorFn: (s: DiscountApplication) => [...Sel],
  ): $Field<'discountApplication', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new DiscountApplication()),
    };
    return this.$_select('discountApplication', options) as any;
  }
}

/**
 * Discount applications capture the intentions of a discount source at
the time of application.

 */
/* #__PURE__ */
export class DiscountApplication extends $Interface<
  {
    AutomaticDiscountApplication: AutomaticDiscountApplication;
    DiscountCodeApplication: DiscountCodeApplication;
    ManualDiscountApplication: ManualDiscountApplication;
    ScriptDiscountApplication: ScriptDiscountApplication;
  },
  'DiscountApplication'
> {
  constructor() {
    super(
      {
        AutomaticDiscountApplication: AutomaticDiscountApplication,
        DiscountCodeApplication: DiscountCodeApplication,
        ManualDiscountApplication: ManualDiscountApplication,
        ScriptDiscountApplication: ScriptDiscountApplication,
      },
      'DiscountApplication',
    );
  }

  /**
   * The method by which the discount's value is allocated to its entitled items.
   */
  get allocationMethod(): $Field<'allocationMethod', DiscountApplicationAllocationMethod> {
    return this.$_select('allocationMethod') as any;
  }

  /**
   * Which lines of targetType that the discount is allocated over.
   */
  get targetSelection(): $Field<'targetSelection', DiscountApplicationTargetSelection> {
    return this.$_select('targetSelection') as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }

  /**
   * The value of the discount application.
   */
  value<Sel extends Selection<PricingValue>>(
    selectorFn: (s: PricingValue) => [...Sel],
  ): $Field<'value', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PricingValue()),
    };
    return this.$_select('value', options) as any;
  }
}

/**
 * The method by which the discount's value is allocated onto its entitled lines.
 */
export enum DiscountApplicationAllocationMethod {
  /**
   * The value is spread across all entitled lines.
   */
  ACROSS = 'ACROSS',

  /**
   * The value is applied onto every entitled line.
   */
  EACH = 'EACH',

  /**
   * The value is specifically applied onto a particular line.
   */
  ONE = 'ONE',
}

/**
 * An auto-generated type for paginating through multiple DiscountApplications.

 */
/* #__PURE__ */
export class DiscountApplicationConnection extends $Base<'DiscountApplicationConnection'> {
  constructor() {
    super('DiscountApplicationConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<DiscountApplicationEdge>>(
    selectorFn: (s: DiscountApplicationEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new DiscountApplicationEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in DiscountApplicationEdge.
   */
  nodes<Sel extends Selection<DiscountApplication>>(
    selectorFn: (s: DiscountApplication) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new DiscountApplication()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one DiscountApplication and a cursor during pagination.

 */
/* #__PURE__ */
export class DiscountApplicationEdge extends $Base<'DiscountApplicationEdge'> {
  constructor() {
    super('DiscountApplicationEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of DiscountApplicationEdge.
   */
  node<Sel extends Selection<DiscountApplication>>(
    selectorFn: (s: DiscountApplication) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new DiscountApplication()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The lines on the order to which the discount is applied, of the type defined by
the discount application's `targetType`. For example, the value `ENTITLED`, combined with a `targetType` of
`LINE_ITEM`, applies the discount on all line items that are entitled to the discount.
The value `ALL`, combined with a `targetType` of `SHIPPING_LINE`, applies the discount on all shipping lines.

 */
export enum DiscountApplicationTargetSelection {
  /**
   * The discount is allocated onto all the lines.
   */
  ALL = 'ALL',

  /**
   * The discount is allocated onto only the lines that it's entitled for.
   */
  ENTITLED = 'ENTITLED',

  /**
   * The discount is allocated onto explicitly chosen lines.
   */
  EXPLICIT = 'EXPLICIT',
}

/**
 * The type of line (i.e. line item or shipping line) on an order that the discount is applicable towards.

 */
export enum DiscountApplicationTargetType {
  /**
   * The discount applies onto line items.
   */
  LINE_ITEM = 'LINE_ITEM',

  /**
   * The discount applies onto shipping lines.
   */
  SHIPPING_LINE = 'SHIPPING_LINE',
}

/**
 * Discount code applications capture the intentions of a discount code at
the time that it is applied.

 */
/* #__PURE__ */
export class DiscountCodeApplication extends $Base<'DiscountCodeApplication'> {
  constructor() {
    super('DiscountCodeApplication');
  }

  /**
   * The method by which the discount's value is allocated to its entitled items.
   */
  get allocationMethod(): $Field<'allocationMethod', DiscountApplicationAllocationMethod> {
    return this.$_select('allocationMethod') as any;
  }

  /**
   * Specifies whether the discount code was applied successfully.
   */
  get applicable(): $Field<'applicable', boolean> {
    return this.$_select('applicable') as any;
  }

  /**
   * The string identifying the discount code that was used at the time of application.
   */
  get code(): $Field<'code', string> {
    return this.$_select('code') as any;
  }

  /**
   * Which lines of targetType that the discount is allocated over.
   */
  get targetSelection(): $Field<'targetSelection', DiscountApplicationTargetSelection> {
    return this.$_select('targetSelection') as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }

  /**
   * The value of the discount application.
   */
  value<Sel extends Selection<PricingValue>>(
    selectorFn: (s: PricingValue) => [...Sel],
  ): $Field<'value', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PricingValue()),
    };
    return this.$_select('value', options) as any;
  }
}

/**
 * Represents an error in the input of a mutation.
 */
/* #__PURE__ */
export class DisplayableError extends $Interface<
  {
    CartUserError: CartUserError;
    CustomerUserError: CustomerUserError;
    MetafieldDeleteUserError: MetafieldDeleteUserError;
    MetafieldsSetUserError: MetafieldsSetUserError;
    UserError: UserError;
    UserErrorsShopPayPaymentRequestSessionUserErrors: UserErrorsShopPayPaymentRequestSessionUserErrors;
  },
  'DisplayableError'
> {
  constructor() {
    super(
      {
        CartUserError: CartUserError,
        CustomerUserError: CustomerUserError,
        MetafieldDeleteUserError: MetafieldDeleteUserError,
        MetafieldsSetUserError: MetafieldsSetUserError,
        UserError: UserError,
        UserErrorsShopPayPaymentRequestSessionUserErrors: UserErrorsShopPayPaymentRequestSessionUserErrors,
      },
      'DisplayableError',
    );
  }

  /**
   * The path to the input field that caused the error.
   */
  get field(): $Field<'field', Readonly<Array<string>> | null | undefined> {
    return this.$_select('field') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string> {
    return this.$_select('message') as any;
  }
}

/**
 * Represents a web address.
 */
/* #__PURE__ */
export class Domain extends $Base<'Domain'> {
  constructor() {
    super('Domain');
  }

  /**
   * The host name of the domain (eg: `example.com`).
   */
  get host(): $Field<'host', string> {
    return this.$_select('host') as any;
  }

  /**
   * Whether SSL is enabled or not.
   */
  get sslEnabled(): $Field<'sslEnabled', boolean> {
    return this.$_select('sslEnabled') as any;
  }

  /**
   * The URL of the domain (eg: `https://example.com`).
   */
  get url(): $Field<'url', URL> {
    return this.$_select('url') as any;
  }
}

/**
 * Represents a video hosted outside of Shopify.
 */
/* #__PURE__ */
export class ExternalVideo extends $Base<'ExternalVideo'> {
  constructor() {
    super('ExternalVideo');
  }

  /**
   * A word or phrase to share the nature or contents of a media.
   */
  get alt(): $Field<'alt', string | null | undefined> {
    return this.$_select('alt') as any;
  }

  /**
   * The embed URL of the video for the respective host.
   */
  get embedUrl(): $Field<'embedUrl', URL> {
    return this.$_select('embedUrl') as any;
  }

  /**
   * The URL.
   */
  get embeddedUrl(): $Field<'embeddedUrl', URL> {
    return this.$_select('embeddedUrl') as any;
  }

  /**
   * The host of the external video.
   */
  get host(): $Field<'host', MediaHost> {
    return this.$_select('host') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The media content type.
   */
  get mediaContentType(): $Field<'mediaContentType', MediaContentType> {
    return this.$_select('mediaContentType') as any;
  }

  /**
   * The origin URL of the video on the respective host.
   */
  get originUrl(): $Field<'originUrl', URL> {
    return this.$_select('originUrl') as any;
  }

  /**
   * The presentation for a media.
   */
  presentation<Sel extends Selection<MediaPresentation>>(
    selectorFn: (s: MediaPresentation) => [...Sel],
  ): $Field<'presentation', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaPresentation()),
    };
    return this.$_select('presentation', options) as any;
  }

  /**
   * The preview image for the media.
   */
  previewImage<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'previewImage', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('previewImage', options) as any;
  }
}

/**
 * A filter that is supported on the parent field.
 */
/* #__PURE__ */
export class Filter extends $Base<'Filter'> {
  constructor() {
    super('Filter');
  }

  /**
   * A unique identifier.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * A human-friendly string for this filter.
   */
  get label(): $Field<'label', string> {
    return this.$_select('label') as any;
  }

  /**
 * Describes how to present the filter values.
Returns a value only for filters of type `LIST`. Returns null for other types.

 */
  get presentation(): $Field<'presentation', FilterPresentation | null | undefined> {
    return this.$_select('presentation') as any;
  }

  /**
   * An enumeration that denotes the type of data this filter represents.
   */
  get type(): $Field<'type', FilterType> {
    return this.$_select('type') as any;
  }

  /**
   * The list of values for this filter.
   */
  values<Sel extends Selection<FilterValue>>(
    selectorFn: (s: FilterValue) => [...Sel],
  ): $Field<'values', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new FilterValue()),
    };
    return this.$_select('values', options) as any;
  }
}

/**
 * Defines how to present the filter values, specifies the presentation of the filter.

 */
export enum FilterPresentation {
  /**
   * Image presentation, filter values display an image.
   */
  IMAGE = 'IMAGE',

  /**
   * Swatch presentation, filter values display color or image patterns.
   */
  SWATCH = 'SWATCH',

  /**
   * Text presentation, no additional visual display for filter values.
   */
  TEXT = 'TEXT',
}

/**
 * The type of data that the filter group represents.

For more information, refer to [Filter products in a collection with the Storefront API]
(https://shopify.dev/custom-storefronts/products-collections/filter-products).

 */
export enum FilterType {
  /**
   * A list of selectable values.
   */
  LIST = 'LIST',

  /**
   * A range of prices.
   */
  PRICE_RANGE = 'PRICE_RANGE',

  /**
   * A boolean value.
   */
  BOOLEAN = 'BOOLEAN',
}

/**
 * A selectable value within a filter.
 */
/* #__PURE__ */
export class FilterValue extends $Base<'FilterValue'> {
  constructor() {
    super('FilterValue');
  }

  /**
   * The number of results that match this filter value.
   */
  get count(): $Field<'count', number> {
    return this.$_select('count') as any;
  }

  /**
   * A unique identifier.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The visual representation when the filter's presentation is `IMAGE`.
   */
  image<Sel extends Selection<MediaImage>>(
    selectorFn: (s: MediaImage) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaImage()),
    };
    return this.$_select('image', options) as any;
  }

  /**
 * An input object that can be used to filter by this value on the parent field.

The value is provided as a helper for building dynamic filtering UI. For
example, if you have a list of selected `FilterValue` objects, you can combine
their respective `input` values to use in a subsequent query.

 */
  get input(): $Field<'input', JSON> {
    return this.$_select('input') as any;
  }

  /**
   * A human-friendly string for this filter value.
   */
  get label(): $Field<'label', string> {
    return this.$_select('label') as any;
  }

  /**
   * The visual representation when the filter's presentation is `SWATCH`.
   */
  swatch<Sel extends Selection<Swatch>>(
    selectorFn: (s: Swatch) => [...Sel],
  ): $Field<'swatch', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Swatch()),
    };
    return this.$_select('swatch', options) as any;
  }
}

/**
 * Represents a single fulfillment in an order.
 */
/* #__PURE__ */
export class Fulfillment extends $Base<'Fulfillment'> {
  constructor() {
    super('Fulfillment');
  }

  /**
   * List of the fulfillment's line items.
   */
  fulfillmentLineItems<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<FulfillmentLineItemConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: FulfillmentLineItemConnection) => [...Sel],
  ): $Field<'fulfillmentLineItems', GetOutput<Sel>, GetVariables<Sel, Args>>;
  fulfillmentLineItems<Sel extends Selection<FulfillmentLineItemConnection>>(
    selectorFn: (s: FulfillmentLineItemConnection) => [...Sel],
  ): $Field<'fulfillmentLineItems', GetOutput<Sel>, GetVariables<Sel>>;
  fulfillmentLineItems(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new FulfillmentLineItemConnection()),
    };
    return this.$_select('fulfillmentLineItems', options) as any;
  }

  /**
   * The name of the tracking company.
   */
  get trackingCompany(): $Field<'trackingCompany', string | null | undefined> {
    return this.$_select('trackingCompany') as any;
  }

  /**
 * Tracking information associated with the fulfillment,
such as the tracking number and tracking URL.

 */
  trackingInfo<
    Args extends VariabledInput<{
      first?: number | null | undefined;
    }>,
    Sel extends Selection<FulfillmentTrackingInfo>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
      }
    >,
    selectorFn: (s: FulfillmentTrackingInfo) => [...Sel],
  ): $Field<'trackingInfo', Array<GetOutput<Sel>>, GetVariables<Sel, Args>>;
  trackingInfo<Sel extends Selection<FulfillmentTrackingInfo>>(
    selectorFn: (s: FulfillmentTrackingInfo) => [...Sel],
  ): $Field<'trackingInfo', Array<GetOutput<Sel>>, GetVariables<Sel>>;
  trackingInfo(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
      },
      args,

      selection: selectorFn(new FulfillmentTrackingInfo()),
    };
    return this.$_select('trackingInfo', options) as any;
  }
}

/**
 * Represents a single line item in a fulfillment. There is at most one fulfillment line item for each order line item.
 */
/* #__PURE__ */
export class FulfillmentLineItem extends $Base<'FulfillmentLineItem'> {
  constructor() {
    super('FulfillmentLineItem');
  }

  /**
   * The associated order's line item.
   */
  lineItem<Sel extends Selection<OrderLineItem>>(
    selectorFn: (s: OrderLineItem) => [...Sel],
  ): $Field<'lineItem', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new OrderLineItem()),
    };
    return this.$_select('lineItem', options) as any;
  }

  /**
   * The amount fulfilled in this fulfillment.
   */
  get quantity(): $Field<'quantity', number> {
    return this.$_select('quantity') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple FulfillmentLineItems.

 */
/* #__PURE__ */
export class FulfillmentLineItemConnection extends $Base<'FulfillmentLineItemConnection'> {
  constructor() {
    super('FulfillmentLineItemConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<FulfillmentLineItemEdge>>(
    selectorFn: (s: FulfillmentLineItemEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new FulfillmentLineItemEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in FulfillmentLineItemEdge.
   */
  nodes<Sel extends Selection<FulfillmentLineItem>>(
    selectorFn: (s: FulfillmentLineItem) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new FulfillmentLineItem()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one FulfillmentLineItem and a cursor during pagination.

 */
/* #__PURE__ */
export class FulfillmentLineItemEdge extends $Base<'FulfillmentLineItemEdge'> {
  constructor() {
    super('FulfillmentLineItemEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of FulfillmentLineItemEdge.
   */
  node<Sel extends Selection<FulfillmentLineItem>>(
    selectorFn: (s: FulfillmentLineItem) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new FulfillmentLineItem()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Tracking information associated with the fulfillment.
 */
/* #__PURE__ */
export class FulfillmentTrackingInfo extends $Base<'FulfillmentTrackingInfo'> {
  constructor() {
    super('FulfillmentTrackingInfo');
  }

  /**
   * The tracking number of the fulfillment.
   */
  get number(): $Field<'number', string | null | undefined> {
    return this.$_select('number') as any;
  }

  /**
   * The URL to track the fulfillment.
   */
  get url(): $Field<'url', URL | null | undefined> {
    return this.$_select('url') as any;
  }
}

/**
 * The generic file resource lets you manage files in a merchant’s store. Generic files include any file that doesn’t fit into a designated type such as image or video. Example: PDF, JSON.
 */
/* #__PURE__ */
export class GenericFile extends $Base<'GenericFile'> {
  constructor() {
    super('GenericFile');
  }

  /**
   * A word or phrase to indicate the contents of a file.
   */
  get alt(): $Field<'alt', string | null | undefined> {
    return this.$_select('alt') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The MIME type of the file.
   */
  get mimeType(): $Field<'mimeType', string | null | undefined> {
    return this.$_select('mimeType') as any;
  }

  /**
   * The size of the original file in bytes.
   */
  get originalFileSize(): $Field<'originalFileSize', number | null | undefined> {
    return this.$_select('originalFileSize') as any;
  }

  /**
   * The preview image for the file.
   */
  previewImage<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'previewImage', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('previewImage', options) as any;
  }

  /**
   * The URL of the file.
   */
  get url(): $Field<'url', URL | null | undefined> {
    return this.$_select('url') as any;
  }
}

/**
 * The input fields used to specify a geographical location.
 */
export type GeoCoordinateInput = {
  latitude: number;
  longitude: number;
};

/**
 * A string containing HTML code. Refer to the [HTML spec](https://html.spec.whatwg.org/#elements-3) for a
complete list of HTML elements.

Example value: `"<p>Grey cotton knit sweater.</p>"`

 */
export type HTML = string;

/**
 * Represents information about the metafields associated to the specified resource.
 */
/* #__PURE__ */
export class HasMetafields extends $Interface<
  {
    Article: Article;
    Blog: Blog;
    Cart: Cart;
    Collection: Collection;
    Company: Company;
    CompanyLocation: CompanyLocation;
    Customer: Customer;
    Location: Location;
    Market: Market;
    Order: Order;
    Page: Page;
    Product: Product;
    ProductVariant: ProductVariant;
    SellingPlan: SellingPlan;
    Shop: Shop;
  },
  'HasMetafields'
> {
  constructor() {
    super(
      {
        Article: Article,
        Blog: Blog,
        Cart: Cart,
        Collection: Collection,
        Company: Company,
        CompanyLocation: CompanyLocation,
        Customer: Customer,
        Location: Location,
        Market: Market,
        Order: Order,
        Page: Page,
        Product: Product,
        ProductVariant: ProductVariant,
        SellingPlan: SellingPlan,
        Shop: Shop,
      },
      'HasMetafields',
    );
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }
}

/**
 * The input fields to identify a metafield on an owner resource by namespace and key.
 */
export type HasMetafieldsIdentifier = {
  key: string;
  namespace?: string | null | undefined;
};

/**
 * An ISO 8601-encoded datetime
 */
export type ISO8601DateTime = string;

/**
 * Represents an image resource.
 */
/* #__PURE__ */
export class Image extends $Base<'Image'> {
  constructor() {
    super('Image');
  }

  /**
   * A word or phrase to share the nature or contents of an image.
   */
  get altText(): $Field<'altText', string | null | undefined> {
    return this.$_select('altText') as any;
  }

  /**
   * The original height of the image in pixels. Returns `null` if the image isn't hosted by Shopify.
   */
  get height(): $Field<'height', number | null | undefined> {
    return this.$_select('height') as any;
  }

  /**
   * A unique ID for the image.
   */
  get id(): $Field<'id', string | null | undefined> {
    return this.$_select('id') as any;
  }

  /**
 * The location of the original image as a URL.

If there are any existing transformations in the original source URL, they will remain and not be stripped.

 */
  get originalSrc(): $Field<'originalSrc', URL> {
    return this.$_select('originalSrc') as any;
  }

  /**
   * The location of the image as a URL.
   */
  get src(): $Field<'src', URL> {
    return this.$_select('src') as any;
  }

  /**
 * The location of the transformed image as a URL.

All transformation arguments are considered "best-effort". If they can be applied to an image, they will be.
Otherwise any transformations which an image type doesn't support will be ignored.

 */
  transformedSrc<
    Args extends VariabledInput<{
      maxWidth?: number | null | undefined;
      maxHeight?: number | null | undefined;
      crop?: CropRegion | null | undefined;
      scale?: number | null | undefined;
      preferredContentType?: ImageContentType | null | undefined;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        maxWidth?: number | null | undefined;
        maxHeight?: number | null | undefined;
        crop?: CropRegion | null | undefined;
        scale?: number | null | undefined;
        preferredContentType?: ImageContentType | null | undefined;
      }
    >,
  ): $Field<'transformedSrc', URL, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        maxWidth: 'Int',
        maxHeight: 'Int',
        crop: 'CropRegion',
        scale: 'Int',
        preferredContentType: 'ImageContentType',
      },
      args,
    };
    return this.$_select('transformedSrc', options) as any;
  }

  /**
 * The location of the image as a URL.

If no transform options are specified, then the original image will be preserved including any pre-applied transforms.

All transformation options are considered "best-effort". Any transformation that the original image type doesn't support will be ignored.

If you need multiple variations of the same image, then you can use [GraphQL aliases](https://graphql.org/learn/queries/#aliases).

 */
  url<
    Args extends VariabledInput<{
      transform?: ImageTransformInput | null | undefined;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        transform?: ImageTransformInput | null | undefined;
      }
    >,
  ): $Field<'url', URL, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        transform: 'ImageTransformInput',
      },
      args,
    };
    return this.$_select('url', options) as any;
  }

  /**
   * The original width of the image in pixels. Returns `null` if the image isn't hosted by Shopify.
   */
  get width(): $Field<'width', number | null | undefined> {
    return this.$_select('width') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Images.

 */
/* #__PURE__ */
export class ImageConnection extends $Base<'ImageConnection'> {
  constructor() {
    super('ImageConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<ImageEdge>>(
    selectorFn: (s: ImageEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ImageEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in ImageEdge.
   */
  nodes<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * List of supported image content types.
 */
export enum ImageContentType {
  /**
   * A PNG image.
   */
  PNG = 'PNG',

  /**
   * A JPG image.
   */
  JPG = 'JPG',

  /**
   * A WEBP image.
   */
  WEBP = 'WEBP',
}

/**
 * An auto-generated type which holds one Image and a cursor during pagination.

 */
/* #__PURE__ */
export class ImageEdge extends $Base<'ImageEdge'> {
  constructor() {
    super('ImageEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of ImageEdge.
   */
  node<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The available options for transforming an image.

All transformation options are considered best effort. Any transformation that
the original image type doesn't support will be ignored.

 */
export type ImageTransformInput = {
  crop?: CropRegion | null | undefined;
  maxHeight?: number | null | undefined;
  maxWidth?: number | null | undefined;
  preferredContentType?: ImageContentType | null | undefined;
  scale?: number | null | undefined;
};

/**
 * Provide details about the contexts influenced by the @inContext directive on a field.
 */
/* #__PURE__ */
export class InContextAnnotation extends $Base<'InContextAnnotation'> {
  constructor() {
    super('InContextAnnotation');
  }

  get description(): $Field<'description', string> {
    return this.$_select('description') as any;
  }

  type<Sel extends Selection<InContextAnnotationType>>(
    selectorFn: (s: InContextAnnotationType) => [...Sel],
  ): $Field<'type', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new InContextAnnotationType()),
    };
    return this.$_select('type', options) as any;
  }
}

/**
 * This gives information about the type of context that impacts a field. For example, for a query with @inContext(language: "EN"), the type would point to the name: LanguageCode and kind: ENUM.
 */
/* #__PURE__ */
export class InContextAnnotationType extends $Base<'InContextAnnotationType'> {
  constructor() {
    super('InContextAnnotationType');
  }

  get kind(): $Field<'kind', string> {
    return this.$_select('kind') as any;
  }

  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }
}

/**
 * A [JSON](https://www.json.org/json-en.html) object.

Example value:
`{
  "product": {
    "id": "gid://shopify/Product/1346443542550",
    "title": "White T-shirt",
    "options": [{
      "name": "Size",
      "values": ["M", "L"]
    }]
  }
}`

 */
export type JSON = string;

/**
 * A language.
 */
/* #__PURE__ */
export class Language extends $Base<'Language'> {
  constructor() {
    super('Language');
  }

  /**
   * The name of the language in the language itself. If the language uses capitalization, it is capitalized for a mid-sentence position.
   */
  get endonymName(): $Field<'endonymName', string> {
    return this.$_select('endonymName') as any;
  }

  /**
   * The ISO code.
   */
  get isoCode(): $Field<'isoCode', LanguageCode> {
    return this.$_select('isoCode') as any;
  }

  /**
   * The name of the language in the current language.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }
}

/**
 * Language codes supported by Shopify.
 */
export enum LanguageCode {
  /**
   * Afrikaans.
   */
  AF = 'AF',

  /**
   * Akan.
   */
  AK = 'AK',

  /**
   * Amharic.
   */
  AM = 'AM',

  /**
   * Arabic.
   */
  AR = 'AR',

  /**
   * Assamese.
   */
  AS = 'AS',

  /**
   * Azerbaijani.
   */
  AZ = 'AZ',

  /**
   * Belarusian.
   */
  BE = 'BE',

  /**
   * Bulgarian.
   */
  BG = 'BG',

  /**
   * Bambara.
   */
  BM = 'BM',

  /**
   * Bangla.
   */
  BN = 'BN',

  /**
   * Tibetan.
   */
  BO = 'BO',

  /**
   * Breton.
   */
  BR = 'BR',

  /**
   * Bosnian.
   */
  BS = 'BS',

  /**
   * Catalan.
   */
  CA = 'CA',

  /**
   * Chechen.
   */
  CE = 'CE',

  /**
   * Central Kurdish.
   */
  CKB = 'CKB',

  /**
   * Czech.
   */
  CS = 'CS',

  /**
   * Welsh.
   */
  CY = 'CY',

  /**
   * Danish.
   */
  DA = 'DA',

  /**
   * German.
   */
  DE = 'DE',

  /**
   * Dzongkha.
   */
  DZ = 'DZ',

  /**
   * Ewe.
   */
  EE = 'EE',

  /**
   * Greek.
   */
  EL = 'EL',

  /**
   * English.
   */
  EN = 'EN',

  /**
   * Esperanto.
   */
  EO = 'EO',

  /**
   * Spanish.
   */
  ES = 'ES',

  /**
   * Estonian.
   */
  ET = 'ET',

  /**
   * Basque.
   */
  EU = 'EU',

  /**
   * Persian.
   */
  FA = 'FA',

  /**
   * Fulah.
   */
  FF = 'FF',

  /**
   * Finnish.
   */
  FI = 'FI',

  /**
   * Filipino.
   */
  FIL = 'FIL',

  /**
   * Faroese.
   */
  FO = 'FO',

  /**
   * French.
   */
  FR = 'FR',

  /**
   * Western Frisian.
   */
  FY = 'FY',

  /**
   * Irish.
   */
  GA = 'GA',

  /**
   * Scottish Gaelic.
   */
  GD = 'GD',

  /**
   * Galician.
   */
  GL = 'GL',

  /**
   * Gujarati.
   */
  GU = 'GU',

  /**
   * Manx.
   */
  GV = 'GV',

  /**
   * Hausa.
   */
  HA = 'HA',

  /**
   * Hebrew.
   */
  HE = 'HE',

  /**
   * Hindi.
   */
  HI = 'HI',

  /**
   * Croatian.
   */
  HR = 'HR',

  /**
   * Hungarian.
   */
  HU = 'HU',

  /**
   * Armenian.
   */
  HY = 'HY',

  /**
   * Interlingua.
   */
  IA = 'IA',

  /**
   * Indonesian.
   */
  ID = 'ID',

  /**
   * Igbo.
   */
  IG = 'IG',

  /**
   * Sichuan Yi.
   */
  II = 'II',

  /**
   * Icelandic.
   */
  IS = 'IS',

  /**
   * Italian.
   */
  IT = 'IT',

  /**
   * Japanese.
   */
  JA = 'JA',

  /**
   * Javanese.
   */
  JV = 'JV',

  /**
   * Georgian.
   */
  KA = 'KA',

  /**
   * Kikuyu.
   */
  KI = 'KI',

  /**
   * Kazakh.
   */
  KK = 'KK',

  /**
   * Kalaallisut.
   */
  KL = 'KL',

  /**
   * Khmer.
   */
  KM = 'KM',

  /**
   * Kannada.
   */
  KN = 'KN',

  /**
   * Korean.
   */
  KO = 'KO',

  /**
   * Kashmiri.
   */
  KS = 'KS',

  /**
   * Kurdish.
   */
  KU = 'KU',

  /**
   * Cornish.
   */
  KW = 'KW',

  /**
   * Kyrgyz.
   */
  KY = 'KY',

  /**
   * Luxembourgish.
   */
  LB = 'LB',

  /**
   * Ganda.
   */
  LG = 'LG',

  /**
   * Lingala.
   */
  LN = 'LN',

  /**
   * Lao.
   */
  LO = 'LO',

  /**
   * Lithuanian.
   */
  LT = 'LT',

  /**
   * Luba-Katanga.
   */
  LU = 'LU',

  /**
   * Latvian.
   */
  LV = 'LV',

  /**
   * Malagasy.
   */
  MG = 'MG',

  /**
   * Māori.
   */
  MI = 'MI',

  /**
   * Macedonian.
   */
  MK = 'MK',

  /**
   * Malayalam.
   */
  ML = 'ML',

  /**
   * Mongolian.
   */
  MN = 'MN',

  /**
   * Marathi.
   */
  MR = 'MR',

  /**
   * Malay.
   */
  MS = 'MS',

  /**
   * Maltese.
   */
  MT = 'MT',

  /**
   * Burmese.
   */
  MY = 'MY',

  /**
   * Norwegian (Bokmål).
   */
  NB = 'NB',

  /**
   * North Ndebele.
   */
  ND = 'ND',

  /**
   * Nepali.
   */
  NE = 'NE',

  /**
   * Dutch.
   */
  NL = 'NL',

  /**
   * Norwegian Nynorsk.
   */
  NN = 'NN',

  /**
   * Norwegian.
   */
  NO = 'NO',

  /**
   * Oromo.
   */
  OM = 'OM',

  /**
   * Odia.
   */
  OR = 'OR',

  /**
   * Ossetic.
   */
  OS = 'OS',

  /**
   * Punjabi.
   */
  PA = 'PA',

  /**
   * Polish.
   */
  PL = 'PL',

  /**
   * Pashto.
   */
  PS = 'PS',

  /**
   * Portuguese (Brazil).
   */
  PT_BR = 'PT_BR',

  /**
   * Portuguese (Portugal).
   */
  PT_PT = 'PT_PT',

  /**
   * Quechua.
   */
  QU = 'QU',

  /**
   * Romansh.
   */
  RM = 'RM',

  /**
   * Rundi.
   */
  RN = 'RN',

  /**
   * Romanian.
   */
  RO = 'RO',

  /**
   * Russian.
   */
  RU = 'RU',

  /**
   * Kinyarwanda.
   */
  RW = 'RW',

  /**
   * Sanskrit.
   */
  SA = 'SA',

  /**
   * Sardinian.
   */
  SC = 'SC',

  /**
   * Sindhi.
   */
  SD = 'SD',

  /**
   * Northern Sami.
   */
  SE = 'SE',

  /**
   * Sango.
   */
  SG = 'SG',

  /**
   * Sinhala.
   */
  SI = 'SI',

  /**
   * Slovak.
   */
  SK = 'SK',

  /**
   * Slovenian.
   */
  SL = 'SL',

  /**
   * Shona.
   */
  SN = 'SN',

  /**
   * Somali.
   */
  SO = 'SO',

  /**
   * Albanian.
   */
  SQ = 'SQ',

  /**
   * Serbian.
   */
  SR = 'SR',

  /**
   * Sundanese.
   */
  SU = 'SU',

  /**
   * Swedish.
   */
  SV = 'SV',

  /**
   * Swahili.
   */
  SW = 'SW',

  /**
   * Tamil.
   */
  TA = 'TA',

  /**
   * Telugu.
   */
  TE = 'TE',

  /**
   * Tajik.
   */
  TG = 'TG',

  /**
   * Thai.
   */
  TH = 'TH',

  /**
   * Tigrinya.
   */
  TI = 'TI',

  /**
   * Turkmen.
   */
  TK = 'TK',

  /**
   * Tongan.
   */
  TO = 'TO',

  /**
   * Turkish.
   */
  TR = 'TR',

  /**
   * Tatar.
   */
  TT = 'TT',

  /**
   * Uyghur.
   */
  UG = 'UG',

  /**
   * Ukrainian.
   */
  UK = 'UK',

  /**
   * Urdu.
   */
  UR = 'UR',

  /**
   * Uzbek.
   */
  UZ = 'UZ',

  /**
   * Vietnamese.
   */
  VI = 'VI',

  /**
   * Wolof.
   */
  WO = 'WO',

  /**
   * Xhosa.
   */
  XH = 'XH',

  /**
   * Yiddish.
   */
  YI = 'YI',

  /**
   * Yoruba.
   */
  YO = 'YO',

  /**
   * Chinese (Simplified).
   */
  ZH_CN = 'ZH_CN',

  /**
   * Chinese (Traditional).
   */
  ZH_TW = 'ZH_TW',

  /**
   * Zulu.
   */
  ZU = 'ZU',

  /**
   * Chinese.
   */
  ZH = 'ZH',

  /**
   * Portuguese.
   */
  PT = 'PT',

  /**
   * Church Slavic.
   */
  CU = 'CU',

  /**
   * Volapük.
   */
  VO = 'VO',

  /**
   * Latin.
   */
  LA = 'LA',

  /**
   * Serbo-Croatian.
   */
  SH = 'SH',

  /**
   * Moldavian.
   */
  MO = 'MO',
}

/**
 * Information about the localized experiences configured for the shop.
 */
/* #__PURE__ */
export class Localization extends $Base<'Localization'> {
  constructor() {
    super('Localization');
  }

  /**
   * The list of countries with enabled localized experiences.
   */
  availableCountries<Sel extends Selection<Country>>(
    selectorFn: (s: Country) => [...Sel],
  ): $Field<'availableCountries', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Country()),
    };
    return this.$_select('availableCountries', options) as any;
  }

  /**
   * The list of languages available for the active country.
   */
  availableLanguages<Sel extends Selection<Language>>(
    selectorFn: (s: Language) => [...Sel],
  ): $Field<'availableLanguages', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Language()),
    };
    return this.$_select('availableLanguages', options) as any;
  }

  /**
   * The country of the active localized experience. Use the `@inContext` directive to change this value.
   */
  country<Sel extends Selection<Country>>(
    selectorFn: (s: Country) => [...Sel],
  ): $Field<'country', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Country()),
    };
    return this.$_select('country', options) as any;
  }

  /**
   * The language of the active localized experience. Use the `@inContext` directive to change this value.
   */
  language<Sel extends Selection<Language>>(
    selectorFn: (s: Language) => [...Sel],
  ): $Field<'language', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Language()),
    };
    return this.$_select('language', options) as any;
  }

  /**
   * The market including the country of the active localized experience. Use the `@inContext` directive to change this value.
   */
  market<Sel extends Selection<Market>>(
    selectorFn: (s: Market) => [...Sel],
  ): $Field<'market', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Market()),
    };
    return this.$_select('market', options) as any;
  }
}

/**
 * Represents a location where product inventory is held.
 */
/* #__PURE__ */
export class Location extends $Base<'Location'> {
  constructor() {
    super('Location');
  }

  /**
   * The address of the location.
   */
  address<Sel extends Selection<LocationAddress>>(
    selectorFn: (s: LocationAddress) => [...Sel],
  ): $Field<'address', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new LocationAddress()),
    };
    return this.$_select('address', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The name of the location.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }
}

/**
 * Represents the address of a location.

 */
/* #__PURE__ */
export class LocationAddress extends $Base<'LocationAddress'> {
  constructor() {
    super('LocationAddress');
  }

  /**
   * The first line of the address for the location.
   */
  get address1(): $Field<'address1', string | null | undefined> {
    return this.$_select('address1') as any;
  }

  /**
   * The second line of the address for the location.
   */
  get address2(): $Field<'address2', string | null | undefined> {
    return this.$_select('address2') as any;
  }

  /**
   * The city of the location.
   */
  get city(): $Field<'city', string | null | undefined> {
    return this.$_select('city') as any;
  }

  /**
   * The country of the location.
   */
  get country(): $Field<'country', string | null | undefined> {
    return this.$_select('country') as any;
  }

  /**
   * The country code of the location.
   */
  get countryCode(): $Field<'countryCode', string | null | undefined> {
    return this.$_select('countryCode') as any;
  }

  /**
   * A formatted version of the address for the location.
   */
  get formatted(): $Field<'formatted', Readonly<Array<string>>> {
    return this.$_select('formatted') as any;
  }

  /**
   * The latitude coordinates of the location.
   */
  get latitude(): $Field<'latitude', number | null | undefined> {
    return this.$_select('latitude') as any;
  }

  /**
   * The longitude coordinates of the location.
   */
  get longitude(): $Field<'longitude', number | null | undefined> {
    return this.$_select('longitude') as any;
  }

  /**
   * The phone number of the location.
   */
  get phone(): $Field<'phone', string | null | undefined> {
    return this.$_select('phone') as any;
  }

  /**
   * The province of the location.
   */
  get province(): $Field<'province', string | null | undefined> {
    return this.$_select('province') as any;
  }

  /**
 * The code for the province, state, or district of the address of the location.

 */
  get provinceCode(): $Field<'provinceCode', string | null | undefined> {
    return this.$_select('provinceCode') as any;
  }

  /**
   * The ZIP code of the location.
   */
  get zip(): $Field<'zip', string | null | undefined> {
    return this.$_select('zip') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Locations.

 */
/* #__PURE__ */
export class LocationConnection extends $Base<'LocationConnection'> {
  constructor() {
    super('LocationConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<LocationEdge>>(
    selectorFn: (s: LocationEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new LocationEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in LocationEdge.
   */
  nodes<Sel extends Selection<Location>>(
    selectorFn: (s: Location) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Location()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one Location and a cursor during pagination.

 */
/* #__PURE__ */
export class LocationEdge extends $Base<'LocationEdge'> {
  constructor() {
    super('LocationEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of LocationEdge.
   */
  node<Sel extends Selection<Location>>(
    selectorFn: (s: Location) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Location()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The set of valid sort keys for the Location query.
 */
export enum LocationSortKeys {
  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
   * Sort by the `name` value.
   */
  NAME = 'NAME',

  /**
   * Sort by the `city` value.
   */
  CITY = 'CITY',

  /**
   * Sort by the `distance` value.
   */
  DISTANCE = 'DISTANCE',
}

/**
 * Represents a mailing address for customers and shipping.
 */
/* #__PURE__ */
export class MailingAddress extends $Base<'MailingAddress'> {
  constructor() {
    super('MailingAddress');
  }

  /**
   * The first line of the address. Typically the street address or PO Box number.
   */
  get address1(): $Field<'address1', string | null | undefined> {
    return this.$_select('address1') as any;
  }

  /**
 * The second line of the address. Typically the number of the apartment, suite, or unit.

 */
  get address2(): $Field<'address2', string | null | undefined> {
    return this.$_select('address2') as any;
  }

  /**
   * The name of the city, district, village, or town.
   */
  get city(): $Field<'city', string | null | undefined> {
    return this.$_select('city') as any;
  }

  /**
   * The name of the customer's company or organization.
   */
  get company(): $Field<'company', string | null | undefined> {
    return this.$_select('company') as any;
  }

  /**
   * The name of the country.
   */
  get country(): $Field<'country', string | null | undefined> {
    return this.$_select('country') as any;
  }

  /**
 * The two-letter code for the country of the address.

For example, US.

 */
  get countryCode(): $Field<'countryCode', string | null | undefined> {
    return this.$_select('countryCode') as any;
  }

  /**
 * The two-letter code for the country of the address.

For example, US.

 */
  get countryCodeV2(): $Field<'countryCodeV2', CountryCode | null | undefined> {
    return this.$_select('countryCodeV2') as any;
  }

  /**
   * The first name of the customer.
   */
  get firstName(): $Field<'firstName', string | null | undefined> {
    return this.$_select('firstName') as any;
  }

  /**
   * A formatted version of the address, customized by the provided arguments.
   */
  formatted<
    Args extends VariabledInput<{
      withName?: boolean | null | undefined;
      withCompany?: boolean | null | undefined;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        withName?: boolean | null | undefined;
        withCompany?: boolean | null | undefined;
      }
    >,
  ): $Field<'formatted', Readonly<Array<string>>, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        withName: 'Boolean',
        withCompany: 'Boolean',
      },
      args,
    };
    return this.$_select('formatted', options) as any;
  }

  /**
   * A comma-separated list of the values for city, province, and country.
   */
  get formattedArea(): $Field<'formattedArea', string | null | undefined> {
    return this.$_select('formattedArea') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The last name of the customer.
   */
  get lastName(): $Field<'lastName', string | null | undefined> {
    return this.$_select('lastName') as any;
  }

  /**
   * The latitude coordinate of the customer address.
   */
  get latitude(): $Field<'latitude', number | null | undefined> {
    return this.$_select('latitude') as any;
  }

  /**
   * The longitude coordinate of the customer address.
   */
  get longitude(): $Field<'longitude', number | null | undefined> {
    return this.$_select('longitude') as any;
  }

  /**
   * The full name of the customer, based on firstName and lastName.
   */
  get name(): $Field<'name', string | null | undefined> {
    return this.$_select('name') as any;
  }

  /**
 * A unique phone number for the customer.

Formatted using E.164 standard. For example, _+16135551111_.

 */
  get phone(): $Field<'phone', string | null | undefined> {
    return this.$_select('phone') as any;
  }

  /**
   * The region of the address, such as the province, state, or district.
   */
  get province(): $Field<'province', string | null | undefined> {
    return this.$_select('province') as any;
  }

  /**
 * The alphanumeric code for the region.

For example, ON.

 */
  get provinceCode(): $Field<'provinceCode', string | null | undefined> {
    return this.$_select('provinceCode') as any;
  }

  /**
   * The zip or postal code of the address.
   */
  get zip(): $Field<'zip', string | null | undefined> {
    return this.$_select('zip') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple MailingAddresses.

 */
/* #__PURE__ */
export class MailingAddressConnection extends $Base<'MailingAddressConnection'> {
  constructor() {
    super('MailingAddressConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<MailingAddressEdge>>(
    selectorFn: (s: MailingAddressEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddressEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in MailingAddressEdge.
   */
  nodes<Sel extends Selection<MailingAddress>>(
    selectorFn: (s: MailingAddress) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddress()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one MailingAddress and a cursor during pagination.

 */
/* #__PURE__ */
export class MailingAddressEdge extends $Base<'MailingAddressEdge'> {
  constructor() {
    super('MailingAddressEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of MailingAddressEdge.
   */
  node<Sel extends Selection<MailingAddress>>(
    selectorFn: (s: MailingAddress) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddress()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The input fields to create or update a mailing address.
 */
export type MailingAddressInput = {
  address1?: string | null | undefined;
  address2?: string | null | undefined;
  city?: string | null | undefined;
  company?: string | null | undefined;
  country?: string | null | undefined;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  phone?: string | null | undefined;
  province?: string | null | undefined;
  zip?: string | null | undefined;
};

/**
 * Manual discount applications capture the intentions of a discount that was manually created.

 */
/* #__PURE__ */
export class ManualDiscountApplication extends $Base<'ManualDiscountApplication'> {
  constructor() {
    super('ManualDiscountApplication');
  }

  /**
   * The method by which the discount's value is allocated to its entitled items.
   */
  get allocationMethod(): $Field<'allocationMethod', DiscountApplicationAllocationMethod> {
    return this.$_select('allocationMethod') as any;
  }

  /**
   * The description of the application.
   */
  get description(): $Field<'description', string | null | undefined> {
    return this.$_select('description') as any;
  }

  /**
   * Which lines of targetType that the discount is allocated over.
   */
  get targetSelection(): $Field<'targetSelection', DiscountApplicationTargetSelection> {
    return this.$_select('targetSelection') as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }

  /**
   * The title of the application.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * The value of the discount application.
   */
  value<Sel extends Selection<PricingValue>>(
    selectorFn: (s: PricingValue) => [...Sel],
  ): $Field<'value', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PricingValue()),
    };
    return this.$_select('value', options) as any;
  }
}

/**
 * A group of one or more regions of the world that a merchant is targeting for sales. To learn more about markets, refer to [the Shopify Markets conceptual overview](/docs/apps/markets).
 */
/* #__PURE__ */
export class Market extends $Base<'Market'> {
  constructor() {
    super('Market');
  }

  /**
 * A human-readable unique string for the market automatically generated from its title.

 */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }
}

/**
 * Represents a media interface.
 */
/* #__PURE__ */
export class Media extends $Interface<
  { ExternalVideo: ExternalVideo; MediaImage: MediaImage; Model3d: Model3d; Video: Video },
  'Media'
> {
  constructor() {
    super({ ExternalVideo: ExternalVideo, MediaImage: MediaImage, Model3d: Model3d, Video: Video }, 'Media');
  }

  /**
   * A word or phrase to share the nature or contents of a media.
   */
  get alt(): $Field<'alt', string | null | undefined> {
    return this.$_select('alt') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The media content type.
   */
  get mediaContentType(): $Field<'mediaContentType', MediaContentType> {
    return this.$_select('mediaContentType') as any;
  }

  /**
   * The presentation for a media.
   */
  presentation<Sel extends Selection<MediaPresentation>>(
    selectorFn: (s: MediaPresentation) => [...Sel],
  ): $Field<'presentation', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaPresentation()),
    };
    return this.$_select('presentation', options) as any;
  }

  /**
   * The preview image for the media.
   */
  previewImage<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'previewImage', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('previewImage', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Media.

 */
/* #__PURE__ */
export class MediaConnection extends $Base<'MediaConnection'> {
  constructor() {
    super('MediaConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<MediaEdge>>(
    selectorFn: (s: MediaEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in MediaEdge.
   */
  nodes<Sel extends Selection<Media>>(
    selectorFn: (s: Media) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Media()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * The possible content types for a media object.
 */
export enum MediaContentType {
  /**
   * An externally hosted video.
   */
  EXTERNAL_VIDEO = 'EXTERNAL_VIDEO',

  /**
   * A Shopify hosted image.
   */
  IMAGE = 'IMAGE',

  /**
   * A 3d model.
   */
  MODEL_3D = 'MODEL_3D',

  /**
   * A Shopify hosted video.
   */
  VIDEO = 'VIDEO',
}

/**
 * An auto-generated type which holds one Media and a cursor during pagination.

 */
/* #__PURE__ */
export class MediaEdge extends $Base<'MediaEdge'> {
  constructor() {
    super('MediaEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of MediaEdge.
   */
  node<Sel extends Selection<Media>>(
    selectorFn: (s: Media) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Media()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Host for a Media Resource.
 */
export enum MediaHost {
  /**
   * Host for YouTube embedded videos.
   */
  YOUTUBE = 'YOUTUBE',

  /**
   * Host for Vimeo embedded videos.
   */
  VIMEO = 'VIMEO',
}

/**
 * Represents a Shopify hosted image.
 */
/* #__PURE__ */
export class MediaImage extends $Base<'MediaImage'> {
  constructor() {
    super('MediaImage');
  }

  /**
   * A word or phrase to share the nature or contents of a media.
   */
  get alt(): $Field<'alt', string | null | undefined> {
    return this.$_select('alt') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The image for the media.
   */
  image<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('image', options) as any;
  }

  /**
   * The media content type.
   */
  get mediaContentType(): $Field<'mediaContentType', MediaContentType> {
    return this.$_select('mediaContentType') as any;
  }

  /**
   * The presentation for a media.
   */
  presentation<Sel extends Selection<MediaPresentation>>(
    selectorFn: (s: MediaPresentation) => [...Sel],
  ): $Field<'presentation', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaPresentation()),
    };
    return this.$_select('presentation', options) as any;
  }

  /**
   * The preview image for the media.
   */
  previewImage<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'previewImage', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('previewImage', options) as any;
  }
}

/**
 * A media presentation.
 */
/* #__PURE__ */
export class MediaPresentation extends $Base<'MediaPresentation'> {
  constructor() {
    super('MediaPresentation');
  }

  /**
   * A JSON object representing a presentation view.
   */
  asJson<
    Args extends VariabledInput<{
      format: MediaPresentationFormat;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        format: MediaPresentationFormat;
      }
    >,
  ): $Field<'asJson', JSON | null | undefined, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        format: 'MediaPresentationFormat!',
      },
      args,
    };
    return this.$_select('asJson', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }
}

/**
 * The possible formats for a media presentation.
 */
export enum MediaPresentationFormat {
  /**
   * A model viewer presentation.
   */
  MODEL_VIEWER = 'MODEL_VIEWER',

  /**
   * A media image presentation.
   */
  IMAGE = 'IMAGE',
}

/**
 * A [navigation menu](https://help.shopify.com/manual/online-store/menus-and-links) representing a hierarchy
of hyperlinks (items).

 */
/* #__PURE__ */
export class Menu extends $Base<'Menu'> {
  constructor() {
    super('Menu');
  }

  /**
   * The menu's handle.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The menu's child items.
   */
  items<Sel extends Selection<MenuItem>>(
    selectorFn: (s: MenuItem) => [...Sel],
  ): $Field<'items', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MenuItem()),
    };
    return this.$_select('items', options) as any;
  }

  /**
   * The count of items on the menu.
   */
  get itemsCount(): $Field<'itemsCount', number> {
    return this.$_select('itemsCount') as any;
  }

  /**
   * The menu's title.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }
}

/**
 * A menu item within a parent menu.
 */
/* #__PURE__ */
export class MenuItem extends $Base<'MenuItem'> {
  constructor() {
    super('MenuItem');
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The menu item's child items.
   */
  items<Sel extends Selection<MenuItem>>(
    selectorFn: (s: MenuItem) => [...Sel],
  ): $Field<'items', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MenuItem()),
    };
    return this.$_select('items', options) as any;
  }

  /**
   * The linked resource.
   */
  resource<Sel extends Selection<MenuItemResource>>(
    selectorFn: (s: MenuItemResource) => [...Sel],
  ): $Field<'resource', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MenuItemResource()),
    };
    return this.$_select('resource', options) as any;
  }

  /**
   * The ID of the linked resource.
   */
  get resourceId(): $Field<'resourceId', string | null | undefined> {
    return this.$_select('resourceId') as any;
  }

  /**
   * The menu item's tags to filter a collection.
   */
  get tags(): $Field<'tags', Readonly<Array<string>>> {
    return this.$_select('tags') as any;
  }

  /**
   * The menu item's title.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * The menu item's type.
   */
  get type(): $Field<'type', MenuItemType> {
    return this.$_select('type') as any;
  }

  /**
   * The menu item's URL.
   */
  get url(): $Field<'url', URL | null | undefined> {
    return this.$_select('url') as any;
  }
}

/**
 * The list of possible resources a `MenuItem` can reference.

 */
/* #__PURE__ */
export class MenuItemResource extends $Union<
  {
    Article: Article;
    Blog: Blog;
    Collection: Collection;
    Metaobject: Metaobject;
    Page: Page;
    Product: Product;
    ShopPolicy: ShopPolicy;
    HasMetafields: HasMetafields;
    Node: Node;
    OnlineStorePublishable: OnlineStorePublishable;
    Trackable: Trackable;
  },
  'MenuItemResource'
> {
  constructor() {
    super(
      {
        Article: Article,
        Blog: Blog,
        Collection: Collection,
        Metaobject: Metaobject,
        Page: Page,
        Product: Product,
        ShopPolicy: ShopPolicy,
        HasMetafields: HasMetafields,
        Node: Node,
        OnlineStorePublishable: OnlineStorePublishable,
        Trackable: Trackable,
      },
      'MenuItemResource',
    );
  }
}

/**
 * A menu item type.
 */
export enum MenuItemType {
  /**
   * A frontpage link.
   */
  FRONTPAGE = 'FRONTPAGE',

  /**
   * A collection link.
   */
  COLLECTION = 'COLLECTION',

  /**
   * A collection link.
   */
  COLLECTIONS = 'COLLECTIONS',

  /**
   * A product link.
   */
  PRODUCT = 'PRODUCT',

  /**
   * A catalog link.
   */
  CATALOG = 'CATALOG',

  /**
   * A page link.
   */
  PAGE = 'PAGE',

  /**
   * A blog link.
   */
  BLOG = 'BLOG',

  /**
   * An article link.
   */
  ARTICLE = 'ARTICLE',

  /**
   * A search link.
   */
  SEARCH = 'SEARCH',

  /**
   * A shop policy link.
   */
  SHOP_POLICY = 'SHOP_POLICY',

  /**
   * An http link.
   */
  HTTP = 'HTTP',

  /**
   * A metaobject page link.
   */
  METAOBJECT = 'METAOBJECT',

  /**
   * A customer account page link.
   */
  CUSTOMER_ACCOUNT_PAGE = 'CUSTOMER_ACCOUNT_PAGE',
}

/**
 * The merchandise to be purchased at checkout.
 */
/* #__PURE__ */
export class Merchandise extends $Union<
  { ProductVariant: ProductVariant; HasMetafields: HasMetafields; Node: Node },
  'Merchandise'
> {
  constructor() {
    super({ ProductVariant: ProductVariant, HasMetafields: HasMetafields, Node: Node }, 'Merchandise');
  }
}

/**
 * Metafields represent custom metadata attached to a resource. Metafields can be sorted into namespaces and are
comprised of keys, values, and value types.

 */
/* #__PURE__ */
export class Metafield extends $Base<'Metafield'> {
  constructor() {
    super('Metafield');
  }

  /**
   * The date and time when the storefront metafield was created.
   */
  get createdAt(): $Field<'createdAt', DateTime> {
    return this.$_select('createdAt') as any;
  }

  /**
   * The description of a metafield.
   */
  get description(): $Field<'description', string | null | undefined> {
    return this.$_select('description') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The unique identifier for the metafield within its namespace.
   */
  get key(): $Field<'key', string> {
    return this.$_select('key') as any;
  }

  /**
   * The container for a group of metafields that the metafield is associated with.
   */
  get namespace(): $Field<'namespace', string> {
    return this.$_select('namespace') as any;
  }

  /**
   * The type of resource that the metafield is attached to.
   */
  parentResource<Sel extends Selection<MetafieldParentResource>>(
    selectorFn: (s: MetafieldParentResource) => [...Sel],
  ): $Field<'parentResource', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetafieldParentResource()),
    };
    return this.$_select('parentResource', options) as any;
  }

  /**
   * Returns a reference object if the metafield's type is a resource reference.
   */
  reference<Sel extends Selection<MetafieldReference>>(
    selectorFn: (s: MetafieldReference) => [...Sel],
  ): $Field<'reference', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetafieldReference()),
    };
    return this.$_select('reference', options) as any;
  }

  /**
   * A list of reference objects if the metafield's type is a resource reference list.
   */
  references<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
    }>,
    Sel extends Selection<MetafieldReferenceConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
      }
    >,
    selectorFn: (s: MetafieldReferenceConnection) => [...Sel],
  ): $Field<'references', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  references<Sel extends Selection<MetafieldReferenceConnection>>(
    selectorFn: (s: MetafieldReferenceConnection) => [...Sel],
  ): $Field<'references', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  references(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
      },
      args,

      selection: selectorFn(new MetafieldReferenceConnection()),
    };
    return this.$_select('references', options) as any;
  }

  /**
 * The type name of the metafield.
Refer to the list of [supported types](https://shopify.dev/apps/metafields/definitions/types).

 */
  get type(): $Field<'type', string> {
    return this.$_select('type') as any;
  }

  /**
   * The date and time when the metafield was last updated.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }

  /**
   * The data stored in the metafield. Always stored as a string, regardless of the metafield's type.
   */
  get value(): $Field<'value', string> {
    return this.$_select('value') as any;
  }
}

/**
 * Possible error codes that can be returned by `MetafieldDeleteUserError`.
 */
export enum MetafieldDeleteErrorCode {
  /**
   * The owner ID is invalid.
   */
  INVALID_OWNER = 'INVALID_OWNER',

  /**
   * Metafield not found.
   */
  METAFIELD_DOES_NOT_EXIST = 'METAFIELD_DOES_NOT_EXIST',
}

/**
 * An error that occurs during the execution of cart metafield deletion.
 */
/* #__PURE__ */
export class MetafieldDeleteUserError extends $Base<'MetafieldDeleteUserError'> {
  constructor() {
    super('MetafieldDeleteUserError');
  }

  /**
   * The error code.
   */
  get code(): $Field<'code', MetafieldDeleteErrorCode | null | undefined> {
    return this.$_select('code') as any;
  }

  /**
   * The path to the input field that caused the error.
   */
  get field(): $Field<'field', Readonly<Array<string>> | null | undefined> {
    return this.$_select('field') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string> {
    return this.$_select('message') as any;
  }
}

/**
 * A filter used to view a subset of products in a collection matching a specific metafield value.

Only the following metafield types are currently supported:
- `number_integer`
- `number_decimal`
- `single_line_text_field`
- `boolean` as of 2022-04.

 */
export type MetafieldFilter = {
  key: string;
  namespace: string;
  value: string;
};

/**
 * A resource that the metafield belongs to.
 */
/* #__PURE__ */
export class MetafieldParentResource extends $Union<
  {
    Article: Article;
    Blog: Blog;
    Cart: Cart;
    Collection: Collection;
    Company: Company;
    CompanyLocation: CompanyLocation;
    Customer: Customer;
    Location: Location;
    Market: Market;
    Order: Order;
    Page: Page;
    Product: Product;
    ProductVariant: ProductVariant;
    SellingPlan: SellingPlan;
    Shop: Shop;
    HasMetafields: HasMetafields;
    Node: Node;
    OnlineStorePublishable: OnlineStorePublishable;
    Trackable: Trackable;
  },
  'MetafieldParentResource'
> {
  constructor() {
    super(
      {
        Article: Article,
        Blog: Blog,
        Cart: Cart,
        Collection: Collection,
        Company: Company,
        CompanyLocation: CompanyLocation,
        Customer: Customer,
        Location: Location,
        Market: Market,
        Order: Order,
        Page: Page,
        Product: Product,
        ProductVariant: ProductVariant,
        SellingPlan: SellingPlan,
        Shop: Shop,
        HasMetafields: HasMetafields,
        Node: Node,
        OnlineStorePublishable: OnlineStorePublishable,
        Trackable: Trackable,
      },
      'MetafieldParentResource',
    );
  }
}

/**
 * Returns the resource which is being referred to by a metafield.

 */
/* #__PURE__ */
export class MetafieldReference extends $Union<
  {
    Collection: Collection;
    GenericFile: GenericFile;
    MediaImage: MediaImage;
    Metaobject: Metaobject;
    Model3d: Model3d;
    Page: Page;
    Product: Product;
    ProductVariant: ProductVariant;
    Video: Video;
    HasMetafields: HasMetafields;
    Node: Node;
    OnlineStorePublishable: OnlineStorePublishable;
    Trackable: Trackable;
    Media: Media;
  },
  'MetafieldReference'
> {
  constructor() {
    super(
      {
        Collection: Collection,
        GenericFile: GenericFile,
        MediaImage: MediaImage,
        Metaobject: Metaobject,
        Model3d: Model3d,
        Page: Page,
        Product: Product,
        ProductVariant: ProductVariant,
        Video: Video,
        HasMetafields: HasMetafields,
        Node: Node,
        OnlineStorePublishable: OnlineStorePublishable,
        Trackable: Trackable,
        Media: Media,
      },
      'MetafieldReference',
    );
  }
}

/**
 * An auto-generated type for paginating through multiple MetafieldReferences.

 */
/* #__PURE__ */
export class MetafieldReferenceConnection extends $Base<'MetafieldReferenceConnection'> {
  constructor() {
    super('MetafieldReferenceConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<MetafieldReferenceEdge>>(
    selectorFn: (s: MetafieldReferenceEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetafieldReferenceEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in MetafieldReferenceEdge.
   */
  nodes<Sel extends Selection<MetafieldReference>>(
    selectorFn: (s: MetafieldReference) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetafieldReference()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one MetafieldReference and a cursor during pagination.

 */
/* #__PURE__ */
export class MetafieldReferenceEdge extends $Base<'MetafieldReferenceEdge'> {
  constructor() {
    super('MetafieldReferenceEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of MetafieldReferenceEdge.
   */
  node<Sel extends Selection<MetafieldReference>>(
    selectorFn: (s: MetafieldReference) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetafieldReference()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * An error that occurs during the execution of `MetafieldsSet`.
 */
/* #__PURE__ */
export class MetafieldsSetUserError extends $Base<'MetafieldsSetUserError'> {
  constructor() {
    super('MetafieldsSetUserError');
  }

  /**
   * The error code.
   */
  get code(): $Field<'code', MetafieldsSetUserErrorCode | null | undefined> {
    return this.$_select('code') as any;
  }

  /**
   * The index of the array element that's causing the error.
   */
  get elementIndex(): $Field<'elementIndex', number | null | undefined> {
    return this.$_select('elementIndex') as any;
  }

  /**
   * The path to the input field that caused the error.
   */
  get field(): $Field<'field', Readonly<Array<string>> | null | undefined> {
    return this.$_select('field') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string> {
    return this.$_select('message') as any;
  }
}

/**
 * Possible error codes that can be returned by `MetafieldsSetUserError`.
 */
export enum MetafieldsSetUserErrorCode {
  /**
   * The input value is blank.
   */
  BLANK = 'BLANK',

  /**
   * The input value isn't included in the list.
   */
  INCLUSION = 'INCLUSION',

  /**
   * The input value should be less than or equal to the maximum value allowed.
   */
  LESS_THAN_OR_EQUAL_TO = 'LESS_THAN_OR_EQUAL_TO',

  /**
   * The input value needs to be blank.
   */
  PRESENT = 'PRESENT',

  /**
   * The input value is too short.
   */
  TOO_SHORT = 'TOO_SHORT',

  /**
   * The input value is too long.
   */
  TOO_LONG = 'TOO_LONG',

  /**
   * The owner ID is invalid.
   */
  INVALID_OWNER = 'INVALID_OWNER',

  /**
   * The value is invalid for metafield type or for definition options.
   */
  INVALID_VALUE = 'INVALID_VALUE',

  /**
   * The type is invalid.
   */
  INVALID_TYPE = 'INVALID_TYPE',
}

/**
 * An instance of a user-defined model based on a MetaobjectDefinition.
 */
/* #__PURE__ */
export class Metaobject extends $Base<'Metaobject'> {
  constructor() {
    super('Metaobject');
  }

  /**
   * Accesses a field of the object by key.
   */
  field<
    Args extends VariabledInput<{
      key: string;
    }>,
    Sel extends Selection<MetaobjectField>,
  >(
    args: ExactArgNames<
      Args,
      {
        key: string;
      }
    >,
    selectorFn: (s: MetaobjectField) => [...Sel],
  ): $Field<'field', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        key: 'String!',
      },
      args,

      selection: selectorFn(new MetaobjectField()),
    };
    return this.$_select('field', options) as any;
  }

  /**
 * All object fields with defined values.
Omitted object keys can be assumed null, and no guarantees are made about field order.

 */
  fields<Sel extends Selection<MetaobjectField>>(
    selectorFn: (s: MetaobjectField) => [...Sel],
  ): $Field<'fields', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetaobjectField()),
    };
    return this.$_select('fields', options) as any;
  }

  /**
   * The unique handle of the metaobject. Useful as a custom ID.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The URL used for viewing the metaobject on the shop's Online Store. Returns `null` if the metaobject definition doesn't have the `online_store` capability.
   */
  get onlineStoreUrl(): $Field<'onlineStoreUrl', URL | null | undefined> {
    return this.$_select('onlineStoreUrl') as any;
  }

  /**
 * The metaobject's SEO information. Returns `null` if the metaobject definition
doesn't have the `renderable` capability.

 */
  seo<Sel extends Selection<MetaobjectSEO>>(
    selectorFn: (s: MetaobjectSEO) => [...Sel],
  ): $Field<'seo', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetaobjectSEO()),
    };
    return this.$_select('seo', options) as any;
  }

  /**
   * The type of the metaobject. Defines the namespace of its associated metafields.
   */
  get type(): $Field<'type', string> {
    return this.$_select('type') as any;
  }

  /**
   * The date and time when the metaobject was last updated.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Metaobjects.

 */
/* #__PURE__ */
export class MetaobjectConnection extends $Base<'MetaobjectConnection'> {
  constructor() {
    super('MetaobjectConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<MetaobjectEdge>>(
    selectorFn: (s: MetaobjectEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetaobjectEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in MetaobjectEdge.
   */
  nodes<Sel extends Selection<Metaobject>>(
    selectorFn: (s: Metaobject) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Metaobject()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one Metaobject and a cursor during pagination.

 */
/* #__PURE__ */
export class MetaobjectEdge extends $Base<'MetaobjectEdge'> {
  constructor() {
    super('MetaobjectEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of MetaobjectEdge.
   */
  node<Sel extends Selection<Metaobject>>(
    selectorFn: (s: Metaobject) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Metaobject()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Provides the value of a Metaobject field.
 */
/* #__PURE__ */
export class MetaobjectField extends $Base<'MetaobjectField'> {
  constructor() {
    super('MetaobjectField');
  }

  /**
   * The field key.
   */
  get key(): $Field<'key', string> {
    return this.$_select('key') as any;
  }

  /**
   * A referenced object if the field type is a resource reference.
   */
  reference<Sel extends Selection<MetafieldReference>>(
    selectorFn: (s: MetafieldReference) => [...Sel],
  ): $Field<'reference', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetafieldReference()),
    };
    return this.$_select('reference', options) as any;
  }

  /**
   * A list of referenced objects if the field type is a resource reference list.
   */
  references<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
    }>,
    Sel extends Selection<MetafieldReferenceConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
      }
    >,
    selectorFn: (s: MetafieldReferenceConnection) => [...Sel],
  ): $Field<'references', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  references<Sel extends Selection<MetafieldReferenceConnection>>(
    selectorFn: (s: MetafieldReferenceConnection) => [...Sel],
  ): $Field<'references', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  references(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
      },
      args,

      selection: selectorFn(new MetafieldReferenceConnection()),
    };
    return this.$_select('references', options) as any;
  }

  /**
 * The type name of the field.
See the list of [supported types](https://shopify.dev/apps/metafields/definitions/types).

 */
  get type(): $Field<'type', string> {
    return this.$_select('type') as any;
  }

  /**
   * The field value.
   */
  get value(): $Field<'value', string | null | undefined> {
    return this.$_select('value') as any;
  }
}

/**
 * The input fields used to retrieve a metaobject by handle.
 */
export type MetaobjectHandleInput = {
  handle: string;
  type: string;
};

/**
 * SEO information for a metaobject.
 */
/* #__PURE__ */
export class MetaobjectSEO extends $Base<'MetaobjectSEO'> {
  constructor() {
    super('MetaobjectSEO');
  }

  /**
   * The meta description.
   */
  description<Sel extends Selection<MetaobjectField>>(
    selectorFn: (s: MetaobjectField) => [...Sel],
  ): $Field<'description', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetaobjectField()),
    };
    return this.$_select('description', options) as any;
  }

  /**
   * The SEO title.
   */
  title<Sel extends Selection<MetaobjectField>>(
    selectorFn: (s: MetaobjectField) => [...Sel],
  ): $Field<'title', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MetaobjectField()),
    };
    return this.$_select('title', options) as any;
  }
}

/**
 * Represents a Shopify hosted 3D model.
 */
/* #__PURE__ */
export class Model3d extends $Base<'Model3d'> {
  constructor() {
    super('Model3d');
  }

  /**
   * A word or phrase to share the nature or contents of a media.
   */
  get alt(): $Field<'alt', string | null | undefined> {
    return this.$_select('alt') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The media content type.
   */
  get mediaContentType(): $Field<'mediaContentType', MediaContentType> {
    return this.$_select('mediaContentType') as any;
  }

  /**
   * The presentation for a media.
   */
  presentation<Sel extends Selection<MediaPresentation>>(
    selectorFn: (s: MediaPresentation) => [...Sel],
  ): $Field<'presentation', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaPresentation()),
    };
    return this.$_select('presentation', options) as any;
  }

  /**
   * The preview image for the media.
   */
  previewImage<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'previewImage', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('previewImage', options) as any;
  }

  /**
   * The sources for a 3d model.
   */
  sources<Sel extends Selection<Model3dSource>>(
    selectorFn: (s: Model3dSource) => [...Sel],
  ): $Field<'sources', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Model3dSource()),
    };
    return this.$_select('sources', options) as any;
  }
}

/**
 * Represents a source for a Shopify hosted 3d model.
 */
/* #__PURE__ */
export class Model3dSource extends $Base<'Model3dSource'> {
  constructor() {
    super('Model3dSource');
  }

  /**
   * The filesize of the 3d model.
   */
  get filesize(): $Field<'filesize', number> {
    return this.$_select('filesize') as any;
  }

  /**
   * The format of the 3d model.
   */
  get format(): $Field<'format', string> {
    return this.$_select('format') as any;
  }

  /**
   * The MIME type of the 3d model.
   */
  get mimeType(): $Field<'mimeType', string> {
    return this.$_select('mimeType') as any;
  }

  /**
   * The URL of the 3d model.
   */
  get url(): $Field<'url', string> {
    return this.$_select('url') as any;
  }
}

/**
 * The input fields for a monetary value with currency.
 */
export type MoneyInput = {
  amount: Decimal;
  currencyCode: CurrencyCode;
};

/**
 * A monetary value with currency.

 */
/* #__PURE__ */
export class MoneyV2 extends $Base<'MoneyV2'> {
  constructor() {
    super('MoneyV2');
  }

  /**
   * Decimal money amount.
   */
  get amount(): $Field<'amount', Decimal> {
    return this.$_select('amount') as any;
  }

  /**
   * Currency of the money.
   */
  get currencyCode(): $Field<'currencyCode', CurrencyCode> {
    return this.$_select('currencyCode') as any;
  }
}

/**
 * The schema’s entry-point for mutations. This acts as the public, top-level API from which all mutation queries must start.
 */
/* #__PURE__ */
export class Mutation extends $Base<'Mutation'> {
  constructor() {
    super('Mutation');
  }

  /**
   * Updates the attributes on a cart.
   */
  cartAttributesUpdate<
    Args extends VariabledInput<{
      attributes: Readonly<Array<AttributeInput>>;
      cartId: string;
    }>,
    Sel extends Selection<CartAttributesUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        attributes: Readonly<Array<AttributeInput>>;
        cartId: string;
      }
    >,
    selectorFn: (s: CartAttributesUpdatePayload) => [...Sel],
  ): $Field<'cartAttributesUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        attributes: '[AttributeInput!]!',
        cartId: 'ID!',
      },
      args,

      selection: selectorFn(new CartAttributesUpdatePayload()),
    };
    return this.$_select('cartAttributesUpdate', options) as any;
  }

  /**
   * Updates the billing address on the cart.
   */
  cartBillingAddressUpdate<
    Args extends VariabledInput<{
      cartId: string;
      billingAddress?: MailingAddressInput | null | undefined;
    }>,
    Sel extends Selection<CartBillingAddressUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        billingAddress?: MailingAddressInput | null | undefined;
      }
    >,
    selectorFn: (s: CartBillingAddressUpdatePayload) => [...Sel],
  ): $Field<'cartBillingAddressUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        billingAddress: 'MailingAddressInput',
      },
      args,

      selection: selectorFn(new CartBillingAddressUpdatePayload()),
    };
    return this.$_select('cartBillingAddressUpdate', options) as any;
  }

  /**
 * Updates customer information associated with a cart.
Buyer identity is used to determine
[international pricing](https://shopify.dev/custom-storefronts/internationalization/international-pricing)
and should match the customer's shipping address.

 */
  cartBuyerIdentityUpdate<
    Args extends VariabledInput<{
      cartId: string;
      buyerIdentity: CartBuyerIdentityInput;
    }>,
    Sel extends Selection<CartBuyerIdentityUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        buyerIdentity: CartBuyerIdentityInput;
      }
    >,
    selectorFn: (s: CartBuyerIdentityUpdatePayload) => [...Sel],
  ): $Field<'cartBuyerIdentityUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        buyerIdentity: 'CartBuyerIdentityInput!',
      },
      args,

      selection: selectorFn(new CartBuyerIdentityUpdatePayload()),
    };
    return this.$_select('cartBuyerIdentityUpdate', options) as any;
  }

  /**
   * Creates a new cart.
   */
  cartCreate<
    Args extends VariabledInput<{
      input?: CartInput | null | undefined;
    }>,
    Sel extends Selection<CartCreatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        input?: CartInput | null | undefined;
      }
    >,
    selectorFn: (s: CartCreatePayload) => [...Sel],
  ): $Field<'cartCreate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  cartCreate<Sel extends Selection<CartCreatePayload>>(
    selectorFn: (s: CartCreatePayload) => [...Sel],
  ): $Field<'cartCreate', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  cartCreate(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        input: 'CartInput',
      },
      args,

      selection: selectorFn(new CartCreatePayload()),
    };
    return this.$_select('cartCreate', options) as any;
  }

  /**
   * Updates the discount codes applied to the cart.
   */
  cartDiscountCodesUpdate<
    Args extends VariabledInput<{
      cartId: string;
      discountCodes?: Readonly<Array<string>> | null | undefined;
    }>,
    Sel extends Selection<CartDiscountCodesUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        discountCodes?: Readonly<Array<string>> | null | undefined;
      }
    >,
    selectorFn: (s: CartDiscountCodesUpdatePayload) => [...Sel],
  ): $Field<'cartDiscountCodesUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        discountCodes: '[String!]',
      },
      args,

      selection: selectorFn(new CartDiscountCodesUpdatePayload()),
    };
    return this.$_select('cartDiscountCodesUpdate', options) as any;
  }

  /**
   * Updates the gift card codes applied to the cart.
   */
  cartGiftCardCodesUpdate<
    Args extends VariabledInput<{
      cartId: string;
      giftCardCodes: Readonly<Array<string>>;
    }>,
    Sel extends Selection<CartGiftCardCodesUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        giftCardCodes: Readonly<Array<string>>;
      }
    >,
    selectorFn: (s: CartGiftCardCodesUpdatePayload) => [...Sel],
  ): $Field<'cartGiftCardCodesUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        giftCardCodes: '[String!]!',
      },
      args,

      selection: selectorFn(new CartGiftCardCodesUpdatePayload()),
    };
    return this.$_select('cartGiftCardCodesUpdate', options) as any;
  }

  /**
   * Adds a merchandise line to the cart.
   */
  cartLinesAdd<
    Args extends VariabledInput<{
      cartId: string;
      lines: Readonly<Array<CartLineInput>>;
    }>,
    Sel extends Selection<CartLinesAddPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        lines: Readonly<Array<CartLineInput>>;
      }
    >,
    selectorFn: (s: CartLinesAddPayload) => [...Sel],
  ): $Field<'cartLinesAdd', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        lines: '[CartLineInput!]!',
      },
      args,

      selection: selectorFn(new CartLinesAddPayload()),
    };
    return this.$_select('cartLinesAdd', options) as any;
  }

  /**
   * Removes one or more merchandise lines from the cart.
   */
  cartLinesRemove<
    Args extends VariabledInput<{
      cartId: string;
      lineIds: Readonly<Array<string>>;
    }>,
    Sel extends Selection<CartLinesRemovePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        lineIds: Readonly<Array<string>>;
      }
    >,
    selectorFn: (s: CartLinesRemovePayload) => [...Sel],
  ): $Field<'cartLinesRemove', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        lineIds: '[ID!]!',
      },
      args,

      selection: selectorFn(new CartLinesRemovePayload()),
    };
    return this.$_select('cartLinesRemove', options) as any;
  }

  /**
   * Updates one or more merchandise lines on a cart.
   */
  cartLinesUpdate<
    Args extends VariabledInput<{
      cartId: string;
      lines: Readonly<Array<CartLineUpdateInput>>;
    }>,
    Sel extends Selection<CartLinesUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        lines: Readonly<Array<CartLineUpdateInput>>;
      }
    >,
    selectorFn: (s: CartLinesUpdatePayload) => [...Sel],
  ): $Field<'cartLinesUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        lines: '[CartLineUpdateInput!]!',
      },
      args,

      selection: selectorFn(new CartLinesUpdatePayload()),
    };
    return this.$_select('cartLinesUpdate', options) as any;
  }

  /**
   * Deletes a cart metafield.
   */
  cartMetafieldDelete<
    Args extends VariabledInput<{
      input: CartMetafieldDeleteInput;
    }>,
    Sel extends Selection<CartMetafieldDeletePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        input: CartMetafieldDeleteInput;
      }
    >,
    selectorFn: (s: CartMetafieldDeletePayload) => [...Sel],
  ): $Field<'cartMetafieldDelete', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        input: 'CartMetafieldDeleteInput!',
      },
      args,

      selection: selectorFn(new CartMetafieldDeletePayload()),
    };
    return this.$_select('cartMetafieldDelete', options) as any;
  }

  /**
 * Sets cart metafield values. Cart metafield values will be set regardless if they were previously created or not.

Allows a maximum of 25 cart metafields to be set at a time.

 */
  cartMetafieldsSet<
    Args extends VariabledInput<{
      metafields: Readonly<Array<CartMetafieldsSetInput>>;
    }>,
    Sel extends Selection<CartMetafieldsSetPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        metafields: Readonly<Array<CartMetafieldsSetInput>>;
      }
    >,
    selectorFn: (s: CartMetafieldsSetPayload) => [...Sel],
  ): $Field<'cartMetafieldsSet', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        metafields: '[CartMetafieldsSetInput!]!',
      },
      args,

      selection: selectorFn(new CartMetafieldsSetPayload()),
    };
    return this.$_select('cartMetafieldsSet', options) as any;
  }

  /**
   * Updates the note on the cart.
   */
  cartNoteUpdate<
    Args extends VariabledInput<{
      cartId: string;
      note: string;
    }>,
    Sel extends Selection<CartNoteUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        note: string;
      }
    >,
    selectorFn: (s: CartNoteUpdatePayload) => [...Sel],
  ): $Field<'cartNoteUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        note: 'String!',
      },
      args,

      selection: selectorFn(new CartNoteUpdatePayload()),
    };
    return this.$_select('cartNoteUpdate', options) as any;
  }

  /**
   * Update the customer's payment method that will be used to checkout.
   */
  cartPaymentUpdate<
    Args extends VariabledInput<{
      cartId: string;
      payment: CartPaymentInput;
    }>,
    Sel extends Selection<CartPaymentUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        payment: CartPaymentInput;
      }
    >,
    selectorFn: (s: CartPaymentUpdatePayload) => [...Sel],
  ): $Field<'cartPaymentUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        payment: 'CartPaymentInput!',
      },
      args,

      selection: selectorFn(new CartPaymentUpdatePayload()),
    };
    return this.$_select('cartPaymentUpdate', options) as any;
  }

  /**
   * Update the selected delivery options for a delivery group.
   */
  cartSelectedDeliveryOptionsUpdate<
    Args extends VariabledInput<{
      cartId: string;
      selectedDeliveryOptions: Readonly<Array<CartSelectedDeliveryOptionInput>>;
    }>,
    Sel extends Selection<CartSelectedDeliveryOptionsUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        selectedDeliveryOptions: Readonly<Array<CartSelectedDeliveryOptionInput>>;
      }
    >,
    selectorFn: (s: CartSelectedDeliveryOptionsUpdatePayload) => [...Sel],
  ): $Field<'cartSelectedDeliveryOptionsUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        selectedDeliveryOptions: '[CartSelectedDeliveryOptionInput!]!',
      },
      args,

      selection: selectorFn(new CartSelectedDeliveryOptionsUpdatePayload()),
    };
    return this.$_select('cartSelectedDeliveryOptionsUpdate', options) as any;
  }

  /**
   * Submit the cart for checkout completion.
   */
  cartSubmitForCompletion<
    Args extends VariabledInput<{
      cartId: string;
      attemptToken: string;
    }>,
    Sel extends Selection<CartSubmitForCompletionPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        cartId: string;
        attemptToken: string;
      }
    >,
    selectorFn: (s: CartSubmitForCompletionPayload) => [...Sel],
  ): $Field<'cartSubmitForCompletion', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        cartId: 'ID!',
        attemptToken: 'String!',
      },
      args,

      selection: selectorFn(new CartSubmitForCompletionPayload()),
    };
    return this.$_select('cartSubmitForCompletion', options) as any;
  }

  /**
 * Creates a customer access token.
The customer access token is required to modify the customer object in any way.

 */
  customerAccessTokenCreate<
    Args extends VariabledInput<{
      input: CustomerAccessTokenCreateInput;
    }>,
    Sel extends Selection<CustomerAccessTokenCreatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        input: CustomerAccessTokenCreateInput;
      }
    >,
    selectorFn: (s: CustomerAccessTokenCreatePayload) => [...Sel],
  ): $Field<'customerAccessTokenCreate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        input: 'CustomerAccessTokenCreateInput!',
      },
      args,

      selection: selectorFn(new CustomerAccessTokenCreatePayload()),
    };
    return this.$_select('customerAccessTokenCreate', options) as any;
  }

  /**
 * Creates a customer access token using a
[multipass token](https://shopify.dev/api/multipass) instead of email and
password. A customer record is created if the customer doesn't exist. If a customer
record already exists but the record is disabled, then the customer record is enabled.

 */
  customerAccessTokenCreateWithMultipass<
    Args extends VariabledInput<{
      multipassToken: string;
    }>,
    Sel extends Selection<CustomerAccessTokenCreateWithMultipassPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        multipassToken: string;
      }
    >,
    selectorFn: (s: CustomerAccessTokenCreateWithMultipassPayload) => [...Sel],
  ): $Field<'customerAccessTokenCreateWithMultipass', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        multipassToken: 'String!',
      },
      args,

      selection: selectorFn(new CustomerAccessTokenCreateWithMultipassPayload()),
    };
    return this.$_select('customerAccessTokenCreateWithMultipass', options) as any;
  }

  /**
   * Permanently destroys a customer access token.
   */
  customerAccessTokenDelete<
    Args extends VariabledInput<{
      customerAccessToken: string;
    }>,
    Sel extends Selection<CustomerAccessTokenDeletePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        customerAccessToken: string;
      }
    >,
    selectorFn: (s: CustomerAccessTokenDeletePayload) => [...Sel],
  ): $Field<'customerAccessTokenDelete', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        customerAccessToken: 'String!',
      },
      args,

      selection: selectorFn(new CustomerAccessTokenDeletePayload()),
    };
    return this.$_select('customerAccessTokenDelete', options) as any;
  }

  /**
 * Renews a customer access token.

Access token renewal must happen *before* a token expires.
If a token has already expired, a new one should be created instead via `customerAccessTokenCreate`.

 */
  customerAccessTokenRenew<
    Args extends VariabledInput<{
      customerAccessToken: string;
    }>,
    Sel extends Selection<CustomerAccessTokenRenewPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        customerAccessToken: string;
      }
    >,
    selectorFn: (s: CustomerAccessTokenRenewPayload) => [...Sel],
  ): $Field<'customerAccessTokenRenew', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        customerAccessToken: 'String!',
      },
      args,

      selection: selectorFn(new CustomerAccessTokenRenewPayload()),
    };
    return this.$_select('customerAccessTokenRenew', options) as any;
  }

  /**
   * Activates a customer.
   */
  customerActivate<
    Args extends VariabledInput<{
      id: string;
      input: CustomerActivateInput;
    }>,
    Sel extends Selection<CustomerActivatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        id: string;
        input: CustomerActivateInput;
      }
    >,
    selectorFn: (s: CustomerActivatePayload) => [...Sel],
  ): $Field<'customerActivate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        id: 'ID!',
        input: 'CustomerActivateInput!',
      },
      args,

      selection: selectorFn(new CustomerActivatePayload()),
    };
    return this.$_select('customerActivate', options) as any;
  }

  /**
   * Activates a customer with the activation url received from `customerCreate`.
   */
  customerActivateByUrl<
    Args extends VariabledInput<{
      activationUrl: URL;
      password: string;
    }>,
    Sel extends Selection<CustomerActivateByUrlPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        activationUrl: URL;
        password: string;
      }
    >,
    selectorFn: (s: CustomerActivateByUrlPayload) => [...Sel],
  ): $Field<'customerActivateByUrl', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        activationUrl: 'URL!',
        password: 'String!',
      },
      args,

      selection: selectorFn(new CustomerActivateByUrlPayload()),
    };
    return this.$_select('customerActivateByUrl', options) as any;
  }

  /**
   * Creates a new address for a customer.
   */
  customerAddressCreate<
    Args extends VariabledInput<{
      customerAccessToken: string;
      address: MailingAddressInput;
    }>,
    Sel extends Selection<CustomerAddressCreatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        customerAccessToken: string;
        address: MailingAddressInput;
      }
    >,
    selectorFn: (s: CustomerAddressCreatePayload) => [...Sel],
  ): $Field<'customerAddressCreate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        customerAccessToken: 'String!',
        address: 'MailingAddressInput!',
      },
      args,

      selection: selectorFn(new CustomerAddressCreatePayload()),
    };
    return this.$_select('customerAddressCreate', options) as any;
  }

  /**
   * Permanently deletes the address of an existing customer.
   */
  customerAddressDelete<
    Args extends VariabledInput<{
      id: string;
      customerAccessToken: string;
    }>,
    Sel extends Selection<CustomerAddressDeletePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        id: string;
        customerAccessToken: string;
      }
    >,
    selectorFn: (s: CustomerAddressDeletePayload) => [...Sel],
  ): $Field<'customerAddressDelete', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        id: 'ID!',
        customerAccessToken: 'String!',
      },
      args,

      selection: selectorFn(new CustomerAddressDeletePayload()),
    };
    return this.$_select('customerAddressDelete', options) as any;
  }

  /**
   * Updates the address of an existing customer.
   */
  customerAddressUpdate<
    Args extends VariabledInput<{
      customerAccessToken: string;
      id: string;
      address: MailingAddressInput;
    }>,
    Sel extends Selection<CustomerAddressUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        customerAccessToken: string;
        id: string;
        address: MailingAddressInput;
      }
    >,
    selectorFn: (s: CustomerAddressUpdatePayload) => [...Sel],
  ): $Field<'customerAddressUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        customerAccessToken: 'String!',
        id: 'ID!',
        address: 'MailingAddressInput!',
      },
      args,

      selection: selectorFn(new CustomerAddressUpdatePayload()),
    };
    return this.$_select('customerAddressUpdate', options) as any;
  }

  /**
   * Creates a new customer.
   */
  customerCreate<
    Args extends VariabledInput<{
      input: CustomerCreateInput;
    }>,
    Sel extends Selection<CustomerCreatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        input: CustomerCreateInput;
      }
    >,
    selectorFn: (s: CustomerCreatePayload) => [...Sel],
  ): $Field<'customerCreate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        input: 'CustomerCreateInput!',
      },
      args,

      selection: selectorFn(new CustomerCreatePayload()),
    };
    return this.$_select('customerCreate', options) as any;
  }

  /**
   * Updates the default address of an existing customer.
   */
  customerDefaultAddressUpdate<
    Args extends VariabledInput<{
      customerAccessToken: string;
      addressId: string;
    }>,
    Sel extends Selection<CustomerDefaultAddressUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        customerAccessToken: string;
        addressId: string;
      }
    >,
    selectorFn: (s: CustomerDefaultAddressUpdatePayload) => [...Sel],
  ): $Field<'customerDefaultAddressUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        customerAccessToken: 'String!',
        addressId: 'ID!',
      },
      args,

      selection: selectorFn(new CustomerDefaultAddressUpdatePayload()),
    };
    return this.$_select('customerDefaultAddressUpdate', options) as any;
  }

  /**
 * Sends a reset password email to the customer. The reset password
email contains a reset password URL and token that you can pass to
the [`customerResetByUrl`](https://shopify.dev/api/storefront/latest/mutations/customerResetByUrl) or
[`customerReset`](https://shopify.dev/api/storefront/latest/mutations/customerReset) mutation to reset the
customer password.

This mutation is throttled by IP. With private access,
you can provide a [`Shopify-Storefront-Buyer-IP`](https://shopify.dev/api/usage/authentication#optional-ip-header) instead of the request IP.
The header is case-sensitive and must be sent as `Shopify-Storefront-Buyer-IP`.

Make sure that the value provided to `Shopify-Storefront-Buyer-IP` is trusted. Unthrottled access to this
mutation presents a security risk.

 */
  customerRecover<
    Args extends VariabledInput<{
      email: string;
    }>,
    Sel extends Selection<CustomerRecoverPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        email: string;
      }
    >,
    selectorFn: (s: CustomerRecoverPayload) => [...Sel],
  ): $Field<'customerRecover', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        email: 'String!',
      },
      args,

      selection: selectorFn(new CustomerRecoverPayload()),
    };
    return this.$_select('customerRecover', options) as any;
  }

  /**
 * "Resets a customer’s password with the token received from a reset password email. You can send a reset password email with the [`customerRecover`](https://shopify.dev/api/storefront/latest/mutations/customerRecover) mutation."

 */
  customerReset<
    Args extends VariabledInput<{
      id: string;
      input: CustomerResetInput;
    }>,
    Sel extends Selection<CustomerResetPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        id: string;
        input: CustomerResetInput;
      }
    >,
    selectorFn: (s: CustomerResetPayload) => [...Sel],
  ): $Field<'customerReset', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        id: 'ID!',
        input: 'CustomerResetInput!',
      },
      args,

      selection: selectorFn(new CustomerResetPayload()),
    };
    return this.$_select('customerReset', options) as any;
  }

  /**
 * "Resets a customer’s password with the reset password URL received from a reset password email. You can send a reset password email with the [`customerRecover`](https://shopify.dev/api/storefront/latest/mutations/customerRecover) mutation."

 */
  customerResetByUrl<
    Args extends VariabledInput<{
      resetUrl: URL;
      password: string;
    }>,
    Sel extends Selection<CustomerResetByUrlPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        resetUrl: URL;
        password: string;
      }
    >,
    selectorFn: (s: CustomerResetByUrlPayload) => [...Sel],
  ): $Field<'customerResetByUrl', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        resetUrl: 'URL!',
        password: 'String!',
      },
      args,

      selection: selectorFn(new CustomerResetByUrlPayload()),
    };
    return this.$_select('customerResetByUrl', options) as any;
  }

  /**
   * Updates an existing customer.
   */
  customerUpdate<
    Args extends VariabledInput<{
      customerAccessToken: string;
      customer: CustomerUpdateInput;
    }>,
    Sel extends Selection<CustomerUpdatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        customerAccessToken: string;
        customer: CustomerUpdateInput;
      }
    >,
    selectorFn: (s: CustomerUpdatePayload) => [...Sel],
  ): $Field<'customerUpdate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        customerAccessToken: 'String!',
        customer: 'CustomerUpdateInput!',
      },
      args,

      selection: selectorFn(new CustomerUpdatePayload()),
    };
    return this.$_select('customerUpdate', options) as any;
  }

  /**
   * Create a new Shop Pay payment request session.
   */
  shopPayPaymentRequestSessionCreate<
    Args extends VariabledInput<{
      sourceIdentifier: string;
      paymentRequest: ShopPayPaymentRequestInput;
    }>,
    Sel extends Selection<ShopPayPaymentRequestSessionCreatePayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        sourceIdentifier: string;
        paymentRequest: ShopPayPaymentRequestInput;
      }
    >,
    selectorFn: (s: ShopPayPaymentRequestSessionCreatePayload) => [...Sel],
  ): $Field<'shopPayPaymentRequestSessionCreate', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        sourceIdentifier: 'String!',
        paymentRequest: 'ShopPayPaymentRequestInput!',
      },
      args,

      selection: selectorFn(new ShopPayPaymentRequestSessionCreatePayload()),
    };
    return this.$_select('shopPayPaymentRequestSessionCreate', options) as any;
  }

  /**
   * Submits a Shop Pay payment request session.
   */
  shopPayPaymentRequestSessionSubmit<
    Args extends VariabledInput<{
      token: string;
      paymentRequest: ShopPayPaymentRequestInput;
      idempotencyKey: string;
      orderName?: string | null | undefined;
    }>,
    Sel extends Selection<ShopPayPaymentRequestSessionSubmitPayload>,
  >(
    args: ExactArgNames<
      Args,
      {
        token: string;
        paymentRequest: ShopPayPaymentRequestInput;
        idempotencyKey: string;
        orderName?: string | null | undefined;
      }
    >,
    selectorFn: (s: ShopPayPaymentRequestSessionSubmitPayload) => [...Sel],
  ): $Field<'shopPayPaymentRequestSessionSubmit', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        token: 'String!',
        paymentRequest: 'ShopPayPaymentRequestInput!',
        idempotencyKey: 'String!',
        orderName: 'String',
      },
      args,

      selection: selectorFn(new ShopPayPaymentRequestSessionSubmitPayload()),
    };
    return this.$_select('shopPayPaymentRequestSessionSubmit', options) as any;
  }
}

/**
 * An object with an ID field to support global identification, in accordance with the
[Relay specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface).
This interface is used by the [node](https://shopify.dev/api/admin-graphql/unstable/queries/node)
and [nodes](https://shopify.dev/api/admin-graphql/unstable/queries/nodes) queries.

 */
/* #__PURE__ */
export class Node extends $Interface<
  {
    AppliedGiftCard: AppliedGiftCard;
    Article: Article;
    Blog: Blog;
    Cart: Cart;
    CartLine: CartLine;
    Collection: Collection;
    Comment: Comment;
    Company: Company;
    CompanyContact: CompanyContact;
    CompanyLocation: CompanyLocation;
    ComponentizableCartLine: ComponentizableCartLine;
    ExternalVideo: ExternalVideo;
    GenericFile: GenericFile;
    Location: Location;
    MailingAddress: MailingAddress;
    Market: Market;
    MediaImage: MediaImage;
    MediaPresentation: MediaPresentation;
    Menu: Menu;
    MenuItem: MenuItem;
    Metafield: Metafield;
    Metaobject: Metaobject;
    Model3d: Model3d;
    Order: Order;
    Page: Page;
    Product: Product;
    ProductOption: ProductOption;
    ProductOptionValue: ProductOptionValue;
    ProductVariant: ProductVariant;
    Shop: Shop;
    ShopPayInstallmentsFinancingPlan: ShopPayInstallmentsFinancingPlan;
    ShopPayInstallmentsFinancingPlanTerm: ShopPayInstallmentsFinancingPlanTerm;
    ShopPayInstallmentsProductVariantPricing: ShopPayInstallmentsProductVariantPricing;
    ShopPolicy: ShopPolicy;
    TaxonomyCategory: TaxonomyCategory;
    UrlRedirect: UrlRedirect;
    Video: Video;
  },
  'Node'
> {
  constructor() {
    super(
      {
        AppliedGiftCard: AppliedGiftCard,
        Article: Article,
        Blog: Blog,
        Cart: Cart,
        CartLine: CartLine,
        Collection: Collection,
        Comment: Comment,
        Company: Company,
        CompanyContact: CompanyContact,
        CompanyLocation: CompanyLocation,
        ComponentizableCartLine: ComponentizableCartLine,
        ExternalVideo: ExternalVideo,
        GenericFile: GenericFile,
        Location: Location,
        MailingAddress: MailingAddress,
        Market: Market,
        MediaImage: MediaImage,
        MediaPresentation: MediaPresentation,
        Menu: Menu,
        MenuItem: MenuItem,
        Metafield: Metafield,
        Metaobject: Metaobject,
        Model3d: Model3d,
        Order: Order,
        Page: Page,
        Product: Product,
        ProductOption: ProductOption,
        ProductOptionValue: ProductOptionValue,
        ProductVariant: ProductVariant,
        Shop: Shop,
        ShopPayInstallmentsFinancingPlan: ShopPayInstallmentsFinancingPlan,
        ShopPayInstallmentsFinancingPlanTerm: ShopPayInstallmentsFinancingPlanTerm,
        ShopPayInstallmentsProductVariantPricing: ShopPayInstallmentsProductVariantPricing,
        ShopPolicy: ShopPolicy,
        TaxonomyCategory: TaxonomyCategory,
        UrlRedirect: UrlRedirect,
        Video: Video,
      },
      'Node',
    );
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }
}

/**
 * Represents a resource that can be published to the Online Store sales channel.
 */
/* #__PURE__ */
export class OnlineStorePublishable extends $Interface<
  { Article: Article; Blog: Blog; Collection: Collection; Metaobject: Metaobject; Page: Page; Product: Product },
  'OnlineStorePublishable'
> {
  constructor() {
    super(
      { Article: Article, Blog: Blog, Collection: Collection, Metaobject: Metaobject, Page: Page, Product: Product },
      'OnlineStorePublishable',
    );
  }

  /**
   * The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel.
   */
  get onlineStoreUrl(): $Field<'onlineStoreUrl', URL | null | undefined> {
    return this.$_select('onlineStoreUrl') as any;
  }
}

/**
 * An order is a customer’s completed request to purchase one or more products from a shop. An order is created when a customer completes the checkout process, during which time they provides an email address, billing address and payment information.
 */
/* #__PURE__ */
export class Order extends $Base<'Order'> {
  constructor() {
    super('Order');
  }

  /**
   * The address associated with the payment method.
   */
  billingAddress<Sel extends Selection<MailingAddress>>(
    selectorFn: (s: MailingAddress) => [...Sel],
  ): $Field<'billingAddress', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddress()),
    };
    return this.$_select('billingAddress', options) as any;
  }

  /**
   * The reason for the order's cancellation. Returns `null` if the order wasn't canceled.
   */
  get cancelReason(): $Field<'cancelReason', OrderCancelReason | null | undefined> {
    return this.$_select('cancelReason') as any;
  }

  /**
   * The date and time when the order was canceled. Returns null if the order wasn't canceled.
   */
  get canceledAt(): $Field<'canceledAt', DateTime | null | undefined> {
    return this.$_select('canceledAt') as any;
  }

  /**
   * The code of the currency used for the payment.
   */
  get currencyCode(): $Field<'currencyCode', CurrencyCode> {
    return this.$_select('currencyCode') as any;
  }

  /**
   * The subtotal of line items and their discounts, excluding line items that have been removed. Does not contain order-level discounts, duties, shipping costs, or shipping discounts. Taxes aren't included unless the order is a taxes-included order.
   */
  currentSubtotalPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'currentSubtotalPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('currentSubtotalPrice', options) as any;
  }

  /**
   * The total cost of duties for the order, including refunds.
   */
  currentTotalDuties<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'currentTotalDuties', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('currentTotalDuties', options) as any;
  }

  /**
   * The total amount of the order, including duties, taxes and discounts, minus amounts for line items that have been removed.
   */
  currentTotalPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'currentTotalPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('currentTotalPrice', options) as any;
  }

  /**
   * The total cost of shipping, excluding shipping lines that have been refunded or removed. Taxes aren't included unless the order is a taxes-included order.
   */
  currentTotalShippingPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'currentTotalShippingPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('currentTotalShippingPrice', options) as any;
  }

  /**
   * The total of all taxes applied to the order, excluding taxes for returned line items.
   */
  currentTotalTax<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'currentTotalTax', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('currentTotalTax', options) as any;
  }

  /**
   * A list of the custom attributes added to the order. For example, whether an order is a customer's first.
   */
  customAttributes<Sel extends Selection<Attribute>>(
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'customAttributes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Attribute()),
    };
    return this.$_select('customAttributes', options) as any;
  }

  /**
   * The locale code in which this specific order happened.
   */
  get customerLocale(): $Field<'customerLocale', string | null | undefined> {
    return this.$_select('customerLocale') as any;
  }

  /**
   * The unique URL that the customer can use to access the order.
   */
  get customerUrl(): $Field<'customerUrl', URL | null | undefined> {
    return this.$_select('customerUrl') as any;
  }

  /**
   * Discounts that have been applied on the order.
   */
  discountApplications<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<DiscountApplicationConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: DiscountApplicationConnection) => [...Sel],
  ): $Field<'discountApplications', GetOutput<Sel>, GetVariables<Sel, Args>>;
  discountApplications<Sel extends Selection<DiscountApplicationConnection>>(
    selectorFn: (s: DiscountApplicationConnection) => [...Sel],
  ): $Field<'discountApplications', GetOutput<Sel>, GetVariables<Sel>>;
  discountApplications(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new DiscountApplicationConnection()),
    };
    return this.$_select('discountApplications', options) as any;
  }

  /**
   * Whether the order has had any edits applied or not.
   */
  get edited(): $Field<'edited', boolean> {
    return this.$_select('edited') as any;
  }

  /**
   * The customer's email address.
   */
  get email(): $Field<'email', string | null | undefined> {
    return this.$_select('email') as any;
  }

  /**
   * The financial status of the order.
   */
  get financialStatus(): $Field<'financialStatus', OrderFinancialStatus | null | undefined> {
    return this.$_select('financialStatus') as any;
  }

  /**
   * The fulfillment status for the order.
   */
  get fulfillmentStatus(): $Field<'fulfillmentStatus', OrderFulfillmentStatus> {
    return this.$_select('fulfillmentStatus') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * List of the order’s line items.
   */
  lineItems<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<OrderLineItemConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: OrderLineItemConnection) => [...Sel],
  ): $Field<'lineItems', GetOutput<Sel>, GetVariables<Sel, Args>>;
  lineItems<Sel extends Selection<OrderLineItemConnection>>(
    selectorFn: (s: OrderLineItemConnection) => [...Sel],
  ): $Field<'lineItems', GetOutput<Sel>, GetVariables<Sel>>;
  lineItems(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new OrderLineItemConnection()),
    };
    return this.$_select('lineItems', options) as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
 * Unique identifier for the order that appears on the order.
For example, _#1000_ or _Store1001.

 */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * A unique numeric identifier for the order for use by shop owner and customer.
   */
  get orderNumber(): $Field<'orderNumber', number> {
    return this.$_select('orderNumber') as any;
  }

  /**
   * The total cost of duties charged at checkout.
   */
  originalTotalDuties<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'originalTotalDuties', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('originalTotalDuties', options) as any;
  }

  /**
   * The total price of the order before any applied edits.
   */
  originalTotalPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'originalTotalPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('originalTotalPrice', options) as any;
  }

  /**
   * The customer's phone number for receiving SMS notifications.
   */
  get phone(): $Field<'phone', string | null | undefined> {
    return this.$_select('phone') as any;
  }

  /**
 * The date and time when the order was imported.
This value can be set to dates in the past when importing from other systems.
If no value is provided, it will be auto-generated based on current date and time.

 */
  get processedAt(): $Field<'processedAt', DateTime> {
    return this.$_select('processedAt') as any;
  }

  /**
   * The address to where the order will be shipped.
   */
  shippingAddress<Sel extends Selection<MailingAddress>>(
    selectorFn: (s: MailingAddress) => [...Sel],
  ): $Field<'shippingAddress', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MailingAddress()),
    };
    return this.$_select('shippingAddress', options) as any;
  }

  /**
 * The discounts that have been allocated onto the shipping line by discount applications.

 */
  shippingDiscountAllocations<Sel extends Selection<DiscountAllocation>>(
    selectorFn: (s: DiscountAllocation) => [...Sel],
  ): $Field<'shippingDiscountAllocations', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new DiscountAllocation()),
    };
    return this.$_select('shippingDiscountAllocations', options) as any;
  }

  /**
   * The unique URL for the order's status page.
   */
  get statusUrl(): $Field<'statusUrl', URL> {
    return this.$_select('statusUrl') as any;
  }

  /**
   * Price of the order before shipping and taxes.
   */
  subtotalPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'subtotalPrice', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('subtotalPrice', options) as any;
  }

  /**
   * Price of the order before duties, shipping and taxes.
   */
  subtotalPriceV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'subtotalPriceV2', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('subtotalPriceV2', options) as any;
  }

  /**
   * List of the order’s successful fulfillments.
   */
  successfulFulfillments<
    Args extends VariabledInput<{
      first?: number | null | undefined;
    }>,
    Sel extends Selection<Fulfillment>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
      }
    >,
    selectorFn: (s: Fulfillment) => [...Sel],
  ): $Field<'successfulFulfillments', Array<GetOutput<Sel>> | undefined, GetVariables<Sel, Args>>;
  successfulFulfillments<Sel extends Selection<Fulfillment>>(
    selectorFn: (s: Fulfillment) => [...Sel],
  ): $Field<'successfulFulfillments', Array<GetOutput<Sel>> | undefined, GetVariables<Sel>>;
  successfulFulfillments(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
      },
      args,

      selection: selectorFn(new Fulfillment()),
    };
    return this.$_select('successfulFulfillments', options) as any;
  }

  /**
   * The sum of all the prices of all the items in the order, duties, taxes and discounts included (must be positive).
   */
  totalPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalPrice', options) as any;
  }

  /**
   * The sum of all the prices of all the items in the order, duties, taxes and discounts included (must be positive).
   */
  totalPriceV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalPriceV2', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalPriceV2', options) as any;
  }

  /**
   * The total amount that has been refunded.
   */
  totalRefunded<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalRefunded', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalRefunded', options) as any;
  }

  /**
   * The total amount that has been refunded.
   */
  totalRefundedV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalRefundedV2', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalRefundedV2', options) as any;
  }

  /**
   * The total cost of shipping.
   */
  totalShippingPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalShippingPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalShippingPrice', options) as any;
  }

  /**
   * The total cost of shipping.
   */
  totalShippingPriceV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalShippingPriceV2', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalShippingPriceV2', options) as any;
  }

  /**
   * The total cost of taxes.
   */
  totalTax<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalTax', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalTax', options) as any;
  }

  /**
   * The total cost of taxes.
   */
  totalTaxV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalTaxV2', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalTaxV2', options) as any;
  }
}

/**
 * Represents the reason for the order's cancellation.
 */
export enum OrderCancelReason {
  /**
   * The customer wanted to cancel the order.
   */
  CUSTOMER = 'CUSTOMER',

  /**
   * Payment was declined.
   */
  DECLINED = 'DECLINED',

  /**
   * The order was fraudulent.
   */
  FRAUD = 'FRAUD',

  /**
   * There was insufficient inventory.
   */
  INVENTORY = 'INVENTORY',

  /**
   * Staff made an error.
   */
  STAFF = 'STAFF',

  /**
   * The order was canceled for an unlisted reason.
   */
  OTHER = 'OTHER',
}

/**
 * An auto-generated type for paginating through multiple Orders.

 */
/* #__PURE__ */
export class OrderConnection extends $Base<'OrderConnection'> {
  constructor() {
    super('OrderConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<OrderEdge>>(
    selectorFn: (s: OrderEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new OrderEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in OrderEdge.
   */
  nodes<Sel extends Selection<Order>>(
    selectorFn: (s: Order) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Order()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }

  /**
   * The total count of Orders.
   */
  get totalCount(): $Field<'totalCount', UnsignedInt64> {
    return this.$_select('totalCount') as any;
  }
}

/**
 * An auto-generated type which holds one Order and a cursor during pagination.

 */
/* #__PURE__ */
export class OrderEdge extends $Base<'OrderEdge'> {
  constructor() {
    super('OrderEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of OrderEdge.
   */
  node<Sel extends Selection<Order>>(
    selectorFn: (s: Order) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Order()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Represents the order's current financial status.
 */
export enum OrderFinancialStatus {
  /**
   * Displayed as **Pending**.
   */
  PENDING = 'PENDING',

  /**
   * Displayed as **Authorized**.
   */
  AUTHORIZED = 'AUTHORIZED',

  /**
   * Displayed as **Partially paid**.
   */
  PARTIALLY_PAID = 'PARTIALLY_PAID',

  /**
   * Displayed as **Partially refunded**.
   */
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',

  /**
   * Displayed as **Voided**.
   */
  VOIDED = 'VOIDED',

  /**
   * Displayed as **Paid**.
   */
  PAID = 'PAID',

  /**
   * Displayed as **Refunded**.
   */
  REFUNDED = 'REFUNDED',
}

/**
 * Represents the order's aggregated fulfillment status for display purposes.
 */
export enum OrderFulfillmentStatus {
  /**
   * Displayed as **Unfulfilled**. None of the items in the order have been fulfilled.
   */
  UNFULFILLED = 'UNFULFILLED',

  /**
   * Displayed as **Partially fulfilled**. Some of the items in the order have been fulfilled.
   */
  PARTIALLY_FULFILLED = 'PARTIALLY_FULFILLED',

  /**
   * Displayed as **Fulfilled**. All of the items in the order have been fulfilled.
   */
  FULFILLED = 'FULFILLED',

  /**
   * Displayed as **Restocked**. All of the items in the order have been restocked. Replaced by "UNFULFILLED" status.
   */
  RESTOCKED = 'RESTOCKED',

  /**
   * Displayed as **Pending fulfillment**. A request for fulfillment of some items awaits a response from the fulfillment service. Replaced by "IN_PROGRESS" status.
   */
  PENDING_FULFILLMENT = 'PENDING_FULFILLMENT',

  /**
   * Displayed as **Open**. None of the items in the order have been fulfilled. Replaced by "UNFULFILLED" status.
   */
  OPEN = 'OPEN',

  /**
   * Displayed as **In progress**. Some of the items in the order have been fulfilled, or a request for fulfillment has been sent to the fulfillment service.
   */
  IN_PROGRESS = 'IN_PROGRESS',

  /**
   * Displayed as **On hold**. All of the unfulfilled items in this order are on hold.
   */
  ON_HOLD = 'ON_HOLD',

  /**
   * Displayed as **Scheduled**. All of the unfulfilled items in this order are scheduled for fulfillment at later time.
   */
  SCHEDULED = 'SCHEDULED',
}

/**
 * Represents a single line in an order. There is one line item for each distinct product variant.
 */
/* #__PURE__ */
export class OrderLineItem extends $Base<'OrderLineItem'> {
  constructor() {
    super('OrderLineItem');
  }

  /**
   * The number of entries associated to the line item minus the items that have been removed.
   */
  get currentQuantity(): $Field<'currentQuantity', number> {
    return this.$_select('currentQuantity') as any;
  }

  /**
   * List of custom attributes associated to the line item.
   */
  customAttributes<Sel extends Selection<Attribute>>(
    selectorFn: (s: Attribute) => [...Sel],
  ): $Field<'customAttributes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Attribute()),
    };
    return this.$_select('customAttributes', options) as any;
  }

  /**
   * The discounts that have been allocated onto the order line item by discount applications.
   */
  discountAllocations<Sel extends Selection<DiscountAllocation>>(
    selectorFn: (s: DiscountAllocation) => [...Sel],
  ): $Field<'discountAllocations', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new DiscountAllocation()),
    };
    return this.$_select('discountAllocations', options) as any;
  }

  /**
   * The total price of the line item, including discounts, and displayed in the presentment currency.
   */
  discountedTotalPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'discountedTotalPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('discountedTotalPrice', options) as any;
  }

  /**
   * The total price of the line item, not including any discounts. The total price is calculated using the original unit price multiplied by the quantity, and it's displayed in the presentment currency.
   */
  originalTotalPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'originalTotalPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('originalTotalPrice', options) as any;
  }

  /**
   * The number of products variants associated to the line item.
   */
  get quantity(): $Field<'quantity', number> {
    return this.$_select('quantity') as any;
  }

  /**
   * The title of the product combined with title of the variant.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * The product variant object associated to the line item.
   */
  variant<Sel extends Selection<ProductVariant>>(
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'variant', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariant()),
    };
    return this.$_select('variant', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple OrderLineItems.

 */
/* #__PURE__ */
export class OrderLineItemConnection extends $Base<'OrderLineItemConnection'> {
  constructor() {
    super('OrderLineItemConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<OrderLineItemEdge>>(
    selectorFn: (s: OrderLineItemEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new OrderLineItemEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in OrderLineItemEdge.
   */
  nodes<Sel extends Selection<OrderLineItem>>(
    selectorFn: (s: OrderLineItem) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new OrderLineItem()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one OrderLineItem and a cursor during pagination.

 */
/* #__PURE__ */
export class OrderLineItemEdge extends $Base<'OrderLineItemEdge'> {
  constructor() {
    super('OrderLineItemEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of OrderLineItemEdge.
   */
  node<Sel extends Selection<OrderLineItem>>(
    selectorFn: (s: OrderLineItem) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new OrderLineItem()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The set of valid sort keys for the Order query.
 */
export enum OrderSortKeys {
  /**
   * Sort by the `processed_at` value.
   */
  PROCESSED_AT = 'PROCESSED_AT',

  /**
   * Sort by the `total_price` value.
   */
  TOTAL_PRICE = 'TOTAL_PRICE',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * Shopify merchants can create pages to hold static HTML content. Each Page object represents a custom page on the online store.
 */
/* #__PURE__ */
export class Page extends $Base<'Page'> {
  constructor() {
    super('Page');
  }

  /**
   * The description of the page, complete with HTML formatting.
   */
  get body(): $Field<'body', HTML> {
    return this.$_select('body') as any;
  }

  /**
   * Summary of the page body.
   */
  get bodySummary(): $Field<'bodySummary', string> {
    return this.$_select('bodySummary') as any;
  }

  /**
   * The timestamp of the page creation.
   */
  get createdAt(): $Field<'createdAt', DateTime> {
    return this.$_select('createdAt') as any;
  }

  /**
   * A human-friendly unique string for the page automatically generated from its title.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The URL used for viewing the resource on the shop's Online Store. Returns `null` if the resource is currently not published to the Online Store sales channel.
   */
  get onlineStoreUrl(): $Field<'onlineStoreUrl', URL | null | undefined> {
    return this.$_select('onlineStoreUrl') as any;
  }

  /**
   * The page's SEO information.
   */
  seo<Sel extends Selection<SEO>>(
    selectorFn: (s: SEO) => [...Sel],
  ): $Field<'seo', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SEO()),
    };
    return this.$_select('seo', options) as any;
  }

  /**
   * The title of the page.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null.
   */
  get trackingParameters(): $Field<'trackingParameters', string | null | undefined> {
    return this.$_select('trackingParameters') as any;
  }

  /**
   * The timestamp of the latest page update.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Pages.

 */
/* #__PURE__ */
export class PageConnection extends $Base<'PageConnection'> {
  constructor() {
    super('PageConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<PageEdge>>(
    selectorFn: (s: PageEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in PageEdge.
   */
  nodes<Sel extends Selection<Page>>(
    selectorFn: (s: Page) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Page()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one Page and a cursor during pagination.

 */
/* #__PURE__ */
export class PageEdge extends $Base<'PageEdge'> {
  constructor() {
    super('PageEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of PageEdge.
   */
  node<Sel extends Selection<Page>>(
    selectorFn: (s: Page) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Page()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Returns information about pagination in a connection, in accordance with the
[Relay specification](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo).
For more information, please read our [GraphQL Pagination Usage Guide](https://shopify.dev/api/usage/pagination-graphql).

 */
/* #__PURE__ */
export class PageInfo extends $Base<'PageInfo'> {
  constructor() {
    super('PageInfo');
  }

  /**
   * The cursor corresponding to the last node in edges.
   */
  get endCursor(): $Field<'endCursor', string | null | undefined> {
    return this.$_select('endCursor') as any;
  }

  /**
   * Whether there are more pages to fetch following the current page.
   */
  get hasNextPage(): $Field<'hasNextPage', boolean> {
    return this.$_select('hasNextPage') as any;
  }

  /**
   * Whether there are any pages prior to the current page.
   */
  get hasPreviousPage(): $Field<'hasPreviousPage', boolean> {
    return this.$_select('hasPreviousPage') as any;
  }

  /**
   * The cursor corresponding to the first node in edges.
   */
  get startCursor(): $Field<'startCursor', string | null | undefined> {
    return this.$_select('startCursor') as any;
  }
}

/**
 * The set of valid sort keys for the Page query.
 */
export enum PageSortKeys {
  /**
   * Sort by the `title` value.
   */
  TITLE = 'TITLE',

  /**
   * Sort by the `updated_at` value.
   */
  UPDATED_AT = 'UPDATED_AT',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * Type for paginating through multiple sitemap's resources.
 */
/* #__PURE__ */
export class PaginatedSitemapResources extends $Base<'PaginatedSitemapResources'> {
  constructor() {
    super('PaginatedSitemapResources');
  }

  /**
   * Whether there are more pages to fetch following the current page.
   */
  get hasNextPage(): $Field<'hasNextPage', boolean> {
    return this.$_select('hasNextPage') as any;
  }

  /**
 * List of sitemap resources for the current page.
Note: The number of items varies between 0 and 250 per page.

 */
  items<Sel extends Selection<SitemapResourceInterface>>(
    selectorFn: (s: SitemapResourceInterface) => [...Sel],
  ): $Field<'items', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SitemapResourceInterface()),
    };
    return this.$_select('items', options) as any;
  }
}

/**
 * Settings related to payments.
 */
/* #__PURE__ */
export class PaymentSettings extends $Base<'PaymentSettings'> {
  constructor() {
    super('PaymentSettings');
  }

  /**
   * List of the card brands which the business entity accepts.
   */
  get acceptedCardBrands(): $Field<'acceptedCardBrands', Readonly<Array<CardBrand>>> {
    return this.$_select('acceptedCardBrands') as any;
  }

  /**
   * The url pointing to the endpoint to vault credit cards.
   */
  get cardVaultUrl(): $Field<'cardVaultUrl', URL> {
    return this.$_select('cardVaultUrl') as any;
  }

  /**
   * The country where the shop is located. When multiple business entities operate within the shop, then this will represent the country of the business entity that's serving the specified buyer context.
   */
  get countryCode(): $Field<'countryCode', CountryCode> {
    return this.$_select('countryCode') as any;
  }

  /**
   * The three-letter code for the shop's primary currency.
   */
  get currencyCode(): $Field<'currencyCode', CurrencyCode> {
    return this.$_select('currencyCode') as any;
  }

  /**
 * A list of enabled currencies (ISO 4217 format) that the shop accepts.
Merchants can enable currencies from their Shopify Payments settings in the Shopify admin.

 */
  get enabledPresentmentCurrencies(): $Field<'enabledPresentmentCurrencies', Readonly<Array<CurrencyCode>>> {
    return this.$_select('enabledPresentmentCurrencies') as any;
  }

  /**
   * The shop’s Shopify Payments account ID.
   */
  get shopifyPaymentsAccountId(): $Field<'shopifyPaymentsAccountId', string | null | undefined> {
    return this.$_select('shopifyPaymentsAccountId') as any;
  }

  /**
   * List of the digital wallets which the business entity supports.
   */
  get supportedDigitalWallets(): $Field<'supportedDigitalWallets', Readonly<Array<DigitalWallet>>> {
    return this.$_select('supportedDigitalWallets') as any;
  }
}

/**
 * Decides the distribution of results.
 */
export enum PredictiveSearchLimitScope {
  /**
   * Return results up to limit across all types.
   */
  ALL = 'ALL',

  /**
   * Return results up to limit per type.
   */
  EACH = 'EACH',
}

/**
 * A predictive search result represents a list of products, collections, pages, articles, and query suggestions
that matches the predictive search query.

 */
/* #__PURE__ */
export class PredictiveSearchResult extends $Base<'PredictiveSearchResult'> {
  constructor() {
    super('PredictiveSearchResult');
  }

  /**
   * The articles that match the search query.
   */
  articles<Sel extends Selection<Article>>(
    selectorFn: (s: Article) => [...Sel],
  ): $Field<'articles', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Article()),
    };
    return this.$_select('articles', options) as any;
  }

  /**
   * The articles that match the search query.
   */
  collections<Sel extends Selection<Collection>>(
    selectorFn: (s: Collection) => [...Sel],
  ): $Field<'collections', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Collection()),
    };
    return this.$_select('collections', options) as any;
  }

  /**
   * The pages that match the search query.
   */
  pages<Sel extends Selection<Page>>(
    selectorFn: (s: Page) => [...Sel],
  ): $Field<'pages', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Page()),
    };
    return this.$_select('pages', options) as any;
  }

  /**
   * The products that match the search query.
   */
  products<Sel extends Selection<Product>>(
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'products', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Product()),
    };
    return this.$_select('products', options) as any;
  }

  /**
   * The query suggestions that are relevant to the search query.
   */
  queries<Sel extends Selection<SearchQuerySuggestion>>(
    selectorFn: (s: SearchQuerySuggestion) => [...Sel],
  ): $Field<'queries', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SearchQuerySuggestion()),
    };
    return this.$_select('queries', options) as any;
  }
}

/**
 * The types of search items to perform predictive search on.
 */
export enum PredictiveSearchType {
  /**
   * Returns matching collections.
   */
  COLLECTION = 'COLLECTION',

  /**
   * Returns matching products.
   */
  PRODUCT = 'PRODUCT',

  /**
   * Returns matching pages.
   */
  PAGE = 'PAGE',

  /**
   * Returns matching articles.
   */
  ARTICLE = 'ARTICLE',

  /**
   * Returns matching query strings.
   */
  QUERY = 'QUERY',
}

/**
 * The preferred delivery methods such as shipping, local pickup or through pickup points.
 */
export enum PreferenceDeliveryMethodType {
  /**
   * A delivery method used to send items directly to a buyer’s specified address.
   */
  SHIPPING = 'SHIPPING',

  /**
   * A delivery method used to let buyers receive items directly from a specific location within an area.
   */
  PICK_UP = 'PICK_UP',

  /**
   * A delivery method used to let buyers collect purchases at designated locations like parcel lockers.
   */
  PICKUP_POINT = 'PICKUP_POINT',
}

/**
 * The input fields for a filter used to view a subset of products in a collection matching a specific price range.

 */
export type PriceRangeFilter = {
  max?: number | null | undefined;
  min?: number | null | undefined;
};

/**
 * The value of the percentage pricing object.
 */
/* #__PURE__ */
export class PricingPercentageValue extends $Base<'PricingPercentageValue'> {
  constructor() {
    super('PricingPercentageValue');
  }

  /**
   * The percentage value of the object.
   */
  get percentage(): $Field<'percentage', number> {
    return this.$_select('percentage') as any;
  }
}

/**
 * The price value (fixed or percentage) for a discount application.
 */
/* #__PURE__ */
export class PricingValue extends $Union<
  { MoneyV2: MoneyV2; PricingPercentageValue: PricingPercentageValue },
  'PricingValue'
> {
  constructor() {
    super({ MoneyV2: MoneyV2, PricingPercentageValue: PricingPercentageValue }, 'PricingValue');
  }
}

/**
 * A product represents an individual item for sale in a Shopify store. Products are often physical, but they don't have to be.
For example, a digital download (such as a movie, music or ebook file) also
qualifies as a product, as do services (such as equipment rental, work for hire,
customization of another product or an extended warranty).

 */
/* #__PURE__ */
export class Product extends $Base<'Product'> {
  constructor() {
    super('Product');
  }

  /**
 * A list of variants whose selected options differ with the provided selected options by one, ordered by variant id.
If selected options are not provided, adjacent variants to the first available variant is returned.

Note that this field returns an array of variants. In most cases, the number of variants in this array will be low.
However, with a low number of options and a high number of values per option, the number of variants returned
here can be high. In such cases, it recommended to avoid using this field.

This list of variants can be used in combination with the `options` field to build a rich variant picker that
includes variant availability or other variant information.

 */
  adjacentVariants<
    Args extends VariabledInput<{
      selectedOptions?: Readonly<Array<SelectedOptionInput>> | null | undefined;
      ignoreUnknownOptions?: boolean | null | undefined;
      caseInsensitiveMatch?: boolean | null | undefined;
    }>,
    Sel extends Selection<ProductVariant>,
  >(
    args: ExactArgNames<
      Args,
      {
        selectedOptions?: Readonly<Array<SelectedOptionInput>> | null | undefined;
        ignoreUnknownOptions?: boolean | null | undefined;
        caseInsensitiveMatch?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'adjacentVariants', Array<GetOutput<Sel>>, GetVariables<Sel, Args>>;
  adjacentVariants<Sel extends Selection<ProductVariant>>(
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'adjacentVariants', Array<GetOutput<Sel>>, GetVariables<Sel>>;
  adjacentVariants(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        selectedOptions: '[SelectedOptionInput!]',
        ignoreUnknownOptions: 'Boolean',
        caseInsensitiveMatch: 'Boolean',
      },
      args,

      selection: selectorFn(new ProductVariant()),
    };
    return this.$_select('adjacentVariants', options) as any;
  }

  /**
   * Indicates if at least one product variant is available for sale.
   */
  get availableForSale(): $Field<'availableForSale', boolean> {
    return this.$_select('availableForSale') as any;
  }

  /**
   * The taxonomy category for the product.
   */
  category<Sel extends Selection<TaxonomyCategory>>(
    selectorFn: (s: TaxonomyCategory) => [...Sel],
  ): $Field<'category', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new TaxonomyCategory()),
    };
    return this.$_select('category', options) as any;
  }

  /**
   * List of collections a product belongs to.
   */
  collections<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<CollectionConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: CollectionConnection) => [...Sel],
  ): $Field<'collections', GetOutput<Sel>, GetVariables<Sel, Args>>;
  collections<Sel extends Selection<CollectionConnection>>(
    selectorFn: (s: CollectionConnection) => [...Sel],
  ): $Field<'collections', GetOutput<Sel>, GetVariables<Sel>>;
  collections(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new CollectionConnection()),
    };
    return this.$_select('collections', options) as any;
  }

  /**
   * The compare at price of the product across all variants.
   */
  compareAtPriceRange<Sel extends Selection<ProductPriceRange>>(
    selectorFn: (s: ProductPriceRange) => [...Sel],
  ): $Field<'compareAtPriceRange', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductPriceRange()),
    };
    return this.$_select('compareAtPriceRange', options) as any;
  }

  /**
   * The date and time when the product was created.
   */
  get createdAt(): $Field<'createdAt', DateTime> {
    return this.$_select('createdAt') as any;
  }

  /**
   * Stripped description of the product, single line with HTML tags removed.
   */
  description<
    Args extends VariabledInput<{
      truncateAt?: number | null | undefined;
    }>,
  >(
    args: ExactArgNames<
      Args,
      {
        truncateAt?: number | null | undefined;
      }
    >,
  ): $Field<'description', string, GetVariables<[], Args>> {
    const options = {
      argTypes: {
        truncateAt: 'Int',
      },
      args,
    };
    return this.$_select('description', options) as any;
  }

  /**
   * The description of the product, complete with HTML formatting.
   */
  get descriptionHtml(): $Field<'descriptionHtml', HTML> {
    return this.$_select('descriptionHtml') as any;
  }

  /**
 * An encoded string containing all option value combinations
with a corresponding variant that is currently available for sale.

Integers represent option and values:
[0,1] represents option_value at array index 0 for the option at array index 0

`:`, `,`, ` ` and `-` are control characters.
`:` indicates a new option. ex: 0:1 indicates value 0 for the option in position 1, value 1 for the option in position 2.
`,` indicates the end of a repeated prefix, mulitple consecutive commas indicate the end of multiple repeated prefixes.
` ` indicates a gap in the sequence of option values. ex: 0 4 indicates option values in position 0 and 4 are present.
`-` indicates a continuous range of option values. ex: 0 1-3 4

Decoding process:

Example options: [Size, Color, Material]
Example values: [[Small, Medium, Large], [Red, Blue], [Cotton, Wool]]
Example encoded string: "0:0:0,1:0-1,,1:0:0-1,1:1,,2:0:1,1:0,,"

Step 1: Expand ranges into the numbers they represent: "0:0:0,1:0 1,,1:0:0 1,1:1,,2:0:1,1:0,,"
Step 2: Expand repeated prefixes: "0:0:0,0:1:0 1,1:0:0 1,1:1:1,2:0:1,2:1:0,"
Step 3: Expand shared prefixes so data is encoded as a string: "0:0:0,0:1:0,0:1:1,1:0:0,1:0:1,1:1:1,2:0:1,2:1:0,"
Step 4: Map to options + option values to determine existing variants:

[Small, Red, Cotton] (0:0:0), [Small, Blue, Cotton] (0:1:0), [Small, Blue, Wool] (0:1:1),
[Medium, Red, Cotton] (1:0:0), [Medium, Red, Wool] (1:0:1), [Medium, Blue, Wool] (1:1:1),
[Large, Red, Wool] (2:0:1), [Large, Blue, Cotton] (2:1:0).


 */
  get encodedVariantAvailability(): $Field<'encodedVariantAvailability', string | null | undefined> {
    return this.$_select('encodedVariantAvailability') as any;
  }

  /**
 * An encoded string containing all option value combinations with a corresponding variant.

Integers represent option and values:
[0,1] represents option_value at array index 0 for the option at array index 0

`:`, `,`, ` ` and `-` are control characters.
`:` indicates a new option. ex: 0:1 indicates value 0 for the option in position 1, value 1 for the option in position 2.
`,` indicates the end of a repeated prefix, mulitple consecutive commas indicate the end of multiple repeated prefixes.
` ` indicates a gap in the sequence of option values. ex: 0 4 indicates option values in position 0 and 4 are present.
`-` indicates a continuous range of option values. ex: 0 1-3 4

Decoding process:

Example options: [Size, Color, Material]
Example values: [[Small, Medium, Large], [Red, Blue], [Cotton, Wool]]
Example encoded string: "0:0:0,1:0-1,,1:0:0-1,1:1,,2:0:1,1:0,,"

Step 1: Expand ranges into the numbers they represent: "0:0:0,1:0 1,,1:0:0 1,1:1,,2:0:1,1:0,,"
Step 2: Expand repeated prefixes: "0:0:0,0:1:0 1,1:0:0 1,1:1:1,2:0:1,2:1:0,"
Step 3: Expand shared prefixes so data is encoded as a string: "0:0:0,0:1:0,0:1:1,1:0:0,1:0:1,1:1:1,2:0:1,2:1:0,"
Step 4: Map to options + option values to determine existing variants:

[Small, Red, Cotton] (0:0:0), [Small, Blue, Cotton] (0:1:0), [Small, Blue, Wool] (0:1:1),
[Medium, Red, Cotton] (1:0:0), [Medium, Red, Wool] (1:0:1), [Medium, Blue, Wool] (1:1:1),
[Large, Red, Wool] (2:0:1), [Large, Blue, Cotton] (2:1:0).


 */
  get encodedVariantExistence(): $Field<'encodedVariantExistence', string | null | undefined> {
    return this.$_select('encodedVariantExistence') as any;
  }

  /**
 * The featured image for the product.

This field is functionally equivalent to `images(first: 1)`.

 */
  featuredImage<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'featuredImage', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('featuredImage', options) as any;
  }

  /**
 * A human-friendly unique string for the Product automatically generated from its title.
They are used by the Liquid templating language to refer to objects.

 */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * List of images associated with the product.
   */
  images<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: ProductImageSortKeys | null | undefined;
    }>,
    Sel extends Selection<ImageConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: ProductImageSortKeys | null | undefined;
      }
    >,
    selectorFn: (s: ImageConnection) => [...Sel],
  ): $Field<'images', GetOutput<Sel>, GetVariables<Sel, Args>>;
  images<Sel extends Selection<ImageConnection>>(
    selectorFn: (s: ImageConnection) => [...Sel],
  ): $Field<'images', GetOutput<Sel>, GetVariables<Sel>>;
  images(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'ProductImageSortKeys',
      },
      args,

      selection: selectorFn(new ImageConnection()),
    };
    return this.$_select('images', options) as any;
  }

  /**
   * Whether the product is a gift card.
   */
  get isGiftCard(): $Field<'isGiftCard', boolean> {
    return this.$_select('isGiftCard') as any;
  }

  /**
   * The media associated with the product.
   */
  media<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: ProductMediaSortKeys | null | undefined;
    }>,
    Sel extends Selection<MediaConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: ProductMediaSortKeys | null | undefined;
      }
    >,
    selectorFn: (s: MediaConnection) => [...Sel],
  ): $Field<'media', GetOutput<Sel>, GetVariables<Sel, Args>>;
  media<Sel extends Selection<MediaConnection>>(
    selectorFn: (s: MediaConnection) => [...Sel],
  ): $Field<'media', GetOutput<Sel>, GetVariables<Sel>>;
  media(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'ProductMediaSortKeys',
      },
      args,

      selection: selectorFn(new MediaConnection()),
    };
    return this.$_select('media', options) as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
 * The URL used for viewing the resource on the shop's Online Store. Returns
`null` if the resource is currently not published to the Online Store sales channel.

 */
  get onlineStoreUrl(): $Field<'onlineStoreUrl', URL | null | undefined> {
    return this.$_select('onlineStoreUrl') as any;
  }

  /**
   * List of product options.
   */
  options<
    Args extends VariabledInput<{
      first?: number | null | undefined;
    }>,
    Sel extends Selection<ProductOption>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
      }
    >,
    selectorFn: (s: ProductOption) => [...Sel],
  ): $Field<'options', Array<GetOutput<Sel>>, GetVariables<Sel, Args>>;
  options<Sel extends Selection<ProductOption>>(
    selectorFn: (s: ProductOption) => [...Sel],
  ): $Field<'options', Array<GetOutput<Sel>>, GetVariables<Sel>>;
  options(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
      },
      args,

      selection: selectorFn(new ProductOption()),
    };
    return this.$_select('options', options) as any;
  }

  /**
   * The price range.
   */
  priceRange<Sel extends Selection<ProductPriceRange>>(
    selectorFn: (s: ProductPriceRange) => [...Sel],
  ): $Field<'priceRange', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductPriceRange()),
    };
    return this.$_select('priceRange', options) as any;
  }

  /**
   * A categorization that a product can be tagged with, commonly used for filtering and searching.
   */
  get productType(): $Field<'productType', string> {
    return this.$_select('productType') as any;
  }

  /**
   * The date and time when the product was published to the channel.
   */
  get publishedAt(): $Field<'publishedAt', DateTime> {
    return this.$_select('publishedAt') as any;
  }

  /**
   * Whether the product can only be purchased with a selling plan.
   */
  get requiresSellingPlan(): $Field<'requiresSellingPlan', boolean> {
    return this.$_select('requiresSellingPlan') as any;
  }

  /**
 * Find an active product variant based on selected options, availability or the first variant.

All arguments are optional. If no selected options are provided, the first available variant is returned.
If no variants are available, the first variant is returned.

 */
  selectedOrFirstAvailableVariant<
    Args extends VariabledInput<{
      selectedOptions?: Readonly<Array<SelectedOptionInput>> | null | undefined;
      ignoreUnknownOptions?: boolean | null | undefined;
      caseInsensitiveMatch?: boolean | null | undefined;
    }>,
    Sel extends Selection<ProductVariant>,
  >(
    args: ExactArgNames<
      Args,
      {
        selectedOptions?: Readonly<Array<SelectedOptionInput>> | null | undefined;
        ignoreUnknownOptions?: boolean | null | undefined;
        caseInsensitiveMatch?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'selectedOrFirstAvailableVariant', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  selectedOrFirstAvailableVariant<Sel extends Selection<ProductVariant>>(
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'selectedOrFirstAvailableVariant', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  selectedOrFirstAvailableVariant(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        selectedOptions: '[SelectedOptionInput!]',
        ignoreUnknownOptions: 'Boolean',
        caseInsensitiveMatch: 'Boolean',
      },
      args,

      selection: selectorFn(new ProductVariant()),
    };
    return this.$_select('selectedOrFirstAvailableVariant', options) as any;
  }

  /**
   * A list of a product's available selling plan groups. A selling plan group represents a selling method. For example, 'Subscribe and save' is a selling method where customers pay for goods or services per delivery. A selling plan group contains individual selling plans.
   */
  sellingPlanGroups<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<SellingPlanGroupConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: SellingPlanGroupConnection) => [...Sel],
  ): $Field<'sellingPlanGroups', GetOutput<Sel>, GetVariables<Sel, Args>>;
  sellingPlanGroups<Sel extends Selection<SellingPlanGroupConnection>>(
    selectorFn: (s: SellingPlanGroupConnection) => [...Sel],
  ): $Field<'sellingPlanGroups', GetOutput<Sel>, GetVariables<Sel>>;
  sellingPlanGroups(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new SellingPlanGroupConnection()),
    };
    return this.$_select('sellingPlanGroups', options) as any;
  }

  /**
   * The product's SEO information.
   */
  seo<Sel extends Selection<SEO>>(selectorFn: (s: SEO) => [...Sel]): $Field<'seo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SEO()),
    };
    return this.$_select('seo', options) as any;
  }

  /**
 * A comma separated list of tags that have been added to the product.
Additional access scope required for private apps: unauthenticated_read_product_tags.

 */
  get tags(): $Field<'tags', Readonly<Array<string>>> {
    return this.$_select('tags') as any;
  }

  /**
   * The product’s title.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * The total quantity of inventory in stock for this Product.
   */
  get totalInventory(): $Field<'totalInventory', number | null | undefined> {
    return this.$_select('totalInventory') as any;
  }

  /**
   * URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null.
   */
  get trackingParameters(): $Field<'trackingParameters', string | null | undefined> {
    return this.$_select('trackingParameters') as any;
  }

  /**
 * The date and time when the product was last modified.
A product's `updatedAt` value can change for different reasons. For example, if an order
is placed for a product that has inventory tracking set up, then the inventory adjustment
is counted as an update.

 */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }

  /**
 * Find a product’s variant based on its selected options.
This is useful for converting a user’s selection of product options into a single matching variant.
If there is not a variant for the selected options, `null` will be returned.

 */
  variantBySelectedOptions<
    Args extends VariabledInput<{
      selectedOptions: Readonly<Array<SelectedOptionInput>>;
      ignoreUnknownOptions?: boolean | null | undefined;
      caseInsensitiveMatch?: boolean | null | undefined;
    }>,
    Sel extends Selection<ProductVariant>,
  >(
    args: ExactArgNames<
      Args,
      {
        selectedOptions: Readonly<Array<SelectedOptionInput>>;
        ignoreUnknownOptions?: boolean | null | undefined;
        caseInsensitiveMatch?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'variantBySelectedOptions', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        selectedOptions: '[SelectedOptionInput!]!',
        ignoreUnknownOptions: 'Boolean',
        caseInsensitiveMatch: 'Boolean',
      },
      args,

      selection: selectorFn(new ProductVariant()),
    };
    return this.$_select('variantBySelectedOptions', options) as any;
  }

  /**
   * List of the product’s variants.
   */
  variants<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: ProductVariantSortKeys | null | undefined;
    }>,
    Sel extends Selection<ProductVariantConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: ProductVariantSortKeys | null | undefined;
      }
    >,
    selectorFn: (s: ProductVariantConnection) => [...Sel],
  ): $Field<'variants', GetOutput<Sel>, GetVariables<Sel, Args>>;
  variants<Sel extends Selection<ProductVariantConnection>>(
    selectorFn: (s: ProductVariantConnection) => [...Sel],
  ): $Field<'variants', GetOutput<Sel>, GetVariables<Sel>>;
  variants(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'ProductVariantSortKeys',
      },
      args,

      selection: selectorFn(new ProductVariantConnection()),
    };
    return this.$_select('variants', options) as any;
  }

  /**
   * The total count of variants for this product.
   */
  variantsCount<Sel extends Selection<Count>>(
    selectorFn: (s: Count) => [...Sel],
  ): $Field<'variantsCount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Count()),
    };
    return this.$_select('variantsCount', options) as any;
  }

  /**
   * The product’s vendor name.
   */
  get vendor(): $Field<'vendor', string> {
    return this.$_select('vendor') as any;
  }
}

/**
 * The set of valid sort keys for the ProductCollection query.
 */
export enum ProductCollectionSortKeys {
  /**
   * Sort by the `title` value.
   */
  TITLE = 'TITLE',

  /**
   * Sort by the `price` value.
   */
  PRICE = 'PRICE',

  /**
   * Sort by the `best-selling` value.
   */
  BEST_SELLING = 'BEST_SELLING',

  /**
   * Sort by the `created` value.
   */
  CREATED = 'CREATED',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
   * Sort by the `manual` value.
   */
  MANUAL = 'MANUAL',

  /**
   * Sort by the `collection-default` value.
   */
  COLLECTION_DEFAULT = 'COLLECTION_DEFAULT',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * An auto-generated type for paginating through multiple Products.

 */
/* #__PURE__ */
export class ProductConnection extends $Base<'ProductConnection'> {
  constructor() {
    super('ProductConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<ProductEdge>>(
    selectorFn: (s: ProductEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of available filters.
   */
  filters<Sel extends Selection<Filter>>(
    selectorFn: (s: Filter) => [...Sel],
  ): $Field<'filters', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Filter()),
    };
    return this.$_select('filters', options) as any;
  }

  /**
   * A list of the nodes contained in ProductEdge.
   */
  nodes<Sel extends Selection<Product>>(
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Product()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one Product and a cursor during pagination.

 */
/* #__PURE__ */
export class ProductEdge extends $Base<'ProductEdge'> {
  constructor() {
    super('ProductEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of ProductEdge.
   */
  node<Sel extends Selection<Product>>(
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Product()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The input fields for a filter used to view a subset of products in a collection.
By default, the `available` and `price` filters are enabled. Filters are customized with the Shopify Search & Discovery app.
Learn more about [customizing storefront filtering](https://help.shopify.com/manual/online-store/themes/customizing-themes/storefront-filters).

 */
export type ProductFilter = {
  available?: boolean | null | undefined;
  price?: PriceRangeFilter | null | undefined;
  productMetafield?: MetafieldFilter | null | undefined;
  productType?: string | null | undefined;
  productVendor?: string | null | undefined;
  tag?: string | null | undefined;
  variantMetafield?: MetafieldFilter | null | undefined;
  variantOption?: VariantOptionFilter | null | undefined;
};

/**
 * The set of valid sort keys for the ProductImage query.
 */
export enum ProductImageSortKeys {
  /**
   * Sort by the `created_at` value.
   */
  CREATED_AT = 'CREATED_AT',

  /**
   * Sort by the `position` value.
   */
  POSITION = 'POSITION',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * The set of valid sort keys for the ProductMedia query.
 */
export enum ProductMediaSortKeys {
  /**
   * Sort by the `position` value.
   */
  POSITION = 'POSITION',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * Product property names like "Size", "Color", and "Material" that the customers can select.
Variants are selected based on permutations of these options.
255 characters limit each.

 */
/* #__PURE__ */
export class ProductOption extends $Base<'ProductOption'> {
  constructor() {
    super('ProductOption');
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The product option’s name.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The corresponding option value to the product option.
   */
  optionValues<Sel extends Selection<ProductOptionValue>>(
    selectorFn: (s: ProductOptionValue) => [...Sel],
  ): $Field<'optionValues', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductOptionValue()),
    };
    return this.$_select('optionValues', options) as any;
  }

  /**
   * The corresponding value to the product option name.
   */
  get values(): $Field<'values', Readonly<Array<string>>> {
    return this.$_select('values') as any;
  }
}

/**
 * The product option value names. For example, "Red", "Blue", and "Green" for a "Color" option.

 */
/* #__PURE__ */
export class ProductOptionValue extends $Base<'ProductOptionValue'> {
  constructor() {
    super('ProductOptionValue');
  }

  /**
 * The product variant that combines this option value with the
lowest-position option values for all other options.

This field will always return a variant, provided a variant including this option value exists.

 */
  firstSelectableVariant<Sel extends Selection<ProductVariant>>(
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'firstSelectableVariant', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariant()),
    };
    return this.$_select('firstSelectableVariant', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The name of the product option value.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The swatch of the product option value.
   */
  swatch<Sel extends Selection<ProductOptionValueSwatch>>(
    selectorFn: (s: ProductOptionValueSwatch) => [...Sel],
  ): $Field<'swatch', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductOptionValueSwatch()),
    };
    return this.$_select('swatch', options) as any;
  }
}

/**
 * The product option value swatch.

 */
/* #__PURE__ */
export class ProductOptionValueSwatch extends $Base<'ProductOptionValueSwatch'> {
  constructor() {
    super('ProductOptionValueSwatch');
  }

  /**
   * The swatch color.
   */
  get color(): $Field<'color', Color | null | undefined> {
    return this.$_select('color') as any;
  }

  /**
   * The swatch image.
   */
  image<Sel extends Selection<Media>>(
    selectorFn: (s: Media) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Media()),
    };
    return this.$_select('image', options) as any;
  }
}

/**
 * The price range of the product.
 */
/* #__PURE__ */
export class ProductPriceRange extends $Base<'ProductPriceRange'> {
  constructor() {
    super('ProductPriceRange');
  }

  /**
   * The highest variant's price.
   */
  maxVariantPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'maxVariantPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('maxVariantPrice', options) as any;
  }

  /**
   * The lowest variant's price.
   */
  minVariantPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'minVariantPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('minVariantPrice', options) as any;
  }
}

/**
 * The recommendation intent that is used to generate product recommendations.
You can use intent to generate product recommendations according to different strategies.

 */
export enum ProductRecommendationIntent {
  /**
   * Offer customers a mix of products that are similar or complementary to a product for which recommendations are to be fetched. An example is substitutable products that display in a You may also like section.
   */
  RELATED = 'RELATED',

  /**
   * Offer customers products that are complementary to a product for which recommendations are to be fetched. An example is add-on products that display in a Pair it with section.
   */
  COMPLEMENTARY = 'COMPLEMENTARY',
}

/**
 * The set of valid sort keys for the Product query.
 */
export enum ProductSortKeys {
  /**
   * Sort by the `title` value.
   */
  TITLE = 'TITLE',

  /**
   * Sort by the `product_type` value.
   */
  PRODUCT_TYPE = 'PRODUCT_TYPE',

  /**
   * Sort by the `vendor` value.
   */
  VENDOR = 'VENDOR',

  /**
   * Sort by the `updated_at` value.
   */
  UPDATED_AT = 'UPDATED_AT',

  /**
   * Sort by the `created_at` value.
   */
  CREATED_AT = 'CREATED_AT',

  /**
   * Sort by the `best_selling` value.
   */
  BEST_SELLING = 'BEST_SELLING',

  /**
   * Sort by the `price` value.
   */
  PRICE = 'PRICE',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * A product variant represents a different version of a product, such as differing sizes or differing colors.

 */
/* #__PURE__ */
export class ProductVariant extends $Base<'ProductVariant'> {
  constructor() {
    super('ProductVariant');
  }

  /**
   * Indicates if the product variant is available for sale.
   */
  get availableForSale(): $Field<'availableForSale', boolean> {
    return this.$_select('availableForSale') as any;
  }

  /**
   * The barcode (for example, ISBN, UPC, or GTIN) associated with the variant.
   */
  get barcode(): $Field<'barcode', string | null | undefined> {
    return this.$_select('barcode') as any;
  }

  /**
   * The compare at price of the variant. This can be used to mark a variant as on sale, when `compareAtPrice` is higher than `price`.
   */
  compareAtPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'compareAtPrice', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('compareAtPrice', options) as any;
  }

  /**
   * The compare at price of the variant. This can be used to mark a variant as on sale, when `compareAtPriceV2` is higher than `priceV2`.
   */
  compareAtPriceV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'compareAtPriceV2', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('compareAtPriceV2', options) as any;
  }

  /**
 * List of bundles components included in the variant considering only fixed bundles.

 */
  components<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
    }>,
    Sel extends Selection<ProductVariantComponentConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
      }
    >,
    selectorFn: (s: ProductVariantComponentConnection) => [...Sel],
  ): $Field<'components', GetOutput<Sel>, GetVariables<Sel, Args>>;
  components<Sel extends Selection<ProductVariantComponentConnection>>(
    selectorFn: (s: ProductVariantComponentConnection) => [...Sel],
  ): $Field<'components', GetOutput<Sel>, GetVariables<Sel>>;
  components(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
      },
      args,

      selection: selectorFn(new ProductVariantComponentConnection()),
    };
    return this.$_select('components', options) as any;
  }

  /**
   * Whether a product is out of stock but still available for purchase (used for backorders).
   */
  get currentlyNotInStock(): $Field<'currentlyNotInStock', boolean> {
    return this.$_select('currentlyNotInStock') as any;
  }

  /**
 * List of bundles that include this variant considering only fixed bundles.

 */
  groupedBy<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
    }>,
    Sel extends Selection<ProductVariantConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
      }
    >,
    selectorFn: (s: ProductVariantConnection) => [...Sel],
  ): $Field<'groupedBy', GetOutput<Sel>, GetVariables<Sel, Args>>;
  groupedBy<Sel extends Selection<ProductVariantConnection>>(
    selectorFn: (s: ProductVariantConnection) => [...Sel],
  ): $Field<'groupedBy', GetOutput<Sel>, GetVariables<Sel>>;
  groupedBy(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
      },
      args,

      selection: selectorFn(new ProductVariantConnection()),
    };
    return this.$_select('groupedBy', options) as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Image associated with the product variant. This field falls back to the product image if no image is available.
   */
  image<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('image', options) as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The product variant’s price.
   */
  price<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'price', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('price', options) as any;
  }

  /**
   * The product variant’s price.
   */
  priceV2<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'priceV2', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('priceV2', options) as any;
  }

  /**
   * The product object that the product variant belongs to.
   */
  product<Sel extends Selection<Product>>(
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'product', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Product()),
    };
    return this.$_select('product', options) as any;
  }

  /**
   * The total sellable quantity of the variant for online sales channels.
   */
  get quantityAvailable(): $Field<'quantityAvailable', number | null | undefined> {
    return this.$_select('quantityAvailable') as any;
  }

  /**
   * A list of quantity breaks for the product variant.
   */
  quantityPriceBreaks<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
    }>,
    Sel extends Selection<QuantityPriceBreakConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
      }
    >,
    selectorFn: (s: QuantityPriceBreakConnection) => [...Sel],
  ): $Field<'quantityPriceBreaks', GetOutput<Sel>, GetVariables<Sel, Args>>;
  quantityPriceBreaks<Sel extends Selection<QuantityPriceBreakConnection>>(
    selectorFn: (s: QuantityPriceBreakConnection) => [...Sel],
  ): $Field<'quantityPriceBreaks', GetOutput<Sel>, GetVariables<Sel>>;
  quantityPriceBreaks(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
      },
      args,

      selection: selectorFn(new QuantityPriceBreakConnection()),
    };
    return this.$_select('quantityPriceBreaks', options) as any;
  }

  /**
   * The quantity rule for the product variant in a given context.
   */
  quantityRule<Sel extends Selection<QuantityRule>>(
    selectorFn: (s: QuantityRule) => [...Sel],
  ): $Field<'quantityRule', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new QuantityRule()),
    };
    return this.$_select('quantityRule', options) as any;
  }

  /**
 * Whether a product variant requires components. The default value is `false`.
If `true`, then the product variant can only be purchased as a parent bundle with components.

 */
  get requiresComponents(): $Field<'requiresComponents', boolean> {
    return this.$_select('requiresComponents') as any;
  }

  /**
   * Whether a customer needs to provide a shipping address when placing an order for the product variant.
   */
  get requiresShipping(): $Field<'requiresShipping', boolean> {
    return this.$_select('requiresShipping') as any;
  }

  /**
   * List of product options applied to the variant.
   */
  selectedOptions<Sel extends Selection<SelectedOption>>(
    selectorFn: (s: SelectedOption) => [...Sel],
  ): $Field<'selectedOptions', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SelectedOption()),
    };
    return this.$_select('selectedOptions', options) as any;
  }

  /**
   * Represents an association between a variant and a selling plan. Selling plan allocations describe which selling plans are available for each variant, and what their impact is on pricing.
   */
  sellingPlanAllocations<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<SellingPlanAllocationConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: SellingPlanAllocationConnection) => [...Sel],
  ): $Field<'sellingPlanAllocations', GetOutput<Sel>, GetVariables<Sel, Args>>;
  sellingPlanAllocations<Sel extends Selection<SellingPlanAllocationConnection>>(
    selectorFn: (s: SellingPlanAllocationConnection) => [...Sel],
  ): $Field<'sellingPlanAllocations', GetOutput<Sel>, GetVariables<Sel>>;
  sellingPlanAllocations(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new SellingPlanAllocationConnection()),
    };
    return this.$_select('sellingPlanAllocations', options) as any;
  }

  /**
   * The Shop Pay Installments pricing information for the product variant.
   */
  shopPayInstallmentsPricing<Sel extends Selection<ShopPayInstallmentsProductVariantPricing>>(
    selectorFn: (s: ShopPayInstallmentsProductVariantPricing) => [...Sel],
  ): $Field<'shopPayInstallmentsPricing', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayInstallmentsProductVariantPricing()),
    };
    return this.$_select('shopPayInstallmentsPricing', options) as any;
  }

  /**
   * The SKU (stock keeping unit) associated with the variant.
   */
  get sku(): $Field<'sku', string | null | undefined> {
    return this.$_select('sku') as any;
  }

  /**
   * The in-store pickup availability of this variant by location.
   */
  storeAvailability<
    Args extends VariabledInput<{
      near?: GeoCoordinateInput | null | undefined;
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<StoreAvailabilityConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        near?: GeoCoordinateInput | null | undefined;
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: StoreAvailabilityConnection) => [...Sel],
  ): $Field<'storeAvailability', GetOutput<Sel>, GetVariables<Sel, Args>>;
  storeAvailability<Sel extends Selection<StoreAvailabilityConnection>>(
    selectorFn: (s: StoreAvailabilityConnection) => [...Sel],
  ): $Field<'storeAvailability', GetOutput<Sel>, GetVariables<Sel>>;
  storeAvailability(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        near: 'GeoCoordinateInput',
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new StoreAvailabilityConnection()),
    };
    return this.$_select('storeAvailability', options) as any;
  }

  /**
   * Whether tax is charged when the product variant is sold.
   */
  get taxable(): $Field<'taxable', boolean> {
    return this.$_select('taxable') as any;
  }

  /**
   * The product variant’s title.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * The unit price value for the variant based on the variant's measurement.
   */
  unitPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'unitPrice', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('unitPrice', options) as any;
  }

  /**
   * The unit price measurement for the variant.
   */
  unitPriceMeasurement<Sel extends Selection<UnitPriceMeasurement>>(
    selectorFn: (s: UnitPriceMeasurement) => [...Sel],
  ): $Field<'unitPriceMeasurement', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UnitPriceMeasurement()),
    };
    return this.$_select('unitPriceMeasurement', options) as any;
  }

  /**
   * The weight of the product variant in the unit system specified with `weight_unit`.
   */
  get weight(): $Field<'weight', number | null | undefined> {
    return this.$_select('weight') as any;
  }

  /**
   * Unit of measurement for weight.
   */
  get weightUnit(): $Field<'weightUnit', WeightUnit> {
    return this.$_select('weightUnit') as any;
  }
}

/**
 * Represents a component of a bundle variant.

 */
/* #__PURE__ */
export class ProductVariantComponent extends $Base<'ProductVariantComponent'> {
  constructor() {
    super('ProductVariantComponent');
  }

  /**
   * The product variant object that the component belongs to.
   */
  productVariant<Sel extends Selection<ProductVariant>>(
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'productVariant', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariant()),
    };
    return this.$_select('productVariant', options) as any;
  }

  /**
   * The quantity of component present in the bundle.
   */
  get quantity(): $Field<'quantity', number> {
    return this.$_select('quantity') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple ProductVariantComponents.

 */
/* #__PURE__ */
export class ProductVariantComponentConnection extends $Base<'ProductVariantComponentConnection'> {
  constructor() {
    super('ProductVariantComponentConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<ProductVariantComponentEdge>>(
    selectorFn: (s: ProductVariantComponentEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariantComponentEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in ProductVariantComponentEdge.
   */
  nodes<Sel extends Selection<ProductVariantComponent>>(
    selectorFn: (s: ProductVariantComponent) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariantComponent()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one ProductVariantComponent and a cursor during pagination.

 */
/* #__PURE__ */
export class ProductVariantComponentEdge extends $Base<'ProductVariantComponentEdge'> {
  constructor() {
    super('ProductVariantComponentEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of ProductVariantComponentEdge.
   */
  node<Sel extends Selection<ProductVariantComponent>>(
    selectorFn: (s: ProductVariantComponent) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariantComponent()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple ProductVariants.

 */
/* #__PURE__ */
export class ProductVariantConnection extends $Base<'ProductVariantConnection'> {
  constructor() {
    super('ProductVariantConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<ProductVariantEdge>>(
    selectorFn: (s: ProductVariantEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariantEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in ProductVariantEdge.
   */
  nodes<Sel extends Selection<ProductVariant>>(
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariant()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one ProductVariant and a cursor during pagination.

 */
/* #__PURE__ */
export class ProductVariantEdge extends $Base<'ProductVariantEdge'> {
  constructor() {
    super('ProductVariantEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of ProductVariantEdge.
   */
  node<Sel extends Selection<ProductVariant>>(
    selectorFn: (s: ProductVariant) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ProductVariant()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The set of valid sort keys for the ProductVariant query.
 */
export enum ProductVariantSortKeys {
  /**
   * Sort by the `title` value.
   */
  TITLE = 'TITLE',

  /**
   * Sort by the `sku` value.
   */
  SKU = 'SKU',

  /**
   * Sort by the `position` value.
   */
  POSITION = 'POSITION',

  /**
   * Sort by the `id` value.
   */
  ID = 'ID',

  /**
 * Sort by relevance to the search terms when the `query` parameter is specified on the connection.
Don't use this sort key when no search query is specified.

 */
  RELEVANCE = 'RELEVANCE',
}

/**
 * Represents information about the buyer that is interacting with the cart.
 */
/* #__PURE__ */
export class PurchasingCompany extends $Base<'PurchasingCompany'> {
  constructor() {
    super('PurchasingCompany');
  }

  /**
   * The company associated to the order or draft order.
   */
  company<Sel extends Selection<Company>>(
    selectorFn: (s: Company) => [...Sel],
  ): $Field<'company', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Company()),
    };
    return this.$_select('company', options) as any;
  }

  /**
   * The company contact associated to the order or draft order.
   */
  contact<Sel extends Selection<CompanyContact>>(
    selectorFn: (s: CompanyContact) => [...Sel],
  ): $Field<'contact', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CompanyContact()),
    };
    return this.$_select('contact', options) as any;
  }

  /**
   * The company location associated to the order or draft order.
   */
  location<Sel extends Selection<CompanyLocation>>(
    selectorFn: (s: CompanyLocation) => [...Sel],
  ): $Field<'location', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new CompanyLocation()),
    };
    return this.$_select('location', options) as any;
  }
}

/**
 * Quantity price breaks lets you offer different rates that are based on the
amount of a specific variant being ordered.

 */
/* #__PURE__ */
export class QuantityPriceBreak extends $Base<'QuantityPriceBreak'> {
  constructor() {
    super('QuantityPriceBreak');
  }

  /**
 * Minimum quantity required to reach new quantity break price.

 */
  get minimumQuantity(): $Field<'minimumQuantity', number> {
    return this.$_select('minimumQuantity') as any;
  }

  /**
 * The price of variant after reaching the minimum quanity.

 */
  price<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'price', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('price', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple QuantityPriceBreaks.

 */
/* #__PURE__ */
export class QuantityPriceBreakConnection extends $Base<'QuantityPriceBreakConnection'> {
  constructor() {
    super('QuantityPriceBreakConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<QuantityPriceBreakEdge>>(
    selectorFn: (s: QuantityPriceBreakEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new QuantityPriceBreakEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in QuantityPriceBreakEdge.
   */
  nodes<Sel extends Selection<QuantityPriceBreak>>(
    selectorFn: (s: QuantityPriceBreak) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new QuantityPriceBreak()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one QuantityPriceBreak and a cursor during pagination.

 */
/* #__PURE__ */
export class QuantityPriceBreakEdge extends $Base<'QuantityPriceBreakEdge'> {
  constructor() {
    super('QuantityPriceBreakEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of QuantityPriceBreakEdge.
   */
  node<Sel extends Selection<QuantityPriceBreak>>(
    selectorFn: (s: QuantityPriceBreak) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new QuantityPriceBreak()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The quantity rule for the product variant in a given context.

 */
/* #__PURE__ */
export class QuantityRule extends $Base<'QuantityRule'> {
  constructor() {
    super('QuantityRule');
  }

  /**
 * The value that specifies the quantity increment between minimum and maximum of the rule.
Only quantities divisible by this value will be considered valid.

The increment must be lower than or equal to the minimum and the maximum, and both minimum and maximum
must be divisible by this value.

 */
  get increment(): $Field<'increment', number> {
    return this.$_select('increment') as any;
  }

  /**
 * An optional value that defines the highest allowed quantity purchased by the customer.
If defined, maximum must be lower than or equal to the minimum and must be a multiple of the increment.

 */
  get maximum(): $Field<'maximum', number | null | undefined> {
    return this.$_select('maximum') as any;
  }

  /**
 * The value that defines the lowest allowed quantity purchased by the customer.
The minimum must be a multiple of the quantity rule's increment.

 */
  get minimum(): $Field<'minimum', number> {
    return this.$_select('minimum') as any;
  }
}

/**
 * The schema’s entry-point for queries. This acts as the public, top-level API from which all queries must start.
 */
/* #__PURE__ */
export class QueryRoot extends $Base<'QueryRoot'> {
  constructor() {
    super('QueryRoot');
  }

  /**
   * Fetch a specific Article by its ID.
   */
  article<
    Args extends VariabledInput<{
      id: string;
    }>,
    Sel extends Selection<Article>,
  >(
    args: ExactArgNames<
      Args,
      {
        id: string;
      }
    >,
    selectorFn: (s: Article) => [...Sel],
  ): $Field<'article', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        id: 'ID!',
      },
      args,

      selection: selectorFn(new Article()),
    };
    return this.$_select('article', options) as any;
  }

  /**
   * List of the shop's articles.
   */
  articles<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: ArticleSortKeys | null | undefined;
      query?: string | null | undefined;
    }>,
    Sel extends Selection<ArticleConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: ArticleSortKeys | null | undefined;
        query?: string | null | undefined;
      }
    >,
    selectorFn: (s: ArticleConnection) => [...Sel],
  ): $Field<'articles', GetOutput<Sel>, GetVariables<Sel, Args>>;
  articles<Sel extends Selection<ArticleConnection>>(
    selectorFn: (s: ArticleConnection) => [...Sel],
  ): $Field<'articles', GetOutput<Sel>, GetVariables<Sel>>;
  articles(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'ArticleSortKeys',
        query: 'String',
      },
      args,

      selection: selectorFn(new ArticleConnection()),
    };
    return this.$_select('articles', options) as any;
  }

  /**
   * Fetch a specific `Blog` by one of its unique attributes.
   */
  blog<
    Args extends VariabledInput<{
      handle?: string | null | undefined;
      id?: string | null | undefined;
    }>,
    Sel extends Selection<Blog>,
  >(
    args: ExactArgNames<
      Args,
      {
        handle?: string | null | undefined;
        id?: string | null | undefined;
      }
    >,
    selectorFn: (s: Blog) => [...Sel],
  ): $Field<'blog', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  blog<Sel extends Selection<Blog>>(
    selectorFn: (s: Blog) => [...Sel],
  ): $Field<'blog', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  blog(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        handle: 'String',
        id: 'ID',
      },
      args,

      selection: selectorFn(new Blog()),
    };
    return this.$_select('blog', options) as any;
  }

  /**
   * Find a blog by its handle.
   */
  blogByHandle<
    Args extends VariabledInput<{
      handle: string;
    }>,
    Sel extends Selection<Blog>,
  >(
    args: ExactArgNames<
      Args,
      {
        handle: string;
      }
    >,
    selectorFn: (s: Blog) => [...Sel],
  ): $Field<'blogByHandle', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        handle: 'String!',
      },
      args,

      selection: selectorFn(new Blog()),
    };
    return this.$_select('blogByHandle', options) as any;
  }

  /**
   * List of the shop's blogs.
   */
  blogs<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: BlogSortKeys | null | undefined;
      query?: string | null | undefined;
    }>,
    Sel extends Selection<BlogConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: BlogSortKeys | null | undefined;
        query?: string | null | undefined;
      }
    >,
    selectorFn: (s: BlogConnection) => [...Sel],
  ): $Field<'blogs', GetOutput<Sel>, GetVariables<Sel, Args>>;
  blogs<Sel extends Selection<BlogConnection>>(
    selectorFn: (s: BlogConnection) => [...Sel],
  ): $Field<'blogs', GetOutput<Sel>, GetVariables<Sel>>;
  blogs(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'BlogSortKeys',
        query: 'String',
      },
      args,

      selection: selectorFn(new BlogConnection()),
    };
    return this.$_select('blogs', options) as any;
  }

  /**
 * Retrieve a cart by its ID. For more information, refer to
[Manage a cart with the Storefront API](https://shopify.dev/custom-storefronts/cart/manage).

 */
  cart<
    Args extends VariabledInput<{
      id: string;
    }>,
    Sel extends Selection<Cart>,
  >(
    args: ExactArgNames<
      Args,
      {
        id: string;
      }
    >,
    selectorFn: (s: Cart) => [...Sel],
  ): $Field<'cart', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        id: 'ID!',
      },
      args,

      selection: selectorFn(new Cart()),
    };
    return this.$_select('cart', options) as any;
  }

  /**
 * A poll for the status of the cart checkout completion and order creation.

 */
  cartCompletionAttempt<
    Args extends VariabledInput<{
      attemptId: string;
    }>,
    Sel extends Selection<CartCompletionAttemptResult>,
  >(
    args: ExactArgNames<
      Args,
      {
        attemptId: string;
      }
    >,
    selectorFn: (s: CartCompletionAttemptResult) => [...Sel],
  ): $Field<'cartCompletionAttempt', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        attemptId: 'String!',
      },
      args,

      selection: selectorFn(new CartCompletionAttemptResult()),
    };
    return this.$_select('cartCompletionAttempt', options) as any;
  }

  /**
   * Fetch a specific `Collection` by one of its unique attributes.
   */
  collection<
    Args extends VariabledInput<{
      id?: string | null | undefined;
      handle?: string | null | undefined;
    }>,
    Sel extends Selection<Collection>,
  >(
    args: ExactArgNames<
      Args,
      {
        id?: string | null | undefined;
        handle?: string | null | undefined;
      }
    >,
    selectorFn: (s: Collection) => [...Sel],
  ): $Field<'collection', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  collection<Sel extends Selection<Collection>>(
    selectorFn: (s: Collection) => [...Sel],
  ): $Field<'collection', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  collection(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        id: 'ID',
        handle: 'String',
      },
      args,

      selection: selectorFn(new Collection()),
    };
    return this.$_select('collection', options) as any;
  }

  /**
   * Find a collection by its handle.
   */
  collectionByHandle<
    Args extends VariabledInput<{
      handle: string;
    }>,
    Sel extends Selection<Collection>,
  >(
    args: ExactArgNames<
      Args,
      {
        handle: string;
      }
    >,
    selectorFn: (s: Collection) => [...Sel],
  ): $Field<'collectionByHandle', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        handle: 'String!',
      },
      args,

      selection: selectorFn(new Collection()),
    };
    return this.$_select('collectionByHandle', options) as any;
  }

  /**
   * List of the shop’s collections.
   */
  collections<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: CollectionSortKeys | null | undefined;
      query?: string | null | undefined;
    }>,
    Sel extends Selection<CollectionConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: CollectionSortKeys | null | undefined;
        query?: string | null | undefined;
      }
    >,
    selectorFn: (s: CollectionConnection) => [...Sel],
  ): $Field<'collections', GetOutput<Sel>, GetVariables<Sel, Args>>;
  collections<Sel extends Selection<CollectionConnection>>(
    selectorFn: (s: CollectionConnection) => [...Sel],
  ): $Field<'collections', GetOutput<Sel>, GetVariables<Sel>>;
  collections(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'CollectionSortKeys',
        query: 'String',
      },
      args,

      selection: selectorFn(new CollectionConnection()),
    };
    return this.$_select('collections', options) as any;
  }

  /**
 * The customer associated with the given access token. Tokens are obtained by using the
[`customerAccessTokenCreate` mutation](https://shopify.dev/docs/api/storefront/latest/mutations/customerAccessTokenCreate).

 */
  customer<
    Args extends VariabledInput<{
      customerAccessToken: string;
    }>,
    Sel extends Selection<Customer>,
  >(
    args: ExactArgNames<
      Args,
      {
        customerAccessToken: string;
      }
    >,
    selectorFn: (s: Customer) => [...Sel],
  ): $Field<'customer', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        customerAccessToken: 'String!',
      },
      args,

      selection: selectorFn(new Customer()),
    };
    return this.$_select('customer', options) as any;
  }

  /**
   * Returns the localized experiences configured for the shop.
   */
  localization<Sel extends Selection<Localization>>(
    selectorFn: (s: Localization) => [...Sel],
  ): $Field<'localization', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Localization()),
    };
    return this.$_select('localization', options) as any;
  }

  /**
 * List of the shop's locations that support in-store pickup.

When sorting by distance, you must specify a location via the `near` argument.


 */
  locations<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: LocationSortKeys | null | undefined;
      near?: GeoCoordinateInput | null | undefined;
    }>,
    Sel extends Selection<LocationConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: LocationSortKeys | null | undefined;
        near?: GeoCoordinateInput | null | undefined;
      }
    >,
    selectorFn: (s: LocationConnection) => [...Sel],
  ): $Field<'locations', GetOutput<Sel>, GetVariables<Sel, Args>>;
  locations<Sel extends Selection<LocationConnection>>(
    selectorFn: (s: LocationConnection) => [...Sel],
  ): $Field<'locations', GetOutput<Sel>, GetVariables<Sel>>;
  locations(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'LocationSortKeys',
        near: 'GeoCoordinateInput',
      },
      args,

      selection: selectorFn(new LocationConnection()),
    };
    return this.$_select('locations', options) as any;
  }

  /**
   * Retrieve a [navigation menu](https://help.shopify.com/manual/online-store/menus-and-links) by its handle.
   */
  menu<
    Args extends VariabledInput<{
      handle: string;
    }>,
    Sel extends Selection<Menu>,
  >(
    args: ExactArgNames<
      Args,
      {
        handle: string;
      }
    >,
    selectorFn: (s: Menu) => [...Sel],
  ): $Field<'menu', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        handle: 'String!',
      },
      args,

      selection: selectorFn(new Menu()),
    };
    return this.$_select('menu', options) as any;
  }

  /**
   * Fetch a specific Metaobject by one of its unique identifiers.
   */
  metaobject<
    Args extends VariabledInput<{
      id?: string | null | undefined;
      handle?: MetaobjectHandleInput | null | undefined;
    }>,
    Sel extends Selection<Metaobject>,
  >(
    args: ExactArgNames<
      Args,
      {
        id?: string | null | undefined;
        handle?: MetaobjectHandleInput | null | undefined;
      }
    >,
    selectorFn: (s: Metaobject) => [...Sel],
  ): $Field<'metaobject', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  metaobject<Sel extends Selection<Metaobject>>(
    selectorFn: (s: Metaobject) => [...Sel],
  ): $Field<'metaobject', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  metaobject(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        id: 'ID',
        handle: 'MetaobjectHandleInput',
      },
      args,

      selection: selectorFn(new Metaobject()),
    };
    return this.$_select('metaobject', options) as any;
  }

  /**
   * All active metaobjects for the shop.
   */
  metaobjects<
    Args extends VariabledInput<{
      type: string;
      sortKey?: string | null | undefined;
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<MetaobjectConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        type: string;
        sortKey?: string | null | undefined;
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: MetaobjectConnection) => [...Sel],
  ): $Field<'metaobjects', GetOutput<Sel>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        type: 'String!',
        sortKey: 'String',
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new MetaobjectConnection()),
    };
    return this.$_select('metaobjects', options) as any;
  }

  /**
   * Returns a specific node by ID.
   */
  node<
    Args extends VariabledInput<{
      id: string;
    }>,
    Sel extends Selection<Node>,
  >(
    args: ExactArgNames<
      Args,
      {
        id: string;
      }
    >,
    selectorFn: (s: Node) => [...Sel],
  ): $Field<'node', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        id: 'ID!',
      },
      args,

      selection: selectorFn(new Node()),
    };
    return this.$_select('node', options) as any;
  }

  /**
   * Returns the list of nodes with the given IDs.
   */
  nodes<
    Args extends VariabledInput<{
      ids: Readonly<Array<string>>;
    }>,
    Sel extends Selection<Node>,
  >(
    args: ExactArgNames<
      Args,
      {
        ids: Readonly<Array<string>>;
      }
    >,
    selectorFn: (s: Node) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        ids: '[ID!]!',
      },
      args,

      selection: selectorFn(new Node()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Fetch a specific `Page` by one of its unique attributes.
   */
  page<
    Args extends VariabledInput<{
      handle?: string | null | undefined;
      id?: string | null | undefined;
    }>,
    Sel extends Selection<Page>,
  >(
    args: ExactArgNames<
      Args,
      {
        handle?: string | null | undefined;
        id?: string | null | undefined;
      }
    >,
    selectorFn: (s: Page) => [...Sel],
  ): $Field<'page', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  page<Sel extends Selection<Page>>(
    selectorFn: (s: Page) => [...Sel],
  ): $Field<'page', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  page(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        handle: 'String',
        id: 'ID',
      },
      args,

      selection: selectorFn(new Page()),
    };
    return this.$_select('page', options) as any;
  }

  /**
   * Find a page by its handle.
   */
  pageByHandle<
    Args extends VariabledInput<{
      handle: string;
    }>,
    Sel extends Selection<Page>,
  >(
    args: ExactArgNames<
      Args,
      {
        handle: string;
      }
    >,
    selectorFn: (s: Page) => [...Sel],
  ): $Field<'pageByHandle', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        handle: 'String!',
      },
      args,

      selection: selectorFn(new Page()),
    };
    return this.$_select('pageByHandle', options) as any;
  }

  /**
   * List of the shop's pages.
   */
  pages<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: PageSortKeys | null | undefined;
      query?: string | null | undefined;
    }>,
    Sel extends Selection<PageConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: PageSortKeys | null | undefined;
        query?: string | null | undefined;
      }
    >,
    selectorFn: (s: PageConnection) => [...Sel],
  ): $Field<'pages', GetOutput<Sel>, GetVariables<Sel, Args>>;
  pages<Sel extends Selection<PageConnection>>(
    selectorFn: (s: PageConnection) => [...Sel],
  ): $Field<'pages', GetOutput<Sel>, GetVariables<Sel>>;
  pages(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'PageSortKeys',
        query: 'String',
      },
      args,

      selection: selectorFn(new PageConnection()),
    };
    return this.$_select('pages', options) as any;
  }

  /**
   * Settings related to payments.
   */
  paymentSettings<Sel extends Selection<PaymentSettings>>(
    selectorFn: (s: PaymentSettings) => [...Sel],
  ): $Field<'paymentSettings', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PaymentSettings()),
    };
    return this.$_select('paymentSettings', options) as any;
  }

  /**
   * List of the predictive search results.
   */
  predictiveSearch<
    Args extends VariabledInput<{
      limit?: number | null | undefined;
      limitScope?: PredictiveSearchLimitScope | null | undefined;
      query: string;
      searchableFields?: Readonly<Array<SearchableField>> | null | undefined;
      types?: Readonly<Array<PredictiveSearchType>> | null | undefined;
      unavailableProducts?: SearchUnavailableProductsType | null | undefined;
    }>,
    Sel extends Selection<PredictiveSearchResult>,
  >(
    args: ExactArgNames<
      Args,
      {
        limit?: number | null | undefined;
        limitScope?: PredictiveSearchLimitScope | null | undefined;
        query: string;
        searchableFields?: Readonly<Array<SearchableField>> | null | undefined;
        types?: Readonly<Array<PredictiveSearchType>> | null | undefined;
        unavailableProducts?: SearchUnavailableProductsType | null | undefined;
      }
    >,
    selectorFn: (s: PredictiveSearchResult) => [...Sel],
  ): $Field<'predictiveSearch', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        limit: 'Int',
        limitScope: 'PredictiveSearchLimitScope',
        query: 'String!',
        searchableFields: '[SearchableField!]',
        types: '[PredictiveSearchType!]',
        unavailableProducts: 'SearchUnavailableProductsType',
      },
      args,

      selection: selectorFn(new PredictiveSearchResult()),
    };
    return this.$_select('predictiveSearch', options) as any;
  }

  /**
   * Fetch a specific `Product` by one of its unique attributes.
   */
  product<
    Args extends VariabledInput<{
      id?: string | null | undefined;
      handle?: string | null | undefined;
    }>,
    Sel extends Selection<Product>,
  >(
    args: ExactArgNames<
      Args,
      {
        id?: string | null | undefined;
        handle?: string | null | undefined;
      }
    >,
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'product', GetOutput<Sel> | undefined, GetVariables<Sel, Args>>;
  product<Sel extends Selection<Product>>(
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'product', GetOutput<Sel> | undefined, GetVariables<Sel>>;
  product(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        id: 'ID',
        handle: 'String',
      },
      args,

      selection: selectorFn(new Product()),
    };
    return this.$_select('product', options) as any;
  }

  /**
   * Find a product by its handle.
   */
  productByHandle<
    Args extends VariabledInput<{
      handle: string;
    }>,
    Sel extends Selection<Product>,
  >(
    args: ExactArgNames<
      Args,
      {
        handle: string;
      }
    >,
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'productByHandle', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        handle: 'String!',
      },
      args,

      selection: selectorFn(new Product()),
    };
    return this.$_select('productByHandle', options) as any;
  }

  /**
 * Find recommended products related to a given `product_id`.
To learn more about how recommendations are generated, see
[*Showing product recommendations on product pages*](https://help.shopify.com/themes/development/recommended-products).

 */
  productRecommendations<
    Args extends VariabledInput<{
      productId?: string | null | undefined;
      productHandle?: string | null | undefined;
      intent?: ProductRecommendationIntent | null | undefined;
    }>,
    Sel extends Selection<Product>,
  >(
    args: ExactArgNames<
      Args,
      {
        productId?: string | null | undefined;
        productHandle?: string | null | undefined;
        intent?: ProductRecommendationIntent | null | undefined;
      }
    >,
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'productRecommendations', Array<GetOutput<Sel>> | undefined, GetVariables<Sel, Args>>;
  productRecommendations<Sel extends Selection<Product>>(
    selectorFn: (s: Product) => [...Sel],
  ): $Field<'productRecommendations', Array<GetOutput<Sel>> | undefined, GetVariables<Sel>>;
  productRecommendations(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        productId: 'ID',
        productHandle: 'String',
        intent: 'ProductRecommendationIntent',
      },
      args,

      selection: selectorFn(new Product()),
    };
    return this.$_select('productRecommendations', options) as any;
  }

  /**
 * Tags added to products.
Additional access scope required: unauthenticated_read_product_tags.

 */
  productTags<
    Args extends VariabledInput<{
      first: number;
    }>,
    Sel extends Selection<StringConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first: number;
      }
    >,
    selectorFn: (s: StringConnection) => [...Sel],
  ): $Field<'productTags', GetOutput<Sel>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        first: 'Int!',
      },
      args,

      selection: selectorFn(new StringConnection()),
    };
    return this.$_select('productTags', options) as any;
  }

  /**
   * List of product types for the shop's products that are published to your app.
   */
  productTypes<
    Args extends VariabledInput<{
      first: number;
    }>,
    Sel extends Selection<StringConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first: number;
      }
    >,
    selectorFn: (s: StringConnection) => [...Sel],
  ): $Field<'productTypes', GetOutput<Sel>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        first: 'Int!',
      },
      args,

      selection: selectorFn(new StringConnection()),
    };
    return this.$_select('productTypes', options) as any;
  }

  /**
   * Returns a list of the shop's products. For storefront search, use the [`search`](https://shopify.dev/docs/api/storefront/latest/queries/search) query.
   */
  products<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: ProductSortKeys | null | undefined;
      query?: string | null | undefined;
    }>,
    Sel extends Selection<ProductConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: ProductSortKeys | null | undefined;
        query?: string | null | undefined;
      }
    >,
    selectorFn: (s: ProductConnection) => [...Sel],
  ): $Field<'products', GetOutput<Sel>, GetVariables<Sel, Args>>;
  products<Sel extends Selection<ProductConnection>>(
    selectorFn: (s: ProductConnection) => [...Sel],
  ): $Field<'products', GetOutput<Sel>, GetVariables<Sel>>;
  products(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'ProductSortKeys',
        query: 'String',
      },
      args,

      selection: selectorFn(new ProductConnection()),
    };
    return this.$_select('products', options) as any;
  }

  /**
   * The list of public Storefront API versions, including supported, release candidate and unstable versions.
   */
  publicApiVersions<Sel extends Selection<ApiVersion>>(
    selectorFn: (s: ApiVersion) => [...Sel],
  ): $Field<'publicApiVersions', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ApiVersion()),
    };
    return this.$_select('publicApiVersions', options) as any;
  }

  /**
   * List of the search results.
   */
  search<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      sortKey?: SearchSortKeys | null | undefined;
      query: string;
      prefix?: SearchPrefixQueryType | null | undefined;
      productFilters?: Readonly<Array<ProductFilter>> | null | undefined;
      types?: Readonly<Array<SearchType>> | null | undefined;
      unavailableProducts?: SearchUnavailableProductsType | null | undefined;
    }>,
    Sel extends Selection<SearchResultItemConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        sortKey?: SearchSortKeys | null | undefined;
        query: string;
        prefix?: SearchPrefixQueryType | null | undefined;
        productFilters?: Readonly<Array<ProductFilter>> | null | undefined;
        types?: Readonly<Array<SearchType>> | null | undefined;
        unavailableProducts?: SearchUnavailableProductsType | null | undefined;
      }
    >,
    selectorFn: (s: SearchResultItemConnection) => [...Sel],
  ): $Field<'search', GetOutput<Sel>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        sortKey: 'SearchSortKeys',
        query: 'String!',
        prefix: 'SearchPrefixQueryType',
        productFilters: '[ProductFilter!]',
        types: '[SearchType!]',
        unavailableProducts: 'SearchUnavailableProductsType',
      },
      args,

      selection: selectorFn(new SearchResultItemConnection()),
    };
    return this.$_select('search', options) as any;
  }

  /**
   * The shop associated with the storefront access token.
   */
  shop<Sel extends Selection<Shop>>(
    selectorFn: (s: Shop) => [...Sel],
  ): $Field<'shop', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Shop()),
    };
    return this.$_select('shop', options) as any;
  }

  /**
   * Contains all fields required to generate sitemaps.
   */
  sitemap<
    Args extends VariabledInput<{
      type: SitemapType;
    }>,
    Sel extends Selection<Sitemap>,
  >(
    args: ExactArgNames<
      Args,
      {
        type: SitemapType;
      }
    >,
    selectorFn: (s: Sitemap) => [...Sel],
  ): $Field<'sitemap', GetOutput<Sel>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        type: 'SitemapType!',
      },
      args,

      selection: selectorFn(new Sitemap()),
    };
    return this.$_select('sitemap', options) as any;
  }

  /**
   * A list of redirects for a shop.
   */
  urlRedirects<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
      query?: string | null | undefined;
    }>,
    Sel extends Selection<UrlRedirectConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
        query?: string | null | undefined;
      }
    >,
    selectorFn: (s: UrlRedirectConnection) => [...Sel],
  ): $Field<'urlRedirects', GetOutput<Sel>, GetVariables<Sel, Args>>;
  urlRedirects<Sel extends Selection<UrlRedirectConnection>>(
    selectorFn: (s: UrlRedirectConnection) => [...Sel],
  ): $Field<'urlRedirects', GetOutput<Sel>, GetVariables<Sel>>;
  urlRedirects(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
        query: 'String',
      },
      args,

      selection: selectorFn(new UrlRedirectConnection()),
    };
    return this.$_select('urlRedirects', options) as any;
  }
}

/**
 * SEO information.
 */
/* #__PURE__ */
export class SEO extends $Base<'SEO'> {
  constructor() {
    super('SEO');
  }

  /**
   * The meta description.
   */
  get description(): $Field<'description', string | null | undefined> {
    return this.$_select('description') as any;
  }

  /**
   * The SEO title.
   */
  get title(): $Field<'title', string | null | undefined> {
    return this.$_select('title') as any;
  }
}

/**
 * Script discount applications capture the intentions of a discount that
was created by a Shopify Script.

 */
/* #__PURE__ */
export class ScriptDiscountApplication extends $Base<'ScriptDiscountApplication'> {
  constructor() {
    super('ScriptDiscountApplication');
  }

  /**
   * The method by which the discount's value is allocated to its entitled items.
   */
  get allocationMethod(): $Field<'allocationMethod', DiscountApplicationAllocationMethod> {
    return this.$_select('allocationMethod') as any;
  }

  /**
   * Which lines of targetType that the discount is allocated over.
   */
  get targetSelection(): $Field<'targetSelection', DiscountApplicationTargetSelection> {
    return this.$_select('targetSelection') as any;
  }

  /**
   * The type of line that the discount is applicable towards.
   */
  get targetType(): $Field<'targetType', DiscountApplicationTargetType> {
    return this.$_select('targetType') as any;
  }

  /**
   * The title of the application as defined by the Script.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * The value of the discount application.
   */
  value<Sel extends Selection<PricingValue>>(
    selectorFn: (s: PricingValue) => [...Sel],
  ): $Field<'value', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PricingValue()),
    };
    return this.$_select('value', options) as any;
  }
}

/**
 * Specifies whether to perform a partial word match on the last search term.
 */
export enum SearchPrefixQueryType {
  /**
   * Perform a partial word match on the last search term.
   */
  LAST = 'LAST',

  /**
   * Don't perform a partial word match on the last search term.
   */
  NONE = 'NONE',
}

/**
 * A search query suggestion.
 */
/* #__PURE__ */
export class SearchQuerySuggestion extends $Base<'SearchQuerySuggestion'> {
  constructor() {
    super('SearchQuerySuggestion');
  }

  /**
   * The text of the search query suggestion with highlighted HTML tags.
   */
  get styledText(): $Field<'styledText', string> {
    return this.$_select('styledText') as any;
  }

  /**
   * The text of the search query suggestion.
   */
  get text(): $Field<'text', string> {
    return this.$_select('text') as any;
  }

  /**
   * URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null.
   */
  get trackingParameters(): $Field<'trackingParameters', string | null | undefined> {
    return this.$_select('trackingParameters') as any;
  }
}

/**
 * A search result that matches the search query.

 */
/* #__PURE__ */
export class SearchResultItem extends $Union<
  {
    Article: Article;
    Page: Page;
    Product: Product;
    HasMetafields: HasMetafields;
    Node: Node;
    OnlineStorePublishable: OnlineStorePublishable;
    Trackable: Trackable;
  },
  'SearchResultItem'
> {
  constructor() {
    super(
      {
        Article: Article,
        Page: Page,
        Product: Product,
        HasMetafields: HasMetafields,
        Node: Node,
        OnlineStorePublishable: OnlineStorePublishable,
        Trackable: Trackable,
      },
      'SearchResultItem',
    );
  }
}

/**
 * An auto-generated type for paginating through multiple SearchResultItems.

 */
/* #__PURE__ */
export class SearchResultItemConnection extends $Base<'SearchResultItemConnection'> {
  constructor() {
    super('SearchResultItemConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<SearchResultItemEdge>>(
    selectorFn: (s: SearchResultItemEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SearchResultItemEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in SearchResultItemEdge.
   */
  nodes<Sel extends Selection<SearchResultItem>>(
    selectorFn: (s: SearchResultItem) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SearchResultItem()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }

  /**
   * A list of available filters.
   */
  productFilters<Sel extends Selection<Filter>>(
    selectorFn: (s: Filter) => [...Sel],
  ): $Field<'productFilters', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Filter()),
    };
    return this.$_select('productFilters', options) as any;
  }

  /**
   * The total number of results.
   */
  get totalCount(): $Field<'totalCount', number> {
    return this.$_select('totalCount') as any;
  }
}

/**
 * An auto-generated type which holds one SearchResultItem and a cursor during pagination.

 */
/* #__PURE__ */
export class SearchResultItemEdge extends $Base<'SearchResultItemEdge'> {
  constructor() {
    super('SearchResultItemEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of SearchResultItemEdge.
   */
  node<Sel extends Selection<SearchResultItem>>(
    selectorFn: (s: SearchResultItem) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SearchResultItem()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The set of valid sort keys for the search query.
 */
export enum SearchSortKeys {
  /**
   * Sort by the `price` value.
   */
  PRICE = 'PRICE',

  /**
   * Sort by relevance to the search terms.
   */
  RELEVANCE = 'RELEVANCE',
}

/**
 * The types of search items to perform search within.
 */
export enum SearchType {
  /**
   * Returns matching products.
   */
  PRODUCT = 'PRODUCT',

  /**
   * Returns matching pages.
   */
  PAGE = 'PAGE',

  /**
   * Returns matching articles.
   */
  ARTICLE = 'ARTICLE',
}

/**
 * Specifies whether to display results for unavailable products.
 */
export enum SearchUnavailableProductsType {
  /**
   * Show unavailable products in the order that they're found.
   */
  SHOW = 'SHOW',

  /**
   * Exclude unavailable products.
   */
  HIDE = 'HIDE',

  /**
   * Show unavailable products after all other matching results. This is the default.
   */
  LAST = 'LAST',
}

/**
 * Specifies the list of resource fields to search.
 */
export enum SearchableField {
  /**
   * Author of the page or article.
   */
  AUTHOR = 'AUTHOR',

  /**
   * Body of the page or article or product description or collection description.
   */
  BODY = 'BODY',

  /**
   * Product type.
   */
  PRODUCT_TYPE = 'PRODUCT_TYPE',

  /**
   * Tag associated with the product or article.
   */
  TAG = 'TAG',

  /**
   * Title of the page or article or product title or collection title.
   */
  TITLE = 'TITLE',

  /**
   * Variant barcode.
   */
  VARIANTS_BARCODE = 'VARIANTS_BARCODE',

  /**
   * Variant SKU.
   */
  VARIANTS_SKU = 'VARIANTS_SKU',

  /**
   * Variant title.
   */
  VARIANTS_TITLE = 'VARIANTS_TITLE',

  /**
   * Product vendor.
   */
  VENDOR = 'VENDOR',
}

/**
 * Properties used by customers to select a product variant.
Products can have multiple options, like different sizes or colors.

 */
/* #__PURE__ */
export class SelectedOption extends $Base<'SelectedOption'> {
  constructor() {
    super('SelectedOption');
  }

  /**
   * The product option’s name.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The product option’s value.
   */
  get value(): $Field<'value', string> {
    return this.$_select('value') as any;
  }
}

/**
 * The input fields required for a selected option.
 */
export type SelectedOptionInput = {
  name: string;
  value: string;
};

/**
 * Represents how products and variants can be sold and purchased.
 */
/* #__PURE__ */
export class SellingPlan extends $Base<'SellingPlan'> {
  constructor() {
    super('SellingPlan');
  }

  /**
   * The billing policy for the selling plan.
   */
  billingPolicy<Sel extends Selection<SellingPlanBillingPolicy>>(
    selectorFn: (s: SellingPlanBillingPolicy) => [...Sel],
  ): $Field<'billingPolicy', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanBillingPolicy()),
    };
    return this.$_select('billingPolicy', options) as any;
  }

  /**
   * The initial payment due for the purchase.
   */
  checkoutCharge<Sel extends Selection<SellingPlanCheckoutCharge>>(
    selectorFn: (s: SellingPlanCheckoutCharge) => [...Sel],
  ): $Field<'checkoutCharge', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanCheckoutCharge()),
    };
    return this.$_select('checkoutCharge', options) as any;
  }

  /**
   * The delivery policy for the selling plan.
   */
  deliveryPolicy<Sel extends Selection<SellingPlanDeliveryPolicy>>(
    selectorFn: (s: SellingPlanDeliveryPolicy) => [...Sel],
  ): $Field<'deliveryPolicy', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanDeliveryPolicy()),
    };
    return this.$_select('deliveryPolicy', options) as any;
  }

  /**
   * The description of the selling plan.
   */
  get description(): $Field<'description', string | null | undefined> {
    return this.$_select('description') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * The name of the selling plan. For example, '6 weeks of prepaid granola, delivered weekly'.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The selling plan options available in the drop-down list in the storefront. For example, 'Delivery every week' or 'Delivery every 2 weeks' specifies the delivery frequency options for the product. Individual selling plans contribute their options to the associated selling plan group. For example, a selling plan group might have an option called `option1: Delivery every`. One selling plan in that group could contribute `option1: 2 weeks` with the pricing for that option, and another selling plan could contribute `option1: 4 weeks`, with different pricing.
   */
  options<Sel extends Selection<SellingPlanOption>>(
    selectorFn: (s: SellingPlanOption) => [...Sel],
  ): $Field<'options', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanOption()),
    };
    return this.$_select('options', options) as any;
  }

  /**
   * The price adjustments that a selling plan makes when a variant is purchased with a selling plan.
   */
  priceAdjustments<Sel extends Selection<SellingPlanPriceAdjustment>>(
    selectorFn: (s: SellingPlanPriceAdjustment) => [...Sel],
  ): $Field<'priceAdjustments', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanPriceAdjustment()),
    };
    return this.$_select('priceAdjustments', options) as any;
  }

  /**
   * Whether purchasing the selling plan will result in multiple deliveries.
   */
  get recurringDeliveries(): $Field<'recurringDeliveries', boolean> {
    return this.$_select('recurringDeliveries') as any;
  }
}

/**
 * Represents an association between a variant and a selling plan. Selling plan allocations describe the options offered for each variant, and the price of the variant when purchased with a selling plan.
 */
/* #__PURE__ */
export class SellingPlanAllocation extends $Base<'SellingPlanAllocation'> {
  constructor() {
    super('SellingPlanAllocation');
  }

  /**
   * The checkout charge amount due for the purchase.
   */
  checkoutChargeAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'checkoutChargeAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('checkoutChargeAmount', options) as any;
  }

  /**
   * A list of price adjustments, with a maximum of two. When there are two, the first price adjustment goes into effect at the time of purchase, while the second one starts after a certain number of orders. A price adjustment represents how a selling plan affects pricing when a variant is purchased with a selling plan. Prices display in the customer's currency if the shop is configured for it.
   */
  priceAdjustments<Sel extends Selection<SellingPlanAllocationPriceAdjustment>>(
    selectorFn: (s: SellingPlanAllocationPriceAdjustment) => [...Sel],
  ): $Field<'priceAdjustments', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanAllocationPriceAdjustment()),
    };
    return this.$_select('priceAdjustments', options) as any;
  }

  /**
   * The remaining balance charge amount due for the purchase.
   */
  remainingBalanceChargeAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'remainingBalanceChargeAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('remainingBalanceChargeAmount', options) as any;
  }

  /**
   * A representation of how products and variants can be sold and purchased. For example, an individual selling plan could be '6 weeks of prepaid granola, delivered weekly'.
   */
  sellingPlan<Sel extends Selection<SellingPlan>>(
    selectorFn: (s: SellingPlan) => [...Sel],
  ): $Field<'sellingPlan', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlan()),
    };
    return this.$_select('sellingPlan', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple SellingPlanAllocations.

 */
/* #__PURE__ */
export class SellingPlanAllocationConnection extends $Base<'SellingPlanAllocationConnection'> {
  constructor() {
    super('SellingPlanAllocationConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<SellingPlanAllocationEdge>>(
    selectorFn: (s: SellingPlanAllocationEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanAllocationEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in SellingPlanAllocationEdge.
   */
  nodes<Sel extends Selection<SellingPlanAllocation>>(
    selectorFn: (s: SellingPlanAllocation) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanAllocation()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one SellingPlanAllocation and a cursor during pagination.

 */
/* #__PURE__ */
export class SellingPlanAllocationEdge extends $Base<'SellingPlanAllocationEdge'> {
  constructor() {
    super('SellingPlanAllocationEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of SellingPlanAllocationEdge.
   */
  node<Sel extends Selection<SellingPlanAllocation>>(
    selectorFn: (s: SellingPlanAllocation) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanAllocation()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * The resulting prices for variants when they're purchased with a specific selling plan.
 */
/* #__PURE__ */
export class SellingPlanAllocationPriceAdjustment extends $Base<'SellingPlanAllocationPriceAdjustment'> {
  constructor() {
    super('SellingPlanAllocationPriceAdjustment');
  }

  /**
   * The price of the variant when it's purchased without a selling plan for the same number of deliveries. For example, if a customer purchases 6 deliveries of $10.00 granola separately, then the price is 6 x $10.00 = $60.00.
   */
  compareAtPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'compareAtPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('compareAtPrice', options) as any;
  }

  /**
   * The effective price for a single delivery. For example, for a prepaid subscription plan that includes 6 deliveries at the price of $48.00, the per delivery price is $8.00.
   */
  perDeliveryPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'perDeliveryPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('perDeliveryPrice', options) as any;
  }

  /**
   * The price of the variant when it's purchased with a selling plan For example, for a prepaid subscription plan that includes 6 deliveries of $10.00 granola, where the customer gets 20% off, the price is 6 x $10.00 x 0.80 = $48.00.
   */
  price<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'price', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('price', options) as any;
  }

  /**
   * The resulting price per unit for the variant associated with the selling plan. If the variant isn't sold by quantity or measurement, then this field returns `null`.
   */
  unitPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'unitPrice', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('unitPrice', options) as any;
  }
}

/**
 * The selling plan billing policy.
 */
/* #__PURE__ */
export class SellingPlanBillingPolicy extends $Union<
  { SellingPlanRecurringBillingPolicy: SellingPlanRecurringBillingPolicy },
  'SellingPlanBillingPolicy'
> {
  constructor() {
    super({ SellingPlanRecurringBillingPolicy: SellingPlanRecurringBillingPolicy }, 'SellingPlanBillingPolicy');
  }
}

/**
 * The initial payment due for the purchase.
 */
/* #__PURE__ */
export class SellingPlanCheckoutCharge extends $Base<'SellingPlanCheckoutCharge'> {
  constructor() {
    super('SellingPlanCheckoutCharge');
  }

  /**
   * The charge type for the checkout charge.
   */
  get type(): $Field<'type', SellingPlanCheckoutChargeType> {
    return this.$_select('type') as any;
  }

  /**
   * The charge value for the checkout charge.
   */
  value<Sel extends Selection<SellingPlanCheckoutChargeValue>>(
    selectorFn: (s: SellingPlanCheckoutChargeValue) => [...Sel],
  ): $Field<'value', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanCheckoutChargeValue()),
    };
    return this.$_select('value', options) as any;
  }
}

/**
 * The percentage value of the price used for checkout charge.
 */
/* #__PURE__ */
export class SellingPlanCheckoutChargePercentageValue extends $Base<'SellingPlanCheckoutChargePercentageValue'> {
  constructor() {
    super('SellingPlanCheckoutChargePercentageValue');
  }

  /**
   * The percentage value of the price used for checkout charge.
   */
  get percentage(): $Field<'percentage', number> {
    return this.$_select('percentage') as any;
  }
}

/**
 * The checkout charge when the full amount isn't charged at checkout.
 */
export enum SellingPlanCheckoutChargeType {
  /**
   * The checkout charge is a percentage of the product or variant price.
   */
  PERCENTAGE = 'PERCENTAGE',

  /**
   * The checkout charge is a fixed price amount.
   */
  PRICE = 'PRICE',
}

/**
 * The portion of the price to be charged at checkout.
 */
/* #__PURE__ */
export class SellingPlanCheckoutChargeValue extends $Union<
  { MoneyV2: MoneyV2; SellingPlanCheckoutChargePercentageValue: SellingPlanCheckoutChargePercentageValue },
  'SellingPlanCheckoutChargeValue'
> {
  constructor() {
    super(
      { MoneyV2: MoneyV2, SellingPlanCheckoutChargePercentageValue: SellingPlanCheckoutChargePercentageValue },
      'SellingPlanCheckoutChargeValue',
    );
  }
}

/**
 * An auto-generated type for paginating through multiple SellingPlans.

 */
/* #__PURE__ */
export class SellingPlanConnection extends $Base<'SellingPlanConnection'> {
  constructor() {
    super('SellingPlanConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<SellingPlanEdge>>(
    selectorFn: (s: SellingPlanEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in SellingPlanEdge.
   */
  nodes<Sel extends Selection<SellingPlan>>(
    selectorFn: (s: SellingPlan) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlan()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * The selling plan delivery policy.
 */
/* #__PURE__ */
export class SellingPlanDeliveryPolicy extends $Union<
  { SellingPlanRecurringDeliveryPolicy: SellingPlanRecurringDeliveryPolicy },
  'SellingPlanDeliveryPolicy'
> {
  constructor() {
    super({ SellingPlanRecurringDeliveryPolicy: SellingPlanRecurringDeliveryPolicy }, 'SellingPlanDeliveryPolicy');
  }
}

/**
 * An auto-generated type which holds one SellingPlan and a cursor during pagination.

 */
/* #__PURE__ */
export class SellingPlanEdge extends $Base<'SellingPlanEdge'> {
  constructor() {
    super('SellingPlanEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of SellingPlanEdge.
   */
  node<Sel extends Selection<SellingPlan>>(
    selectorFn: (s: SellingPlan) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlan()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * A fixed amount that's deducted from the original variant price. For example, $10.00 off.
 */
/* #__PURE__ */
export class SellingPlanFixedAmountPriceAdjustment extends $Base<'SellingPlanFixedAmountPriceAdjustment'> {
  constructor() {
    super('SellingPlanFixedAmountPriceAdjustment');
  }

  /**
   * The money value of the price adjustment.
   */
  adjustmentAmount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'adjustmentAmount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('adjustmentAmount', options) as any;
  }
}

/**
 * A fixed price adjustment for a variant that's purchased with a selling plan.
 */
/* #__PURE__ */
export class SellingPlanFixedPriceAdjustment extends $Base<'SellingPlanFixedPriceAdjustment'> {
  constructor() {
    super('SellingPlanFixedPriceAdjustment');
  }

  /**
   * A new price of the variant when it's purchased with the selling plan.
   */
  price<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'price', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('price', options) as any;
  }
}

/**
 * Represents a selling method. For example, 'Subscribe and save' is a selling method where customers pay for goods or services per delivery. A selling plan group contains individual selling plans.
 */
/* #__PURE__ */
export class SellingPlanGroup extends $Base<'SellingPlanGroup'> {
  constructor() {
    super('SellingPlanGroup');
  }

  /**
   * A display friendly name for the app that created the selling plan group.
   */
  get appName(): $Field<'appName', string | null | undefined> {
    return this.$_select('appName') as any;
  }

  /**
   * The name of the selling plan group.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * Represents the selling plan options available in the drop-down list in the storefront. For example, 'Delivery every week' or 'Delivery every 2 weeks' specifies the delivery frequency options for the product.
   */
  options<Sel extends Selection<SellingPlanGroupOption>>(
    selectorFn: (s: SellingPlanGroupOption) => [...Sel],
  ): $Field<'options', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanGroupOption()),
    };
    return this.$_select('options', options) as any;
  }

  /**
   * A list of selling plans in a selling plan group. A selling plan is a representation of how products and variants can be sold and purchased. For example, an individual selling plan could be '6 weeks of prepaid granola, delivered weekly'.
   */
  sellingPlans<
    Args extends VariabledInput<{
      first?: number | null | undefined;
      after?: string | null | undefined;
      last?: number | null | undefined;
      before?: string | null | undefined;
      reverse?: boolean | null | undefined;
    }>,
    Sel extends Selection<SellingPlanConnection>,
  >(
    args: ExactArgNames<
      Args,
      {
        first?: number | null | undefined;
        after?: string | null | undefined;
        last?: number | null | undefined;
        before?: string | null | undefined;
        reverse?: boolean | null | undefined;
      }
    >,
    selectorFn: (s: SellingPlanConnection) => [...Sel],
  ): $Field<'sellingPlans', GetOutput<Sel>, GetVariables<Sel, Args>>;
  sellingPlans<Sel extends Selection<SellingPlanConnection>>(
    selectorFn: (s: SellingPlanConnection) => [...Sel],
  ): $Field<'sellingPlans', GetOutput<Sel>, GetVariables<Sel>>;
  sellingPlans(arg1: any, arg2?: any) {
    const { args, selectorFn } = !arg2 ? { args: {}, selectorFn: arg1 } : { args: arg1, selectorFn: arg2 };

    const options = {
      argTypes: {
        first: 'Int',
        after: 'String',
        last: 'Int',
        before: 'String',
        reverse: 'Boolean',
      },
      args,

      selection: selectorFn(new SellingPlanConnection()),
    };
    return this.$_select('sellingPlans', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple SellingPlanGroups.

 */
/* #__PURE__ */
export class SellingPlanGroupConnection extends $Base<'SellingPlanGroupConnection'> {
  constructor() {
    super('SellingPlanGroupConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<SellingPlanGroupEdge>>(
    selectorFn: (s: SellingPlanGroupEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanGroupEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in SellingPlanGroupEdge.
   */
  nodes<Sel extends Selection<SellingPlanGroup>>(
    selectorFn: (s: SellingPlanGroup) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanGroup()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one SellingPlanGroup and a cursor during pagination.

 */
/* #__PURE__ */
export class SellingPlanGroupEdge extends $Base<'SellingPlanGroupEdge'> {
  constructor() {
    super('SellingPlanGroupEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of SellingPlanGroupEdge.
   */
  node<Sel extends Selection<SellingPlanGroup>>(
    selectorFn: (s: SellingPlanGroup) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanGroup()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Represents an option on a selling plan group that's available in the drop-down list in the storefront.

Individual selling plans contribute their options to the associated selling plan group. For example, a selling plan group might have an option called `option1: Delivery every`. One selling plan in that group could contribute `option1: 2 weeks` with the pricing for that option, and another selling plan could contribute `option1: 4 weeks`, with different pricing.
 */
/* #__PURE__ */
export class SellingPlanGroupOption extends $Base<'SellingPlanGroupOption'> {
  constructor() {
    super('SellingPlanGroupOption');
  }

  /**
   * The name of the option. For example, 'Delivery every'.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * The values for the options specified by the selling plans in the selling plan group. For example, '1 week', '2 weeks', '3 weeks'.
   */
  get values(): $Field<'values', Readonly<Array<string>>> {
    return this.$_select('values') as any;
  }
}

/**
 * Represents a valid selling plan interval.
 */
export enum SellingPlanInterval {
  /**
   * Day interval.
   */
  DAY = 'DAY',

  /**
   * Month interval.
   */
  MONTH = 'MONTH',

  /**
   * Week interval.
   */
  WEEK = 'WEEK',

  /**
   * Year interval.
   */
  YEAR = 'YEAR',
}

/**
 * An option provided by a Selling Plan.
 */
/* #__PURE__ */
export class SellingPlanOption extends $Base<'SellingPlanOption'> {
  constructor() {
    super('SellingPlanOption');
  }

  /**
   * The name of the option (ie "Delivery every").
   */
  get name(): $Field<'name', string | null | undefined> {
    return this.$_select('name') as any;
  }

  /**
   * The value of the option (ie "Month").
   */
  get value(): $Field<'value', string | null | undefined> {
    return this.$_select('value') as any;
  }
}

/**
 * A percentage amount that's deducted from the original variant price. For example, 10% off.
 */
/* #__PURE__ */
export class SellingPlanPercentagePriceAdjustment extends $Base<'SellingPlanPercentagePriceAdjustment'> {
  constructor() {
    super('SellingPlanPercentagePriceAdjustment');
  }

  /**
   * The percentage value of the price adjustment.
   */
  get adjustmentPercentage(): $Field<'adjustmentPercentage', number> {
    return this.$_select('adjustmentPercentage') as any;
  }
}

/**
 * Represents by how much the price of a variant associated with a selling plan is adjusted. Each variant can have up to two price adjustments. If a variant has multiple price adjustments, then the first price adjustment applies when the variant is initially purchased. The second price adjustment applies after a certain number of orders (specified by the `orderCount` field) are made. If a selling plan doesn't have any price adjustments, then the unadjusted price of the variant is the effective price.
 */
/* #__PURE__ */
export class SellingPlanPriceAdjustment extends $Base<'SellingPlanPriceAdjustment'> {
  constructor() {
    super('SellingPlanPriceAdjustment');
  }

  /**
   * The type of price adjustment. An adjustment value can have one of three types: percentage, amount off, or a new price.
   */
  adjustmentValue<Sel extends Selection<SellingPlanPriceAdjustmentValue>>(
    selectorFn: (s: SellingPlanPriceAdjustmentValue) => [...Sel],
  ): $Field<'adjustmentValue', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SellingPlanPriceAdjustmentValue()),
    };
    return this.$_select('adjustmentValue', options) as any;
  }

  /**
   * The number of orders that the price adjustment applies to. If the price adjustment always applies, then this field is `null`.
   */
  get orderCount(): $Field<'orderCount', number | null | undefined> {
    return this.$_select('orderCount') as any;
  }
}

/**
 * Represents by how much the price of a variant associated with a selling plan is adjusted. Each variant can have up to two price adjustments.
 */
/* #__PURE__ */
export class SellingPlanPriceAdjustmentValue extends $Union<
  {
    SellingPlanFixedAmountPriceAdjustment: SellingPlanFixedAmountPriceAdjustment;
    SellingPlanFixedPriceAdjustment: SellingPlanFixedPriceAdjustment;
    SellingPlanPercentagePriceAdjustment: SellingPlanPercentagePriceAdjustment;
  },
  'SellingPlanPriceAdjustmentValue'
> {
  constructor() {
    super(
      {
        SellingPlanFixedAmountPriceAdjustment: SellingPlanFixedAmountPriceAdjustment,
        SellingPlanFixedPriceAdjustment: SellingPlanFixedPriceAdjustment,
        SellingPlanPercentagePriceAdjustment: SellingPlanPercentagePriceAdjustment,
      },
      'SellingPlanPriceAdjustmentValue',
    );
  }
}

/**
 * The recurring billing policy for the selling plan.
 */
/* #__PURE__ */
export class SellingPlanRecurringBillingPolicy extends $Base<'SellingPlanRecurringBillingPolicy'> {
  constructor() {
    super('SellingPlanRecurringBillingPolicy');
  }

  /**
   * The billing frequency, it can be either: day, week, month or year.
   */
  get interval(): $Field<'interval', SellingPlanInterval> {
    return this.$_select('interval') as any;
  }

  /**
   * The number of intervals between billings.
   */
  get intervalCount(): $Field<'intervalCount', number> {
    return this.$_select('intervalCount') as any;
  }
}

/**
 * The recurring delivery policy for the selling plan.
 */
/* #__PURE__ */
export class SellingPlanRecurringDeliveryPolicy extends $Base<'SellingPlanRecurringDeliveryPolicy'> {
  constructor() {
    super('SellingPlanRecurringDeliveryPolicy');
  }

  /**
   * The delivery frequency, it can be either: day, week, month or year.
   */
  get interval(): $Field<'interval', SellingPlanInterval> {
    return this.$_select('interval') as any;
  }

  /**
   * The number of intervals between deliveries.
   */
  get intervalCount(): $Field<'intervalCount', number> {
    return this.$_select('intervalCount') as any;
  }
}

/**
 * Shop represents a collection of the general settings and information about the shop.
 */
/* #__PURE__ */
export class Shop extends $Base<'Shop'> {
  constructor() {
    super('Shop');
  }

  /**
   * The shop's branding configuration.
   */
  brand<Sel extends Selection<Brand>>(
    selectorFn: (s: Brand) => [...Sel],
  ): $Field<'brand', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Brand()),
    };
    return this.$_select('brand', options) as any;
  }

  /**
   * A description of the shop.
   */
  get description(): $Field<'description', string | null | undefined> {
    return this.$_select('description') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Returns a metafield found by namespace and key.
   */
  metafield<
    Args extends VariabledInput<{
      namespace?: string | null | undefined;
      key: string;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        namespace?: string | null | undefined;
        key: string;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafield', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        namespace: 'String',
        key: 'String!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafield', options) as any;
  }

  /**
   * The metafields associated with the resource matching the supplied list of namespaces and keys.
   */
  metafields<
    Args extends VariabledInput<{
      identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
    }>,
    Sel extends Selection<Metafield>,
  >(
    args: ExactArgNames<
      Args,
      {
        identifiers: Readonly<Array<HasMetafieldsIdentifier>>;
      }
    >,
    selectorFn: (s: Metafield) => [...Sel],
  ): $Field<'metafields', Array<GetOutput<Sel> | undefined>, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        identifiers: '[HasMetafieldsIdentifier!]!',
      },
      args,

      selection: selectorFn(new Metafield()),
    };
    return this.$_select('metafields', options) as any;
  }

  /**
   * A string representing the way currency is formatted when the currency isn’t specified.
   */
  get moneyFormat(): $Field<'moneyFormat', string> {
    return this.$_select('moneyFormat') as any;
  }

  /**
   * The shop’s name.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }

  /**
   * Settings related to payments.
   */
  paymentSettings<Sel extends Selection<PaymentSettings>>(
    selectorFn: (s: PaymentSettings) => [...Sel],
  ): $Field<'paymentSettings', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PaymentSettings()),
    };
    return this.$_select('paymentSettings', options) as any;
  }

  /**
   * The primary domain of the shop’s Online Store.
   */
  primaryDomain<Sel extends Selection<Domain>>(
    selectorFn: (s: Domain) => [...Sel],
  ): $Field<'primaryDomain', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Domain()),
    };
    return this.$_select('primaryDomain', options) as any;
  }

  /**
   * The shop’s privacy policy.
   */
  privacyPolicy<Sel extends Selection<ShopPolicy>>(
    selectorFn: (s: ShopPolicy) => [...Sel],
  ): $Field<'privacyPolicy', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPolicy()),
    };
    return this.$_select('privacyPolicy', options) as any;
  }

  /**
   * The shop’s refund policy.
   */
  refundPolicy<Sel extends Selection<ShopPolicy>>(
    selectorFn: (s: ShopPolicy) => [...Sel],
  ): $Field<'refundPolicy', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPolicy()),
    };
    return this.$_select('refundPolicy', options) as any;
  }

  /**
   * The shop’s shipping policy.
   */
  shippingPolicy<Sel extends Selection<ShopPolicy>>(
    selectorFn: (s: ShopPolicy) => [...Sel],
  ): $Field<'shippingPolicy', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPolicy()),
    };
    return this.$_select('shippingPolicy', options) as any;
  }

  /**
   * Countries that the shop ships to.
   */
  get shipsToCountries(): $Field<'shipsToCountries', Readonly<Array<CountryCode>>> {
    return this.$_select('shipsToCountries') as any;
  }

  /**
   * The Shop Pay Installments pricing information for the shop.
   */
  shopPayInstallmentsPricing<Sel extends Selection<ShopPayInstallmentsPricing>>(
    selectorFn: (s: ShopPayInstallmentsPricing) => [...Sel],
  ): $Field<'shopPayInstallmentsPricing', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayInstallmentsPricing()),
    };
    return this.$_select('shopPayInstallmentsPricing', options) as any;
  }

  /**
   * The shop’s subscription policy.
   */
  subscriptionPolicy<Sel extends Selection<ShopPolicyWithDefault>>(
    selectorFn: (s: ShopPolicyWithDefault) => [...Sel],
  ): $Field<'subscriptionPolicy', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPolicyWithDefault()),
    };
    return this.$_select('subscriptionPolicy', options) as any;
  }

  /**
   * The shop’s terms of service.
   */
  termsOfService<Sel extends Selection<ShopPolicy>>(
    selectorFn: (s: ShopPolicy) => [...Sel],
  ): $Field<'termsOfService', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPolicy()),
    };
    return this.$_select('termsOfService', options) as any;
  }
}

/**
 * The financing plan in Shop Pay Installments.
 */
/* #__PURE__ */
export class ShopPayInstallmentsFinancingPlan extends $Base<'ShopPayInstallmentsFinancingPlan'> {
  constructor() {
    super('ShopPayInstallmentsFinancingPlan');
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The maximum price to qualify for the financing plan.
   */
  maxPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'maxPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('maxPrice', options) as any;
  }

  /**
   * The minimum price to qualify for the financing plan.
   */
  minPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'minPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('minPrice', options) as any;
  }

  /**
   * The terms of the financing plan.
   */
  terms<Sel extends Selection<ShopPayInstallmentsFinancingPlanTerm>>(
    selectorFn: (s: ShopPayInstallmentsFinancingPlanTerm) => [...Sel],
  ): $Field<'terms', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayInstallmentsFinancingPlanTerm()),
    };
    return this.$_select('terms', options) as any;
  }
}

/**
 * The payment frequency for a Shop Pay Installments Financing Plan.
 */
export enum ShopPayInstallmentsFinancingPlanFrequency {
  /**
   * Weekly payment frequency.
   */
  WEEKLY = 'WEEKLY',

  /**
   * Monthly payment frequency.
   */
  MONTHLY = 'MONTHLY',
}

/**
 * The terms of the financing plan in Shop Pay Installments.
 */
/* #__PURE__ */
export class ShopPayInstallmentsFinancingPlanTerm extends $Base<'ShopPayInstallmentsFinancingPlanTerm'> {
  constructor() {
    super('ShopPayInstallmentsFinancingPlanTerm');
  }

  /**
   * The annual percentage rate (APR) of the financing plan.
   */
  get apr(): $Field<'apr', number> {
    return this.$_select('apr') as any;
  }

  /**
   * The payment frequency for the financing plan.
   */
  get frequency(): $Field<'frequency', ShopPayInstallmentsFinancingPlanFrequency> {
    return this.$_select('frequency') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The number of installments for the financing plan.
   */
  installmentsCount<Sel extends Selection<Count>>(
    selectorFn: (s: Count) => [...Sel],
  ): $Field<'installmentsCount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Count()),
    };
    return this.$_select('installmentsCount', options) as any;
  }

  /**
   * The type of loan for the financing plan.
   */
  get loanType(): $Field<'loanType', ShopPayInstallmentsLoan> {
    return this.$_select('loanType') as any;
  }
}

/**
 * The loan type for a Shop Pay Installments Financing Plan Term.
 */
export enum ShopPayInstallmentsLoan {
  /**
   * An interest-bearing loan type.
   */
  INTEREST = 'INTEREST',

  /**
   * A split-pay loan type.
   */
  SPLIT_PAY = 'SPLIT_PAY',

  /**
   * A zero-percent loan type.
   */
  ZERO_PERCENT = 'ZERO_PERCENT',
}

/**
 * The result for a Shop Pay Installments pricing request.
 */
/* #__PURE__ */
export class ShopPayInstallmentsPricing extends $Base<'ShopPayInstallmentsPricing'> {
  constructor() {
    super('ShopPayInstallmentsPricing');
  }

  /**
   * The financing plans available for the given price range.
   */
  financingPlans<Sel extends Selection<ShopPayInstallmentsFinancingPlan>>(
    selectorFn: (s: ShopPayInstallmentsFinancingPlan) => [...Sel],
  ): $Field<'financingPlans', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayInstallmentsFinancingPlan()),
    };
    return this.$_select('financingPlans', options) as any;
  }

  /**
   * The maximum price to qualify for financing.
   */
  maxPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'maxPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('maxPrice', options) as any;
  }

  /**
   * The minimum price to qualify for financing.
   */
  minPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'minPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('minPrice', options) as any;
  }
}

/**
 * The shop pay installments pricing information for a product variant.
 */
/* #__PURE__ */
export class ShopPayInstallmentsProductVariantPricing extends $Base<'ShopPayInstallmentsProductVariantPricing'> {
  constructor() {
    super('ShopPayInstallmentsProductVariantPricing');
  }

  /**
   * Whether the product variant is available.
   */
  get available(): $Field<'available', boolean> {
    return this.$_select('available') as any;
  }

  /**
   * Whether the product variant is eligible for Shop Pay Installments.
   */
  get eligible(): $Field<'eligible', boolean> {
    return this.$_select('eligible') as any;
  }

  /**
   * The full price of the product variant.
   */
  fullPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'fullPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('fullPrice', options) as any;
  }

  /**
   * The ID of the product variant.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The number of payment terms available for the product variant.
   */
  installmentsCount<Sel extends Selection<Count>>(
    selectorFn: (s: Count) => [...Sel],
  ): $Field<'installmentsCount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Count()),
    };
    return this.$_select('installmentsCount', options) as any;
  }

  /**
   * The price per term for the product variant.
   */
  pricePerTerm<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'pricePerTerm', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('pricePerTerm', options) as any;
  }
}

/**
 * Represents a Shop Pay payment request.
 */
/* #__PURE__ */
export class ShopPayPaymentRequest extends $Base<'ShopPayPaymentRequest'> {
  constructor() {
    super('ShopPayPaymentRequest');
  }

  /**
   * The delivery methods for the payment request.
   */
  deliveryMethods<Sel extends Selection<ShopPayPaymentRequestDeliveryMethod>>(
    selectorFn: (s: ShopPayPaymentRequestDeliveryMethod) => [...Sel],
  ): $Field<'deliveryMethods', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestDeliveryMethod()),
    };
    return this.$_select('deliveryMethods', options) as any;
  }

  /**
   * The discount codes for the payment request.
   */
  get discountCodes(): $Field<'discountCodes', Readonly<Array<string>>> {
    return this.$_select('discountCodes') as any;
  }

  /**
   * The discounts for the payment request order.
   */
  discounts<Sel extends Selection<ShopPayPaymentRequestDiscount>>(
    selectorFn: (s: ShopPayPaymentRequestDiscount) => [...Sel],
  ): $Field<'discounts', Array<GetOutput<Sel>> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestDiscount()),
    };
    return this.$_select('discounts', options) as any;
  }

  /**
   * The line items for the payment request.
   */
  lineItems<Sel extends Selection<ShopPayPaymentRequestLineItem>>(
    selectorFn: (s: ShopPayPaymentRequestLineItem) => [...Sel],
  ): $Field<'lineItems', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestLineItem()),
    };
    return this.$_select('lineItems', options) as any;
  }

  /**
   * The locale for the payment request.
   */
  get locale(): $Field<'locale', string> {
    return this.$_select('locale') as any;
  }

  /**
   * The presentment currency for the payment request.
   */
  get presentmentCurrency(): $Field<'presentmentCurrency', CurrencyCode> {
    return this.$_select('presentmentCurrency') as any;
  }

  /**
   * The delivery method type for the payment request.
   */
  get selectedDeliveryMethodType(): $Field<'selectedDeliveryMethodType', ShopPayPaymentRequestDeliveryMethodType> {
    return this.$_select('selectedDeliveryMethodType') as any;
  }

  /**
   * The shipping address for the payment request.
   */
  shippingAddress<Sel extends Selection<ShopPayPaymentRequestContactField>>(
    selectorFn: (s: ShopPayPaymentRequestContactField) => [...Sel],
  ): $Field<'shippingAddress', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestContactField()),
    };
    return this.$_select('shippingAddress', options) as any;
  }

  /**
   * The shipping lines for the payment request.
   */
  shippingLines<Sel extends Selection<ShopPayPaymentRequestShippingLine>>(
    selectorFn: (s: ShopPayPaymentRequestShippingLine) => [...Sel],
  ): $Field<'shippingLines', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestShippingLine()),
    };
    return this.$_select('shippingLines', options) as any;
  }

  /**
   * The subtotal amount for the payment request.
   */
  subtotal<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'subtotal', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('subtotal', options) as any;
  }

  /**
   * The total amount for the payment request.
   */
  total<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'total', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('total', options) as any;
  }

  /**
   * The total shipping price for the payment request.
   */
  totalShippingPrice<Sel extends Selection<ShopPayPaymentRequestTotalShippingPrice>>(
    selectorFn: (s: ShopPayPaymentRequestTotalShippingPrice) => [...Sel],
  ): $Field<'totalShippingPrice', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestTotalShippingPrice()),
    };
    return this.$_select('totalShippingPrice', options) as any;
  }

  /**
   * The total tax for the payment request.
   */
  totalTax<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'totalTax', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('totalTax', options) as any;
  }
}

/**
 * Represents a contact field for a Shop Pay payment request.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestContactField extends $Base<'ShopPayPaymentRequestContactField'> {
  constructor() {
    super('ShopPayPaymentRequestContactField');
  }

  /**
   * The first address line of the contact field.
   */
  get address1(): $Field<'address1', string> {
    return this.$_select('address1') as any;
  }

  /**
   * The second address line of the contact field.
   */
  get address2(): $Field<'address2', string | null | undefined> {
    return this.$_select('address2') as any;
  }

  /**
   * The city of the contact field.
   */
  get city(): $Field<'city', string> {
    return this.$_select('city') as any;
  }

  /**
   * The company name of the contact field.
   */
  get companyName(): $Field<'companyName', string | null | undefined> {
    return this.$_select('companyName') as any;
  }

  /**
   * The country of the contact field.
   */
  get countryCode(): $Field<'countryCode', string> {
    return this.$_select('countryCode') as any;
  }

  /**
   * The email of the contact field.
   */
  get email(): $Field<'email', string | null | undefined> {
    return this.$_select('email') as any;
  }

  /**
   * The first name of the contact field.
   */
  get firstName(): $Field<'firstName', string> {
    return this.$_select('firstName') as any;
  }

  /**
   * The first name of the contact field.
   */
  get lastName(): $Field<'lastName', string> {
    return this.$_select('lastName') as any;
  }

  /**
   * The phone number of the contact field.
   */
  get phone(): $Field<'phone', string | null | undefined> {
    return this.$_select('phone') as any;
  }

  /**
   * The postal code of the contact field.
   */
  get postalCode(): $Field<'postalCode', string | null | undefined> {
    return this.$_select('postalCode') as any;
  }

  /**
   * The province of the contact field.
   */
  get provinceCode(): $Field<'provinceCode', string | null | undefined> {
    return this.$_select('provinceCode') as any;
  }
}

/**
 * Represents a delivery method for a Shop Pay payment request.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestDeliveryMethod extends $Base<'ShopPayPaymentRequestDeliveryMethod'> {
  constructor() {
    super('ShopPayPaymentRequestDeliveryMethod');
  }

  /**
   * The amount for the delivery method.
   */
  amount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'amount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('amount', options) as any;
  }

  /**
   * The code of the delivery method.
   */
  get code(): $Field<'code', string> {
    return this.$_select('code') as any;
  }

  /**
   * The detail about when the delivery may be expected.
   */
  get deliveryExpectationLabel(): $Field<'deliveryExpectationLabel', string | null | undefined> {
    return this.$_select('deliveryExpectationLabel') as any;
  }

  /**
   * The detail of the delivery method.
   */
  get detail(): $Field<'detail', string | null | undefined> {
    return this.$_select('detail') as any;
  }

  /**
   * The label of the delivery method.
   */
  get label(): $Field<'label', string> {
    return this.$_select('label') as any;
  }

  /**
   * The maximum delivery date for the delivery method.
   */
  get maxDeliveryDate(): $Field<'maxDeliveryDate', ISO8601DateTime | null | undefined> {
    return this.$_select('maxDeliveryDate') as any;
  }

  /**
   * The minimum delivery date for the delivery method.
   */
  get minDeliveryDate(): $Field<'minDeliveryDate', ISO8601DateTime | null | undefined> {
    return this.$_select('minDeliveryDate') as any;
  }
}

/**
 * The input fields to create a delivery method for a Shop Pay payment request.
 */
export type ShopPayPaymentRequestDeliveryMethodInput = {
  amount?: MoneyInput | null | undefined;
  code?: string | null | undefined;
  deliveryExpectationLabel?: string | null | undefined;
  detail?: string | null | undefined;
  label?: string | null | undefined;
  maxDeliveryDate?: ISO8601DateTime | null | undefined;
  minDeliveryDate?: ISO8601DateTime | null | undefined;
};

/**
 * Represents the delivery method type for a Shop Pay payment request.
 */
export enum ShopPayPaymentRequestDeliveryMethodType {
  /**
   * The delivery method type is shipping.
   */
  SHIPPING = 'SHIPPING',

  /**
   * The delivery method type is pickup.
   */
  PICKUP = 'PICKUP',
}

/**
 * Represents a discount for a Shop Pay payment request.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestDiscount extends $Base<'ShopPayPaymentRequestDiscount'> {
  constructor() {
    super('ShopPayPaymentRequestDiscount');
  }

  /**
   * The amount of the discount.
   */
  amount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'amount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('amount', options) as any;
  }

  /**
   * The label of the discount.
   */
  get label(): $Field<'label', string> {
    return this.$_select('label') as any;
  }
}

/**
 * The input fields to create a discount for a Shop Pay payment request.
 */
export type ShopPayPaymentRequestDiscountInput = {
  amount?: MoneyInput | null | undefined;
  label?: string | null | undefined;
};

/**
 * Represents an image for a Shop Pay payment request line item.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestImage extends $Base<'ShopPayPaymentRequestImage'> {
  constructor() {
    super('ShopPayPaymentRequestImage');
  }

  /**
   * The alt text of the image.
   */
  get alt(): $Field<'alt', string | null | undefined> {
    return this.$_select('alt') as any;
  }

  /**
   * The source URL of the image.
   */
  get url(): $Field<'url', string> {
    return this.$_select('url') as any;
  }
}

/**
 * The input fields to create an image for a Shop Pay payment request.
 */
export type ShopPayPaymentRequestImageInput = {
  alt?: string | null | undefined;
  url: string;
};

/**
 * The input fields represent a Shop Pay payment request.
 */
export type ShopPayPaymentRequestInput = {
  deliveryMethods?: Readonly<Array<ShopPayPaymentRequestDeliveryMethodInput>> | null | undefined;
  discountCodes?: Readonly<Array<string>> | null | undefined;
  discounts?: Readonly<Array<ShopPayPaymentRequestDiscountInput>> | null | undefined;
  lineItems?: Readonly<Array<ShopPayPaymentRequestLineItemInput>> | null | undefined;
  locale: string;
  paymentMethod?: string | null | undefined;
  presentmentCurrency: CurrencyCode;
  selectedDeliveryMethodType?: ShopPayPaymentRequestDeliveryMethodType | null | undefined;
  shippingLines?: Readonly<Array<ShopPayPaymentRequestShippingLineInput>> | null | undefined;
  subtotal: MoneyInput;
  total: MoneyInput;
  totalShippingPrice?: ShopPayPaymentRequestTotalShippingPriceInput | null | undefined;
  totalTax?: MoneyInput | null | undefined;
};

/**
 * Represents a line item for a Shop Pay payment request.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestLineItem extends $Base<'ShopPayPaymentRequestLineItem'> {
  constructor() {
    super('ShopPayPaymentRequestLineItem');
  }

  /**
   * The final item price for the line item.
   */
  finalItemPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'finalItemPrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('finalItemPrice', options) as any;
  }

  /**
   * The final line price for the line item.
   */
  finalLinePrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'finalLinePrice', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('finalLinePrice', options) as any;
  }

  /**
   * The image of the line item.
   */
  image<Sel extends Selection<ShopPayPaymentRequestImage>>(
    selectorFn: (s: ShopPayPaymentRequestImage) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestImage()),
    };
    return this.$_select('image', options) as any;
  }

  /**
   * The item discounts for the line item.
   */
  itemDiscounts<Sel extends Selection<ShopPayPaymentRequestDiscount>>(
    selectorFn: (s: ShopPayPaymentRequestDiscount) => [...Sel],
  ): $Field<'itemDiscounts', Array<GetOutput<Sel>> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestDiscount()),
    };
    return this.$_select('itemDiscounts', options) as any;
  }

  /**
   * The label of the line item.
   */
  get label(): $Field<'label', string> {
    return this.$_select('label') as any;
  }

  /**
   * The line discounts for the line item.
   */
  lineDiscounts<Sel extends Selection<ShopPayPaymentRequestDiscount>>(
    selectorFn: (s: ShopPayPaymentRequestDiscount) => [...Sel],
  ): $Field<'lineDiscounts', Array<GetOutput<Sel>> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestDiscount()),
    };
    return this.$_select('lineDiscounts', options) as any;
  }

  /**
   * The original item price for the line item.
   */
  originalItemPrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'originalItemPrice', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('originalItemPrice', options) as any;
  }

  /**
   * The original line price for the line item.
   */
  originalLinePrice<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'originalLinePrice', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('originalLinePrice', options) as any;
  }

  /**
   * The quantity of the line item.
   */
  get quantity(): $Field<'quantity', number> {
    return this.$_select('quantity') as any;
  }

  /**
   * Whether the line item requires shipping.
   */
  get requiresShipping(): $Field<'requiresShipping', boolean | null | undefined> {
    return this.$_select('requiresShipping') as any;
  }

  /**
   * The SKU of the line item.
   */
  get sku(): $Field<'sku', string | null | undefined> {
    return this.$_select('sku') as any;
  }
}

/**
 * The input fields to create a line item for a Shop Pay payment request.
 */
export type ShopPayPaymentRequestLineItemInput = {
  finalItemPrice?: MoneyInput | null | undefined;
  finalLinePrice?: MoneyInput | null | undefined;
  image?: ShopPayPaymentRequestImageInput | null | undefined;
  itemDiscounts?: Readonly<Array<ShopPayPaymentRequestDiscountInput>> | null | undefined;
  label?: string | null | undefined;
  lineDiscounts?: Readonly<Array<ShopPayPaymentRequestDiscountInput>> | null | undefined;
  originalItemPrice?: MoneyInput | null | undefined;
  originalLinePrice?: MoneyInput | null | undefined;
  quantity: number;
  requiresShipping?: boolean | null | undefined;
  sku?: string | null | undefined;
};

/**
 * Represents a receipt for a Shop Pay payment request.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestReceipt extends $Base<'ShopPayPaymentRequestReceipt'> {
  constructor() {
    super('ShopPayPaymentRequestReceipt');
  }

  /**
   * The payment request object.
   */
  paymentRequest<Sel extends Selection<ShopPayPaymentRequest>>(
    selectorFn: (s: ShopPayPaymentRequest) => [...Sel],
  ): $Field<'paymentRequest', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequest()),
    };
    return this.$_select('paymentRequest', options) as any;
  }

  /**
   * The processing status.
   */
  get processingStatusType(): $Field<'processingStatusType', string> {
    return this.$_select('processingStatusType') as any;
  }

  /**
   * The token of the receipt.
   */
  get token(): $Field<'token', string> {
    return this.$_select('token') as any;
  }
}

/**
 * Represents a Shop Pay payment request session.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestSession extends $Base<'ShopPayPaymentRequestSession'> {
  constructor() {
    super('ShopPayPaymentRequestSession');
  }

  /**
   * The checkout URL of the Shop Pay payment request session.
   */
  get checkoutUrl(): $Field<'checkoutUrl', URL> {
    return this.$_select('checkoutUrl') as any;
  }

  /**
   * The payment request associated with the Shop Pay payment request session.
   */
  paymentRequest<Sel extends Selection<ShopPayPaymentRequest>>(
    selectorFn: (s: ShopPayPaymentRequest) => [...Sel],
  ): $Field<'paymentRequest', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequest()),
    };
    return this.$_select('paymentRequest', options) as any;
  }

  /**
   * The source identifier of the Shop Pay payment request session.
   */
  get sourceIdentifier(): $Field<'sourceIdentifier', string> {
    return this.$_select('sourceIdentifier') as any;
  }

  /**
   * The token of the Shop Pay payment request session.
   */
  get token(): $Field<'token', string> {
    return this.$_select('token') as any;
  }
}

/**
 * Return type for `shopPayPaymentRequestSessionCreate` mutation.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestSessionCreatePayload extends $Base<'ShopPayPaymentRequestSessionCreatePayload'> {
  constructor() {
    super('ShopPayPaymentRequestSessionCreatePayload');
  }

  /**
   * The new Shop Pay payment request session object.
   */
  shopPayPaymentRequestSession<Sel extends Selection<ShopPayPaymentRequestSession>>(
    selectorFn: (s: ShopPayPaymentRequestSession) => [...Sel],
  ): $Field<'shopPayPaymentRequestSession', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestSession()),
    };
    return this.$_select('shopPayPaymentRequestSession', options) as any;
  }

  /**
   * Error codes for failed Shop Pay payment request session mutations.
   */
  userErrors<Sel extends Selection<UserErrorsShopPayPaymentRequestSessionUserErrors>>(
    selectorFn: (s: UserErrorsShopPayPaymentRequestSessionUserErrors) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserErrorsShopPayPaymentRequestSessionUserErrors()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Return type for `shopPayPaymentRequestSessionSubmit` mutation.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestSessionSubmitPayload extends $Base<'ShopPayPaymentRequestSessionSubmitPayload'> {
  constructor() {
    super('ShopPayPaymentRequestSessionSubmitPayload');
  }

  /**
   * The checkout on which the payment was applied.
   */
  paymentRequestReceipt<Sel extends Selection<ShopPayPaymentRequestReceipt>>(
    selectorFn: (s: ShopPayPaymentRequestReceipt) => [...Sel],
  ): $Field<'paymentRequestReceipt', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestReceipt()),
    };
    return this.$_select('paymentRequestReceipt', options) as any;
  }

  /**
   * Error codes for failed Shop Pay payment request session mutations.
   */
  userErrors<Sel extends Selection<UserErrorsShopPayPaymentRequestSessionUserErrors>>(
    selectorFn: (s: UserErrorsShopPayPaymentRequestSessionUserErrors) => [...Sel],
  ): $Field<'userErrors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UserErrorsShopPayPaymentRequestSessionUserErrors()),
    };
    return this.$_select('userErrors', options) as any;
  }
}

/**
 * Represents a shipping line for a Shop Pay payment request.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestShippingLine extends $Base<'ShopPayPaymentRequestShippingLine'> {
  constructor() {
    super('ShopPayPaymentRequestShippingLine');
  }

  /**
   * The amount for the shipping line.
   */
  amount<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'amount', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('amount', options) as any;
  }

  /**
   * The code of the shipping line.
   */
  get code(): $Field<'code', string> {
    return this.$_select('code') as any;
  }

  /**
   * The label of the shipping line.
   */
  get label(): $Field<'label', string> {
    return this.$_select('label') as any;
  }
}

/**
 * The input fields to create a shipping line for a Shop Pay payment request.
 */
export type ShopPayPaymentRequestShippingLineInput = {
  amount?: MoneyInput | null | undefined;
  code?: string | null | undefined;
  label?: string | null | undefined;
};

/**
 * Represents a shipping total for a Shop Pay payment request.
 */
/* #__PURE__ */
export class ShopPayPaymentRequestTotalShippingPrice extends $Base<'ShopPayPaymentRequestTotalShippingPrice'> {
  constructor() {
    super('ShopPayPaymentRequestTotalShippingPrice');
  }

  /**
   * The discounts for the shipping total.
   */
  discounts<Sel extends Selection<ShopPayPaymentRequestDiscount>>(
    selectorFn: (s: ShopPayPaymentRequestDiscount) => [...Sel],
  ): $Field<'discounts', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new ShopPayPaymentRequestDiscount()),
    };
    return this.$_select('discounts', options) as any;
  }

  /**
   * The final total for the shipping total.
   */
  finalTotal<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'finalTotal', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('finalTotal', options) as any;
  }

  /**
   * The original total for the shipping total.
   */
  originalTotal<Sel extends Selection<MoneyV2>>(
    selectorFn: (s: MoneyV2) => [...Sel],
  ): $Field<'originalTotal', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MoneyV2()),
    };
    return this.$_select('originalTotal', options) as any;
  }
}

/**
 * The input fields to create a shipping total for a Shop Pay payment request.
 */
export type ShopPayPaymentRequestTotalShippingPriceInput = {
  discounts?: Readonly<Array<ShopPayPaymentRequestDiscountInput>> | null | undefined;
  finalTotal?: MoneyInput | null | undefined;
  originalTotal?: MoneyInput | null | undefined;
};

/**
 * The input fields for submitting Shop Pay payment method information for checkout.

 */
export type ShopPayWalletContentInput = {
  billingAddress: MailingAddressInput;
  sessionToken: string;
};

/**
 * Policy that a merchant has configured for their store, such as their refund or privacy policy.
 */
/* #__PURE__ */
export class ShopPolicy extends $Base<'ShopPolicy'> {
  constructor() {
    super('ShopPolicy');
  }

  /**
   * Policy text, maximum size of 64kb.
   */
  get body(): $Field<'body', string> {
    return this.$_select('body') as any;
  }

  /**
   * Policy’s handle.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * Policy’s title.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * Public URL to the policy.
   */
  get url(): $Field<'url', URL> {
    return this.$_select('url') as any;
  }
}

/**
 * A policy for the store that comes with a default value, such as a subscription policy.
If the merchant hasn't configured a policy for their store, then the policy will return the default value.
Otherwise, the policy will return the merchant-configured value.

 */
/* #__PURE__ */
export class ShopPolicyWithDefault extends $Base<'ShopPolicyWithDefault'> {
  constructor() {
    super('ShopPolicyWithDefault');
  }

  /**
   * The text of the policy. Maximum size: 64KB.
   */
  get body(): $Field<'body', string> {
    return this.$_select('body') as any;
  }

  /**
   * The handle of the policy.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * The unique ID of the policy. A default policy doesn't have an ID.
   */
  get id(): $Field<'id', string | null | undefined> {
    return this.$_select('id') as any;
  }

  /**
   * The title of the policy.
   */
  get title(): $Field<'title', string> {
    return this.$_select('title') as any;
  }

  /**
   * Public URL to the policy.
   */
  get url(): $Field<'url', URL> {
    return this.$_select('url') as any;
  }
}

/**
 * Contains all fields required to generate sitemaps.
 */
/* #__PURE__ */
export class Sitemap extends $Base<'Sitemap'> {
  constructor() {
    super('Sitemap');
  }

  /**
   * The number of sitemap's pages for a given type.
   */
  pagesCount<Sel extends Selection<Count>>(
    selectorFn: (s: Count) => [...Sel],
  ): $Field<'pagesCount', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Count()),
    };
    return this.$_select('pagesCount', options) as any;
  }

  /**
 * A list of sitemap's resources for a given type.

Important Notes:
  - The number of items per page varies from 0 to 250.
  - Empty pages (0 items) may occur and do not necessarily indicate the end of results.
  - Always check `hasNextPage` to determine if more pages are available.

 */
  resources<
    Args extends VariabledInput<{
      page: number;
    }>,
    Sel extends Selection<PaginatedSitemapResources>,
  >(
    args: ExactArgNames<
      Args,
      {
        page: number;
      }
    >,
    selectorFn: (s: PaginatedSitemapResources) => [...Sel],
  ): $Field<'resources', GetOutput<Sel> | undefined, GetVariables<Sel, Args>> {
    const options = {
      argTypes: {
        page: 'Int!',
      },
      args,

      selection: selectorFn(new PaginatedSitemapResources()),
    };
    return this.$_select('resources', options) as any;
  }
}

/**
 * Represents a sitemap's image.
 */
/* #__PURE__ */
export class SitemapImage extends $Base<'SitemapImage'> {
  constructor() {
    super('SitemapImage');
  }

  /**
   * Image's alt text.
   */
  get alt(): $Field<'alt', string | null | undefined> {
    return this.$_select('alt') as any;
  }

  /**
   * Path to the image.
   */
  get filepath(): $Field<'filepath', string | null | undefined> {
    return this.$_select('filepath') as any;
  }

  /**
   * The date and time when the image was updated.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * Represents a sitemap resource that is not a metaobject.
 */
/* #__PURE__ */
export class SitemapResource extends $Base<'SitemapResource'> {
  constructor() {
    super('SitemapResource');
  }

  /**
   * Resource's handle.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * Resource's image.
   */
  image<Sel extends Selection<SitemapImage>>(
    selectorFn: (s: SitemapImage) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SitemapImage()),
    };
    return this.$_select('image', options) as any;
  }

  /**
   * Resource's title.
   */
  get title(): $Field<'title', string | null | undefined> {
    return this.$_select('title') as any;
  }

  /**
   * The date and time when the resource was updated.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * Represents the common fields for all sitemap resource types.
 */
/* #__PURE__ */
export class SitemapResourceInterface extends $Interface<
  { SitemapResource: SitemapResource; SitemapResourceMetaobject: SitemapResourceMetaobject },
  'SitemapResourceInterface'
> {
  constructor() {
    super(
      { SitemapResource: SitemapResource, SitemapResourceMetaobject: SitemapResourceMetaobject },
      'SitemapResourceInterface',
    );
  }

  /**
   * Resource's handle.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * The date and time when the resource was updated.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * A SitemapResourceMetaobject represents a metaobject with
[the `renderable` capability](https://shopify.dev/docs/apps/build/custom-data/metaobjects/use-metaobject-capabilities#render-metaobjects-as-web-pages).

 */
/* #__PURE__ */
export class SitemapResourceMetaobject extends $Base<'SitemapResourceMetaobject'> {
  constructor() {
    super('SitemapResourceMetaobject');
  }

  /**
   * Resource's handle.
   */
  get handle(): $Field<'handle', string> {
    return this.$_select('handle') as any;
  }

  /**
   * The URL handle for accessing pages of this metaobject type in the Online Store.
   */
  get onlineStoreUrlHandle(): $Field<'onlineStoreUrlHandle', string | null | undefined> {
    return this.$_select('onlineStoreUrlHandle') as any;
  }

  /**
   * The type of the metaobject. Defines the namespace of its associated metafields.
   */
  get type(): $Field<'type', string> {
    return this.$_select('type') as any;
  }

  /**
   * The date and time when the resource was updated.
   */
  get updatedAt(): $Field<'updatedAt', DateTime> {
    return this.$_select('updatedAt') as any;
  }
}

/**
 * The types of resources potentially present in a sitemap.
 */
export enum SitemapType {
  /**
   * Products present in the sitemap.
   */
  PRODUCT = 'PRODUCT',

  /**
   * Collections present in the sitemap.
   */
  COLLECTION = 'COLLECTION',

  /**
   * Pages present in the sitemap.
   */
  PAGE = 'PAGE',

  /**
 * Metaobjects present in the sitemap. Only metaobject types with the
[`renderable` capability](https://shopify.dev/docs/apps/build/custom-data/metaobjects/use-metaobject-capabilities#render-metaobjects-as-web-pages)
are included in sitemap.

 */
  METAOBJECT = 'METAOBJECT',

  /**
   * Blogs present in the sitemap.
   */
  BLOG = 'BLOG',

  /**
   * Articles present in the sitemap.
   */
  ARTICLE = 'ARTICLE',
}

/**
 * The availability of a product variant at a particular location.
Local pick-up must be enabled in the  store's shipping settings, otherwise this will return an empty result.

 */
/* #__PURE__ */
export class StoreAvailability extends $Base<'StoreAvailability'> {
  constructor() {
    super('StoreAvailability');
  }

  /**
   * Whether the product variant is in-stock at this location.
   */
  get available(): $Field<'available', boolean> {
    return this.$_select('available') as any;
  }

  /**
   * The location where this product variant is stocked at.
   */
  location<Sel extends Selection<Location>>(
    selectorFn: (s: Location) => [...Sel],
  ): $Field<'location', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Location()),
    };
    return this.$_select('location', options) as any;
  }

  /**
   * Returns the estimated amount of time it takes for pickup to be ready (Example: Usually ready in 24 hours).
   */
  get pickUpTime(): $Field<'pickUpTime', string> {
    return this.$_select('pickUpTime') as any;
  }

  /**
   * The quantity of the product variant in-stock at this location.
   */
  get quantityAvailable(): $Field<'quantityAvailable', number> {
    return this.$_select('quantityAvailable') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple StoreAvailabilities.

 */
/* #__PURE__ */
export class StoreAvailabilityConnection extends $Base<'StoreAvailabilityConnection'> {
  constructor() {
    super('StoreAvailabilityConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<StoreAvailabilityEdge>>(
    selectorFn: (s: StoreAvailabilityEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new StoreAvailabilityEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in StoreAvailabilityEdge.
   */
  nodes<Sel extends Selection<StoreAvailability>>(
    selectorFn: (s: StoreAvailability) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new StoreAvailability()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one StoreAvailability and a cursor during pagination.

 */
/* #__PURE__ */
export class StoreAvailabilityEdge extends $Base<'StoreAvailabilityEdge'> {
  constructor() {
    super('StoreAvailabilityEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of StoreAvailabilityEdge.
   */
  node<Sel extends Selection<StoreAvailability>>(
    selectorFn: (s: StoreAvailability) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new StoreAvailability()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * An auto-generated type for paginating through multiple Strings.

 */
/* #__PURE__ */
export class StringConnection extends $Base<'StringConnection'> {
  constructor() {
    super('StringConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<StringEdge>>(
    selectorFn: (s: StringEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new StringEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one String and a cursor during pagination.

 */
/* #__PURE__ */
export class StringEdge extends $Base<'StringEdge'> {
  constructor() {
    super('StringEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of StringEdge.
   */
  get node(): $Field<'node', string> {
    return this.$_select('node') as any;
  }
}

/**
 * An error that occurred during cart submit for completion.
 */
/* #__PURE__ */
export class SubmissionError extends $Base<'SubmissionError'> {
  constructor() {
    super('SubmissionError');
  }

  /**
   * The error code.
   */
  get code(): $Field<'code', SubmissionErrorCode> {
    return this.$_select('code') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string | null | undefined> {
    return this.$_select('message') as any;
  }
}

/**
 * The code of the error that occurred during cart submit for completion.
 */
export enum SubmissionErrorCode {
  ERROR = 'ERROR',

  NO_DELIVERY_GROUP_SELECTED = 'NO_DELIVERY_GROUP_SELECTED',

  BUYER_IDENTITY_EMAIL_IS_INVALID = 'BUYER_IDENTITY_EMAIL_IS_INVALID',

  BUYER_IDENTITY_EMAIL_REQUIRED = 'BUYER_IDENTITY_EMAIL_REQUIRED',

  BUYER_IDENTITY_PHONE_IS_INVALID = 'BUYER_IDENTITY_PHONE_IS_INVALID',

  DELIVERY_ADDRESS1_INVALID = 'DELIVERY_ADDRESS1_INVALID',

  DELIVERY_ADDRESS1_REQUIRED = 'DELIVERY_ADDRESS1_REQUIRED',

  DELIVERY_ADDRESS1_TOO_LONG = 'DELIVERY_ADDRESS1_TOO_LONG',

  DELIVERY_ADDRESS2_INVALID = 'DELIVERY_ADDRESS2_INVALID',

  DELIVERY_ADDRESS2_REQUIRED = 'DELIVERY_ADDRESS2_REQUIRED',

  DELIVERY_ADDRESS2_TOO_LONG = 'DELIVERY_ADDRESS2_TOO_LONG',

  DELIVERY_CITY_INVALID = 'DELIVERY_CITY_INVALID',

  DELIVERY_CITY_REQUIRED = 'DELIVERY_CITY_REQUIRED',

  DELIVERY_CITY_TOO_LONG = 'DELIVERY_CITY_TOO_LONG',

  DELIVERY_COMPANY_INVALID = 'DELIVERY_COMPANY_INVALID',

  DELIVERY_COMPANY_REQUIRED = 'DELIVERY_COMPANY_REQUIRED',

  DELIVERY_COMPANY_TOO_LONG = 'DELIVERY_COMPANY_TOO_LONG',

  DELIVERY_COUNTRY_REQUIRED = 'DELIVERY_COUNTRY_REQUIRED',

  DELIVERY_FIRST_NAME_INVALID = 'DELIVERY_FIRST_NAME_INVALID',

  DELIVERY_FIRST_NAME_REQUIRED = 'DELIVERY_FIRST_NAME_REQUIRED',

  DELIVERY_FIRST_NAME_TOO_LONG = 'DELIVERY_FIRST_NAME_TOO_LONG',

  DELIVERY_INVALID_POSTAL_CODE_FOR_COUNTRY = 'DELIVERY_INVALID_POSTAL_CODE_FOR_COUNTRY',

  DELIVERY_INVALID_POSTAL_CODE_FOR_ZONE = 'DELIVERY_INVALID_POSTAL_CODE_FOR_ZONE',

  DELIVERY_LAST_NAME_INVALID = 'DELIVERY_LAST_NAME_INVALID',

  DELIVERY_LAST_NAME_REQUIRED = 'DELIVERY_LAST_NAME_REQUIRED',

  DELIVERY_LAST_NAME_TOO_LONG = 'DELIVERY_LAST_NAME_TOO_LONG',

  DELIVERY_NO_DELIVERY_AVAILABLE = 'DELIVERY_NO_DELIVERY_AVAILABLE',

  DELIVERY_NO_DELIVERY_AVAILABLE_FOR_MERCHANDISE_LINE = 'DELIVERY_NO_DELIVERY_AVAILABLE_FOR_MERCHANDISE_LINE',

  DELIVERY_OPTIONS_PHONE_NUMBER_INVALID = 'DELIVERY_OPTIONS_PHONE_NUMBER_INVALID',

  DELIVERY_OPTIONS_PHONE_NUMBER_REQUIRED = 'DELIVERY_OPTIONS_PHONE_NUMBER_REQUIRED',

  DELIVERY_PHONE_NUMBER_INVALID = 'DELIVERY_PHONE_NUMBER_INVALID',

  DELIVERY_PHONE_NUMBER_REQUIRED = 'DELIVERY_PHONE_NUMBER_REQUIRED',

  DELIVERY_POSTAL_CODE_INVALID = 'DELIVERY_POSTAL_CODE_INVALID',

  DELIVERY_POSTAL_CODE_REQUIRED = 'DELIVERY_POSTAL_CODE_REQUIRED',

  DELIVERY_ZONE_NOT_FOUND = 'DELIVERY_ZONE_NOT_FOUND',

  DELIVERY_ZONE_REQUIRED_FOR_COUNTRY = 'DELIVERY_ZONE_REQUIRED_FOR_COUNTRY',

  DELIVERY_ADDRESS_REQUIRED = 'DELIVERY_ADDRESS_REQUIRED',

  MERCHANDISE_NOT_APPLICABLE = 'MERCHANDISE_NOT_APPLICABLE',

  MERCHANDISE_LINE_LIMIT_REACHED = 'MERCHANDISE_LINE_LIMIT_REACHED',

  MERCHANDISE_NOT_ENOUGH_STOCK_AVAILABLE = 'MERCHANDISE_NOT_ENOUGH_STOCK_AVAILABLE',

  MERCHANDISE_OUT_OF_STOCK = 'MERCHANDISE_OUT_OF_STOCK',

  MERCHANDISE_PRODUCT_NOT_PUBLISHED = 'MERCHANDISE_PRODUCT_NOT_PUBLISHED',

  PAYMENTS_ADDRESS1_INVALID = 'PAYMENTS_ADDRESS1_INVALID',

  PAYMENTS_ADDRESS1_REQUIRED = 'PAYMENTS_ADDRESS1_REQUIRED',

  PAYMENTS_ADDRESS1_TOO_LONG = 'PAYMENTS_ADDRESS1_TOO_LONG',

  PAYMENTS_ADDRESS2_INVALID = 'PAYMENTS_ADDRESS2_INVALID',

  PAYMENTS_ADDRESS2_REQUIRED = 'PAYMENTS_ADDRESS2_REQUIRED',

  PAYMENTS_ADDRESS2_TOO_LONG = 'PAYMENTS_ADDRESS2_TOO_LONG',

  PAYMENTS_CITY_INVALID = 'PAYMENTS_CITY_INVALID',

  PAYMENTS_CITY_REQUIRED = 'PAYMENTS_CITY_REQUIRED',

  PAYMENTS_CITY_TOO_LONG = 'PAYMENTS_CITY_TOO_LONG',

  PAYMENTS_COMPANY_INVALID = 'PAYMENTS_COMPANY_INVALID',

  PAYMENTS_COMPANY_REQUIRED = 'PAYMENTS_COMPANY_REQUIRED',

  PAYMENTS_COMPANY_TOO_LONG = 'PAYMENTS_COMPANY_TOO_LONG',

  PAYMENTS_COUNTRY_REQUIRED = 'PAYMENTS_COUNTRY_REQUIRED',

  PAYMENTS_CREDIT_CARD_BASE_EXPIRED = 'PAYMENTS_CREDIT_CARD_BASE_EXPIRED',

  PAYMENTS_CREDIT_CARD_BASE_GATEWAY_NOT_SUPPORTED = 'PAYMENTS_CREDIT_CARD_BASE_GATEWAY_NOT_SUPPORTED',

  PAYMENTS_CREDIT_CARD_BASE_INVALID_START_DATE_OR_ISSUE_NUMBER_FOR_DEBIT = 'PAYMENTS_CREDIT_CARD_BASE_INVALID_START_DATE_OR_ISSUE_NUMBER_FOR_DEBIT',

  PAYMENTS_CREDIT_CARD_BRAND_NOT_SUPPORTED = 'PAYMENTS_CREDIT_CARD_BRAND_NOT_SUPPORTED',

  PAYMENTS_CREDIT_CARD_FIRST_NAME_BLANK = 'PAYMENTS_CREDIT_CARD_FIRST_NAME_BLANK',

  PAYMENTS_CREDIT_CARD_GENERIC = 'PAYMENTS_CREDIT_CARD_GENERIC',

  PAYMENTS_CREDIT_CARD_LAST_NAME_BLANK = 'PAYMENTS_CREDIT_CARD_LAST_NAME_BLANK',

  PAYMENTS_CREDIT_CARD_MONTH_INCLUSION = 'PAYMENTS_CREDIT_CARD_MONTH_INCLUSION',

  PAYMENTS_CREDIT_CARD_NAME_INVALID = 'PAYMENTS_CREDIT_CARD_NAME_INVALID',

  PAYMENTS_CREDIT_CARD_NUMBER_INVALID = 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID',

  PAYMENTS_CREDIT_CARD_NUMBER_INVALID_FORMAT = 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID_FORMAT',

  PAYMENTS_CREDIT_CARD_SESSION_ID = 'PAYMENTS_CREDIT_CARD_SESSION_ID',

  PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_BLANK = 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_BLANK',

  PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_INVALID_FOR_CARD_TYPE = 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_INVALID_FOR_CARD_TYPE',

  PAYMENTS_CREDIT_CARD_YEAR_EXPIRED = 'PAYMENTS_CREDIT_CARD_YEAR_EXPIRED',

  PAYMENTS_CREDIT_CARD_YEAR_INVALID_EXPIRY_YEAR = 'PAYMENTS_CREDIT_CARD_YEAR_INVALID_EXPIRY_YEAR',

  PAYMENTS_FIRST_NAME_INVALID = 'PAYMENTS_FIRST_NAME_INVALID',

  PAYMENTS_FIRST_NAME_REQUIRED = 'PAYMENTS_FIRST_NAME_REQUIRED',

  PAYMENTS_FIRST_NAME_TOO_LONG = 'PAYMENTS_FIRST_NAME_TOO_LONG',

  PAYMENTS_INVALID_POSTAL_CODE_FOR_COUNTRY = 'PAYMENTS_INVALID_POSTAL_CODE_FOR_COUNTRY',

  PAYMENTS_INVALID_POSTAL_CODE_FOR_ZONE = 'PAYMENTS_INVALID_POSTAL_CODE_FOR_ZONE',

  PAYMENTS_LAST_NAME_INVALID = 'PAYMENTS_LAST_NAME_INVALID',

  PAYMENTS_LAST_NAME_REQUIRED = 'PAYMENTS_LAST_NAME_REQUIRED',

  PAYMENTS_LAST_NAME_TOO_LONG = 'PAYMENTS_LAST_NAME_TOO_LONG',

  PAYMENTS_METHOD_UNAVAILABLE = 'PAYMENTS_METHOD_UNAVAILABLE',

  PAYMENTS_METHOD_REQUIRED = 'PAYMENTS_METHOD_REQUIRED',

  PAYMENTS_UNACCEPTABLE_PAYMENT_AMOUNT = 'PAYMENTS_UNACCEPTABLE_PAYMENT_AMOUNT',

  PAYMENTS_PHONE_NUMBER_INVALID = 'PAYMENTS_PHONE_NUMBER_INVALID',

  PAYMENTS_PHONE_NUMBER_REQUIRED = 'PAYMENTS_PHONE_NUMBER_REQUIRED',

  PAYMENTS_POSTAL_CODE_INVALID = 'PAYMENTS_POSTAL_CODE_INVALID',

  PAYMENTS_POSTAL_CODE_REQUIRED = 'PAYMENTS_POSTAL_CODE_REQUIRED',

  PAYMENTS_SHOPIFY_PAYMENTS_REQUIRED = 'PAYMENTS_SHOPIFY_PAYMENTS_REQUIRED',

  PAYMENTS_WALLET_CONTENT_MISSING = 'PAYMENTS_WALLET_CONTENT_MISSING',

  PAYMENTS_BILLING_ADDRESS_ZONE_NOT_FOUND = 'PAYMENTS_BILLING_ADDRESS_ZONE_NOT_FOUND',

  PAYMENTS_BILLING_ADDRESS_ZONE_REQUIRED_FOR_COUNTRY = 'PAYMENTS_BILLING_ADDRESS_ZONE_REQUIRED_FOR_COUNTRY',

  TAXES_MUST_BE_DEFINED = 'TAXES_MUST_BE_DEFINED',

  TAXES_LINE_ID_NOT_FOUND = 'TAXES_LINE_ID_NOT_FOUND',

  TAXES_DELIVERY_GROUP_ID_NOT_FOUND = 'TAXES_DELIVERY_GROUP_ID_NOT_FOUND',
}

/**
 * Cart submit for checkout completion is successful.
 */
/* #__PURE__ */
export class SubmitAlreadyAccepted extends $Base<'SubmitAlreadyAccepted'> {
  constructor() {
    super('SubmitAlreadyAccepted');
  }

  /**
   * The ID of the cart completion attempt that will be used for polling for the result.
   */
  get attemptId(): $Field<'attemptId', string> {
    return this.$_select('attemptId') as any;
  }
}

/**
 * Cart submit for checkout completion failed.
 */
/* #__PURE__ */
export class SubmitFailed extends $Base<'SubmitFailed'> {
  constructor() {
    super('SubmitFailed');
  }

  /**
   * The URL of the checkout for the cart.
   */
  get checkoutUrl(): $Field<'checkoutUrl', URL | null | undefined> {
    return this.$_select('checkoutUrl') as any;
  }

  /**
   * The list of errors that occurred from executing the mutation.
   */
  errors<Sel extends Selection<SubmissionError>>(
    selectorFn: (s: SubmissionError) => [...Sel],
  ): $Field<'errors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new SubmissionError()),
    };
    return this.$_select('errors', options) as any;
  }
}

/**
 * Cart submit for checkout completion is already accepted.
 */
/* #__PURE__ */
export class SubmitSuccess extends $Base<'SubmitSuccess'> {
  constructor() {
    super('SubmitSuccess');
  }

  /**
   * The ID of the cart completion attempt that will be used for polling for the result.
   */
  get attemptId(): $Field<'attemptId', string> {
    return this.$_select('attemptId') as any;
  }
}

/**
 * Cart submit for checkout completion is throttled.
 */
/* #__PURE__ */
export class SubmitThrottled extends $Base<'SubmitThrottled'> {
  constructor() {
    super('SubmitThrottled');
  }

  /**
 * UTC date time string that indicates the time after which clients should make their next
poll request. Any poll requests sent before this time will be ignored. Use this value to schedule the
next poll request.

 */
  get pollAfter(): $Field<'pollAfter', DateTime> {
    return this.$_select('pollAfter') as any;
  }
}

/**
 * Color and image for visual representation.
 */
/* #__PURE__ */
export class Swatch extends $Base<'Swatch'> {
  constructor() {
    super('Swatch');
  }

  /**
   * The swatch color.
   */
  get color(): $Field<'color', Color | null | undefined> {
    return this.$_select('color') as any;
  }

  /**
   * The swatch image.
   */
  image<Sel extends Selection<MediaImage>>(
    selectorFn: (s: MediaImage) => [...Sel],
  ): $Field<'image', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaImage()),
    };
    return this.$_select('image', options) as any;
  }
}

/**
 * The taxonomy category for the product.

 */
/* #__PURE__ */
export class TaxonomyCategory extends $Base<'TaxonomyCategory'> {
  constructor() {
    super('TaxonomyCategory');
  }

  /**
   * All parent nodes of the current taxonomy category.
   */
  ancestors<Sel extends Selection<TaxonomyCategory>>(
    selectorFn: (s: TaxonomyCategory) => [...Sel],
  ): $Field<'ancestors', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new TaxonomyCategory()),
    };
    return this.$_select('ancestors', options) as any;
  }

  /**
   * A static identifier for the taxonomy category.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The localized name of the taxonomy category.
   */
  get name(): $Field<'name', string> {
    return this.$_select('name') as any;
  }
}

/**
 * Represents a resource that you can track the origin of the search traffic.
 */
/* #__PURE__ */
export class Trackable extends $Interface<
  {
    Article: Article;
    Collection: Collection;
    Page: Page;
    Product: Product;
    SearchQuerySuggestion: SearchQuerySuggestion;
  },
  'Trackable'
> {
  constructor() {
    super(
      {
        Article: Article,
        Collection: Collection,
        Page: Page,
        Product: Product,
        SearchQuerySuggestion: SearchQuerySuggestion,
      },
      'Trackable',
    );
  }

  /**
   * URL parameters to be added to a page URL to track the origin of on-site search traffic for [analytics reporting](https://help.shopify.com/manual/reports-and-analytics/shopify-reports/report-types/default-reports/behaviour-reports). Returns a result when accessed through the [search](https://shopify.dev/docs/api/storefront/current/queries/search) or [predictiveSearch](https://shopify.dev/docs/api/storefront/current/queries/predictiveSearch) queries, otherwise returns null.
   */
  get trackingParameters(): $Field<'trackingParameters', string | null | undefined> {
    return this.$_select('trackingParameters') as any;
  }
}

/**
 * Represents an [RFC 3986](https://datatracker.ietf.org/doc/html/rfc3986) and
[RFC 3987](https://datatracker.ietf.org/doc/html/rfc3987)-compliant URI string.

For example, `"https://example.myshopify.com"` is a valid URL. It includes a scheme (`https`) and a host
(`example.myshopify.com`).

 */
export type URL = string;

/**
 * The measurement used to calculate a unit price for a product variant (e.g. $9.99 / 100ml).

 */
/* #__PURE__ */
export class UnitPriceMeasurement extends $Base<'UnitPriceMeasurement'> {
  constructor() {
    super('UnitPriceMeasurement');
  }

  /**
   * The type of unit of measurement for the unit price measurement.
   */
  get measuredType(): $Field<'measuredType', UnitPriceMeasurementMeasuredType | null | undefined> {
    return this.$_select('measuredType') as any;
  }

  /**
   * The quantity unit for the unit price measurement.
   */
  get quantityUnit(): $Field<'quantityUnit', UnitPriceMeasurementMeasuredUnit | null | undefined> {
    return this.$_select('quantityUnit') as any;
  }

  /**
   * The quantity value for the unit price measurement.
   */
  get quantityValue(): $Field<'quantityValue', number> {
    return this.$_select('quantityValue') as any;
  }

  /**
   * The reference unit for the unit price measurement.
   */
  get referenceUnit(): $Field<'referenceUnit', UnitPriceMeasurementMeasuredUnit | null | undefined> {
    return this.$_select('referenceUnit') as any;
  }

  /**
   * The reference value for the unit price measurement.
   */
  get referenceValue(): $Field<'referenceValue', number> {
    return this.$_select('referenceValue') as any;
  }
}

/**
 * The accepted types of unit of measurement.
 */
export enum UnitPriceMeasurementMeasuredType {
  /**
   * Unit of measurements representing volumes.
   */
  VOLUME = 'VOLUME',

  /**
   * Unit of measurements representing weights.
   */
  WEIGHT = 'WEIGHT',

  /**
   * Unit of measurements representing lengths.
   */
  LENGTH = 'LENGTH',

  /**
   * Unit of measurements representing areas.
   */
  AREA = 'AREA',
}

/**
 * The valid units of measurement for a unit price measurement.
 */
export enum UnitPriceMeasurementMeasuredUnit {
  /**
   * 1000 milliliters equals 1 liter.
   */
  ML = 'ML',

  /**
   * 100 centiliters equals 1 liter.
   */
  CL = 'CL',

  /**
   * Metric system unit of volume.
   */
  L = 'L',

  /**
   * 1 cubic meter equals 1000 liters.
   */
  M3 = 'M3',

  /**
   * 1000 milligrams equals 1 gram.
   */
  MG = 'MG',

  /**
   * Metric system unit of weight.
   */
  G = 'G',

  /**
   * 1 kilogram equals 1000 grams.
   */
  KG = 'KG',

  /**
   * 1000 millimeters equals 1 meter.
   */
  MM = 'MM',

  /**
   * 100 centimeters equals 1 meter.
   */
  CM = 'CM',

  /**
   * Metric system unit of length.
   */
  M = 'M',

  /**
   * Metric system unit of area.
   */
  M2 = 'M2',
}

/**
 * Systems of weights and measures.
 */
export enum UnitSystem {
  /**
   * Imperial system of weights and measures.
   */
  IMPERIAL_SYSTEM = 'IMPERIAL_SYSTEM',

  /**
   * Metric system of weights and measures.
   */
  METRIC_SYSTEM = 'METRIC_SYSTEM',
}

/**
 * An unsigned 64-bit integer. Represents whole numeric values between 0 and 2^64 - 1 encoded as a string of base-10 digits.

Example value: `"50"`.

 */
export type UnsignedInt64 = string;

/**
 * A redirect on the online store.
 */
/* #__PURE__ */
export class UrlRedirect extends $Base<'UrlRedirect'> {
  constructor() {
    super('UrlRedirect');
  }

  /**
   * The ID of the URL redirect.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The old path to be redirected from. When the user visits this path, they'll be redirected to the target location.
   */
  get path(): $Field<'path', string> {
    return this.$_select('path') as any;
  }

  /**
   * The target location where the user will be redirected to.
   */
  get target(): $Field<'target', string> {
    return this.$_select('target') as any;
  }
}

/**
 * An auto-generated type for paginating through multiple UrlRedirects.

 */
/* #__PURE__ */
export class UrlRedirectConnection extends $Base<'UrlRedirectConnection'> {
  constructor() {
    super('UrlRedirectConnection');
  }

  /**
   * A list of edges.
   */
  edges<Sel extends Selection<UrlRedirectEdge>>(
    selectorFn: (s: UrlRedirectEdge) => [...Sel],
  ): $Field<'edges', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UrlRedirectEdge()),
    };
    return this.$_select('edges', options) as any;
  }

  /**
   * A list of the nodes contained in UrlRedirectEdge.
   */
  nodes<Sel extends Selection<UrlRedirect>>(
    selectorFn: (s: UrlRedirect) => [...Sel],
  ): $Field<'nodes', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UrlRedirect()),
    };
    return this.$_select('nodes', options) as any;
  }

  /**
   * Information to aid in pagination.
   */
  pageInfo<Sel extends Selection<PageInfo>>(
    selectorFn: (s: PageInfo) => [...Sel],
  ): $Field<'pageInfo', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new PageInfo()),
    };
    return this.$_select('pageInfo', options) as any;
  }
}

/**
 * An auto-generated type which holds one UrlRedirect and a cursor during pagination.

 */
/* #__PURE__ */
export class UrlRedirectEdge extends $Base<'UrlRedirectEdge'> {
  constructor() {
    super('UrlRedirectEdge');
  }

  /**
   * A cursor for use in pagination.
   */
  get cursor(): $Field<'cursor', string> {
    return this.$_select('cursor') as any;
  }

  /**
   * The item at the end of UrlRedirectEdge.
   */
  node<Sel extends Selection<UrlRedirect>>(
    selectorFn: (s: UrlRedirect) => [...Sel],
  ): $Field<'node', GetOutput<Sel>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new UrlRedirect()),
    };
    return this.$_select('node', options) as any;
  }
}

/**
 * Represents an error in the input of a mutation.
 */
/* #__PURE__ */
export class UserError extends $Base<'UserError'> {
  constructor() {
    super('UserError');
  }

  /**
   * The path to the input field that caused the error.
   */
  get field(): $Field<'field', Readonly<Array<string>> | null | undefined> {
    return this.$_select('field') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string> {
    return this.$_select('message') as any;
  }
}

/**
 * Error codes for failed Shop Pay payment request session mutations.
 */
/* #__PURE__ */
export class UserErrorsShopPayPaymentRequestSessionUserErrors extends $Base<'UserErrorsShopPayPaymentRequestSessionUserErrors'> {
  constructor() {
    super('UserErrorsShopPayPaymentRequestSessionUserErrors');
  }

  /**
   * The error code.
   */
  get code(): $Field<'code', UserErrorsShopPayPaymentRequestSessionUserErrorsCode | null | undefined> {
    return this.$_select('code') as any;
  }

  /**
   * The path to the input field that caused the error.
   */
  get field(): $Field<'field', Readonly<Array<string>> | null | undefined> {
    return this.$_select('field') as any;
  }

  /**
   * The error message.
   */
  get message(): $Field<'message', string> {
    return this.$_select('message') as any;
  }
}

/**
 * Possible error codes that can be returned by `ShopPayPaymentRequestSessionUserErrors`.
 */
export enum UserErrorsShopPayPaymentRequestSessionUserErrorsCode {
  /**
   * Payment request input is invalid.
   */
  PAYMENT_REQUEST_INVALID_INPUT = 'PAYMENT_REQUEST_INVALID_INPUT',

  /**
   * Payment request not found.
   */
  PAYMENT_REQUEST_NOT_FOUND = 'PAYMENT_REQUEST_NOT_FOUND',

  /**
   * Idempotency key has already been used.
   */
  IDEMPOTENCY_KEY_ALREADY_USED = 'IDEMPOTENCY_KEY_ALREADY_USED',
}

/**
 * The input fields for a filter used to view a subset of products in a collection matching a specific variant option.
 */
export type VariantOptionFilter = {
  name: string;
  value: string;
};

/**
 * Represents a Shopify hosted video.
 */
/* #__PURE__ */
export class Video extends $Base<'Video'> {
  constructor() {
    super('Video');
  }

  /**
   * A word or phrase to share the nature or contents of a media.
   */
  get alt(): $Field<'alt', string | null | undefined> {
    return this.$_select('alt') as any;
  }

  /**
   * A globally-unique ID.
   */
  get id(): $Field<'id', string> {
    return this.$_select('id') as any;
  }

  /**
   * The media content type.
   */
  get mediaContentType(): $Field<'mediaContentType', MediaContentType> {
    return this.$_select('mediaContentType') as any;
  }

  /**
   * The presentation for a media.
   */
  presentation<Sel extends Selection<MediaPresentation>>(
    selectorFn: (s: MediaPresentation) => [...Sel],
  ): $Field<'presentation', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new MediaPresentation()),
    };
    return this.$_select('presentation', options) as any;
  }

  /**
   * The preview image for the media.
   */
  previewImage<Sel extends Selection<Image>>(
    selectorFn: (s: Image) => [...Sel],
  ): $Field<'previewImage', GetOutput<Sel> | undefined, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new Image()),
    };
    return this.$_select('previewImage', options) as any;
  }

  /**
   * The sources for a video.
   */
  sources<Sel extends Selection<VideoSource>>(
    selectorFn: (s: VideoSource) => [...Sel],
  ): $Field<'sources', Array<GetOutput<Sel>>, GetVariables<Sel>> {
    const options = {
      selection: selectorFn(new VideoSource()),
    };
    return this.$_select('sources', options) as any;
  }
}

/**
 * Represents a source for a Shopify hosted video.
 */
/* #__PURE__ */
export class VideoSource extends $Base<'VideoSource'> {
  constructor() {
    super('VideoSource');
  }

  /**
   * The format of the video source.
   */
  get format(): $Field<'format', string> {
    return this.$_select('format') as any;
  }

  /**
   * The height of the video.
   */
  get height(): $Field<'height', number> {
    return this.$_select('height') as any;
  }

  /**
   * The video MIME type.
   */
  get mimeType(): $Field<'mimeType', string> {
    return this.$_select('mimeType') as any;
  }

  /**
   * The URL of the video.
   */
  get url(): $Field<'url', string> {
    return this.$_select('url') as any;
  }

  /**
   * The width of the video.
   */
  get width(): $Field<'width', number> {
    return this.$_select('width') as any;
  }
}

/**
 * Units of measurement for weight.
 */
export enum WeightUnit {
  /**
   * 1 kilogram equals 1000 grams.
   */
  KILOGRAMS = 'KILOGRAMS',

  /**
   * Metric system unit of mass.
   */
  GRAMS = 'GRAMS',

  /**
   * 1 pound equals 16 ounces.
   */
  POUNDS = 'POUNDS',

  /**
   * Imperial system unit of mass.
   */
  OUNCES = 'OUNCES',
}

const $Root = {
  query: QueryRoot,
  mutation: Mutation,
};

namespace $RootTypes {
  export type query = QueryRoot;
  export type mutation = Mutation;
}

export function query<Sel extends Selection<$RootTypes.query>>(
  name: string,
  selectFn: (q: $RootTypes.query) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, GetVariables<Sel>>;
export function query<Sel extends Selection<$RootTypes.query>>(
  selectFn: (q: $RootTypes.query) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, Simplify<GetVariables<Sel>>>;
export function query<Sel extends Selection<$RootTypes.query>>(name: any, selectFn?: any) {
  if (!selectFn) {
    selectFn = name;
    name = '';
  }
  let field = new $Field<'query', GetOutput<Sel>, GetVariables<Sel>>('query', {
    selection: selectFn(new $Root.query()),
  });
  const str = fieldToQuery(`query ${name}`, field);

  return gql(str) as any;
}

export function mutation<Sel extends Selection<$RootTypes.mutation>>(
  name: string,
  selectFn: (q: $RootTypes.mutation) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, GetVariables<Sel>>;
export function mutation<Sel extends Selection<$RootTypes.mutation>>(
  selectFn: (q: $RootTypes.mutation) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, Simplify<GetVariables<Sel>>>;
export function mutation<Sel extends Selection<$RootTypes.query>>(name: any, selectFn?: any) {
  if (!selectFn) {
    selectFn = name;
    name = '';
  }
  let field = new $Field<'mutation', GetOutput<Sel>, GetVariables<Sel>>('mutation', {
    selection: selectFn(new $Root.mutation()),
  });
  const str = fieldToQuery(`mutation ${name}`, field);

  return gql(str) as any;
}

const $InputTypes: { [key: string]: { [key: string]: string } } = {
  ApplePayWalletContentInput: {
    billingAddress: 'MailingAddressInput!',
    data: 'String!',
    header: 'ApplePayWalletHeaderInput!',
    lastDigits: 'String',
    signature: 'String!',
    version: 'String!',
  },
  ApplePayWalletHeaderInput: {
    applicationData: 'String',
    ephemeralPublicKey: 'String!',
    publicKeyHash: 'String!',
    transactionId: 'String!',
  },
  AttributeInput: {
    key: 'String!',
    value: 'String!',
  },
  BuyerInput: {
    companyLocationId: 'ID',
    customerAccessToken: 'String!',
  },
  CartBuyerIdentityInput: {
    companyLocationId: 'ID',
    countryCode: 'CountryCode',
    customerAccessToken: 'String',
    deliveryAddressPreferences: '[DeliveryAddressInput!]',
    email: 'String',
    phone: 'String',
    preferences: 'CartPreferencesInput',
  },
  CartDeliveryCoordinatesPreferenceInput: {
    countryCode: 'CountryCode!',
    latitude: 'Float!',
    longitude: 'Float!',
  },
  CartDeliveryPreferenceInput: {
    coordinates: 'CartDeliveryCoordinatesPreferenceInput',
    deliveryMethod: '[PreferenceDeliveryMethodType!]',
    pickupHandle: '[String!]',
  },
  CartDirectPaymentMethodInput: {
    billingAddress: 'MailingAddressInput!',
    cardSource: 'CartCardSource',
    sessionId: 'String!',
  },
  CartFreePaymentMethodInput: {
    billingAddress: 'MailingAddressInput!',
  },
  CartInput: {
    attributes: '[AttributeInput!]',
    buyerIdentity: 'CartBuyerIdentityInput',
    discountCodes: '[String!]',
    giftCardCodes: '[String!]',
    lines: '[CartLineInput!]',
    metafields: '[CartInputMetafieldInput!]',
    note: 'String',
  },
  CartInputMetafieldInput: {
    key: 'String!',
    type: 'String!',
    value: 'String!',
  },
  CartLineInput: {
    attributes: '[AttributeInput!]',
    merchandiseId: 'ID!',
    quantity: 'Int',
    sellingPlanId: 'ID',
  },
  CartLineUpdateInput: {
    attributes: '[AttributeInput!]',
    id: 'ID!',
    merchandiseId: 'ID',
    quantity: 'Int',
    sellingPlanId: 'ID',
  },
  CartMetafieldDeleteInput: {
    key: 'String!',
    ownerId: 'ID!',
  },
  CartMetafieldsSetInput: {
    key: 'String!',
    ownerId: 'ID!',
    type: 'String!',
    value: 'String!',
  },
  CartPaymentInput: {
    amount: 'MoneyInput!',
    directPaymentMethod: 'CartDirectPaymentMethodInput',
    freePaymentMethod: 'CartFreePaymentMethodInput',
    sourceIdentifier: 'String',
    walletPaymentMethod: 'CartWalletPaymentMethodInput',
  },
  CartPreferencesInput: {
    delivery: 'CartDeliveryPreferenceInput',
    wallet: '[String!]',
  },
  CartSelectedDeliveryOptionInput: {
    deliveryGroupId: 'ID!',
    deliveryOptionHandle: 'String!',
  },
  CartWalletPaymentMethodInput: {
    applePayWalletContent: 'ApplePayWalletContentInput',
    shopPayWalletContent: 'ShopPayWalletContentInput',
  },
  CustomerAccessTokenCreateInput: {
    email: 'String!',
    password: 'String!',
  },
  CustomerActivateInput: {
    activationToken: 'String!',
    password: 'String!',
  },
  CustomerCreateInput: {
    acceptsMarketing: 'Boolean',
    email: 'String!',
    firstName: 'String',
    lastName: 'String',
    password: 'String!',
    phone: 'String',
  },
  CustomerResetInput: {
    password: 'String!',
    resetToken: 'String!',
  },
  CustomerUpdateInput: {
    acceptsMarketing: 'Boolean',
    email: 'String',
    firstName: 'String',
    lastName: 'String',
    password: 'String',
    phone: 'String',
  },
  DeliveryAddressInput: {
    customerAddressId: 'ID',
    deliveryAddress: 'MailingAddressInput',
    deliveryAddressValidationStrategy: 'DeliveryAddressValidationStrategy',
    oneTimeUse: 'Boolean',
  },
  GeoCoordinateInput: {
    latitude: 'Float!',
    longitude: 'Float!',
  },
  HasMetafieldsIdentifier: {
    key: 'String!',
    namespace: 'String',
  },
  ImageTransformInput: {
    crop: 'CropRegion',
    maxHeight: 'Int',
    maxWidth: 'Int',
    preferredContentType: 'ImageContentType',
    scale: 'Int',
  },
  MailingAddressInput: {
    address1: 'String',
    address2: 'String',
    city: 'String',
    company: 'String',
    country: 'String',
    firstName: 'String',
    lastName: 'String',
    phone: 'String',
    province: 'String',
    zip: 'String',
  },
  MetafieldFilter: {
    key: 'String!',
    namespace: 'String!',
    value: 'String!',
  },
  MetaobjectHandleInput: {
    handle: 'String!',
    type: 'String!',
  },
  MoneyInput: {
    amount: 'Decimal!',
    currencyCode: 'CurrencyCode!',
  },
  PriceRangeFilter: {
    max: 'Float',
    min: 'Float',
  },
  ProductFilter: {
    available: 'Boolean',
    price: 'PriceRangeFilter',
    productMetafield: 'MetafieldFilter',
    productType: 'String',
    productVendor: 'String',
    tag: 'String',
    variantMetafield: 'MetafieldFilter',
    variantOption: 'VariantOptionFilter',
  },
  SelectedOptionInput: {
    name: 'String!',
    value: 'String!',
  },
  ShopPayPaymentRequestDeliveryMethodInput: {
    amount: 'MoneyInput',
    code: 'String',
    deliveryExpectationLabel: 'String',
    detail: 'String',
    label: 'String',
    maxDeliveryDate: 'ISO8601DateTime',
    minDeliveryDate: 'ISO8601DateTime',
  },
  ShopPayPaymentRequestDiscountInput: {
    amount: 'MoneyInput',
    label: 'String',
  },
  ShopPayPaymentRequestImageInput: {
    alt: 'String',
    url: 'String!',
  },
  ShopPayPaymentRequestInput: {
    deliveryMethods: '[ShopPayPaymentRequestDeliveryMethodInput!]',
    discountCodes: '[String!]',
    discounts: '[ShopPayPaymentRequestDiscountInput!]',
    lineItems: '[ShopPayPaymentRequestLineItemInput!]',
    locale: 'String!',
    paymentMethod: 'String',
    presentmentCurrency: 'CurrencyCode!',
    selectedDeliveryMethodType: 'ShopPayPaymentRequestDeliveryMethodType',
    shippingLines: '[ShopPayPaymentRequestShippingLineInput!]',
    subtotal: 'MoneyInput!',
    total: 'MoneyInput!',
    totalShippingPrice: 'ShopPayPaymentRequestTotalShippingPriceInput',
    totalTax: 'MoneyInput',
  },
  ShopPayPaymentRequestLineItemInput: {
    finalItemPrice: 'MoneyInput',
    finalLinePrice: 'MoneyInput',
    image: 'ShopPayPaymentRequestImageInput',
    itemDiscounts: '[ShopPayPaymentRequestDiscountInput!]',
    label: 'String',
    lineDiscounts: '[ShopPayPaymentRequestDiscountInput!]',
    originalItemPrice: 'MoneyInput',
    originalLinePrice: 'MoneyInput',
    quantity: 'Int!',
    requiresShipping: 'Boolean',
    sku: 'String',
  },
  ShopPayPaymentRequestShippingLineInput: {
    amount: 'MoneyInput',
    code: 'String',
    label: 'String',
  },
  ShopPayPaymentRequestTotalShippingPriceInput: {
    discounts: '[ShopPayPaymentRequestDiscountInput!]',
    finalTotal: 'MoneyInput',
    originalTotal: 'MoneyInput',
  },
  ShopPayWalletContentInput: {
    billingAddress: 'MailingAddressInput!',
    sessionToken: 'String!',
  },
  VariantOptionFilter: {
    name: 'String!',
    value: 'String!',
  },
};
